(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.1/optimize for better performance and smaller assets.');


// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**_UNUSED/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**_UNUSED/
	if (typeof x.$ === 'undefined')
	//*/
	/**/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0_UNUSED = 0;
var _Utils_Tuple0 = { $: '#0' };

function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr_UNUSED(c) { return c; }
function _Utils_chr(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil_UNUSED = { $: 0 };
var _List_Nil = { $: '[]' };

function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log_UNUSED = F2(function(tag, value)
{
	return value;
});

var _Debug_log = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString_UNUSED(value)
{
	return '<internals>';
}

function _Debug_toString(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash_UNUSED(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.start.line === region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'on lines ' + region.start.line + ' through ' + region.end.line;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap(value) { return { $: 0, a: value }; }
function _Json_unwrap(value) { return value.a; }

function _Json_wrap_UNUSED(value) { return value; }
function _Json_unwrap_UNUSED(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**_UNUSED/
	var node = args['node'];
	//*/
	/**/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**_UNUSED/''//*//**/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**_UNUSED/''//*//**/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**_UNUSED/''//*//**/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		message: func(record.message),
		stopPropagation: record.stopPropagation,
		preventDefault: record.preventDefault
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.message;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var view = impl.view;
			/**_UNUSED/
			var domNode = args['node'];
			//*/
			/**/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.setup && impl.setup(sendToApp)
			var view = impl.view;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.onUrlChange;
	var onUrlRequest = impl.onUrlRequest;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		setup: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.protocol === next.protocol
							&& curr.host === next.host
							&& curr.port_.a === next.port_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		init: function(flags)
		{
			return A3(impl.init, flags, _Browser_getUrl(), key);
		},
		view: impl.view,
		update: impl.update,
		subscriptions: impl.subscriptions
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hidden: 'hidden', change: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hidden: 'msHidden', change: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
		: { hidden: 'hidden', change: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		scene: _Browser_getScene(),
		viewport: {
			x: _Browser_window.pageXOffset,
			y: _Browser_window.pageYOffset,
			width: _Browser_doc.documentElement.clientWidth,
			height: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			scene: {
				width: node.scrollWidth,
				height: node.scrollHeight
			},
			viewport: {
				x: node.scrollLeft,
				y: node.scrollTop,
				width: node.clientWidth,
				height: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: x,
				y: y,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			},
			element: {
				x: x + rect.left,
				y: y + rect.top,
				width: rect.width,
				height: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.multiline) { flags += 'm'; }
	if (options.caseInsensitive) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $elm$core$Basics$EQ = {$: 'EQ'};
var $elm$core$Basics$GT = {$: 'GT'};
var $elm$core$Basics$LT = {$: 'LT'};
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 'Err', a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 'Failure', a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 'Index', a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 'Ok', a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 'OneOf', a: a};
};
var $elm$core$Basics$False = {$: 'False'};
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 'Just', a: a};
};
var $elm$core$Maybe$Nothing = {$: 'Nothing'};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 'Field':
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 'Nothing') {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'Index':
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'OneOf':
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 'SubTree', a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.nodeListSize) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.tail);
		} else {
			var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.tail);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{nodeList: nodeList, nodeListSize: (len / $elm$core$Array$branchFactor) | 0, tail: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = {$: 'True'};
var $elm$core$Result$isOk = function (result) {
	if (result.$ === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 'Normal':
			return 0;
		case 'MayStopPropagation':
			return 1;
		case 'MayPreventDefault':
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 'External', a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 'Internal', a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $elm$url$Url$Http = {$: 'Http'};
var $elm$url$Url$Https = {$: 'Https'};
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Http,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Https,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0.a;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = function (a) {
	return {$: 'Perform', a: a};
};
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(_Utils_Tuple0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0.a;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return _Utils_Tuple0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(_Utils_Tuple0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0.a;
		return $elm$core$Task$Perform(
			A2($elm$core$Task$map, tagger, task));
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2($elm$core$Task$map, toMessage, task)));
	});
var $elm$browser$Browser$element = _Browser_element;
var $author$project$ExpressionInput$UnknownInput = function (a) {
	return {$: 'UnknownInput', a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$ExpressionInput$ContentType$Territory = {$: 'Territory'};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $author$project$DataElement$DataElementCollection = function (a) {
	return {$: 'DataElementCollection', a: a};
};
var $author$project$UuidDict$UuidDict = function (a) {
	return {$: 'UuidDict', a: a};
};
var $author$project$UuidDict$empty = $author$project$UuidDict$UuidDict($elm$core$Dict$empty);
var $author$project$DataElement$emptyCollection = $author$project$DataElement$DataElementCollection($author$project$UuidDict$empty);
var $author$project$ExpressionInput$emptyViewInfo = {contentType: $author$project$ExpressionInput$ContentType$Territory, dataElements: $author$project$DataElement$emptyCollection, i18nMessages: $elm$core$Dict$empty, iconsUri: '', veevaMessages: $elm$core$Dict$empty};
var $author$project$ExpressionInput$GlobalBoolInput = F2(
	function (a, b) {
		return {$: 'GlobalBoolInput', a: a, b: b};
	});
var $author$project$StudioApp$Error$InExpressionInput = {$: 'InExpressionInput'};
var $author$project$FieldType$BoolType = {$: 'BoolType'};
var $author$project$ComparableType$DateComp = {$: 'DateComp'};
var $author$project$ComparableType$DateTimeComp = {$: 'DateTimeComp'};
var $author$project$FieldType$DateTimeType = {$: 'DateTimeType'};
var $author$project$FieldType$DateType = {$: 'DateType'};
var $author$project$ComparableType$NumberComp = {$: 'NumberComp'};
var $author$project$FieldType$NumberType = {$: 'NumberType'};
var $author$project$ComparableType$StringComp = {$: 'StringComp'};
var $author$project$FieldType$StringType = {$: 'StringType'};
var $author$project$DataElement$Expression$applyGlobalBool = F2(
	function (transformers, globalBool) {
		switch (globalBool.$) {
			case 'GlobalBoolLookup':
				var singletonRef = globalBool.a;
				var fieldName = globalBool.b;
				return A2(transformers.globalBoolLookup, singletonRef, fieldName);
			case 'GlobalBoolHardcoded':
				var bool = globalBool.a;
				return transformers.hardcodedBool(bool);
			case 'GlobalGTString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalGTNumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalGTDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalGTDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalGTEString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalGTENumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalGTEDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalGTEDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalLTString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalLTNumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalLTDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalLTDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalLTEString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalLTENumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalLTEDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalLTEDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalEqualString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalEqualNumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalEqualDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalEqualDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalEqualBool':
				var boolA = globalBool.a;
				var boolB = globalBool.b;
				return A3(
					transformers.equal,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, boolA),
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, boolB));
			case 'GlobalNotEqualString':
				var stringA = globalBool.a;
				var stringB = globalBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, stringB));
			case 'GlobalNotEqualNumber':
				var numberA = globalBool.a;
				var numberB = globalBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, numberB));
			case 'GlobalNotEqualDate':
				var dateA = globalBool.a;
				var dateB = globalBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, dateB));
			case 'GlobalNotEqualDateTime':
				var dateTimeA = globalBool.a;
				var dateTimeB = globalBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTimeB));
			case 'GlobalNotEqualBool':
				var boolA = globalBool.a;
				var boolB = globalBool.b;
				return A3(
					transformers.notEqual,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, boolA),
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, boolB));
			case 'GlobalStringIn':
				var string = globalBool.a;
				var list = globalBool.b;
				return A2(
					transformers.stringIn,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, string),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
			case 'GlobalStringNotIn':
				var string = globalBool.a;
				var list = globalBool.b;
				return A2(
					transformers.stringNotIn,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, string),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
			case 'GlobalNot':
				var innerBool = globalBool.a;
				return transformers.not(
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, innerBool));
			case 'GlobalBoolIf':
				var cond = globalBool.a;
				var then_ = globalBool.b;
				var else_ = globalBool.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, else_));
			case 'GlobalPickBool':
				var innerList = globalBool.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, innerList));
			case 'GlobalAll':
				var innerList = globalBool.a;
				return transformers.all(
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, innerList));
			case 'GlobalAny':
				var innerList = globalBool.a;
				return transformers.any(
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, innerList));
			case 'GlobalIsNull':
				var field = globalBool.a;
				return transformers.isNull(
					A2($author$project$DataElement$Expression$applyGlobalField, transformers, field));
			default:
				var field = globalBool.a;
				return transformers.isNotNull(
					A2($author$project$DataElement$Expression$applyGlobalField, transformers, field));
		}
	});
var $author$project$DataElement$Expression$applyGlobalBoolList = F2(
	function (transformers, globalBoolList) {
		switch (globalBoolList.$) {
			case 'GlobalAllBoolsInField':
				var listRef = globalBoolList.a;
				var fieldName = globalBoolList.b;
				return A2(transformers.allBoolsInField, listRef, fieldName);
			case 'GlobalBoolsAsList':
				var globalBools = globalBoolList.a;
				return transformers.boolsAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalBool(transformers),
						globalBools));
			default:
				var cond = globalBoolList.a;
				var then_ = globalBoolList.b;
				var else_ = globalBoolList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalBoolList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyGlobalComparableList = F2(
	function (transformers, globalCompList) {
		switch (globalCompList.$) {
			case 'GlobalCompStringListExpr':
				var globalStringList = globalCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, globalStringList));
			case 'GlobalCompNumberListExpr':
				var globalNumberList = globalCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, globalNumberList));
			case 'GlobalCompDateListExpr':
				var globalDateList = globalCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, globalDateList));
			default:
				var globalDateTimeList = globalCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, globalDateTimeList));
		}
	});
var $author$project$DataElement$Expression$applyGlobalDate = F2(
	function (transformers, globalDate) {
		switch (globalDate.$) {
			case 'GlobalDateLookup':
				var singletonRef = globalDate.a;
				var fieldName = globalDate.b;
				return A2(transformers.globalDateLookup, singletonRef, fieldName);
			case 'GlobalDateHardcoded':
				var date = globalDate.a;
				return transformers.hardcodedDate(date);
			case 'GlobalDateTimeToDate':
				var dateTime = globalDate.a;
				return transformers.dateTimeToDate(
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, dateTime));
			case 'GlobalDateCeiling':
				var dateInterval = globalDate.a;
				var innerDate = globalDate.b;
				return A2(
					transformers.dateCeiling,
					dateInterval,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDateFloor':
				var dateInterval = globalDate.a;
				var innerDate = globalDate.b;
				return A2(
					transformers.dateFloor,
					dateInterval,
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDateAdd':
				var dateUnit = globalDate.a;
				var innerNum = globalDate.b;
				var innerDate = globalDate.c;
				return A3(
					transformers.dateAdd,
					dateUnit,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, innerNum),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDateSubtract':
				var dateUnit = globalDate.a;
				var innerNum = globalDate.b;
				var innerDate = globalDate.c;
				return A3(
					transformers.dateSubtract,
					dateUnit,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, innerNum),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDateIf':
				var cond = globalDate.a;
				var then_ = globalDate.b;
				var else_ = globalDate.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, else_));
			case 'GlobalPickDate':
				var innerList = globalDate.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, innerList));
			case 'GlobalMaxDate':
				var list = globalDate.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, list));
			default:
				var list = globalDate.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyGlobalDateList = F2(
	function (transformers, globalDateList) {
		switch (globalDateList.$) {
			case 'GlobalAllDatesInField':
				var listRef = globalDateList.a;
				var fieldName = globalDateList.b;
				return A2(transformers.allDatesInField, listRef, fieldName);
			case 'GlobalDatesAsList':
				var globalDates = globalDateList.a;
				return transformers.datesAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalDate(transformers),
						globalDates));
			default:
				var cond = globalDateList.a;
				var then_ = globalDateList.b;
				var else_ = globalDateList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalDateList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyGlobalDateTime = F2(
	function (transformers, globalDateTime) {
		switch (globalDateTime.$) {
			case 'GlobalDateTimeLookup':
				var singletonRef = globalDateTime.a;
				var fieldName = globalDateTime.b;
				return A2(transformers.globalDateTimeLookup, singletonRef, fieldName);
			case 'GlobalDateTimeHardcoded':
				var posix = globalDateTime.a;
				return transformers.hardcodedDateTime(posix);
			case 'GlobalDateTimeIf':
				var cond = globalDateTime.a;
				var then_ = globalDateTime.b;
				var else_ = globalDateTime.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, else_));
			case 'GlobalPickDateTime':
				var innerList = globalDateTime.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, innerList));
			case 'GlobalMaxDateTime':
				var list = globalDateTime.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, list));
			default:
				var list = globalDateTime.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyGlobalDateTimeList = F2(
	function (transformers, globalDateTimeList) {
		switch (globalDateTimeList.$) {
			case 'GlobalAllDateTimesInField':
				var listRef = globalDateTimeList.a;
				var fieldName = globalDateTimeList.b;
				return A2(transformers.allDateTimesInField, listRef, fieldName);
			case 'GlobalDateTimesAsList':
				var globalDateTimes = globalDateTimeList.a;
				return transformers.dateTimesAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalDateTime(transformers),
						globalDateTimes));
			default:
				var cond = globalDateTimeList.a;
				var then_ = globalDateTimeList.b;
				var else_ = globalDateTimeList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalDateTimeList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyGlobalField = F2(
	function (transformers, globalField) {
		switch (globalField.$) {
			case 'GlobalStringExpr':
				var globalString = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalString, transformers, globalString);
			case 'GlobalNumberExpr':
				var globalNumber = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumber);
			case 'GlobalDateExpr':
				var globalDate = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalDate, transformers, globalDate);
			case 'GlobalDateTimeExpr':
				var globalDateTime = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, globalDateTime);
			default:
				var globalBool = globalField.a;
				return A2($author$project$DataElement$Expression$applyGlobalBool, transformers, globalBool);
		}
	});
var $author$project$DataElement$Expression$applyGlobalNumber = F2(
	function (transformers, globalNumber) {
		switch (globalNumber.$) {
			case 'GlobalNumberLookup':
				var singletonRef = globalNumber.a;
				var fieldName = globalNumber.b;
				return A2(transformers.globalNumberLookup, singletonRef, fieldName);
			case 'GlobalNumberHardcoded':
				var number = globalNumber.a;
				return transformers.hardcodedNumber(number);
			case 'GlobalCountUnique':
				var globalCompList = globalNumber.a;
				return function (_v4) {
					var compType = _v4.a;
					var item = _v4.b;
					return A2(transformers.countUnique, compType, item);
				}(
					A2($author$project$DataElement$Expression$applyGlobalComparableList, transformers, globalCompList));
			case 'GlobalRound':
				var innerNumber = globalNumber.a;
				return transformers.round(
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, innerNumber));
			case 'GlobalSum':
				var globalNumberList = globalNumber.a;
				return transformers.sum(
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, globalNumberList));
			case 'GlobalProduct':
				var globalNumberList = globalNumber.a;
				return transformers.product(
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, globalNumberList));
			case 'GlobalAdd':
				var globalNumA = globalNumber.a;
				var globalNumB = globalNumber.b;
				return A2(
					transformers.add,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumB));
			case 'GlobalSubtract':
				var globalNumA = globalNumber.a;
				var globalNumB = globalNumber.b;
				return A2(
					transformers.subtract,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumB));
			case 'GlobalMultiply':
				var globalNumA = globalNumber.a;
				var globalNumB = globalNumber.b;
				return A2(
					transformers.multiply,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumB));
			case 'GlobalDivide':
				var globalNumA = globalNumber.a;
				var globalNumB = globalNumber.b;
				return A2(
					transformers.divide,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumA),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumB));
			case 'GlobalMonthNumber':
				var innerDate = globalNumber.a;
				return transformers.monthNumber(
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalYearNumber':
				var innerDate = globalNumber.a;
				return transformers.yearNumber(
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalDayInMonth':
				var innerDate = globalNumber.a;
				return transformers.dayInMonth(
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalNumberIf':
				var cond = globalNumber.a;
				var then_ = globalNumber.b;
				var else_ = globalNumber.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, else_));
			case 'GlobalPickNumber':
				var innerList = globalNumber.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, innerList));
			case 'GlobalMaxNumber':
				var list = globalNumber.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, list));
			default:
				var list = globalNumber.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyGlobalNumberList = F2(
	function (transformers, globalNumberList) {
		switch (globalNumberList.$) {
			case 'GlobalAllNumbersInField':
				var listRef = globalNumberList.a;
				var fieldName = globalNumberList.b;
				return A2(transformers.allNumbersInField, listRef, fieldName);
			case 'GlobalNumbersAsList':
				var globalNumbers = globalNumberList.a;
				return transformers.numbersAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalNumber(transformers),
						globalNumbers));
			default:
				var cond = globalNumberList.a;
				var then_ = globalNumberList.b;
				var else_ = globalNumberList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalNumberList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyGlobalString = F2(
	function (transformers, globalString) {
		switch (globalString.$) {
			case 'GlobalStringHardcoded':
				var words = globalString.a;
				return transformers.hardcodedString(words);
			case 'GlobalStringLookup':
				var singletonRef = globalString.a;
				var fieldName = globalString.b;
				return A2(transformers.globalStringLookup, singletonRef, fieldName);
			case 'GlobalFormatDate':
				var innerString = globalString.a;
				var innerDate = globalString.b;
				return A2(
					transformers.formatDate,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, innerString),
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalFormatDateLocaleAware':
				var innerDate = globalString.a;
				return transformers.formatDateLocaleAware(
					A2($author$project$DataElement$Expression$applyGlobalDate, transformers, innerDate));
			case 'GlobalFormatDateTime':
				var innerDateTime = globalString.a;
				return transformers.formatDateTime(
					A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, innerDateTime));
			case 'GlobalFormatNumber':
				var decimals = globalString.a;
				var innerNumber = globalString.b;
				return A2(
					transformers.formatNumber,
					decimals,
					A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, innerNumber));
			case 'GlobalStringIf':
				var cond = globalString.a;
				var then_ = globalString.b;
				var else_ = globalString.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, else_));
			case 'GlobalPickString':
				var innerList = globalString.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, innerList));
			case 'GlobalConcat':
				var join = globalString.a;
				var list = globalString.b;
				return A2(
					transformers.concat,
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, join),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
			case 'GlobalMaxString':
				var list = globalString.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
			default:
				var list = globalString.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyGlobalStringList = F2(
	function (transformers, globalStringList) {
		switch (globalStringList.$) {
			case 'GlobalAllStringsInField':
				var listRef = globalStringList.a;
				var fieldName = globalStringList.b;
				return A2(transformers.allStringsInField, listRef, fieldName);
			case 'GlobalStringsAsList':
				var globalStrings = globalStringList.a;
				return transformers.stringsAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyGlobalString(transformers),
						globalStrings));
			case 'GlobalStringListIf':
				var cond = globalStringList.a;
				var then_ = globalStringList.b;
				var else_ = globalStringList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyGlobalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, then_),
					A2($author$project$DataElement$Expression$applyGlobalStringList, transformers, else_));
			case 'GlobalChallengeReasons':
				var acctId = globalStringList.a;
				return transformers.challengeReasons(
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, acctId));
			default:
				var acctId = globalStringList.a;
				return transformers.targetChallengeReasons(
					A2($author$project$DataElement$Expression$applyGlobalString, transformers, acctId));
		}
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$DataElement$Expression$applyLocalBool = F2(
	function (transformers, localBool) {
		switch (localBool.$) {
			case 'LocalBool':
				var fieldName = localBool.a;
				return transformers.localBool(fieldName);
			case 'LocalSingletonBool':
				var singletonRef = localBool.a;
				var fieldName = localBool.b;
				return A2(transformers.globalBoolLookup, singletonRef, fieldName);
			case 'LocalBoolHardcoded':
				var bool = localBool.a;
				return transformers.hardcodedBool(bool);
			case 'LocalGTString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalGTNumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalGTDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalGTDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.greaterThan,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalGTEString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalGTENumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalGTEDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalGTEDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.greaterThanOrEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalLTString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalLTNumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalLTDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalLTDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.lessThan,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalLTEString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalLTENumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalLTEDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalLTEDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.lessThanOrEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalEqualString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalEqualNumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalEqualDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalEqualDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.comparableEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalEqualBool':
				var boolA = localBool.a;
				var boolB = localBool.b;
				return A3(
					transformers.equal,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, boolA),
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, boolB));
			case 'LocalNotEqualString':
				var stringA = localBool.a;
				var stringB = localBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringA),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, stringB));
			case 'LocalNotEqualNumber':
				var numberA = localBool.a;
				var numberB = localBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, numberB));
			case 'LocalNotEqualDate':
				var dateA = localBool.a;
				var dateB = localBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateA),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, dateB));
			case 'LocalNotEqualDateTime':
				var dateTimeA = localBool.a;
				var dateTimeB = localBool.b;
				return A3(
					transformers.comparableNotEqual,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeA),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTimeB));
			case 'LocalNotEqualBool':
				var boolA = localBool.a;
				var boolB = localBool.b;
				return A3(
					transformers.notEqual,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, boolA),
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, boolB));
			case 'LocalStringIn':
				var string = localBool.a;
				var list = localBool.b;
				return A2(
					transformers.stringIn,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, string),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
			case 'LocalStringNotIn':
				var string = localBool.a;
				var list = localBool.b;
				return A2(
					transformers.stringNotIn,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, string),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
			case 'LocalNot':
				var innerBool = localBool.a;
				return transformers.not(
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, innerBool));
			case 'LocalBoolIf':
				var cond = localBool.a;
				var then_ = localBool.b;
				var else_ = localBool.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, else_));
			case 'LocalPickBool':
				var innerList = localBool.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, innerList));
			case 'LocalAll':
				var innerList = localBool.a;
				return transformers.all(
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, innerList));
			case 'LocalAny':
				var innerList = localBool.a;
				return transformers.any(
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, innerList));
			case 'LocalIsNull':
				var field = localBool.a;
				return transformers.isNull(
					A2($author$project$DataElement$Expression$applyLocalField, transformers, field));
			default:
				var field = localBool.a;
				return transformers.isNotNull(
					A2($author$project$DataElement$Expression$applyLocalField, transformers, field));
		}
	});
var $author$project$DataElement$Expression$applyLocalBoolList = F2(
	function (transformers, localBoolList) {
		switch (localBoolList.$) {
			case 'RelatedBool':
				var relationship = localBoolList.a;
				var fieldName = localBoolList.b;
				return A2(transformers.relatedBool, relationship, fieldName);
			case 'LocalAllBoolsInField':
				var listRef = localBoolList.a;
				var fieldName = localBoolList.b;
				return A2(transformers.allBoolsInField, listRef, fieldName);
			case 'LocalBoolsAsList':
				var localBools = localBoolList.a;
				return transformers.boolsAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalBool(transformers),
						localBools));
			default:
				var cond = localBoolList.a;
				var then_ = localBoolList.b;
				var else_ = localBoolList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$BoolType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalBoolList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyLocalComparableList = F2(
	function (transformers, localCompList) {
		switch (localCompList.$) {
			case 'LocalCompStringListExpr':
				var localStringList = localCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, localStringList));
			case 'LocalCompNumberListExpr':
				var localNumberList = localCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, localNumberList));
			case 'LocalCompDateListExpr':
				var localDateList = localCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, localDateList));
			default:
				var localDateTimeList = localCompList.a;
				return _Utils_Tuple2(
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, localDateTimeList));
		}
	});
var $author$project$DataElement$Expression$applyLocalDate = F2(
	function (transformers, localDate) {
		switch (localDate.$) {
			case 'LocalDate':
				var fieldName = localDate.a;
				return transformers.localDate(fieldName);
			case 'LocalSingletonDate':
				var singletonRef = localDate.a;
				var fieldName = localDate.b;
				return A2(transformers.globalDateLookup, singletonRef, fieldName);
			case 'LocalDateHardcoded':
				var date = localDate.a;
				return transformers.hardcodedDate(date);
			case 'LocalDateTimeToDate':
				var dateTime = localDate.a;
				return transformers.dateTimeToDate(
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, dateTime));
			case 'LocalDateCeiling':
				var dateInterval = localDate.a;
				var innerDate = localDate.b;
				return A2(
					transformers.dateCeiling,
					dateInterval,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDateFloor':
				var dateInterval = localDate.a;
				var innerDate = localDate.b;
				return A2(
					transformers.dateFloor,
					dateInterval,
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDateAdd':
				var dateUnit = localDate.a;
				var innerNum = localDate.b;
				var innerDate = localDate.c;
				return A3(
					transformers.dateAdd,
					dateUnit,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, innerNum),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDateSubtract':
				var dateUnit = localDate.a;
				var innerNum = localDate.b;
				var innerDate = localDate.c;
				return A3(
					transformers.dateSubtract,
					dateUnit,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, innerNum),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDateIf':
				var cond = localDate.a;
				var then_ = localDate.b;
				var else_ = localDate.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, else_));
			case 'LocalPickDate':
				var innerList = localDate.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, innerList));
			case 'LocalMaxDate':
				var list = localDate.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, list));
			default:
				var list = localDate.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$DateComp,
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyLocalDateList = F2(
	function (transformers, localDateList) {
		switch (localDateList.$) {
			case 'RelatedDate':
				var relationship = localDateList.a;
				var fieldName = localDateList.b;
				return A2(transformers.relatedDate, relationship, fieldName);
			case 'LocalAllDatesInField':
				var listRef = localDateList.a;
				var fieldName = localDateList.b;
				return A2(transformers.allDatesInField, listRef, fieldName);
			case 'LocalDatesAsList':
				var localDates = localDateList.a;
				return transformers.datesAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalDate(transformers),
						localDates));
			default:
				var cond = localDateList.a;
				var then_ = localDateList.b;
				var else_ = localDateList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalDateList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyLocalDateTime = F2(
	function (transformers, localDateTime) {
		switch (localDateTime.$) {
			case 'LocalDateTime':
				var fieldName = localDateTime.a;
				return transformers.localDateTime(fieldName);
			case 'LocalSingletonDateTime':
				var singletonRef = localDateTime.a;
				var fieldName = localDateTime.b;
				return A2(transformers.globalDateTimeLookup, singletonRef, fieldName);
			case 'LocalDateTimeHardcoded':
				var posix = localDateTime.a;
				return transformers.hardcodedDateTime(posix);
			case 'LocalDateTimeIf':
				var cond = localDateTime.a;
				var then_ = localDateTime.b;
				var else_ = localDateTime.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, else_));
			case 'LocalPickDateTime':
				var innerList = localDateTime.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, innerList));
			case 'LocalMaxDateTime':
				var list = localDateTime.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, list));
			default:
				var list = localDateTime.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$DateTimeComp,
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyLocalDateTimeList = F2(
	function (transformers, localDateTimeList) {
		switch (localDateTimeList.$) {
			case 'RelatedDateTime':
				var relationship = localDateTimeList.a;
				var fieldName = localDateTimeList.b;
				return A2(transformers.relatedDateTime, relationship, fieldName);
			case 'LocalAllDateTimesInField':
				var listRef = localDateTimeList.a;
				var fieldName = localDateTimeList.b;
				return A2(transformers.allDateTimesInField, listRef, fieldName);
			case 'LocalDateTimesAsList':
				var localDateTimes = localDateTimeList.a;
				return transformers.dateTimesAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalDateTime(transformers),
						localDateTimes));
			default:
				var cond = localDateTimeList.a;
				var then_ = localDateTimeList.b;
				var else_ = localDateTimeList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$DateTimeType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalDateTimeList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyLocalField = F2(
	function (transformers, localField) {
		switch (localField.$) {
			case 'LocalStringExpr':
				var localString = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalString, transformers, localString);
			case 'LocalNumberExpr':
				var localNumber = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumber);
			case 'LocalDateExpr':
				var localDate = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalDate, transformers, localDate);
			case 'LocalDateTimeExpr':
				var localDateTime = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, localDateTime);
			default:
				var localBool = localField.a;
				return A2($author$project$DataElement$Expression$applyLocalBool, transformers, localBool);
		}
	});
var $author$project$DataElement$Expression$applyLocalNumber = F2(
	function (transformers, localNumber) {
		switch (localNumber.$) {
			case 'LocalNumber':
				var fieldName = localNumber.a;
				return transformers.localNumber(fieldName);
			case 'LocalSingletonNumber':
				var singletonRef = localNumber.a;
				var fieldName = localNumber.b;
				return A2(transformers.globalNumberLookup, singletonRef, fieldName);
			case 'LocalNumberHardcoded':
				var number = localNumber.a;
				return transformers.hardcodedNumber(number);
			case 'LocalCountUnique':
				var localComparableList = localNumber.a;
				return function (_v4) {
					var compType = _v4.a;
					var item = _v4.b;
					return A2(transformers.countUnique, compType, item);
				}(
					A2($author$project$DataElement$Expression$applyLocalComparableList, transformers, localComparableList));
			case 'LocalRound':
				var innerNumber = localNumber.a;
				return transformers.round(
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, innerNumber));
			case 'LocalSum':
				var localNumberList = localNumber.a;
				return transformers.sum(
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, localNumberList));
			case 'LocalProduct':
				var localNumberList = localNumber.a;
				return transformers.product(
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, localNumberList));
			case 'LocalAdd':
				var localNumA = localNumber.a;
				var localNumB = localNumber.b;
				return A2(
					transformers.add,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumB));
			case 'LocalSubtract':
				var localNumA = localNumber.a;
				var localNumB = localNumber.b;
				return A2(
					transformers.subtract,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumB));
			case 'LocalMultiply':
				var localNumA = localNumber.a;
				var localNumB = localNumber.b;
				return A2(
					transformers.multiply,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumB));
			case 'LocalDivide':
				var localNumA = localNumber.a;
				var localNumB = localNumber.b;
				return A2(
					transformers.divide,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumA),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumB));
			case 'LocalMonthNumber':
				var innerDate = localNumber.a;
				return transformers.monthNumber(
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalYearNumber':
				var innerDate = localNumber.a;
				return transformers.yearNumber(
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalDayInMonth':
				var innerDate = localNumber.a;
				return transformers.dayInMonth(
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalNumberIf':
				var cond = localNumber.a;
				var then_ = localNumber.b;
				var else_ = localNumber.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, else_));
			case 'LocalPickNumber':
				var innerList = localNumber.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, innerList));
			case 'LocalMaxNumber':
				var list = localNumber.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, list));
			default:
				var list = localNumber.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$NumberComp,
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyLocalNumberList = F2(
	function (transformers, localNumberList) {
		switch (localNumberList.$) {
			case 'RelatedNumber':
				var relationship = localNumberList.a;
				var fieldName = localNumberList.b;
				return A2(transformers.relatedNumber, relationship, fieldName);
			case 'LocalAllNumbersInField':
				var listRef = localNumberList.a;
				var fieldName = localNumberList.b;
				return A2(transformers.allNumbersInField, listRef, fieldName);
			case 'LocalNumbersAsList':
				var localNumbers = localNumberList.a;
				return transformers.numbersAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalNumber(transformers),
						localNumbers));
			default:
				var cond = localNumberList.a;
				var then_ = localNumberList.b;
				var else_ = localNumberList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$NumberType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalNumberList, transformers, else_));
		}
	});
var $author$project$DataElement$Expression$applyLocalString = F2(
	function (transformers, localString) {
		switch (localString.$) {
			case 'LocalString':
				var fieldName = localString.a;
				return transformers.localString(fieldName);
			case 'LocalSingletonString':
				var singletonRef = localString.a;
				var fieldName = localString.b;
				return A2(transformers.globalStringLookup, singletonRef, fieldName);
			case 'LocalStringHardcoded':
				var words = localString.a;
				return transformers.hardcodedString(words);
			case 'LocalFormatDate':
				var innerString = localString.a;
				var innerDate = localString.b;
				return A2(
					transformers.formatDate,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, innerString),
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalFormatDateLocaleAware':
				var innerDate = localString.a;
				return transformers.formatDateLocaleAware(
					A2($author$project$DataElement$Expression$applyLocalDate, transformers, innerDate));
			case 'LocalFormatDateTime':
				var innerDateTime = localString.a;
				return transformers.formatDateTime(
					A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, innerDateTime));
			case 'LocalFormatNumber':
				var decimals = localString.a;
				var innerNumber = localString.b;
				return A2(
					transformers.formatNumber,
					decimals,
					A2($author$project$DataElement$Expression$applyLocalNumber, transformers, innerNumber));
			case 'LocalStringIf':
				var cond = localString.a;
				var then_ = localString.b;
				var else_ = localString.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalString, transformers, else_));
			case 'LocalPickString':
				var innerList = localString.a;
				return A2(
					transformers.pickOne,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, innerList));
			case 'LocalConcat':
				var join = localString.a;
				var list = localString.b;
				return A2(
					transformers.concat,
					A2($author$project$DataElement$Expression$applyLocalString, transformers, join),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
			case 'LocalMaxString':
				var list = localString.a;
				return A2(
					transformers.max,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
			default:
				var list = localString.a;
				return A2(
					transformers.min,
					$author$project$ComparableType$StringComp,
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, list));
		}
	});
var $author$project$DataElement$Expression$applyLocalStringList = F2(
	function (transformers, localStringList) {
		switch (localStringList.$) {
			case 'RelatedString':
				var relationship = localStringList.a;
				var fieldName = localStringList.b;
				return A2(transformers.relatedString, relationship, fieldName);
			case 'LocalAllStringsInField':
				var listRef = localStringList.a;
				var fieldName = localStringList.b;
				return A2(transformers.allStringsInField, listRef, fieldName);
			case 'LocalStringsAsList':
				var localStrings = localStringList.a;
				return transformers.stringsAsList(
					A2(
						$elm$core$List$map,
						$author$project$DataElement$Expression$applyLocalString(transformers),
						localStrings));
			case 'LocalStringListIf':
				var cond = localStringList.a;
				var then_ = localStringList.b;
				var else_ = localStringList.c;
				return A4(
					transformers.if_,
					$author$project$FieldType$StringType,
					A2($author$project$DataElement$Expression$applyLocalBool, transformers, cond),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, then_),
					A2($author$project$DataElement$Expression$applyLocalStringList, transformers, else_));
			case 'LocalChallengeReasons':
				var acctId = localStringList.a;
				return transformers.challengeReasons(
					A2($author$project$DataElement$Expression$applyLocalString, transformers, acctId));
			default:
				var acctId = localStringList.a;
				return transformers.targetChallengeReasons(
					A2($author$project$DataElement$Expression$applyLocalString, transformers, acctId));
		}
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$ComparableType$toString = function (comp) {
	switch (comp.$) {
		case 'StringComp':
			return 'String';
		case 'NumberComp':
			return 'Number';
		case 'DateComp':
			return 'Date';
		default:
			return 'Date/Time';
	}
};
var $author$project$ComparableType$encode = function (fieldType) {
	return $elm$json$Json$Encode$string(
		$author$project$ComparableType$toString(fieldType));
};
var $author$project$FieldName$encode = function (_v0) {
	var name = _v0.a;
	return $elm$json$Json$Encode$string(name);
};
var $author$project$FieldType$toString = function (fieldType) {
	switch (fieldType.$) {
		case 'StringType':
			return 'string';
		case 'NumberType':
			return 'number';
		case 'DateType':
			return 'date';
		case 'DateTimeType':
			return 'datetime';
		default:
			return 'bool';
	}
};
var $author$project$FieldType$encode = function (fieldType) {
	return $elm$json$Json$Encode$string(
		$author$project$FieldType$toString(fieldType));
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(_Utils_Tuple0),
			pairs));
};
var $author$project$DataElement$Expression$encodeAddition = F2(
	function (innerValA, innerValB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Add Number')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$NumberType)),
					_Utils_Tuple2('expression1', innerValA),
					_Utils_Tuple2('expression2', innerValB)
				]));
	});
var $author$project$DataElement$Expression$encodeAll = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('All')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0.a;
	return internalString;
};
var $danyx23$elm_uuid$Uuid$encode = A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string);
var $author$project$DataElement$Reference$encoder = function (_v0) {
	var uuid = _v0.a;
	return $danyx23$elm_uuid$Uuid$encode(uuid);
};
var $author$project$DataElement$Expression$encodeAllValuesInField = F3(
	function (fieldType, listRef, fieldName) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Field in List')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2(
					'dataElement',
					$author$project$DataElement$Reference$encoder(listRef)),
					_Utils_Tuple2(
					'field',
					$author$project$FieldName$encode(fieldName))
				]));
	});
var $author$project$DataElement$Expression$encodeAny = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Any')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeChallengeReasons = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Challenge Reasons')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeCompare = F5(
	function (label, encodeInputType, inputType, innerA, innerB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(label)),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$BoolType)),
					_Utils_Tuple2('expression1', innerA),
					_Utils_Tuple2('expression2', innerB),
					_Utils_Tuple2(
					'inputDataType',
					encodeInputType(inputType))
				]));
	});
var $author$project$DataElement$Expression$encodeConcat = F2(
	function (joinVal, listVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Concat')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$StringType)),
					_Utils_Tuple2('joinExpression', joinVal),
					_Utils_Tuple2('listExpression', listVal)
				]));
	});
var $author$project$DataElement$Expression$encodeCountUnique = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Count Unique')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DateUnit$toString = function (interval) {
	switch (interval.$) {
		case 'Days':
			return 'Days';
		case 'Weeks':
			return 'Weeks';
		case 'Months':
			return 'Months';
		default:
			return 'Years';
	}
};
var $author$project$DateUnit$encode = function (interval) {
	return $elm$json$Json$Encode$string(
		$author$project$DateUnit$toString(interval));
};
var $author$project$DataElement$Expression$encodeDateAdd = F3(
	function (dateUnit, numVal, innerDateVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Date Addition')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$DateType)),
					_Utils_Tuple2('expression1', innerDateVal),
					_Utils_Tuple2('expression2', numVal),
					_Utils_Tuple2(
					'dateUnit',
					$author$project$DateUnit$encode(dateUnit))
				]));
	});
var $author$project$DateInterval$toString = function (interval) {
	switch (interval.$) {
		case 'Week':
			return 'Week';
		case 'Month':
			return 'Month';
		case 'Quarter':
			return 'Quarter';
		default:
			return 'Year';
	}
};
var $author$project$DateInterval$encode = function (interval) {
	return $elm$json$Json$Encode$string(
		$author$project$DateInterval$toString(interval));
};
var $author$project$DataElement$Expression$encodeDateCeiling = F2(
	function (interval, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Date Ceiling')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$DateType)),
					_Utils_Tuple2('expression', innerVal),
					_Utils_Tuple2(
					'dateInterval',
					$author$project$DateInterval$encode(interval))
				]));
	});
var $author$project$DataElement$Expression$encodeDateFloor = F2(
	function (interval, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Date Floor')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$DateType)),
					_Utils_Tuple2('expression', innerVal),
					_Utils_Tuple2(
					'dateInterval',
					$author$project$DateInterval$encode(interval))
				]));
	});
var $author$project$DataElement$Expression$encodeDateSubtract = F3(
	function (dateUnit, numVal, innerDateVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Date Subtraction')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$DateType)),
					_Utils_Tuple2('expression1', innerDateVal),
					_Utils_Tuple2('expression2', numVal),
					_Utils_Tuple2(
					'dateUnit',
					$author$project$DateUnit$encode(dateUnit))
				]));
	});
var $author$project$DataElement$Expression$encodeDateTimeToDate = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date/Time to Date')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateType)),
				_Utils_Tuple2('dateTimeExpression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeDayInMonth = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date Day in Month')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeDivision = F2(
	function (innerValA, innerValB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Divide Number')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$NumberType)),
					_Utils_Tuple2('expression1', innerValA),
					_Utils_Tuple2('expression2', innerValB)
				]));
	});
var $author$project$DataElement$Expression$encodeFormatDate = F2(
	function (stringVal, dateVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Format Date')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$StringType)),
					_Utils_Tuple2('dateExpression', dateVal),
					_Utils_Tuple2('formatExpression', stringVal)
				]));
	});
var $author$project$DataElement$Expression$encodeFormatDateLocaleAware = function (dateVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Format Date')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2('dateExpression', dateVal)
			]));
};
var $author$project$DataElement$Expression$encodeFormatDateTime = function (dateTimeVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Format Date/Time')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2('dateTimeExpression', dateTimeVal)
			]));
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$DataElement$Expression$encodeFormatNumber = F2(
	function (decimals, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Number to String')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$StringType)),
					_Utils_Tuple2('expression', innerVal),
					_Utils_Tuple2(
					'decimals',
					$elm$json$Json$Encode$int(decimals))
				]));
	});
var $author$project$DataElement$Expression$encodeGlobalLookup = F3(
	function (fieldType, singletonRef, fieldName) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Singleton Field')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2(
					'dataElement',
					$author$project$DataElement$Reference$encoder(singletonRef)),
					_Utils_Tuple2(
					'field',
					$author$project$FieldName$encode(fieldName))
				]));
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$DataElement$Expression$encodeHardcodedBool = function (bool) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$bool(bool))
			]));
};
var $elm$time$Time$Jan = {$: 'Jan'};
var $justinmimbs$date$Date$RD = function (a) {
	return {$: 'RD', a: a};
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$Apr = {$: 'Apr'};
var $elm$time$Time$Aug = {$: 'Aug'};
var $elm$time$Time$Dec = {$: 'Dec'};
var $elm$time$Time$Feb = {$: 'Feb'};
var $elm$time$Time$Jul = {$: 'Jul'};
var $elm$time$Time$Jun = {$: 'Jun'};
var $elm$time$Time$Mar = {$: 'Mar'};
var $elm$time$Time$May = {$: 'May'};
var $elm$time$Time$Nov = {$: 'Nov'};
var $elm$time$Time$Oct = {$: 'Oct'};
var $elm$time$Time$Sep = {$: 'Sep'};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Jan;
		case 2:
			return $elm$time$Time$Feb;
		case 3:
			return $elm$time$Time$Mar;
		case 4:
			return $elm$time$Time$Apr;
		case 5:
			return $elm$time$Time$May;
		case 6:
			return $elm$time$Time$Jun;
		case 7:
			return $elm$time$Time$Jul;
		case 8:
			return $elm$time$Time$Aug;
		case 9:
			return $elm$time$Time$Sep;
		case 10:
			return $elm$time$Time$Oct;
		case 11:
			return $elm$time$Time$Nov;
		default:
			return $elm$time$Time$Dec;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {day: d, month: m, year: y};
			}
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0.a;
	var y = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd));
	return {
		ordinalDay: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		year: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0.a;
	var date = $justinmimbs$date$Date$toOrdinalDate(
		$justinmimbs$date$Date$RD(rd));
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.year, $elm$time$Time$Jan, date.ordinalDay);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.day;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.month;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.ordinalDay;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(jan4));
};
var $elm$time$Time$Fri = {$: 'Fri'};
var $elm$time$Time$Mon = {$: 'Mon'};
var $elm$time$Time$Sat = {$: 'Sat'};
var $elm$time$Time$Sun = {$: 'Sun'};
var $elm$time$Time$Thu = {$: 'Thu'};
var $elm$time$Time$Tue = {$: 'Tue'};
var $elm$time$Time$Wed = {$: 'Wed'};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Mon;
		case 2:
			return $elm$time$Time$Tue;
		case 3:
			return $elm$time$Time$Wed;
		case 4:
			return $elm$time$Time$Thu;
		case 5:
			return $elm$time$Time$Fri;
		case 6:
			return $elm$time$Time$Sat;
		default:
			return $elm$time$Time$Sun;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0.a;
	var wdn = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(rd));
	var wy = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd + (4 - wdn)));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		weekNumber: 1 + (((rd - week1Day1) / 7) | 0),
		weekYear: wy,
		weekday: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekNumber;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekYear;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char.valueOf()) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.monthNameShort(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.monthName(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.monthNameShort(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.dayWithSuffix(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.weekdayName(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4(
							$justinmimbs$date$Date$formatField,
							language,
							_Utils_chr('E'),
							length,
							date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (token.$ === 'Field') {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 'Literal', a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 'Bad', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 'Good', a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parseA(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					var _v2 = callback(a);
					var parseB = _v2.a;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
					}
				}
			});
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0.a;
		var parseB = _v1.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v2 = parseA(s0);
				if (_v2.$ === 'Bad') {
					var p = _v2.a;
					var x = _v2.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v2.a;
					var a = _v2.b;
					var s1 = _v2.c;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3(
							$elm$parser$Parser$Advanced$Good,
							p1 || p2,
							A2(func, a, b),
							s2);
					}
				}
			});
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, false, a, s);
		});
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 'Expecting', a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 'Token', a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 'AddRight', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {col: col, contextStack: contextStack, problem: problem, row: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 'Empty'};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.row, s.col, x, s.context));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.offset, s.row, s.col, s.src);
			var newOffset = _v1.a;
			var newRow = _v1.b;
			var newCol = _v1.c;
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
				$elm$parser$Parser$Advanced$Good,
				progress,
				_Utils_Tuple0,
				{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
		});
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 'UnexpectedChar'};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.offset, s.src);
				return _Utils_eq(newOffset, -1) ? A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: 1, context: s.context, indent: s.indent, offset: s.offset + 1, row: s.row + 1, src: s.src}) : A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: s.col + 1, context: s.context, indent: s.indent, offset: newOffset, row: s.row, src: s.src}));
			});
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.src);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.offset, offset) < 0,
					_Utils_Tuple0,
					{col: col, context: s0.context, indent: s0.indent, offset: offset, row: row, src: s0.src});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.offset, s.row, s.col, s);
		});
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = $elm$parser$Parser$Advanced$Parser(
	function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, s.offset, s);
	});
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 'Problem', a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						A2(
							func,
							A3($elm$core$String$slice, s0.offset, s1.offset, s0.src),
							a),
						s1);
				}
			});
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 'Literal') && _v0.b.b) && (_v0.b.a.$ === 'Literal')) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v0 = thunk(_Utils_Tuple0);
			var parse = _v0.a;
			return parse(s);
		});
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (!_Utils_eq(
		_char,
		_Utils_chr('\''))) && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						func(a),
						s1);
				} else {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				}
			});
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 'Append', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
		});
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 'ExpectingEnd'};
var $elm$parser$Parser$Advanced$end = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return _Utils_eq(
				$elm$core$String$length(s.src),
				s.offset) ? A3($elm$parser$Parser$Advanced$Good, false, _Utils_Tuple0, s) : A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(_Utils_Tuple0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq(
									_Utils_chr('\'')))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq(
								_Utils_chr('\'')))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq(
				_Utils_chr('\'')))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq(
						_Utils_chr('\''))),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {col: col, problem: problem, row: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.row, p.col, p.problem);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 'Empty':
					return list;
				case 'AddRight':
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0.a;
		var _v1 = parse(
			{col: 1, context: _List_Nil, indent: 1, offset: 0, row: 1, src: src});
		if (_v1.$ === 'Good') {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (_v0.$ === 'Ok') {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (result.$ === 'Ok') {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	dayWithSuffix: $justinmimbs$date$Date$withOrdinalSuffix,
	monthName: $justinmimbs$date$Date$monthToName,
	monthNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	weekdayName: $justinmimbs$date$Date$weekdayToName,
	weekdayNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$DataElement$Expression$encodeHardcodedDate = function (date) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateType)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$string(
					$justinmimbs$date$Date$toIsoString(date)))
			]));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0.a;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.start, posixMinutes) < 0) {
					return posixMinutes + era.offset;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		month: month,
		year: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).day;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).month;
		switch (_v0) {
			case 1:
				return $elm$time$Time$Jan;
			case 2:
				return $elm$time$Time$Feb;
			case 3:
				return $elm$time$Time$Mar;
			case 4:
				return $elm$time$Time$Apr;
			case 5:
				return $elm$time$Time$May;
			case 6:
				return $elm$time$Time$Jun;
			case 7:
				return $elm$time$Time$Jul;
			case 8:
				return $elm$time$Time$Aug;
			case 9:
				return $elm$time$Time$Sep;
			case 10:
				return $elm$time$Time$Oct;
			case 11:
				return $elm$time$Time$Nov;
			default:
				return $elm$time$Time$Dec;
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			_Utils_chr('0'),
			$elm$core$String$fromInt(time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).year;
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 'Zone', a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$encode = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string);
var $author$project$DataElement$Expression$encodeHardcodedDateTime = function (posix) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateTimeType)),
				_Utils_Tuple2(
				'value',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(posix))
			]));
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$DataElement$Expression$encodeHardcodedNumber = function (number) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$float(number))
			]));
};
var $author$project$DataElement$Expression$encodeHardcodedString = function (words) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Static')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$string(words))
			]));
};
var $author$project$DataElement$Expression$encodeIf = F4(
	function (fieldType, condVal, thenVal, elseVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('If')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2('ifExpression', condVal),
					_Utils_Tuple2('thenExpression', thenVal),
					_Utils_Tuple2('elseExpression', elseVal)
				]));
	});
var $author$project$DataElement$Expression$encodeIsNotNull = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Is Not Null')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeIsNull = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Is Null')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $author$project$DataElement$Expression$encodeListOfExpressions = F2(
	function (fieldType, values) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('List of Expressions')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2(
					'expressions',
					A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, values))
				]));
	});
var $author$project$DataElement$Expression$encodeLocalBoolField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeLocalDateField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeLocalDateTimeField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$DateTimeType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeLocalNumberField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeLocalStringField = function (fieldName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Local Field')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2(
				'field',
				$author$project$FieldName$encode(fieldName))
			]));
};
var $author$project$DataElement$Expression$encodeMax = F2(
	function (compType, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Max')),
					_Utils_Tuple2(
					'dataType',
					$author$project$ComparableType$encode(compType)),
					_Utils_Tuple2('expression', innerVal)
				]));
	});
var $author$project$DataElement$Expression$encodeMin = F2(
	function (compType, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Min')),
					_Utils_Tuple2(
					'dataType',
					$author$project$ComparableType$encode(compType)),
					_Utils_Tuple2('expression', innerVal)
				]));
	});
var $author$project$DataElement$Expression$encodeMonthNumber = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date Month')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeMultiplication = F2(
	function (innerValA, innerValB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Multiply Number')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$NumberType)),
					_Utils_Tuple2('expression1', innerValA),
					_Utils_Tuple2('expression2', innerValB)
				]));
	});
var $author$project$DataElement$Expression$encodeNot = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Not')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$BoolType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodePickOne = F2(
	function (fieldType, innerVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Pick One')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2('expression', innerVal)
				]));
	});
var $author$project$DataElement$Expression$encodeProduct = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Product')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeRound = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Round Number')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeStringIn = F2(
	function (stringVal, listVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('In')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$BoolType)),
					_Utils_Tuple2('expression1', stringVal),
					_Utils_Tuple2('expression2', listVal)
				]));
	});
var $author$project$DataElement$Expression$encodeStringNotIn = F2(
	function (stringVal, listVal) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Not In')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$BoolType)),
					_Utils_Tuple2('expression1', stringVal),
					_Utils_Tuple2('expression2', listVal)
				]));
	});
var $author$project$DataElement$Expression$encodeSubtraction = F2(
	function (innerValA, innerValB) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Subtract Number')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode($author$project$FieldType$NumberType)),
					_Utils_Tuple2('expression1', innerValA),
					_Utils_Tuple2('expression2', innerValB)
				]));
	});
var $author$project$DataElement$Expression$encodeSum = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Sum')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeTargetChallengeReasons = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Target Challenge Reasons')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$StringType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $author$project$DataElement$Expression$encodeYearNumber = function (innerVal) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date Year')),
				_Utils_Tuple2(
				'dataType',
				$author$project$FieldType$encode($author$project$FieldType$NumberType)),
				_Utils_Tuple2('expression', innerVal)
			]));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$DataElement$Expression$encodeRelatedField = F3(
	function (fieldType, relationship, fieldName) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Related Field')),
					_Utils_Tuple2(
					'dataType',
					$author$project$FieldType$encode(fieldType)),
					_Utils_Tuple2(
					'relationship',
					$author$project$DataElement$Expression$encodeRelationship(relationship)),
					_Utils_Tuple2(
					'field',
					$author$project$FieldName$encode(fieldName))
				]));
	});
var $author$project$DataElement$Expression$encodeRelationship = function (_v0) {
	var localIds = _v0.localIds;
	var nextElement = _v0.nextElement;
	var idToMatch = _v0.idToMatch;
	var optionalFilter = _v0.optionalFilter;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nextElement',
				$author$project$DataElement$Reference$encoder(nextElement)),
				_Utils_Tuple2(
				'idToMatch',
				A2(
					$author$project$DataElement$Expression$applyLocalString,
					$author$project$DataElement$Expression$cyclic$encodeTransformer(),
					idToMatch)),
				_Utils_Tuple2(
				'localIds',
				A2(
					$author$project$DataElement$Expression$applyLocalStringList,
					$author$project$DataElement$Expression$cyclic$encodeTransformer(),
					localIds)),
				_Utils_Tuple2(
				'filterBy',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						$author$project$DataElement$Expression$applyLocalBool(
							$author$project$DataElement$Expression$cyclic$encodeTransformer()),
						optionalFilter)))
			]));
};
function $author$project$DataElement$Expression$cyclic$encodeTransformer() {
	return {
		add: $author$project$DataElement$Expression$encodeAddition,
		all: $author$project$DataElement$Expression$encodeAll,
		allBoolsInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$BoolType),
		allDateTimesInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$DateTimeType),
		allDatesInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$DateType),
		allNumbersInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$NumberType),
		allStringsInField: $author$project$DataElement$Expression$encodeAllValuesInField($author$project$FieldType$StringType),
		any: $author$project$DataElement$Expression$encodeAny,
		boolsAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$BoolType),
		challengeReasons: $author$project$DataElement$Expression$encodeChallengeReasons,
		comparableEqual: A2($author$project$DataElement$Expression$encodeCompare, 'Equal', $author$project$ComparableType$encode),
		comparableNotEqual: A2($author$project$DataElement$Expression$encodeCompare, 'Not Equal', $author$project$ComparableType$encode),
		concat: $author$project$DataElement$Expression$encodeConcat,
		countUnique: $elm$core$Basics$always($author$project$DataElement$Expression$encodeCountUnique),
		dateAdd: $author$project$DataElement$Expression$encodeDateAdd,
		dateCeiling: $author$project$DataElement$Expression$encodeDateCeiling,
		dateFloor: $author$project$DataElement$Expression$encodeDateFloor,
		dateSubtract: $author$project$DataElement$Expression$encodeDateSubtract,
		dateTimeToDate: $author$project$DataElement$Expression$encodeDateTimeToDate,
		dateTimesAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$DateTimeType),
		datesAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$DateType),
		dayInMonth: $author$project$DataElement$Expression$encodeDayInMonth,
		divide: $author$project$DataElement$Expression$encodeDivision,
		equal: A2($author$project$DataElement$Expression$encodeCompare, 'Equal', $author$project$FieldType$encode),
		formatDate: $author$project$DataElement$Expression$encodeFormatDate,
		formatDateLocaleAware: $author$project$DataElement$Expression$encodeFormatDateLocaleAware,
		formatDateTime: $author$project$DataElement$Expression$encodeFormatDateTime,
		formatNumber: $author$project$DataElement$Expression$encodeFormatNumber,
		globalBoolLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$BoolType),
		globalDateLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$DateType),
		globalDateTimeLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$DateTimeType),
		globalNumberLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$NumberType),
		globalStringLookup: $author$project$DataElement$Expression$encodeGlobalLookup($author$project$FieldType$StringType),
		greaterThan: A2($author$project$DataElement$Expression$encodeCompare, 'GT', $author$project$ComparableType$encode),
		greaterThanOrEqual: A2($author$project$DataElement$Expression$encodeCompare, 'GTE', $author$project$ComparableType$encode),
		hardcodedBool: $author$project$DataElement$Expression$encodeHardcodedBool,
		hardcodedDate: $author$project$DataElement$Expression$encodeHardcodedDate,
		hardcodedDateTime: $author$project$DataElement$Expression$encodeHardcodedDateTime,
		hardcodedNumber: $author$project$DataElement$Expression$encodeHardcodedNumber,
		hardcodedString: $author$project$DataElement$Expression$encodeHardcodedString,
		if_: $author$project$DataElement$Expression$encodeIf,
		isNotNull: $author$project$DataElement$Expression$encodeIsNotNull,
		isNull: $author$project$DataElement$Expression$encodeIsNull,
		lessThan: A2($author$project$DataElement$Expression$encodeCompare, 'LT', $author$project$ComparableType$encode),
		lessThanOrEqual: A2($author$project$DataElement$Expression$encodeCompare, 'LTE', $author$project$ComparableType$encode),
		localBool: $author$project$DataElement$Expression$encodeLocalBoolField,
		localDate: $author$project$DataElement$Expression$encodeLocalDateField,
		localDateTime: $author$project$DataElement$Expression$encodeLocalDateTimeField,
		localNumber: $author$project$DataElement$Expression$encodeLocalNumberField,
		localString: $author$project$DataElement$Expression$encodeLocalStringField,
		max: $author$project$DataElement$Expression$encodeMax,
		min: $author$project$DataElement$Expression$encodeMin,
		monthNumber: $author$project$DataElement$Expression$encodeMonthNumber,
		multiply: $author$project$DataElement$Expression$encodeMultiplication,
		not: $author$project$DataElement$Expression$encodeNot,
		notEqual: A2($author$project$DataElement$Expression$encodeCompare, 'Not Equal', $author$project$FieldType$encode),
		numbersAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$NumberType),
		pickOne: $author$project$DataElement$Expression$encodePickOne,
		product: $author$project$DataElement$Expression$encodeProduct,
		relatedBool: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$BoolType),
		relatedDate: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$DateType),
		relatedDateTime: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$DateTimeType),
		relatedNumber: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$NumberType),
		relatedString: $author$project$DataElement$Expression$encodeRelatedField($author$project$FieldType$StringType),
		round: $author$project$DataElement$Expression$encodeRound,
		stringIn: $author$project$DataElement$Expression$encodeStringIn,
		stringNotIn: $author$project$DataElement$Expression$encodeStringNotIn,
		stringsAsList: $author$project$DataElement$Expression$encodeListOfExpressions($author$project$FieldType$StringType),
		subtract: $author$project$DataElement$Expression$encodeSubtraction,
		sum: $author$project$DataElement$Expression$encodeSum,
		targetChallengeReasons: $author$project$DataElement$Expression$encodeTargetChallengeReasons,
		yearNumber: $author$project$DataElement$Expression$encodeYearNumber
	};
}
try {
	var $author$project$DataElement$Expression$encodeTransformer = $author$project$DataElement$Expression$cyclic$encodeTransformer();
	$author$project$DataElement$Expression$cyclic$encodeTransformer = function () {
		return $author$project$DataElement$Expression$encodeTransformer;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    encodeTransformer\n  │     ↓\n  │    encodeRelatedField\n  │     ↓\n  │    encodeRelationship\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$Expression$GlobalAdd = F2(
	function (a, b) {
		return {$: 'GlobalAdd', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAll = function (a) {
	return {$: 'GlobalAll', a: a};
};
var $author$project$DataElement$Expression$GlobalAllBoolsInField = F2(
	function (a, b) {
		return {$: 'GlobalAllBoolsInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAllDateTimesInField = F2(
	function (a, b) {
		return {$: 'GlobalAllDateTimesInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAllDatesInField = F2(
	function (a, b) {
		return {$: 'GlobalAllDatesInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAllNumbersInField = F2(
	function (a, b) {
		return {$: 'GlobalAllNumbersInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAllStringsInField = F2(
	function (a, b) {
		return {$: 'GlobalAllStringsInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalAny = function (a) {
	return {$: 'GlobalAny', a: a};
};
var $author$project$DataElement$Expression$GlobalBoolExpr = function (a) {
	return {$: 'GlobalBoolExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalBoolHardcoded = function (a) {
	return {$: 'GlobalBoolHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalBoolIf = F3(
	function (a, b, c) {
		return {$: 'GlobalBoolIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalBoolListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalBoolListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalBoolLookup = F2(
	function (a, b) {
		return {$: 'GlobalBoolLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalBoolsAsList = function (a) {
	return {$: 'GlobalBoolsAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalChallengeReasons = function (a) {
	return {$: 'GlobalChallengeReasons', a: a};
};
var $author$project$DataElement$Expression$GlobalCompDateListExpr = function (a) {
	return {$: 'GlobalCompDateListExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompDateTimeListExpr = function (a) {
	return {$: 'GlobalCompDateTimeListExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompNumberListExpr = function (a) {
	return {$: 'GlobalCompNumberListExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompStringListExpr = function (a) {
	return {$: 'GlobalCompStringListExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalConcat = F2(
	function (a, b) {
		return {$: 'GlobalConcat', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalCountUnique = function (a) {
	return {$: 'GlobalCountUnique', a: a};
};
var $author$project$DataElement$Expression$GlobalDateAdd = F3(
	function (a, b, c) {
		return {$: 'GlobalDateAdd', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateCeiling = F2(
	function (a, b) {
		return {$: 'GlobalDateCeiling', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalDateExpr = function (a) {
	return {$: 'GlobalDateExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalDateFloor = F2(
	function (a, b) {
		return {$: 'GlobalDateFloor', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalDateHardcoded = function (a) {
	return {$: 'GlobalDateHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalDateIf = F3(
	function (a, b, c) {
		return {$: 'GlobalDateIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalDateListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateLookup = F2(
	function (a, b) {
		return {$: 'GlobalDateLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalDateSubtract = F3(
	function (a, b, c) {
		return {$: 'GlobalDateSubtract', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateTimeExpr = function (a) {
	return {$: 'GlobalDateTimeExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalDateTimeHardcoded = function (a) {
	return {$: 'GlobalDateTimeHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalDateTimeIf = F3(
	function (a, b, c) {
		return {$: 'GlobalDateTimeIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateTimeListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalDateTimeListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalDateTimeLookup = F2(
	function (a, b) {
		return {$: 'GlobalDateTimeLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalDateTimeToDate = function (a) {
	return {$: 'GlobalDateTimeToDate', a: a};
};
var $author$project$DataElement$Expression$GlobalDateTimesAsList = function (a) {
	return {$: 'GlobalDateTimesAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalDatesAsList = function (a) {
	return {$: 'GlobalDatesAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalDayInMonth = function (a) {
	return {$: 'GlobalDayInMonth', a: a};
};
var $author$project$DataElement$Expression$GlobalDivide = F2(
	function (a, b) {
		return {$: 'GlobalDivide', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualBool = F2(
	function (a, b) {
		return {$: 'GlobalEqualBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualDate = F2(
	function (a, b) {
		return {$: 'GlobalEqualDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualDateTime = F2(
	function (a, b) {
		return {$: 'GlobalEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualNumber = F2(
	function (a, b) {
		return {$: 'GlobalEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalEqualString = F2(
	function (a, b) {
		return {$: 'GlobalEqualString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalFormatDate = F2(
	function (a, b) {
		return {$: 'GlobalFormatDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalFormatDateLocaleAware = function (a) {
	return {$: 'GlobalFormatDateLocaleAware', a: a};
};
var $author$project$DataElement$Expression$GlobalFormatDateTime = function (a) {
	return {$: 'GlobalFormatDateTime', a: a};
};
var $author$project$DataElement$Expression$GlobalFormatNumber = F2(
	function (a, b) {
		return {$: 'GlobalFormatNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTDate = F2(
	function (a, b) {
		return {$: 'GlobalGTDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTDateTime = F2(
	function (a, b) {
		return {$: 'GlobalGTDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTEDate = F2(
	function (a, b) {
		return {$: 'GlobalGTEDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTEDateTime = F2(
	function (a, b) {
		return {$: 'GlobalGTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTENumber = F2(
	function (a, b) {
		return {$: 'GlobalGTENumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTEString = F2(
	function (a, b) {
		return {$: 'GlobalGTEString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTNumber = F2(
	function (a, b) {
		return {$: 'GlobalGTNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalGTString = F2(
	function (a, b) {
		return {$: 'GlobalGTString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalIsNotNull = function (a) {
	return {$: 'GlobalIsNotNull', a: a};
};
var $author$project$DataElement$Expression$GlobalIsNull = function (a) {
	return {$: 'GlobalIsNull', a: a};
};
var $author$project$DataElement$Expression$GlobalLTDate = F2(
	function (a, b) {
		return {$: 'GlobalLTDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTDateTime = F2(
	function (a, b) {
		return {$: 'GlobalLTDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTEDate = F2(
	function (a, b) {
		return {$: 'GlobalLTEDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTEDateTime = F2(
	function (a, b) {
		return {$: 'GlobalLTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTENumber = F2(
	function (a, b) {
		return {$: 'GlobalLTENumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTEString = F2(
	function (a, b) {
		return {$: 'GlobalLTEString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTNumber = F2(
	function (a, b) {
		return {$: 'GlobalLTNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalLTString = F2(
	function (a, b) {
		return {$: 'GlobalLTString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalMaxDate = function (a) {
	return {$: 'GlobalMaxDate', a: a};
};
var $author$project$DataElement$Expression$GlobalMaxDateTime = function (a) {
	return {$: 'GlobalMaxDateTime', a: a};
};
var $author$project$DataElement$Expression$GlobalMaxNumber = function (a) {
	return {$: 'GlobalMaxNumber', a: a};
};
var $author$project$DataElement$Expression$GlobalMaxString = function (a) {
	return {$: 'GlobalMaxString', a: a};
};
var $author$project$DataElement$Expression$GlobalMinDate = function (a) {
	return {$: 'GlobalMinDate', a: a};
};
var $author$project$DataElement$Expression$GlobalMinDateTime = function (a) {
	return {$: 'GlobalMinDateTime', a: a};
};
var $author$project$DataElement$Expression$GlobalMinNumber = function (a) {
	return {$: 'GlobalMinNumber', a: a};
};
var $author$project$DataElement$Expression$GlobalMinString = function (a) {
	return {$: 'GlobalMinString', a: a};
};
var $author$project$DataElement$Expression$GlobalMonthNumber = function (a) {
	return {$: 'GlobalMonthNumber', a: a};
};
var $author$project$DataElement$Expression$GlobalMultiply = F2(
	function (a, b) {
		return {$: 'GlobalMultiply', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNot = function (a) {
	return {$: 'GlobalNot', a: a};
};
var $author$project$DataElement$Expression$GlobalNotEqualBool = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNotEqualDate = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNotEqualDateTime = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNotEqualNumber = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNotEqualString = F2(
	function (a, b) {
		return {$: 'GlobalNotEqualString', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNumberExpr = function (a) {
	return {$: 'GlobalNumberExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalNumberHardcoded = function (a) {
	return {$: 'GlobalNumberHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalNumberIf = F3(
	function (a, b, c) {
		return {$: 'GlobalNumberIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalNumberListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalNumberListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalNumberLookup = F2(
	function (a, b) {
		return {$: 'GlobalNumberLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalNumbersAsList = function (a) {
	return {$: 'GlobalNumbersAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalPickBool = function (a) {
	return {$: 'GlobalPickBool', a: a};
};
var $author$project$DataElement$Expression$GlobalPickDate = function (a) {
	return {$: 'GlobalPickDate', a: a};
};
var $author$project$DataElement$Expression$GlobalPickDateTime = function (a) {
	return {$: 'GlobalPickDateTime', a: a};
};
var $author$project$DataElement$Expression$GlobalPickNumber = function (a) {
	return {$: 'GlobalPickNumber', a: a};
};
var $author$project$DataElement$Expression$GlobalPickString = function (a) {
	return {$: 'GlobalPickString', a: a};
};
var $author$project$DataElement$Expression$GlobalProduct = function (a) {
	return {$: 'GlobalProduct', a: a};
};
var $author$project$DataElement$Expression$GlobalRound = function (a) {
	return {$: 'GlobalRound', a: a};
};
var $author$project$DataElement$Expression$GlobalStringExpr = function (a) {
	return {$: 'GlobalStringExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalStringHardcoded = function (a) {
	return {$: 'GlobalStringHardcoded', a: a};
};
var $author$project$DataElement$Expression$GlobalStringIf = F3(
	function (a, b, c) {
		return {$: 'GlobalStringIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalStringIn = F2(
	function (a, b) {
		return {$: 'GlobalStringIn', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalStringListIf = F3(
	function (a, b, c) {
		return {$: 'GlobalStringListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$GlobalStringLookup = F2(
	function (a, b) {
		return {$: 'GlobalStringLookup', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalStringNotIn = F2(
	function (a, b) {
		return {$: 'GlobalStringNotIn', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalStringsAsList = function (a) {
	return {$: 'GlobalStringsAsList', a: a};
};
var $author$project$DataElement$Expression$GlobalSubtract = F2(
	function (a, b) {
		return {$: 'GlobalSubtract', a: a, b: b};
	});
var $author$project$DataElement$Expression$GlobalSum = function (a) {
	return {$: 'GlobalSum', a: a};
};
var $author$project$DataElement$Expression$GlobalTargetChallengeReasons = function (a) {
	return {$: 'GlobalTargetChallengeReasons', a: a};
};
var $author$project$DataElement$Expression$GlobalYearNumber = function (a) {
	return {$: 'GlobalYearNumber', a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$combineHelp = F2(
	function (list, acc) {
		combineHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				if (head.$ === 'Just') {
					var a = head.a;
					var $temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					list = $temp$list;
					acc = $temp$acc;
					continue combineHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = function (list) {
	return A2($elm_community$maybe_extra$Maybe$Extra$combineHelp, list, _List_Nil);
};
var $Kurren123$k_dropdown_container$DropdownContainer$Closed = {$: 'Closed'};
var $Kurren123$k_dropdown_container$DropdownContainer$State = function (a) {
	return {$: 'State', a: a};
};
var $Kurren123$k_dropdown_container$DropdownContainer$initialState = $Kurren123$k_dropdown_container$DropdownContainer$State(false);
var $author$project$Input$emptyState = {dropdownState: $Kurren123$k_dropdown_container$DropdownContainer$initialState, open: $Kurren123$k_dropdown_container$DropdownContainer$Closed, text: ''};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 'Nothing') {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Input$toMaybe = function (inputA) {
	if (inputA.$ === 'Unselected') {
		return $elm$core$Maybe$Nothing;
	} else {
		var a = inputA.a;
		return $elm$core$Maybe$Just(a);
	}
};
var $author$project$IntInput$toMaybe = function (intInput) {
	switch (intInput.$) {
		case 'Empty':
			return $elm$core$Maybe$Nothing;
		case 'Dash':
			return $elm$core$Maybe$Nothing;
		default:
			var x = intInput.a;
			return $elm$core$Maybe$Just(x);
	}
};
var $elm_community$list_extra$List$Extra$unconsLast = function (list) {
	var _v0 = $elm$core$List$reverse(list);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var last_ = _v0.a;
		var rest = _v0.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				last_,
				$elm$core$List$reverse(rest)));
	}
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (maybeValue.$ === 'Just') {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$DataElement$ProtoElement$Parse$wrap = F2(
	function (innerFun, inputA) {
		return A2(
			$elm$core$Maybe$andThen,
			innerFun,
			$author$project$Input$toMaybe(inputA));
	});
var $author$project$DataElement$ProtoElement$Parse$globalBoolHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalBoolLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$GlobalBoolLookup, ref, fieldName));
		case 'ProtoGlobalBoolHardcoded':
			var words = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$GlobalBoolHardcoded(words));
		case 'ProtoGlobalGTString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalGTString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringBInput));
		case 'ProtoGlobalGTNumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalGTNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberBInput));
		case 'ProtoGlobalGTDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalGTDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateB));
		case 'ProtoGlobalGTDateTime':
			var dateTimeA = proto.a;
			var dateTimeB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalGTDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateTimeA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateTimeB));
		case 'ProtoGlobalGTComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalGTEString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalGTEString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringBInput));
		case 'ProtoGlobalGTENumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalGTENumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberBInput));
		case 'ProtoGlobalGTEDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalGTEDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateB));
		case 'ProtoGlobalGTEDateTime':
			var dateTimeA = proto.a;
			var dateTimeB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalGTEDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateTimeA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateTimeB));
		case 'ProtoGlobalGTEComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalLTString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalLTString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringBInput));
		case 'ProtoGlobalLTNumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalLTNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberBInput));
		case 'ProtoGlobalLTDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalLTDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateB));
		case 'ProtoGlobalLTDateTime':
			var dateTimeA = proto.a;
			var dateTimeB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalLTDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateTimeA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateTimeB));
		case 'ProtoGlobalLTComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalLTEString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalLTEString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringBInput));
		case 'ProtoGlobalLTENumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalLTENumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberBInput));
		case 'ProtoGlobalLTEDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalLTEDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateB));
		case 'ProtoGlobalLTEDateTime':
			var dateTimeA = proto.a;
			var dateTimeB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalLTEDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateTimeA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateTimeB));
		case 'ProtoGlobalLTEComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalEqualString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalEqualString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringBInput));
		case 'ProtoGlobalEqualNumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalEqualNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberBInput));
		case 'ProtoGlobalEqualDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalEqualDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateB));
		case 'ProtoGlobalEqualDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalEqualDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateB));
		case 'ProtoGlobalEqualBool':
			var boolA = proto.a;
			var boolB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalEqualBool,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(boolA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(boolB));
		case 'ProtoGlobalEqualComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalEqualAny':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalNotEqualString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalNotEqualString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringBInput));
		case 'ProtoGlobalNotEqualNumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalNotEqualNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberBInput));
		case 'ProtoGlobalNotEqualDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalNotEqualDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateB));
		case 'ProtoGlobalNotEqualDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalNotEqualDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateB));
		case 'ProtoGlobalNotEqualBool':
			var boolA = proto.a;
			var boolB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalNotEqualBool,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(boolA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(boolB));
		case 'ProtoGlobalNotEqualComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalNotEqualAny':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalStringIn':
			var stringInput = proto.a;
			var stringListInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalStringIn,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList()(stringListInput));
		case 'ProtoGlobalStringNotIn':
			var stringInput = proto.a;
			var stringListInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalStringNotIn,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList()(stringListInput));
		case 'ProtoGlobalNot':
			var boolInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalNot,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(boolInput));
		case 'ProtoGlobalBoolIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalBoolIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(elseInput));
		case 'ProtoGlobalPickBool':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalPickBool,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBoolList()(listInput));
		case 'ProtoGlobalAll':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalAll,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBoolList()(listInput));
		case 'ProtoGlobalAny':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalAny,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBoolList()(listInput));
		case 'ProtoGlobalIsNull':
			var field = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalIsNull,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalField()(field));
		default:
			var field = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalIsNotNull,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalField()(field));
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalBoolListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalBoolListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalBoolListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBoolList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBoolList()(elseInput));
		case 'ProtoGlobalBoolsAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v20 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v20.$ === 'Just') && (_v20.a.a.$ === 'Unselected')) {
				var _v21 = _v20.a;
				var inputState = _v21.a.a;
				var restOfList = _v21.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$GlobalBoolsAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalAllBoolsInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalComparableListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalCompStringList':
			var stringList = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalCompStringListExpr,
				$author$project$DataElement$ProtoElement$Parse$globalStringListHelper(stringList));
		case 'ProtoGlobalCompNumberList':
			var numberList = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalCompNumberListExpr,
				$author$project$DataElement$ProtoElement$Parse$globalNumberListHelper(numberList));
		case 'ProtoGlobalCompDateList':
			var dateList = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalCompDateListExpr,
				$author$project$DataElement$ProtoElement$Parse$globalDateListHelper(dateList));
		case 'ProtoGlobalCompFieldList':
			return $elm$core$Maybe$Nothing;
		default:
			var dateTimeList = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalCompDateTimeListExpr,
				$author$project$DataElement$ProtoElement$Parse$globalDateTimeListHelper(dateTimeList));
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalDateHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$GlobalDateLookup, ref, fieldName));
		case 'ProtoGlobalDateHardcoded':
			var date = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$GlobalDateHardcoded(date));
		case 'ProtoGlobalDateTimeToDate':
			var dateTime = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalDateTimeToDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(dateTime));
		case 'ProtoGlobalDateCeiling':
			var dateInterval = proto.a;
			var date = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalDateCeiling,
				$author$project$Input$toMaybe(dateInterval),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(date));
		case 'ProtoGlobalDateFloor':
			var dateInterval = proto.a;
			var date = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalDateFloor,
				$author$project$Input$toMaybe(dateInterval),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(date));
		case 'ProtoGlobalDateAdd':
			var dateUnit = proto.a;
			var number = proto.b;
			var date = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalDateAdd,
				$author$project$Input$toMaybe(dateUnit),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(number),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(date));
		case 'ProtoGlobalDateSubtract':
			var dateUnit = proto.a;
			var number = proto.b;
			var date = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalDateSubtract,
				$author$project$Input$toMaybe(dateUnit),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(number),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(date));
		case 'ProtoGlobalDateIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalDateIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(elseInput));
		case 'ProtoGlobalPickDate':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalPickDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateList()(listInput));
		case 'ProtoGlobalMaxDate':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalMaxDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateList()(listInput));
		default:
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalMinDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateList()(listInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalDateListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalDateListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateList()(elseInput));
		case 'ProtoGlobalDatesAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v15 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v15.$ === 'Just') && (_v15.a.a.$ === 'Unselected')) {
				var _v16 = _v15.a;
				var inputState = _v16.a.a;
				var restOfList = _v16.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$GlobalDatesAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalAllDatesInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalDateTimeHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateTimeLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$GlobalDateTimeLookup, ref, fieldName));
		case 'ProtoGlobalDateTimeHardcoded':
			var date = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$GlobalDateTimeHardcoded(date));
		case 'ProtoGlobalDateTimeIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalDateTimeIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(elseInput));
		case 'ProtoGlobalPickDateTime':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalPickDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTimeList()(listInput));
		case 'ProtoGlobalMaxDateTime':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalMaxDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTimeList()(listInput));
		default:
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalMinDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTimeList()(listInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalDateTimeListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateTimeListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalDateTimeListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTimeList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTimeList()(elseInput));
		case 'ProtoGlobalAllDateTimesInField':
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalAllDateTimesInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
		default:
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v11 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v11.$ === 'Just') && (_v11.a.a.$ === 'Unselected')) {
				var _v12 = _v11.a;
				var inputState = _v12.a.a;
				var restOfList = _v12.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$GlobalDateTimesAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalFieldHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringField':
			var stringProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalStringExpr,
				$author$project$DataElement$ProtoElement$Parse$globalStringHelper(stringProto));
		case 'ProtoGlobalNumberField':
			var numberProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalNumberExpr,
				$author$project$DataElement$ProtoElement$Parse$globalNumberHelper(numberProto));
		case 'ProtoGlobalDateField':
			var dateProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalDateExpr,
				$author$project$DataElement$ProtoElement$Parse$globalDateHelper(dateProto));
		case 'ProtoGlobalDateTimeField':
			var dateTimeProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalDateTimeExpr,
				$author$project$DataElement$ProtoElement$Parse$globalDateTimeHelper(dateTimeProto));
		case 'ProtoGlobalBoolField':
			var boolProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalBoolExpr,
				$author$project$DataElement$ProtoElement$Parse$globalBoolHelper(boolProto));
		case 'ProtoGlobalAnyField':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalNumberHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalNumberLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$GlobalNumberLookup, ref, fieldName));
		case 'ProtoGlobalNumberHardcoded':
			var words = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$GlobalNumberHardcoded(words));
		case 'ProtoGlobalRoundNumber':
			var numberInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalRound,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberInput));
		case 'ProtoGlobalSum':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalSum,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList()(listInput));
		case 'ProtoGlobalProduct':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalProduct,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList()(listInput));
		case 'ProtoGlobalAdd':
			var numberA = proto.a;
			var numberB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalAdd,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberB));
		case 'ProtoGlobalSubtract':
			var numberA = proto.a;
			var numberB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalSubtract,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberB));
		case 'ProtoGlobalMultiply':
			var numberA = proto.a;
			var numberB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalMultiply,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberB));
		case 'ProtoGlobalDivide':
			var numberA = proto.a;
			var numberB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalDivide,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberB));
		case 'ProtoGlobalMonthNumber':
			var dateInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalMonthNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateInput));
		case 'ProtoGlobalYearNumber':
			var dateInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalYearNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateInput));
		case 'ProtoGlobalDayInMonth':
			var dateInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalDayInMonth,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateInput));
		case 'ProtoGlobalNumberIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalNumberIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(elseInput));
		case 'ProtoGlobalPickNumber':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalPickNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList()(listInput));
		case 'ProtoGlobalMaxNumber':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalMaxNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList()(listInput));
		case 'ProtoGlobalMinNumber':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalMinNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList()(listInput));
		default:
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalCountUnique,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalComparableList()(listInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalNumberListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalNumberListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalNumberListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList()(elseInput));
		case 'ProtoGlobalNumbersAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v6 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v6.$ === 'Just') && (_v6.a.a.$ === 'Unselected')) {
				var _v7 = _v6.a;
				var inputState = _v7.a.a;
				var restOfList = _v7.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$GlobalNumbersAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalAllNumbersInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalStringHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$GlobalStringLookup, ref, fieldName));
		case 'ProtoGlobalStringHardcoded':
			var words = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$GlobalStringHardcoded(words));
		case 'ProtoGlobalFormatDate':
			var stringInput = proto.a;
			var dateInput = proto.b;
			if (stringInput.$ === 'Unselected') {
				var inputState = stringInput.a;
				return _Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$GlobalFormatDateLocaleAware,
					$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateInput)) : $elm$core$Maybe$Nothing;
			} else {
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$Expression$GlobalFormatDate,
					$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(stringInput),
					$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate()(dateInput));
			}
		case 'ProtoGlobalFormatNumber':
			var inputDecimal = proto.a;
			var numberInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalFormatNumber,
				$author$project$IntInput$toMaybe(inputDecimal),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber()(numberInput));
		case 'ProtoGlobalStringIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalStringIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(elseInput));
		case 'ProtoGlobalPickString':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalPickString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList()(listInput));
		case 'ProtoGlobalConcat':
			var joinInput = proto.a;
			var listInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalConcat,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(joinInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList()(listInput));
		case 'ProtoGlobalMaxString':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalMaxString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList()(listInput));
		case 'ProtoGlobalFormatDateTime':
			var input = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalFormatDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime()(input));
		default:
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalMinString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList()(listInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalStringListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$GlobalStringListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList()(elseInput));
		case 'ProtoGlobalStringsAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v1 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v1.$ === 'Just') && (_v1.a.a.$ === 'Unselected')) {
				var _v2 = _v1.a;
				var inputState = _v2.a.a;
				var restOfList = _v2.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$GlobalStringsAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$globalString(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'ProtoGlobalAllStringsInField':
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$GlobalAllStringsInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
		case 'ProtoGlobalChallengeReasons':
			var acctId = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalChallengeReasons,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(acctId));
		default:
			var acctId = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalTargetChallengeReasons,
				$author$project$DataElement$ProtoElement$Parse$cyclic$globalString()(acctId));
	}
};
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalBool() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalBoolHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalBoolList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalBoolListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalComparableList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalComparableListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalDate() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalDateHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalDateList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalDateListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalDateTimeHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTimeList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalDateTimeListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalField() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalFieldHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalNumberHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalNumberListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalString() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalStringHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalStringListHelper);
}
try {
	var $author$project$DataElement$ProtoElement$Parse$globalBool = $author$project$DataElement$ProtoElement$Parse$cyclic$globalBool();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalBool = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalBool;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalBoolList = $author$project$DataElement$ProtoElement$Parse$cyclic$globalBoolList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalBoolList = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalBoolList;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalComparableList = $author$project$DataElement$ProtoElement$Parse$cyclic$globalComparableList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalComparableList = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalComparableList;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalDate = $author$project$DataElement$ProtoElement$Parse$cyclic$globalDate();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalDate = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalDate;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalDateList = $author$project$DataElement$ProtoElement$Parse$cyclic$globalDateList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateList = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalDateList;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalDateTime = $author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTime = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalDateTime;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalDateTimeList = $author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTimeList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalDateTimeList = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalDateTimeList;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalField = $author$project$DataElement$ProtoElement$Parse$cyclic$globalField();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalField = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalField;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalNumber = $author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumber = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalNumber;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalNumberList = $author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalNumberList = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalNumberList;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalString = $author$project$DataElement$ProtoElement$Parse$cyclic$globalString();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalString = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalString;
	};
	var $author$project$DataElement$ProtoElement$Parse$globalStringList = $author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$globalStringList = function () {
		return $author$project$DataElement$ProtoElement$Parse$globalStringList;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.ProtoElement.Parse` are causing infinite recursion:\n\n  ┌─────┐\n  │    globalBool\n  │     ↓\n  │    globalBoolHelper\n  │     ↓\n  │    globalBoolList\n  │     ↓\n  │    globalBoolListHelper\n  │     ↓\n  │    globalComparableList\n  │     ↓\n  │    globalComparableListHelper\n  │     ↓\n  │    globalDate\n  │     ↓\n  │    globalDateHelper\n  │     ↓\n  │    globalDateList\n  │     ↓\n  │    globalDateListHelper\n  │     ↓\n  │    globalDateTime\n  │     ↓\n  │    globalDateTimeHelper\n  │     ↓\n  │    globalDateTimeList\n  │     ↓\n  │    globalDateTimeListHelper\n  │     ↓\n  │    globalField\n  │     ↓\n  │    globalFieldHelper\n  │     ↓\n  │    globalNumber\n  │     ↓\n  │    globalNumberHelper\n  │     ↓\n  │    globalNumberList\n  │     ↓\n  │    globalNumberListHelper\n  │     ↓\n  │    globalString\n  │     ↓\n  │    globalStringHelper\n  │     ↓\n  │    globalStringList\n  │     ↓\n  │    globalStringListHelper\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $pzp1997$assoc_list$AssocList$D = function (a) {
	return {$: 'D', a: a};
};
var $pzp1997$assoc_list$AssocList$empty = $pzp1997$assoc_list$AssocList$D(_List_Nil);
var $pzp1997$assoc_list$AssocList$toList = function (_v0) {
	var alist = _v0.a;
	return alist;
};
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0.a;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = $pzp1997$assoc_list$AssocList$D(rest);
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0.a;
		return $pzp1997$assoc_list$AssocList$D(
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var key = _v1.a;
					return !_Utils_eq(key, targetKey);
				},
				alist));
	});
var $pzp1997$assoc_list$AssocList$update = F3(
	function (targetKey, alter, dict) {
		var alist = dict.a;
		var maybeValue = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (maybeValue.$ === 'Just') {
			var _v1 = alter(maybeValue);
			if (_v1.$ === 'Just') {
				var alteredValue = _v1.a;
				return $pzp1997$assoc_list$AssocList$D(
					A2(
						$elm$core$List$map,
						function (entry) {
							var key = entry.a;
							return _Utils_eq(key, targetKey) ? _Utils_Tuple2(targetKey, alteredValue) : entry;
						},
						alist));
			} else {
				return A2($pzp1997$assoc_list$AssocList$remove, targetKey, dict);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (_v2.$ === 'Just') {
				var alteredValue = _v2.a;
				return $pzp1997$assoc_list$AssocList$D(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(targetKey, alteredValue),
						alist));
			} else {
				return dict;
			}
		}
	});
var $author$project$DataElement$MergeList$fields = function (_v0) {
	var matrix = _v0.a;
	var addFieldForRef = F2(
		function (listElem, _v2) {
			var label = _v2.a;
			var fieldName = _v2.b;
			return A2(
				$pzp1997$assoc_list$AssocList$update,
				label,
				function (currentList) {
					return $elm$core$Maybe$Just(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(listElem, fieldName),
							A2($elm$core$Maybe$withDefault, _List_Nil, currentList)));
				});
		});
	var addAllFieldsForRef = F2(
		function (_v1, currentDict) {
			var listElem = _v1.a;
			var fieldDict = _v1.b;
			return A3(
				$elm$core$List$foldl,
				addFieldForRef(listElem),
				currentDict,
				$pzp1997$assoc_list$AssocList$toList(fieldDict));
		});
	return A3($elm$core$List$foldr, addAllFieldsForRef, $pzp1997$assoc_list$AssocList$empty, matrix);
};
var $author$project$ObjectName$ObjectName = function (a) {
	return {$: 'ObjectName', a: a};
};
var $author$project$ObjectName$fromString = $author$project$ObjectName$ObjectName;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1.$) {
					case 'LT':
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 'EQ':
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$UuidDict$get = F2(
	function (uuid, _v0) {
		var dict = _v0.a;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Dict$get,
				$danyx23$elm_uuid$Uuid$toString(uuid),
				dict));
	});
var $author$project$DataElement$Reference$getUuid = function (_v0) {
	var uuid = _v0.a;
	return uuid;
};
var $author$project$DataElement$getDataElementFromReferenceElement = F2(
	function (_v0, ref) {
		var uuidDict = _v0.a;
		return A2(
			$author$project$UuidDict$get,
			$author$project$DataElement$Reference$getUuid(ref),
			uuidDict);
	});
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 'Nothing') {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$DataElement$getObjectTags = F3(
	function (elementsByName, _v213, field) {
		var el = _v213.b;
		if (el.$ === 'RecordList') {
			switch (el.a.$) {
				case 'CrmQuery':
					var info = el.a.a;
					return $elm_community$maybe_extra$Maybe$Extra$toList(
						A2($pzp1997$assoc_list$AssocList$get, field, info.objectTags));
				case 'SalesQuery':
					return _List_Nil;
				case 'NitroQuery':
					return _List_Nil;
				case 'CrmDataEngineQuery':
					return _List_Nil;
				case 'CallAttendees':
					var _v215 = el.a;
					return _List_fromArray(
						[
							$author$project$ObjectName$fromString('Account')
						]);
				case 'CalcOneForOne':
					var oneForOne = el.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyLocalField(
								A2($author$project$DataElement$objectTagLocalTransformer, elementsByName, oneForOne.original)),
							A2($pzp1997$assoc_list$AssocList$get, field, oneForOne.fields)));
				case 'CalcSortList':
					var info = el.a.a;
					return A3($author$project$DataElement$getObjectTagsFromReferenceElement, elementsByName, info.original, field);
				case 'CalcFilterList':
					var filterList = el.a.a;
					return A3($author$project$DataElement$getObjectTagsFromReferenceElement, elementsByName, filterList.original, field);
				case 'CalcSublist':
					var info = el.a.a;
					return A3($author$project$DataElement$getObjectTagsFromReferenceElement, elementsByName, info.original, field);
				case 'CalcMergeList':
					var info = el.a.a;
					return $elm$core$List$concat(
						A2(
							$elm$core$List$map,
							function (_v216) {
								var ref = _v216.a;
								var refFieldName = _v216.b;
								return A3($author$project$DataElement$getObjectTagsFromReferenceElement, elementsByName, ref, refFieldName);
							},
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$pzp1997$assoc_list$AssocList$get,
									field,
									$author$project$DataElement$MergeList$fields(info)))));
				case 'AlignedTerritories':
					return _List_Nil;
				case 'FeedbackChannelGoals':
					return _List_Nil;
				case 'FeedbackProductGoals':
					return _List_Nil;
				case 'FeedbackAccountData':
					return _List_Nil;
				case 'FeedbackAccountChannelGoals':
					return _List_Nil;
				case 'FeedbackAccountProductGoals':
					return _List_Nil;
				default:
					return _List_Nil;
			}
		} else {
			switch (el.a.$) {
				case 'FeedbackOverview':
					return _List_Nil;
				case 'ContextQuery':
					var info = el.a.a;
					return $elm_community$maybe_extra$Maybe$Extra$toList(info.objectTag);
				case 'LimitOneCrmQuery':
					var info = el.a.a;
					return $elm_community$maybe_extra$Maybe$Extra$toList(
						A2($pzp1997$assoc_list$AssocList$get, field, info.objectTags));
				case 'LimitOneSalesQuery':
					return _List_Nil;
				case 'LimitOneNitroQuery':
					return _List_Nil;
				case 'LimitOneCrmDataEngineQuery':
					return _List_Nil;
				case 'Today':
					var _v217 = el.a;
					return _List_Nil;
				case 'Now':
					var _v218 = el.a;
					return _List_Nil;
				case 'CalcSummarize':
					var info = el.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyGlobalField(
								$author$project$DataElement$objectTagGlobalTransformer(elementsByName)),
							A2($pzp1997$assoc_list$AssocList$get, field, info.fields)));
				case 'ObjectTranslation':
					return _List_Nil;
				case 'FieldTranslation':
					return _List_Nil;
				case 'VeevaMessages':
					return _List_Nil;
				case 'DatepickerSelection':
					return _List_Nil;
				default:
					return _List_Nil;
			}
		}
	});
var $author$project$DataElement$getObjectTagsFromReferenceElement = F3(
	function (elementsByName, ref, fieldName) {
		var _v212 = A2($author$project$DataElement$getDataElementFromReferenceElement, elementsByName, ref);
		if (_v212.$ === 'Just') {
			var element = _v212.a;
			return A3($author$project$DataElement$getObjectTags, elementsByName, element, fieldName);
		} else {
			return _List_Nil;
		}
	});
var $author$project$DataElement$getRelatedObjectTagsField = F4(
	function (elementsByName, listRef, relationship, fieldName) {
		return A3($author$project$DataElement$getObjectTagsFromReferenceElement, elementsByName, relationship.nextElement, fieldName);
	});
var $author$project$DataElement$objectTagGlobalTransformer = function (elementsByName) {
	return {
		add: F2(
			function (_v112, _v113) {
				return _List_Nil;
			}),
		all: function (_v114) {
			return _List_Nil;
		},
		allBoolsInField: F2(
			function (_v115, _v116) {
				return _List_Nil;
			}),
		allDateTimesInField: F2(
			function (_v117, _v118) {
				return _List_Nil;
			}),
		allDatesInField: F2(
			function (_v119, _v120) {
				return _List_Nil;
			}),
		allNumbersInField: F2(
			function (_v121, _v122) {
				return _List_Nil;
			}),
		allStringsInField: $author$project$DataElement$getObjectTagsFromReferenceElement(elementsByName),
		any: function (_v123) {
			return _List_Nil;
		},
		boolsAsList: function (_v124) {
			return _List_Nil;
		},
		challengeReasons: function (_v125) {
			return _List_Nil;
		},
		comparableEqual: F3(
			function (_v126, _v127, _v128) {
				return _List_Nil;
			}),
		comparableNotEqual: F3(
			function (_v129, _v130, _v131) {
				return _List_Nil;
			}),
		concat: F2(
			function (_v132, _v133) {
				return _List_Nil;
			}),
		countUnique: F2(
			function (_v134, _v135) {
				return _List_Nil;
			}),
		dateAdd: F3(
			function (_v136, _v137, _v138) {
				return _List_Nil;
			}),
		dateCeiling: F2(
			function (_v139, _v140) {
				return _List_Nil;
			}),
		dateFloor: F2(
			function (_v141, _v142) {
				return _List_Nil;
			}),
		dateSubtract: F3(
			function (_v143, _v144, _v145) {
				return _List_Nil;
			}),
		dateTimeToDate: function (_v146) {
			return _List_Nil;
		},
		dateTimesAsList: function (_v147) {
			return _List_Nil;
		},
		datesAsList: function (_v148) {
			return _List_Nil;
		},
		dayInMonth: function (_v149) {
			return _List_Nil;
		},
		divide: F2(
			function (_v150, _v151) {
				return _List_Nil;
			}),
		equal: F3(
			function (_v152, _v153, _v154) {
				return _List_Nil;
			}),
		formatDate: F2(
			function (_v155, _v156) {
				return _List_Nil;
			}),
		formatDateLocaleAware: function (_v157) {
			return _List_Nil;
		},
		formatDateTime: function (_v158) {
			return _List_Nil;
		},
		formatNumber: F2(
			function (_v159, _v160) {
				return _List_Nil;
			}),
		globalBoolLookup: F2(
			function (_v161, _v162) {
				return _List_Nil;
			}),
		globalDateLookup: F2(
			function (_v163, _v164) {
				return _List_Nil;
			}),
		globalDateTimeLookup: F2(
			function (_v165, _v166) {
				return _List_Nil;
			}),
		globalNumberLookup: F2(
			function (_v167, _v168) {
				return _List_Nil;
			}),
		globalStringLookup: $author$project$DataElement$getObjectTagsFromReferenceElement(elementsByName),
		greaterThan: F3(
			function (_v169, _v170, _v171) {
				return _List_Nil;
			}),
		greaterThanOrEqual: F3(
			function (_v172, _v173, _v174) {
				return _List_Nil;
			}),
		hardcodedBool: function (_v175) {
			return _List_Nil;
		},
		hardcodedDate: function (_v176) {
			return _List_Nil;
		},
		hardcodedDateTime: function (_v177) {
			return _List_Nil;
		},
		hardcodedNumber: function (_v178) {
			return _List_Nil;
		},
		hardcodedString: function (_v179) {
			return _List_Nil;
		},
		if_: F4(
			function (_v180, _v181, b, c) {
				return A2($elm$core$List$append, b, c);
			}),
		isNotNull: function (_v182) {
			return _List_Nil;
		},
		isNull: function (_v183) {
			return _List_Nil;
		},
		lessThan: F3(
			function (_v184, _v185, _v186) {
				return _List_Nil;
			}),
		lessThanOrEqual: F3(
			function (_v187, _v188, _v189) {
				return _List_Nil;
			}),
		max: function (_v190) {
			return $elm$core$Basics$identity;
		},
		min: function (_v191) {
			return $elm$core$Basics$identity;
		},
		monthNumber: function (_v192) {
			return _List_Nil;
		},
		multiply: F2(
			function (_v193, _v194) {
				return _List_Nil;
			}),
		not: function (_v195) {
			return _List_Nil;
		},
		notEqual: F3(
			function (_v196, _v197, _v198) {
				return _List_Nil;
			}),
		numbersAsList: function (_v199) {
			return _List_Nil;
		},
		pickOne: function (_v200) {
			return $elm$core$Basics$identity;
		},
		product: function (_v201) {
			return _List_Nil;
		},
		round: function (_v202) {
			return _List_Nil;
		},
		stringIn: F2(
			function (_v203, _v204) {
				return _List_Nil;
			}),
		stringNotIn: F2(
			function (_v205, _v206) {
				return _List_Nil;
			}),
		stringsAsList: $elm$core$List$concat,
		subtract: F2(
			function (_v207, _v208) {
				return _List_Nil;
			}),
		sum: function (_v209) {
			return _List_Nil;
		},
		targetChallengeReasons: function (_v210) {
			return _List_Nil;
		},
		yearNumber: function (_v211) {
			return _List_Nil;
		}
	};
};
var $author$project$DataElement$objectTagLocalTransformer = F2(
	function (elementsByName, ref) {
		return {
			add: F2(
				function (_v0, _v1) {
					return _List_Nil;
				}),
			all: function (_v2) {
				return _List_Nil;
			},
			allBoolsInField: F2(
				function (_v3, _v4) {
					return _List_Nil;
				}),
			allDateTimesInField: F2(
				function (_v5, _v6) {
					return _List_Nil;
				}),
			allDatesInField: F2(
				function (_v7, _v8) {
					return _List_Nil;
				}),
			allNumbersInField: F2(
				function (_v9, _v10) {
					return _List_Nil;
				}),
			allStringsInField: $author$project$DataElement$getObjectTagsFromReferenceElement(elementsByName),
			any: function (_v11) {
				return _List_Nil;
			},
			boolsAsList: function (_v12) {
				return _List_Nil;
			},
			challengeReasons: function (_v13) {
				return _List_Nil;
			},
			comparableEqual: F3(
				function (_v14, _v15, _v16) {
					return _List_Nil;
				}),
			comparableNotEqual: F3(
				function (_v17, _v18, _v19) {
					return _List_Nil;
				}),
			concat: F2(
				function (_v20, _v21) {
					return _List_Nil;
				}),
			countUnique: F2(
				function (_v22, _v23) {
					return _List_Nil;
				}),
			dateAdd: F3(
				function (_v24, _v25, _v26) {
					return _List_Nil;
				}),
			dateCeiling: F2(
				function (_v27, _v28) {
					return _List_Nil;
				}),
			dateFloor: F2(
				function (_v29, _v30) {
					return _List_Nil;
				}),
			dateSubtract: F3(
				function (_v31, _v32, _v33) {
					return _List_Nil;
				}),
			dateTimeToDate: function (_v34) {
				return _List_Nil;
			},
			dateTimesAsList: function (_v35) {
				return _List_Nil;
			},
			datesAsList: function (_v36) {
				return _List_Nil;
			},
			dayInMonth: function (_v37) {
				return _List_Nil;
			},
			divide: F2(
				function (_v38, _v39) {
					return _List_Nil;
				}),
			equal: F3(
				function (_v40, _v41, _v42) {
					return _List_Nil;
				}),
			formatDate: F2(
				function (_v43, _v44) {
					return _List_Nil;
				}),
			formatDateLocaleAware: function (_v45) {
				return _List_Nil;
			},
			formatDateTime: function (_v46) {
				return _List_Nil;
			},
			formatNumber: F2(
				function (_v47, _v48) {
					return _List_Nil;
				}),
			globalBoolLookup: F2(
				function (_v49, _v50) {
					return _List_Nil;
				}),
			globalDateLookup: F2(
				function (_v51, _v52) {
					return _List_Nil;
				}),
			globalDateTimeLookup: F2(
				function (_v53, _v54) {
					return _List_Nil;
				}),
			globalNumberLookup: F2(
				function (_v55, _v56) {
					return _List_Nil;
				}),
			globalStringLookup: $author$project$DataElement$getObjectTagsFromReferenceElement(elementsByName),
			greaterThan: F3(
				function (_v57, _v58, _v59) {
					return _List_Nil;
				}),
			greaterThanOrEqual: F3(
				function (_v60, _v61, _v62) {
					return _List_Nil;
				}),
			hardcodedBool: function (_v63) {
				return _List_Nil;
			},
			hardcodedDate: function (_v64) {
				return _List_Nil;
			},
			hardcodedDateTime: function (_v65) {
				return _List_Nil;
			},
			hardcodedNumber: function (_v66) {
				return _List_Nil;
			},
			hardcodedString: function (_v67) {
				return _List_Nil;
			},
			if_: F4(
				function (_v68, _v69, b, c) {
					return A2($elm$core$List$append, b, c);
				}),
			isNotNull: function (_v70) {
				return _List_Nil;
			},
			isNull: function (_v71) {
				return _List_Nil;
			},
			lessThan: F3(
				function (_v72, _v73, _v74) {
					return _List_Nil;
				}),
			lessThanOrEqual: F3(
				function (_v75, _v76, _v77) {
					return _List_Nil;
				}),
			localBool: function (_v78) {
				return _List_Nil;
			},
			localDate: function (_v79) {
				return _List_Nil;
			},
			localDateTime: function (_v80) {
				return _List_Nil;
			},
			localNumber: function (_v81) {
				return _List_Nil;
			},
			localString: A2($author$project$DataElement$getObjectTagsFromReferenceElement, elementsByName, ref),
			max: function (_v82) {
				return $elm$core$Basics$identity;
			},
			min: function (_v83) {
				return $elm$core$Basics$identity;
			},
			monthNumber: function (_v84) {
				return _List_Nil;
			},
			multiply: F2(
				function (_v85, _v86) {
					return _List_Nil;
				}),
			not: function (_v87) {
				return _List_Nil;
			},
			notEqual: F3(
				function (_v88, _v89, _v90) {
					return _List_Nil;
				}),
			numbersAsList: function (_v91) {
				return _List_Nil;
			},
			pickOne: function (_v92) {
				return $elm$core$Basics$identity;
			},
			product: function (_v93) {
				return _List_Nil;
			},
			relatedBool: F2(
				function (_v94, _v95) {
					return _List_Nil;
				}),
			relatedDate: F2(
				function (_v96, _v97) {
					return _List_Nil;
				}),
			relatedDateTime: F2(
				function (_v98, _v99) {
					return _List_Nil;
				}),
			relatedNumber: F2(
				function (_v100, _v101) {
					return _List_Nil;
				}),
			relatedString: A2($author$project$DataElement$getRelatedObjectTagsField, elementsByName, ref),
			round: function (_v102) {
				return _List_Nil;
			},
			stringIn: F2(
				function (_v103, _v104) {
					return _List_Nil;
				}),
			stringNotIn: F2(
				function (_v105, _v106) {
					return _List_Nil;
				}),
			stringsAsList: $elm$core$List$concat,
			subtract: F2(
				function (_v107, _v108) {
					return _List_Nil;
				}),
			sum: function (_v109) {
				return _List_Nil;
			},
			targetChallengeReasons: function (_v110) {
				return _List_Nil;
			},
			yearNumber: function (_v111) {
				return _List_Nil;
			}
		};
	});
var $author$project$ExpressionInput$Msg$InnerMsg = F2(
	function (a, b) {
		return {$: 'InnerMsg', a: a, b: b};
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$ExpressionInput$Msg$DragMsg = function (a) {
	return {$: 'DragMsg', a: a};
};
var $annaghi$dnd_list$DnDList$Model = function (a) {
	return {$: 'Model', a: a};
};
var $annaghi$dnd_list$DnDList$GotDragElement = function (a) {
	return {$: 'GotDragElement', a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2(
					$elm$core$Task$onError,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Err),
					A2(
						$elm$core$Task$andThen,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
							$elm$core$Result$Ok),
						task))));
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $annaghi$dnd_list$DnDList$dragElementCommands = F2(
	function (stepMsg, state) {
		var _v0 = state.dragElement;
		if (_v0.$ === 'Nothing') {
			return A2(
				$elm$core$Task$attempt,
				A2($elm$core$Basics$composeL, stepMsg, $annaghi$dnd_list$DnDList$GotDragElement),
				$elm$browser$Browser$Dom$getElement(state.dragElementId));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $annaghi$dnd_list$DnDList$GotDropElement = function (a) {
	return {$: 'GotDropElement', a: a};
};
var $annaghi$dnd_list$DnDList$dropElementCommands = F2(
	function (stepMsg, state) {
		return (!state.dragCounter) ? A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeL, stepMsg, $annaghi$dnd_list$DnDList$GotDropElement),
			$elm$browser$Browser$Dom$getElement(state.dropElementId)) : $elm$core$Platform$Cmd$none;
	});
var $annaghi$dnd_list$DnDList$commands = F2(
	function (stepMsg, _v0) {
		var model = _v0.a;
		if (model.$ === 'Nothing') {
			return $elm$core$Platform$Cmd$none;
		} else {
			var state = model.a;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($annaghi$dnd_list$DnDList$dragElementCommands, stepMsg, state),
						A2($annaghi$dnd_list$DnDList$dropElementCommands, stepMsg, state)
					]));
		}
	});
var $annaghi$dnd_list$DnDList$DragStart = F3(
	function (a, b, c) {
		return {$: 'DragStart', a: a, b: b, c: c};
	});
var $annaghi$dnd_list$Internal$Common$Utils$Position = F2(
	function (x, y) {
		return {x: x, y: y};
	});
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $annaghi$dnd_list$Internal$Common$Utils$clientX = A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float);
var $annaghi$dnd_list$Internal$Common$Utils$clientY = A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float);
var $annaghi$dnd_list$Internal$Common$Utils$decodeCoordinates = A3($elm$json$Json$Decode$map2, $annaghi$dnd_list$Internal$Common$Utils$Position, $annaghi$dnd_list$Internal$Common$Utils$clientX, $annaghi$dnd_list$Internal$Common$Utils$clientY);
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $annaghi$dnd_list$Internal$Common$Utils$decodeMainMouseButton = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (button) {
			return (!button) ? decoder : $elm$json$Json$Decode$fail('Event is only relevant when the main mouse button was pressed.');
		},
		A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
};
var $annaghi$dnd_list$Internal$Common$Utils$decodeCoordinatesWithButtonCheck = $annaghi$dnd_list$Internal$Common$Utils$decodeMainMouseButton($annaghi$dnd_list$Internal$Common$Utils$decodeCoordinates);
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 'MayPreventDefault', a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $annaghi$dnd_list$DnDList$dragEvents = F3(
	function (stepMsg, dragIndex, dragElementId) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'mousedown',
				A2(
					$elm$json$Json$Decode$map,
					function (msg) {
						return _Utils_Tuple2(msg, true);
					},
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeL,
							stepMsg,
							A2($annaghi$dnd_list$DnDList$DragStart, dragIndex, dragElementId)),
						$annaghi$dnd_list$Internal$Common$Utils$decodeCoordinatesWithButtonCheck)))
			]);
	});
var $annaghi$dnd_list$DnDList$DragEnter = function (a) {
	return {$: 'DragEnter', a: a};
};
var $annaghi$dnd_list$DnDList$DragLeave = {$: 'DragLeave'};
var $annaghi$dnd_list$DnDList$DragOver = F2(
	function (a, b) {
		return {$: 'DragOver', a: a, b: b};
	});
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 'Normal', a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $annaghi$dnd_list$DnDList$dropEvents = F3(
	function (stepMsg, dropIndex, dropElementId) {
		return _List_fromArray(
			[
				$elm$html$Html$Events$onMouseOver(
				stepMsg(
					A2($annaghi$dnd_list$DnDList$DragOver, dropIndex, dropElementId))),
				$elm$html$Html$Events$onMouseEnter(
				stepMsg(
					$annaghi$dnd_list$DnDList$DragEnter(dropIndex))),
				$elm$html$Html$Events$onMouseLeave(
				stepMsg($annaghi$dnd_list$DnDList$DragLeave))
			]);
	});
var $annaghi$dnd_list$Internal$Common$Utils$px = function (n) {
	return $elm$core$String$fromInt(n) + 'px';
};
var $elm$core$Basics$round = _Basics_round;
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $annaghi$dnd_list$Internal$Common$Utils$translate = F2(
	function (x, y) {
		return 'translate3d(' + ($annaghi$dnd_list$Internal$Common$Utils$px(x) + (', ' + ($annaghi$dnd_list$Internal$Common$Utils$px(y) + ', 0)')));
	});
var $annaghi$dnd_list$DnDList$ghostStyles = F2(
	function (movement, _v0) {
		var model = _v0.a;
		if (model.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var state = model.a;
			var _v2 = state.dragElement;
			if (_v2.$ === 'Just') {
				var element = _v2.a.element;
				var viewport = _v2.a.viewport;
				var transform = function () {
					switch (movement.$) {
						case 'Horizontal':
							return A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$annaghi$dnd_list$Internal$Common$Utils$translate,
									$elm$core$Basics$round(((state.currentPosition.x - state.startPosition.x) + element.x) - viewport.x),
									$elm$core$Basics$round(element.y - viewport.y)));
						case 'Vertical':
							return A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$annaghi$dnd_list$Internal$Common$Utils$translate,
									$elm$core$Basics$round(element.x - viewport.x),
									$elm$core$Basics$round(((state.currentPosition.y - state.startPosition.y) + element.y) - viewport.y)));
						default:
							return A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$annaghi$dnd_list$Internal$Common$Utils$translate,
									$elm$core$Basics$round(((state.currentPosition.x - state.startPosition.x) + element.x) - viewport.x),
									$elm$core$Basics$round(((state.currentPosition.y - state.startPosition.y) + element.y) - viewport.y)));
					}
				}();
				var baseStyles = _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
						A2($elm$html$Html$Attributes$style, 'top', '0'),
						A2($elm$html$Html$Attributes$style, 'left', '0'),
						A2(
						$elm$html$Html$Attributes$style,
						'height',
						$annaghi$dnd_list$Internal$Common$Utils$px(
							$elm$core$Basics$round(element.height))),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$annaghi$dnd_list$Internal$Common$Utils$px(
							$elm$core$Basics$round(element.width))),
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
					]);
				return A2($elm$core$List$cons, transform, baseStyles);
			} else {
				return _List_Nil;
			}
		}
	});
var $annaghi$dnd_list$DnDList$info = function (_v0) {
	var model = _v0.a;
	return A2(
		$elm$core$Maybe$andThen,
		function (state) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (dragElement, dropElement) {
						return {currentPosition: state.currentPosition, dragElement: dragElement, dragElementId: state.dragElementId, dragIndex: state.dragIndex, dropElement: dropElement, dropElementId: state.dropElementId, dropIndex: state.dropIndex, startPosition: state.startPosition};
					}),
				state.dragElement,
				state.dropElement);
		},
		model);
};
var $annaghi$dnd_list$DnDList$Drag = function (a) {
	return {$: 'Drag', a: a};
};
var $annaghi$dnd_list$DnDList$DragEnd = {$: 'DragEnd'};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Document = {$: 'Document'};
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 'MySub', a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {pids: pids, subs: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (node.$ === 'Document') {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$Black = {$: 'Black'};
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = {$: 'Red'};
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1.$) {
				case 'LT':
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 'EQ':
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {event: event, key: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (node.$ === 'Document') {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.pids,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (_v0.$ === 'Just') {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.key;
		var event = _v0.event;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.subs);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'mousemove');
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'mouseup');
var $annaghi$dnd_list$DnDList$subscriptions = F2(
	function (stepMsg, _v0) {
		var model = _v0.a;
		if (model.$ === 'Nothing') {
			return $elm$core$Platform$Sub$none;
		} else {
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$elm$browser$Browser$Events$onMouseMove(
						A2(
							$elm$json$Json$Decode$map,
							A2($elm$core$Basics$composeL, stepMsg, $annaghi$dnd_list$DnDList$Drag),
							$annaghi$dnd_list$Internal$Common$Utils$decodeCoordinates)),
						$elm$browser$Browser$Events$onMouseUp(
						$elm$json$Json$Decode$succeed(
							stepMsg($annaghi$dnd_list$DnDList$DragEnd)))
					]));
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$splitAt = F2(
	function (i, list) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, i, list),
			A2($elm$core$List$drop, i, list));
	});
var $annaghi$dnd_list$Internal$Common$Operations$afterBackward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, j + 1, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, (i - j) - 1, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, end);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				head,
				_Utils_ap(middle, tail)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$afterForward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, i, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, (j - i) + 1, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, middle);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				tail,
				_Utils_ap(head, end)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$insertAfter = F3(
	function (dragIndex, dropIndex, list) {
		return (_Utils_cmp(dragIndex, dropIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$afterForward, dragIndex, dropIndex, list) : ((_Utils_cmp(dropIndex, dragIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$afterBackward, dragIndex, dropIndex, list) : list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$beforeBackward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, j, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, i - j, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, end);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				head,
				_Utils_ap(middle, tail)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$beforeForward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, i, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, j - i, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, middle);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				tail,
				_Utils_ap(head, end)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$insertBefore = F3(
	function (dragIndex, dropIndex, list) {
		return (_Utils_cmp(dragIndex, dropIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$beforeForward, dragIndex, dropIndex, list) : ((_Utils_cmp(dropIndex, dragIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$beforeBackward, dragIndex, dropIndex, list) : list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$rotate = F3(
	function (dragIndex, dropIndex, list) {
		return (_Utils_cmp(dragIndex, dropIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$afterForward, dragIndex, dropIndex, list) : ((_Utils_cmp(dropIndex, dragIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$beforeBackward, dragIndex, dropIndex, list) : list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$swapAt = F3(
	function (i, j, list) {
		var item_j = A2(
			$elm$core$List$take,
			1,
			A2($elm$core$List$drop, j, list));
		var item_i = A2(
			$elm$core$List$take,
			1,
			A2($elm$core$List$drop, i, list));
		return $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return _Utils_eq(index, i) ? item_j : (_Utils_eq(index, j) ? item_i : _List_fromArray(
							[item]));
					}),
				list));
	});
var $annaghi$dnd_list$Internal$Common$Operations$swap = F3(
	function (dragIndex, dropIndex, list) {
		return (!_Utils_eq(dragIndex, dropIndex)) ? A3($annaghi$dnd_list$Internal$Common$Operations$swapAt, dragIndex, dropIndex, list) : list;
	});
var $annaghi$dnd_list$DnDList$listUpdate = F4(
	function (operation, dragIndex, dropIndex, list) {
		switch (operation.$) {
			case 'InsertAfter':
				return A3($annaghi$dnd_list$Internal$Common$Operations$insertAfter, dragIndex, dropIndex, list);
			case 'InsertBefore':
				return A3($annaghi$dnd_list$Internal$Common$Operations$insertBefore, dragIndex, dropIndex, list);
			case 'Rotate':
				return A3($annaghi$dnd_list$Internal$Common$Operations$rotate, dragIndex, dropIndex, list);
			case 'Swap':
				return A3($annaghi$dnd_list$Internal$Common$Operations$swap, dragIndex, dropIndex, list);
			default:
				return list;
		}
	});
var $annaghi$dnd_list$DnDList$stateUpdate = F3(
	function (operation, dropIndex, state) {
		switch (operation.$) {
			case 'InsertAfter':
				return _Utils_update(
					state,
					{
						dragCounter: 0,
						dragIndex: (_Utils_cmp(dropIndex, state.dragIndex) < 0) ? (dropIndex + 1) : dropIndex
					});
			case 'InsertBefore':
				return _Utils_update(
					state,
					{
						dragCounter: 0,
						dragIndex: (_Utils_cmp(state.dragIndex, dropIndex) < 0) ? (dropIndex - 1) : dropIndex
					});
			case 'Rotate':
				return _Utils_update(
					state,
					{dragCounter: 0, dragIndex: dropIndex});
			case 'Swap':
				return _Utils_update(
					state,
					{dragCounter: 0, dragIndex: dropIndex});
			default:
				return _Utils_update(
					state,
					{dragCounter: 0});
		}
	});
var $annaghi$dnd_list$DnDList$update = F4(
	function (_v0, msg, _v1, list) {
		var beforeUpdate = _v0.beforeUpdate;
		var listen = _v0.listen;
		var operation = _v0.operation;
		var model = _v1.a;
		switch (msg.$) {
			case 'DragStart':
				var dragIndex = msg.a;
				var dragElementId = msg.b;
				var xy = msg.c;
				return _Utils_Tuple2(
					$annaghi$dnd_list$DnDList$Model(
						$elm$core$Maybe$Just(
							{currentPosition: xy, dragCounter: 0, dragElement: $elm$core$Maybe$Nothing, dragElementId: dragElementId, dragIndex: dragIndex, dropElement: $elm$core$Maybe$Nothing, dropElementId: dragElementId, dropIndex: dragIndex, startPosition: xy})),
					list);
			case 'Drag':
				var xy = msg.a;
				return _Utils_Tuple2(
					$annaghi$dnd_list$DnDList$Model(
						A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_update(
									state,
									{currentPosition: xy, dragCounter: state.dragCounter + 1});
							},
							model)),
					list);
			case 'DragOver':
				var dropIndex = msg.a;
				var dropElementId = msg.b;
				return _Utils_Tuple2(
					$annaghi$dnd_list$DnDList$Model(
						A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_update(
									state,
									{dropElementId: dropElementId, dropIndex: dropIndex});
							},
							model)),
					list);
			case 'DragEnter':
				var dropIndex = msg.a;
				var _v3 = _Utils_Tuple2(model, listen);
				if ((_v3.a.$ === 'Just') && (_v3.b.$ === 'OnDrag')) {
					var state = _v3.a.a;
					var _v4 = _v3.b;
					return ((state.dragCounter > 1) && (!_Utils_eq(state.dragIndex, dropIndex))) ? _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model(
							$elm$core$Maybe$Just(
								A3($annaghi$dnd_list$DnDList$stateUpdate, operation, dropIndex, state))),
						A4(
							$annaghi$dnd_list$DnDList$listUpdate,
							operation,
							state.dragIndex,
							dropIndex,
							A3(beforeUpdate, state.dragIndex, dropIndex, list))) : _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model(model),
						list);
				} else {
					return _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model(
							A2(
								$elm$core$Maybe$map,
								function (state) {
									return _Utils_update(
										state,
										{dragCounter: 0});
								},
								model)),
						list);
				}
			case 'DragLeave':
				return _Utils_Tuple2(
					$annaghi$dnd_list$DnDList$Model(
						A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_update(
									state,
									{dropIndex: state.dragIndex});
							},
							model)),
					list);
			case 'DragEnd':
				var _v5 = _Utils_Tuple2(model, listen);
				if ((_v5.a.$ === 'Just') && (_v5.b.$ === 'OnDrop')) {
					var state = _v5.a.a;
					var _v6 = _v5.b;
					return (!_Utils_eq(state.dragIndex, state.dropIndex)) ? _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model($elm$core$Maybe$Nothing),
						A4(
							$annaghi$dnd_list$DnDList$listUpdate,
							operation,
							state.dragIndex,
							state.dropIndex,
							A3(beforeUpdate, state.dragIndex, state.dropIndex, list))) : _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model($elm$core$Maybe$Nothing),
						list);
				} else {
					return _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model($elm$core$Maybe$Nothing),
						list);
				}
			case 'GotDragElement':
				if (msg.a.$ === 'Err') {
					return _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model(model),
						list);
				} else {
					var dragElement = msg.a.a;
					return _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model(
							A2(
								$elm$core$Maybe$map,
								function (state) {
									return _Utils_update(
										state,
										{
											dragElement: $elm$core$Maybe$Just(dragElement),
											dropElement: $elm$core$Maybe$Just(dragElement)
										});
								},
								model)),
						list);
				}
			default:
				if (msg.a.$ === 'Err') {
					return _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model(model),
						list);
				} else {
					var dropElement = msg.a.a;
					return _Utils_Tuple2(
						$annaghi$dnd_list$DnDList$Model(
							A2(
								$elm$core$Maybe$map,
								function (state) {
									return _Utils_update(
										state,
										{
											dropElement: $elm$core$Maybe$Just(dropElement)
										});
								},
								model)),
						list);
				}
		}
	});
var $annaghi$dnd_list$DnDList$create = F2(
	function (config, stepMsg) {
		return {
			commands: $annaghi$dnd_list$DnDList$commands(stepMsg),
			dragEvents: $annaghi$dnd_list$DnDList$dragEvents(stepMsg),
			dropEvents: $annaghi$dnd_list$DnDList$dropEvents(stepMsg),
			ghostStyles: $annaghi$dnd_list$DnDList$ghostStyles(config.movement),
			info: $annaghi$dnd_list$DnDList$info,
			model: $annaghi$dnd_list$DnDList$Model($elm$core$Maybe$Nothing),
			subscriptions: $annaghi$dnd_list$DnDList$subscriptions(stepMsg),
			update: $annaghi$dnd_list$DnDList$update(config)
		};
	});
var $annaghi$dnd_list$DnDList$InsertBefore = {$: 'InsertBefore'};
var $annaghi$dnd_list$DnDList$OnDrag = {$: 'OnDrag'};
var $annaghi$dnd_list$DnDList$Vertical = {$: 'Vertical'};
var $author$project$ExpressionInput$Msg$dnDConfig = {
	beforeUpdate: F3(
		function (_v0, _v1, list) {
			return list;
		}),
	listen: $annaghi$dnd_list$DnDList$OnDrag,
	movement: $annaghi$dnd_list$DnDList$Vertical,
	operation: $annaghi$dnd_list$DnDList$InsertBefore
};
var $author$project$ExpressionInput$Msg$dndSystem = A2($annaghi$dnd_list$DnDList$create, $author$project$ExpressionInput$Msg$dnDConfig, $author$project$ExpressionInput$Msg$DragMsg);
var $author$project$Input$Selected = function (a) {
	return {$: 'Selected', a: a};
};
var $author$project$Input$Unselected = function (a) {
	return {$: 'Unselected', a: a};
};
var $author$project$Input$map = F2(
	function (innerFun, input) {
		if (input.$ === 'Unselected') {
			var state = input.a;
			return $author$project$Input$Unselected(state);
		} else {
			var a = input.a;
			return $author$project$Input$Selected(
				innerFun(a));
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$ExpressionInput$protoGlobalAnyDragCmds = function (proto) {
	if (proto.$ === 'ProtoGlobalAnyIf') {
		var inputIf = proto.a;
		var inputThen = proto.b;
		var inputElse = proto.c;
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$ExpressionInput$Msg$InnerMsg(0),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$ExpressionInput$Msg$InnerMsg(1),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyDragCmds, inputThen)))),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$ExpressionInput$Msg$InnerMsg(2),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyDragCmds, inputElse))))
				]));
	} else {
		var list = proto.a;
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$ExpressionInput$Msg$InnerMsg(0),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				$author$project$Input$toMaybe(
					A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalAnyListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalAnyListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyListDragCmds, inputElse))))
					]));
		case 'ProtoGlobalAnysAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var inputRef = proto.a;
			var field = proto.b;
			return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$ExpressionInput$protoGlobalBoolDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalBoolLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalBoolHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalGTString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputB))))
					]));
		case 'ProtoGlobalGTNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalGTDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputB))))
					]));
		case 'ProtoGlobalGTDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoGlobalGTComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputB))))
					]));
		case 'ProtoGlobalGTEString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputB))))
					]));
		case 'ProtoGlobalGTENumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalGTEDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputB))))
					]));
		case 'ProtoGlobalGTEDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoGlobalGTEComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTEString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTENumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTEDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTEDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoGlobalLTEComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputB))))
					]));
		case 'ProtoGlobalEqualString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputB))))
					]));
		case 'ProtoGlobalEqualNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalEqualDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputB))))
					]));
		case 'ProtoGlobalEqualDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoGlobalEqualBool':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputB))))
					]));
		case 'ProtoGlobalEqualComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputB))))
					]));
		case 'ProtoGlobalEqualAny':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyDragCmds, inputB))))
					]));
		case 'ProtoGlobalNotEqualString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputB))))
					]));
		case 'ProtoGlobalNotEqualNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalNotEqualDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputB))))
					]));
		case 'ProtoGlobalNotEqualDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoGlobalNotEqualBool':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputB))))
					]));
		case 'ProtoGlobalNotEqualComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputB))))
					]));
		case 'ProtoGlobalNotEqualAny':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyDragCmds, inputB))))
					]));
		case 'ProtoGlobalStringIn':
			var inputString = proto.a;
			var inputList = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputString)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListDragCmds, inputList))))
					]));
		case 'ProtoGlobalStringNotIn':
			var inputString = proto.a;
			var inputList = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputString)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListDragCmds, inputList))))
					]));
		case 'ProtoGlobalNot':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, input))));
		case 'ProtoGlobalBoolIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputElse))))
					]));
		case 'ProtoGlobalPickBool':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListDragCmds, input))));
		case 'ProtoGlobalAll':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListDragCmds, input))));
		case 'ProtoGlobalAny':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListDragCmds, input))));
		case 'ProtoGlobalIsNull':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldDragCmds, input))));
		default:
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldDragCmds, input))));
	}
};
var $author$project$ExpressionInput$protoGlobalBoolListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalBoolListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListDragCmds, inputElse))))
					]));
		case 'ProtoGlobalBoolsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var inputRef = proto.a;
			var field = proto.b;
			return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$ExpressionInput$protoGlobalCompDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalMaxComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldListDragCmds, list))));
		case 'ProtoGlobalMinComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldListDragCmds, list))));
		case 'ProtoGlobalCompIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompDragCmds, inputElse))))
					]));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalCountUniqueListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalCompStringList':
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoGlobalStringListDragCmds(stringList);
		case 'ProtoGlobalCompNumberList':
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoGlobalNumberListDragCmds(stringList);
		case 'ProtoGlobalCompDateList':
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateListDragCmds(stringList);
		case 'ProtoGlobalCompDateTimeList':
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateTimeListDragCmds(stringList);
		default:
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoGlobalFieldListDragCmds(stringList);
	}
};
var $author$project$ExpressionInput$protoGlobalDateDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalDateHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalDateTimeToDate':
			var inputDateTime = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputDateTime))));
		case 'ProtoGlobalDateCeiling':
			var inputDateInterval = proto.a;
			var inputDate = proto.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputDate))));
		case 'ProtoGlobalDateFloor':
			var inputDateInterval = proto.a;
			var inputDate = proto.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputDate))));
		case 'ProtoGlobalDateAdd':
			var inputDateUnit = proto.a;
			var inputNumber = proto.b;
			var inputDate = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputDate)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputNumber))))
					]));
		case 'ProtoGlobalDateSubtract':
			var inputDateUnit = proto.a;
			var inputNumber = proto.b;
			var inputDate = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputDate)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputNumber))))
					]));
		case 'ProtoGlobalDateIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputElse))))
					]));
		case 'ProtoGlobalPickDate':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListDragCmds, list))));
		case 'ProtoGlobalMaxDate':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListDragCmds, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalDateListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListDragCmds, inputElse))))
					]));
		case 'ProtoGlobalDatesAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var inputRef = proto.a;
			var field = proto.b;
			return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$ExpressionInput$protoGlobalDateTimeDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateTimeLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalDateTimeHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalDateTimeIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputElse))))
					]));
		case 'ProtoGlobalPickDateTime':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListDragCmds, list))));
		case 'ProtoGlobalMaxDateTime':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListDragCmds, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalDateTimeListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateTimeListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListDragCmds, inputElse))))
					]));
		case 'ProtoGlobalAllDateTimesInField':
			var ref = proto.a;
			var state = proto.b;
			return $elm$core$Platform$Cmd$none;
		default:
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
	}
};
var $author$project$ExpressionInput$protoGlobalFieldDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringField':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalStringDragCmds(innerProto);
		case 'ProtoGlobalNumberField':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalNumberDragCmds(innerProto);
		case 'ProtoGlobalDateField':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateDragCmds(innerProto);
		case 'ProtoGlobalDateTimeField':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateTimeDragCmds(innerProto);
		case 'ProtoGlobalBoolField':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalBoolDragCmds(innerProto);
		case 'ProtoGlobalAnyField':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalAnyDragCmds(innerProto);
		default:
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalCompDragCmds(innerProto);
	}
};
var $author$project$ExpressionInput$protoGlobalFieldListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalCompListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldListDragCmds, inputElse))))
					]));
		case 'ProtoGlobalCompsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var inputRef = proto.a;
			var field = proto.b;
			return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$ExpressionInput$protoGlobalNumberDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalNumberLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalNumberHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalCountUnique':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCountUniqueListDragCmds, list))));
		case 'ProtoGlobalRoundNumber':
			var inputNumber = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputNumber))));
		case 'ProtoGlobalSum':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListDragCmds, list))));
		case 'ProtoGlobalProduct':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListDragCmds, list))));
		case 'ProtoGlobalAdd':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalSubtract':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalMultiply':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalDivide':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputB))))
					]));
		case 'ProtoGlobalMonthNumber':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputDate))));
		case 'ProtoGlobalYearNumber':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputDate))));
		case 'ProtoGlobalDayInMonth':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputDate))));
		case 'ProtoGlobalNumberIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputElse))))
					]));
		case 'ProtoGlobalPickNumber':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListDragCmds, list))));
		case 'ProtoGlobalMaxNumber':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListDragCmds, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalNumberListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalNumberListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListDragCmds, inputElse))))
					]));
		case 'ProtoGlobalNumbersAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var inputRef = proto.a;
			var field = proto.b;
			return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$ExpressionInput$protoGlobalStringDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalStringHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalFormatDate':
			var inputString = proto.a;
			var inputDate = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateDragCmds, inputDate)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputString))))
					]));
		case 'ProtoGlobalFormatDateTime':
			var inputDateTime = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeDragCmds, inputDateTime))));
		case 'ProtoGlobalFormatNumber':
			var intInput = proto.a;
			var inputNumber = proto.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberDragCmds, inputNumber))));
		case 'ProtoGlobalStringIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputElse))))
					]));
		case 'ProtoGlobalPickString':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListDragCmds, list))));
		case 'ProtoGlobalConcat':
			var inputString = proto.a;
			var list = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListDragCmds, list)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, inputString))))
					]));
		case 'ProtoGlobalMaxString':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListDragCmds, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalStringListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListDragCmds, inputElse))))
					]));
		case 'ProtoGlobalStringsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		case 'ProtoGlobalAllStringsInField':
			var inputRef = proto.a;
			var field = proto.b;
			return $elm$core$Platform$Cmd$none;
		case 'ProtoGlobalChallengeReasons':
			var acctIdInput = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, acctIdInput))));
		default:
			var acctIdInput = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringDragCmds, acctIdInput))));
	}
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalAdd = F2(
	function (a, b) {
		return {$: 'ProtoGlobalAdd', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAll = function (a) {
	return {$: 'ProtoGlobalAll', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField = F2(
	function (a, b) {
		return {$: 'ProtoGlobalAllAnysInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAllBoolsInField = F2(
	function (a, b) {
		return {$: 'ProtoGlobalAllBoolsInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAllCompsInField = F2(
	function (a, b) {
		return {$: 'ProtoGlobalAllCompsInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAllDateTimesInField = F2(
	function (a, b) {
		return {$: 'ProtoGlobalAllDateTimesInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAllDatesInField = F2(
	function (a, b) {
		return {$: 'ProtoGlobalAllDatesInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAllNumbersInField = F2(
	function (a, b) {
		return {$: 'ProtoGlobalAllNumbersInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAllStringsInField = F2(
	function (a, b) {
		return {$: 'ProtoGlobalAllStringsInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAny = function (a) {
	return {$: 'ProtoGlobalAny', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField = function (a) {
	return {$: 'ProtoGlobalAnyField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalAnyIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalAnyListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList = F2(
	function (a, b) {
		return {$: 'ProtoGlobalAnysAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalBoolField = function (a) {
	return {$: 'ProtoGlobalBoolField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalBoolFieldList = function (a) {
	return {$: 'ProtoGlobalBoolFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalBoolIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalBoolIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalBoolListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalBoolListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalBoolsAsList = F2(
	function (a, b) {
		return {$: 'ProtoGlobalBoolsAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalChallengeReasons = function (a) {
	return {$: 'ProtoGlobalChallengeReasons', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField = function (a) {
	return {$: 'ProtoGlobalCompAsCompField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField = function (a) {
	return {$: 'ProtoGlobalCompAsField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateList = function (a) {
	return {$: 'ProtoGlobalCompDateList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateTimeList = function (a) {
	return {$: 'ProtoGlobalCompDateTimeList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList = function (a) {
	return {$: 'ProtoGlobalCompFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalCompIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompListAsFieldList = function (a) {
	return {$: 'ProtoGlobalCompListAsFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalCompListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompNumberList = function (a) {
	return {$: 'ProtoGlobalCompNumberList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompStringList = function (a) {
	return {$: 'ProtoGlobalCompStringList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList = F2(
	function (a, b) {
		return {$: 'ProtoGlobalCompsAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalConcat = F2(
	function (a, b) {
		return {$: 'ProtoGlobalConcat', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalCountUnique = function (a) {
	return {$: 'ProtoGlobalCountUnique', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateAdd = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalDateAdd', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateCeiling = F2(
	function (a, b) {
		return {$: 'ProtoGlobalDateCeiling', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateComp = function (a) {
	return {$: 'ProtoGlobalDateComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateField = function (a) {
	return {$: 'ProtoGlobalDateField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateFieldList = function (a) {
	return {$: 'ProtoGlobalDateFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateFloor = F2(
	function (a, b) {
		return {$: 'ProtoGlobalDateFloor', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalDateIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalDateListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateSubtract = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalDateSubtract', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp = function (a) {
	return {$: 'ProtoGlobalDateTimeComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeField = function (a) {
	return {$: 'ProtoGlobalDateTimeField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeFieldList = function (a) {
	return {$: 'ProtoGlobalDateTimeFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalDateTimeIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalDateTimeListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeToDate = function (a) {
	return {$: 'ProtoGlobalDateTimeToDate', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimesAsList = F2(
	function (a, b) {
		return {$: 'ProtoGlobalDateTimesAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDatesAsList = F2(
	function (a, b) {
		return {$: 'ProtoGlobalDatesAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDayInMonth = function (a) {
	return {$: 'ProtoGlobalDayInMonth', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDivide = F2(
	function (a, b) {
		return {$: 'ProtoGlobalDivide', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalEqualAny = F2(
	function (a, b) {
		return {$: 'ProtoGlobalEqualAny', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalEqualBool = F2(
	function (a, b) {
		return {$: 'ProtoGlobalEqualBool', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp = F2(
	function (a, b) {
		return {$: 'ProtoGlobalEqualComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalEqualDate = F2(
	function (a, b) {
		return {$: 'ProtoGlobalEqualDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalEqualDateTime = F2(
	function (a, b) {
		return {$: 'ProtoGlobalEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalEqualNumber = F2(
	function (a, b) {
		return {$: 'ProtoGlobalEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalEqualString = F2(
	function (a, b) {
		return {$: 'ProtoGlobalEqualString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList = function (a) {
	return {$: 'ProtoGlobalFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalFormatDate = F2(
	function (a, b) {
		return {$: 'ProtoGlobalFormatDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalFormatDateTime = function (a) {
	return {$: 'ProtoGlobalFormatDateTime', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalFormatNumber = F2(
	function (a, b) {
		return {$: 'ProtoGlobalFormatNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTComp = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTDate = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTDateTime = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTEComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTEDate = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTEDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTEDateTime = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTENumber = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTENumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTEString = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTEString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTNumber = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalGTString = F2(
	function (a, b) {
		return {$: 'ProtoGlobalGTString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalIsNotNull = function (a) {
	return {$: 'ProtoGlobalIsNotNull', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalIsNull = function (a) {
	return {$: 'ProtoGlobalIsNull', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTComp = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTDate = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTDateTime = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTEComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTEDate = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTEDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTEDateTime = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTENumber = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTENumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTEString = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTEString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTNumber = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalLTString = F2(
	function (a, b) {
		return {$: 'ProtoGlobalLTString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalMaxComp = function (a) {
	return {$: 'ProtoGlobalMaxComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMaxDate = function (a) {
	return {$: 'ProtoGlobalMaxDate', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMaxDateTime = function (a) {
	return {$: 'ProtoGlobalMaxDateTime', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMaxNumber = function (a) {
	return {$: 'ProtoGlobalMaxNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMaxString = function (a) {
	return {$: 'ProtoGlobalMaxString', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMinComp = function (a) {
	return {$: 'ProtoGlobalMinComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMinDate = function (a) {
	return {$: 'ProtoGlobalMinDate', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMinDateTime = function (a) {
	return {$: 'ProtoGlobalMinDateTime', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMinNumber = function (a) {
	return {$: 'ProtoGlobalMinNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMinString = function (a) {
	return {$: 'ProtoGlobalMinString', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMonthNumber = function (a) {
	return {$: 'ProtoGlobalMonthNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalMultiply = F2(
	function (a, b) {
		return {$: 'ProtoGlobalMultiply', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNot = function (a) {
	return {$: 'ProtoGlobalNot', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualAny = F2(
	function (a, b) {
		return {$: 'ProtoGlobalNotEqualAny', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualBool = F2(
	function (a, b) {
		return {$: 'ProtoGlobalNotEqualBool', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp = F2(
	function (a, b) {
		return {$: 'ProtoGlobalNotEqualComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDate = F2(
	function (a, b) {
		return {$: 'ProtoGlobalNotEqualDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDateTime = F2(
	function (a, b) {
		return {$: 'ProtoGlobalNotEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualNumber = F2(
	function (a, b) {
		return {$: 'ProtoGlobalNotEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualString = F2(
	function (a, b) {
		return {$: 'ProtoGlobalNotEqualString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp = function (a) {
	return {$: 'ProtoGlobalNumberComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalNumberField = function (a) {
	return {$: 'ProtoGlobalNumberField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalNumberFieldList = function (a) {
	return {$: 'ProtoGlobalNumberFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalNumberIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalNumberListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNumbersAsList = F2(
	function (a, b) {
		return {$: 'ProtoGlobalNumbersAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalPickAny = function (a) {
	return {$: 'ProtoGlobalPickAny', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalPickBool = function (a) {
	return {$: 'ProtoGlobalPickBool', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalPickComp = function (a) {
	return {$: 'ProtoGlobalPickComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalPickDate = function (a) {
	return {$: 'ProtoGlobalPickDate', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalPickDateTime = function (a) {
	return {$: 'ProtoGlobalPickDateTime', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalPickNumber = function (a) {
	return {$: 'ProtoGlobalPickNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalPickString = function (a) {
	return {$: 'ProtoGlobalPickString', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalProduct = function (a) {
	return {$: 'ProtoGlobalProduct', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalRoundNumber = function (a) {
	return {$: 'ProtoGlobalRoundNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringComp = function (a) {
	return {$: 'ProtoGlobalStringComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringField = function (a) {
	return {$: 'ProtoGlobalStringField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringFieldList = function (a) {
	return {$: 'ProtoGlobalStringFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalStringIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringIn = F2(
	function (a, b) {
		return {$: 'ProtoGlobalStringIn', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoGlobalStringListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringNotIn = F2(
	function (a, b) {
		return {$: 'ProtoGlobalStringNotIn', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringsAsList = F2(
	function (a, b) {
		return {$: 'ProtoGlobalStringsAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalSubtract = F2(
	function (a, b) {
		return {$: 'ProtoGlobalSubtract', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalSum = function (a) {
	return {$: 'ProtoGlobalSum', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalTargetChallengeReasons = function (a) {
	return {$: 'ProtoGlobalTargetChallengeReasons', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalYearNumber = function (a) {
	return {$: 'ProtoGlobalYearNumber', a: a};
};
var $author$project$Input$maybe = function (inputMaybe) {
	if (inputMaybe.$ === 'Unselected') {
		var state = inputMaybe.a;
		return $elm$core$Maybe$Just(
			$author$project$Input$Unselected(state));
	} else {
		if (inputMaybe.a.$ === 'Just') {
			var a = inputMaybe.a.a;
			return $elm$core$Maybe$Just(
				$author$project$Input$Selected(a));
		} else {
			var _v1 = inputMaybe.a;
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$DataElement$ProtoExpression$globalBoolListToAnyList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalBoolListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalBoolListToAnyList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalBoolListToAnyList, elseInput)));
		case 'ProtoGlobalBoolsAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$globalBoolToAny),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (proto.b.$ === 'Unselected') {
				var refInput = proto.a;
				var fieldState = proto.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$globalBoolToAny = function (globalBool) {
	switch (globalBool.$) {
		case 'ProtoGlobalBoolIf':
			var ifInput = globalBool.a;
			var thenInput = globalBool.b;
			var elseInput = globalBool.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalBoolToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalBoolToAny, elseInput)));
		case 'ProtoGlobalPickBool':
			var anyList = globalBool.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalBoolListToAnyList, anyList)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$globalDateTimeListToCompList = function (globalDateTimeList) {
	switch (globalDateTimeList.$) {
		case 'ProtoGlobalDateTimeListIf':
			var ifInput = globalDateTimeList.a;
			var thenInput = globalDateTimeList.b;
			var elseInput = globalDateTimeList.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeListToCompList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeListToCompList, elseInput)));
		case 'ProtoGlobalDateTimesAsList':
			var listOfExprs = globalDateTimeList.a;
			var dragModel = globalDateTimeList.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$globalDateTimeToComp),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (globalDateTimeList.b.$ === 'Unselected') {
				var refInput = globalDateTimeList.a;
				var fieldState = globalDateTimeList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllCompsInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$globalDateTimeToComp = function (globalDateTime) {
	switch (globalDateTime.$) {
		case 'ProtoGlobalMaxDateTime':
			var listInput = globalDateTime.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalMaxComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeListToCompList, listInput)));
		case 'ProtoGlobalMinDateTime':
			var listInput = globalDateTime.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalMinComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeListToCompList, listInput)));
		case 'ProtoGlobalDateTimeIf':
			var ifInput = globalDateTime.a;
			var thenInput = globalDateTime.b;
			var elseInput = globalDateTime.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, elseInput)));
		case 'ProtoGlobalPickDateTime':
			var listInput = globalDateTime.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeListToCompList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$globalDateListToCompList = function (globalDateList) {
	switch (globalDateList.$) {
		case 'ProtoGlobalDateListIf':
			var ifInput = globalDateList.a;
			var thenInput = globalDateList.b;
			var elseInput = globalDateList.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateListToCompList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateListToCompList, elseInput)));
		case 'ProtoGlobalDatesAsList':
			var listOfExprs = globalDateList.a;
			var dragModel = globalDateList.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$globalDateToComp),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (globalDateList.b.$ === 'Unselected') {
				var refInput = globalDateList.a;
				var fieldState = globalDateList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllCompsInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$globalDateToComp = function (globalDate) {
	switch (globalDate.$) {
		case 'ProtoGlobalMaxDate':
			var listInput = globalDate.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalMaxComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateListToCompList, listInput)));
		case 'ProtoGlobalMinDate':
			var listInput = globalDate.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalMinComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateListToCompList, listInput)));
		case 'ProtoGlobalDateIf':
			var ifInput = globalDate.a;
			var thenInput = globalDate.b;
			var elseInput = globalDate.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, elseInput)));
		case 'ProtoGlobalPickDate':
			var listInput = globalDate.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateListToCompList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$globalNumberListToCompList = function (globalNumberList) {
	switch (globalNumberList.$) {
		case 'ProtoGlobalNumberListIf':
			var ifInput = globalNumberList.a;
			var thenInput = globalNumberList.b;
			var elseInput = globalNumberList.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberListToCompList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberListToCompList, elseInput)));
		case 'ProtoGlobalNumbersAsList':
			var listOfExprs = globalNumberList.a;
			var dragModel = globalNumberList.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$globalNumberToComp),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (globalNumberList.b.$ === 'Unselected') {
				var refInput = globalNumberList.a;
				var fieldState = globalNumberList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllCompsInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$globalNumberToComp = function (globalNumber) {
	switch (globalNumber.$) {
		case 'ProtoGlobalMaxNumber':
			var listInput = globalNumber.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalMaxComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberListToCompList, listInput)));
		case 'ProtoGlobalMinNumber':
			var listInput = globalNumber.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalMinComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberListToCompList, listInput)));
		case 'ProtoGlobalNumberIf':
			var ifInput = globalNumber.a;
			var thenInput = globalNumber.b;
			var elseInput = globalNumber.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, elseInput)));
		case 'ProtoGlobalPickNumber':
			var listInput = globalNumber.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberListToCompList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$globalStringListToCompList = function (globalStringList) {
	switch (globalStringList.$) {
		case 'ProtoGlobalStringListIf':
			var ifInput = globalStringList.a;
			var thenInput = globalStringList.b;
			var elseInput = globalStringList.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringListToCompList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringListToCompList, elseInput)));
		case 'ProtoGlobalStringsAsList':
			var listOfExprs = globalStringList.a;
			var dragModel = globalStringList.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$globalStringToComp),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		case 'ProtoGlobalAllStringsInField':
			if (globalStringList.b.$ === 'Unselected') {
				var refInput = globalStringList.a;
				var fieldState = globalStringList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllCompsInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'ProtoGlobalChallengeReasons':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$globalStringToComp = function (globalString) {
	switch (globalString.$) {
		case 'ProtoGlobalMaxString':
			var listInput = globalString.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalMaxComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringListToCompList, listInput)));
		case 'ProtoGlobalMinString':
			var listInput = globalString.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalMinComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringListToCompList, listInput)));
		case 'ProtoGlobalStringIf':
			var ifInput = globalString.a;
			var thenInput = globalString.b;
			var elseInput = globalString.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, elseInput)));
		case 'ProtoGlobalPickString':
			var listInput = globalString.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringListToCompList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$adjustGlobalBoolComparisons = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalGTString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalGTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringB))));
		case 'ProtoGlobalGTNumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalGTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberB))));
		case 'ProtoGlobalGTDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalGTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateB))));
		case 'ProtoGlobalGTDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalGTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateB))));
		case 'ProtoGlobalGTEString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringB))));
		case 'ProtoGlobalGTENumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberB))));
		case 'ProtoGlobalGTEDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateB))));
		case 'ProtoGlobalGTEDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateB))));
		case 'ProtoGlobalLTString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalLTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringB))));
		case 'ProtoGlobalLTNumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalLTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberB))));
		case 'ProtoGlobalLTDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalLTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateB))));
		case 'ProtoGlobalLTDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalLTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateB))));
		case 'ProtoGlobalLTEString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringB))));
		case 'ProtoGlobalLTENumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberB))));
		case 'ProtoGlobalLTEDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateB))));
		case 'ProtoGlobalLTEDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateB))));
		case 'ProtoGlobalEqualString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringB))));
		case 'ProtoGlobalEqualNumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberB))));
		case 'ProtoGlobalEqualDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateB))));
		case 'ProtoGlobalEqualDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateB))));
		case 'ProtoGlobalEqualBool':
			var boolA = proto.a;
			var boolB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalEqualAny,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalBoolToAny, boolA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalBoolToAny, boolB))));
		case 'ProtoGlobalNotEqualString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToComp, stringB))));
		case 'ProtoGlobalNotEqualNumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToComp, numberB))));
		case 'ProtoGlobalNotEqualDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToComp, dateB))));
		case 'ProtoGlobalNotEqualDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToComp, dateB))));
		case 'ProtoGlobalNotEqualBool':
			var boolA = proto.a;
			var boolB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualAny,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalBoolToAny, boolA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalBoolToAny, boolB))));
		default:
			return proto;
	}
};
var $author$project$DataElement$ProtoExpression$globalCompListToAnyList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalCompListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToAnyList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToAnyList, elseInput)));
		case 'ProtoGlobalCompsAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$globalCompToAny),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			var refInput = proto.a;
			var fieldState = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField, refInput, fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$globalCompToAny = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalMaxComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalMinComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoGlobalCompIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToAny, elseInput)));
		default:
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToAnyList, listInput)));
	}
};
var $author$project$ExpressionInput$convertGlobalCompFieldToGlobalField = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringComp':
			var globalString = proto.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalStringField(globalString);
		case 'ProtoGlobalNumberComp':
			var globalNumber = proto.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberField(globalNumber);
		case 'ProtoGlobalDateComp':
			var globalDate = proto.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateField(globalDate);
		case 'ProtoGlobalDateTimeComp':
			var globalDateTime = proto.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeField(globalDateTime);
		default:
			var globalComp = proto.a;
			var _v1 = $author$project$DataElement$ProtoExpression$globalCompToAny(globalComp);
			if (_v1.$ === 'Just') {
				var globalAny = _v1.a;
				return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny);
			} else {
				return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(globalComp);
			}
	}
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$DataElement$ProtoExpression$globalAnyListToBoolList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalBoolListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToBoolList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToBoolList, elseInput));
		case 'ProtoGlobalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalBoolsAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToBool),
					listOfExprs),
				dragModel);
		default:
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllBoolsInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyToBool = function (globalAny) {
	if (globalAny.$ === 'ProtoGlobalAnyIf') {
		var ifInput = globalAny.a;
		var thenInput = globalAny.b;
		var elseInput = globalAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoGlobalBoolIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToBool, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToBool, elseInput));
	} else {
		var anyList = globalAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalPickBool(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToBoolList, anyList));
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyListToCompList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToCompList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToCompList, elseInput));
		case 'ProtoGlobalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToComp),
					listOfExprs),
				dragModel);
		default:
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllCompsInField, refInput, fieldState);
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyToComp = function (globalAny) {
	if (globalAny.$ === 'ProtoGlobalAnyIf') {
		var ifInput = globalAny.a;
		var thenInput = globalAny.b;
		var elseInput = globalAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToComp, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToComp, elseInput));
	} else {
		var anyList = globalAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalPickComp(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToCompList, anyList));
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyListToDateList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateList, elseInput));
		case 'ProtoGlobalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDatesAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToDate),
					listOfExprs),
				dragModel);
		default:
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllDatesInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyToDate = function (globalAny) {
	if (globalAny.$ === 'ProtoGlobalAnyIf') {
		var ifInput = globalAny.a;
		var thenInput = globalAny.b;
		var elseInput = globalAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDate, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDate, elseInput));
	} else {
		var anyList = globalAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalPickDate(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateList, anyList));
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyListToDateTimeList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateTimeList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateTimeList, elseInput));
		case 'ProtoGlobalAllAnysInField':
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllDateTimesInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		default:
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimesAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToDateTime),
					listOfExprs),
				dragModel);
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyToDateTime = function (globalAny) {
	if (globalAny.$ === 'ProtoGlobalAnyIf') {
		var ifInput = globalAny.a;
		var thenInput = globalAny.b;
		var elseInput = globalAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDateTime, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDateTime, elseInput));
	} else {
		var anyList = globalAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalPickDateTime(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateTimeList, anyList));
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyListToNumberList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToNumberList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToNumberList, elseInput));
		case 'ProtoGlobalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumbersAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToNumber),
					listOfExprs),
				dragModel);
		default:
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllNumbersInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyToNumber = function (globalAny) {
	if (globalAny.$ === 'ProtoGlobalAnyIf') {
		var ifInput = globalAny.a;
		var thenInput = globalAny.b;
		var elseInput = globalAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToNumber, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToNumber, elseInput));
	} else {
		var numberList = globalAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalPickNumber(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToNumberList, numberList));
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyListToStringList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToStringList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToStringList, elseInput));
		case 'ProtoGlobalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringsAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToString),
					listOfExprs),
				dragModel);
		default:
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllStringsInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$globalAnyToString = function (globalAny) {
	if (globalAny.$ === 'ProtoGlobalAnyIf') {
		var ifInput = globalAny.a;
		var thenInput = globalAny.b;
		var elseInput = globalAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToString, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToString, elseInput));
	} else {
		var stringList = globalAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalPickString(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToStringList, stringList));
	}
};
var $author$project$DataElement$ProtoExpression$globalCompListToDateList = function (globalCompList) {
	switch (globalCompList.$) {
		case 'ProtoGlobalCompListIf':
			var ifInput = globalCompList.a;
			var thenInput = globalCompList.b;
			var elseInput = globalCompList.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateList, elseInput));
		case 'ProtoGlobalCompsAsList':
			var listOfExpr = globalCompList.a;
			var dragModel = globalCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDatesAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalCompToDate),
					listOfExpr),
				dragModel);
		default:
			var refInput = globalCompList.a;
			var fieldState = globalCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllDatesInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$globalCompToDate = function (globalComp) {
	switch (globalComp.$) {
		case 'ProtoGlobalMaxComp':
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxDate(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateList, listInput));
		case 'ProtoGlobalMinComp':
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMinDate(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateList, listInput));
		case 'ProtoGlobalCompIf':
			var ifInput = globalComp.a;
			var thenInput = globalComp.b;
			var elseInput = globalComp.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, elseInput));
		default:
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalPickDate(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$globalCompListToDateTimeList = function (globalCompList) {
	switch (globalCompList.$) {
		case 'ProtoGlobalCompListIf':
			var ifInput = globalCompList.a;
			var thenInput = globalCompList.b;
			var elseInput = globalCompList.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateTimeList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateTimeList, elseInput));
		case 'ProtoGlobalAllCompsInField':
			var refInput = globalCompList.a;
			var fieldState = globalCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllDateTimesInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		default:
			var listOfExpr = globalCompList.a;
			var dragModel = globalCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimesAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalCompToDateTime),
					listOfExpr),
				dragModel);
	}
};
var $author$project$DataElement$ProtoExpression$globalCompToDateTime = function (globalComp) {
	switch (globalComp.$) {
		case 'ProtoGlobalMaxComp':
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxDateTime(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateTimeList, listInput));
		case 'ProtoGlobalCompIf':
			var ifInput = globalComp.a;
			var thenInput = globalComp.b;
			var elseInput = globalComp.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, elseInput));
		case 'ProtoGlobalMinComp':
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMinDateTime(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateTimeList, listInput));
		default:
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalPickDateTime(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateTimeList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$globalCompListToNumberList = function (globalCompList) {
	switch (globalCompList.$) {
		case 'ProtoGlobalCompListIf':
			var ifInput = globalCompList.a;
			var thenInput = globalCompList.b;
			var elseInput = globalCompList.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToNumberList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToNumberList, elseInput));
		case 'ProtoGlobalCompsAsList':
			var listOfExpr = globalCompList.a;
			var dragModel = globalCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumbersAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalCompToNumber),
					listOfExpr),
				dragModel);
		default:
			var refInput = globalCompList.a;
			var fieldState = globalCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllNumbersInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$globalCompToNumber = function (globalComp) {
	switch (globalComp.$) {
		case 'ProtoGlobalMaxComp':
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxNumber(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToNumberList, listInput));
		case 'ProtoGlobalMinComp':
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMinNumber(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToNumberList, listInput));
		case 'ProtoGlobalCompIf':
			var ifInput = globalComp.a;
			var thenInput = globalComp.b;
			var elseInput = globalComp.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, elseInput));
		default:
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalPickNumber(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToNumberList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$globalCompListToStringList = function (globalCompList) {
	switch (globalCompList.$) {
		case 'ProtoGlobalCompListIf':
			var ifInput = globalCompList.a;
			var thenInput = globalCompList.b;
			var elseInput = globalCompList.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToStringList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToStringList, elseInput));
		case 'ProtoGlobalCompsAsList':
			var listOfExpr = globalCompList.a;
			var dragModel = globalCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringsAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$globalCompToString),
					listOfExpr),
				dragModel);
		default:
			var refInput = globalCompList.a;
			var fieldState = globalCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllStringsInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$globalCompToString = function (globalComp) {
	switch (globalComp.$) {
		case 'ProtoGlobalMaxComp':
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxString(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToStringList, listInput));
		case 'ProtoGlobalMinComp':
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMinString(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToStringList, listInput));
		case 'ProtoGlobalCompIf':
			var ifInput = globalComp.a;
			var thenInput = globalComp.b;
			var elseInput = globalComp.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, elseInput));
		default:
			var listInput = globalComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalPickString(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToStringList, listInput));
	}
};
var $author$project$Input$empty = $author$project$Input$Unselected($author$project$Input$emptyState);
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$ExpressionInput$addUnseletedAtEnd = function (inputList) {
	var _v0 = $elm_community$list_extra$List$Extra$last(inputList);
	if (_v0.$ === 'Nothing') {
		return _List_fromArray(
			[$author$project$Input$empty]);
	} else {
		if (_v0.a.$ === 'Selected') {
			return _Utils_ap(
				inputList,
				_List_fromArray(
					[$author$project$Input$empty]));
		} else {
			return inputList;
		}
	}
};
var $author$project$ExpressionInput$consLast = function (_v0) {
	var item = _v0.a;
	var list = _v0.b;
	return _Utils_ap(
		list,
		_List_fromArray(
			[item]));
};
var $author$project$Input$isSelected = function (inputA) {
	if (inputA.$ === 'Selected') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$ExpressionInput$removeUnselected = A2(
	$elm$core$Basics$composeR,
	$elm_community$list_extra$List$Extra$unconsLast,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$mapSecond(
					$elm$core$List$filter($author$project$Input$isSelected)),
				$author$project$ExpressionInput$consLast)),
		$elm$core$Maybe$withDefault(_List_Nil)));
var $author$project$ExpressionInput$resizeInputList = A2($elm$core$Basics$composeR, $author$project$ExpressionInput$removeUnselected, $author$project$ExpressionInput$addUnseletedAtEnd);
var $author$project$ExpressionInput$selectGlobalAny = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalAny':
			var globalAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny));
		case 'BaseGlobalString':
			var globalString = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringField(globalString));
		case 'BaseGlobalNumber':
			var globalNumber = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberField(globalNumber));
		case 'BaseGlobalDate':
			var globalDate = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateField(globalDate));
		case 'BaseGlobalDateTime':
			var globalDateTime = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeField(globalDateTime));
		case 'BaseGlobalBool':
			var globalBool = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalBoolField(globalBool));
		case 'BaseGlobalComp':
			var globalComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(globalComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalAnyList = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalStringList':
			var globalStringList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringFieldList(globalStringList));
		case 'BaseGlobalNumberList':
			var globalNumberList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberFieldList(globalNumberList));
		case 'BaseGlobalDateList':
			var globalDateList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateFieldList(globalDateList));
		case 'BaseGlobalDateTimeList':
			var globalDateTimeList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeFieldList(globalDateTimeList));
		case 'BaseGlobalBoolList':
			var globalBoolList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalBoolFieldList(globalBoolList));
		case 'BaseGlobalAnyList':
			var globalAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(globalAnyList));
		case 'BaseGlobalCompList':
			var globalCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompListAsFieldList(globalCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalBool = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalBool':
			var globalBool = proto.a;
			return $elm$core$Maybe$Just(globalBool);
		case 'BaseGlobalAny':
			var globalAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyToBool(globalAny));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalBoolList = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalBoolList':
			var globalBoolList = proto.a;
			return $elm$core$Maybe$Just(globalBoolList);
		case 'BaseGlobalAnyList':
			var globalAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyListToBoolList(globalAnyList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalComp = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalAny':
			var globalAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
					$author$project$DataElement$ProtoExpression$globalAnyToComp(globalAny)));
		case 'BaseGlobalString':
			var globalString = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringComp(globalString));
		case 'BaseGlobalNumber':
			var globalNumber = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp(globalNumber));
		case 'BaseGlobalDate':
			var globalDate = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateComp(globalDate));
		case 'BaseGlobalDateTime':
			var globalDateTime = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp(globalDateTime));
		case 'BaseGlobalComp':
			var globalComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalCompList = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalStringList':
			var globalStringList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompStringList(globalStringList));
		case 'BaseGlobalNumberList':
			var globalNumberList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompNumberList(globalNumberList));
		case 'BaseGlobalDateList':
			var globalDateList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompDateList(globalDateList));
		case 'BaseGlobalDateTimeList':
			var globalDateTimeList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompDateTimeList(globalDateTimeList));
		case 'BaseGlobalAnyList':
			var globalAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
					$author$project$DataElement$ProtoExpression$globalAnyListToCompList(globalAnyList)));
		case 'BaseGlobalCompList':
			var globalCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(globalCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalDate = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalDate':
			var globalDate = proto.a;
			return $elm$core$Maybe$Just(globalDate);
		case 'BaseGlobalAny':
			var globalAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyToDate(globalAny));
		case 'BaseGlobalComp':
			var globalComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalCompToDate(globalComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalDateList = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalDateList':
			var globalDateList = proto.a;
			return $elm$core$Maybe$Just(globalDateList);
		case 'BaseGlobalAnyList':
			var globalAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyListToDateList(globalAnyList));
		case 'BaseGlobalCompList':
			var globalCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalCompListToDateList(globalCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalDateTime = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalDateTime':
			var globalDateTime = proto.a;
			return $elm$core$Maybe$Just(globalDateTime);
		case 'BaseGlobalAny':
			var globalAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyToDateTime(globalAny));
		case 'BaseGlobalComp':
			var globalComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalCompToDateTime(globalComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalDateTimeList = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalDateTimeList':
			var globalDateTimeList = proto.a;
			return $elm$core$Maybe$Just(globalDateTimeList);
		case 'BaseGlobalAnyList':
			var globalAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyListToDateTimeList(globalAnyList));
		case 'BaseGlobalCompList':
			var globalCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalCompListToDateTimeList(globalCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalField = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalString':
			var globalString = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringField(globalString));
		case 'BaseGlobalNumber':
			var globalNumber = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberField(globalNumber));
		case 'BaseGlobalDate':
			var globalDate = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateField(globalDate));
		case 'BaseGlobalDateTime':
			var globalDateTime = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeField(globalDateTime));
		case 'BaseGlobalBool':
			var globalBool = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalBoolField(globalBool));
		case 'BaseGlobalAny':
			var globalAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny));
		case 'BaseGlobalComp':
			var globalComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(globalComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalNumber = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalNumber':
			var globalNumber = proto.a;
			return $elm$core$Maybe$Just(globalNumber);
		case 'BaseGlobalAny':
			var globalAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyToNumber(globalAny));
		case 'BaseGlobalComp':
			var globalComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalCompToNumber(globalComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalNumberList = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalNumberList':
			var globalNumberList = proto.a;
			return $elm$core$Maybe$Just(globalNumberList);
		case 'BaseGlobalAnyList':
			var globalAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyListToNumberList(globalAnyList));
		case 'BaseGlobalCompList':
			var globalCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalCompListToNumberList(globalCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalString = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalString':
			var globalString = proto.a;
			return $elm$core$Maybe$Just(globalString);
		case 'BaseGlobalAny':
			var globalAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyToString(globalAny));
		case 'BaseGlobalComp':
			var globalComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalCompToString(globalComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectGlobalStringList = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalStringList':
			var globalStringList = proto.a;
			return $elm$core$Maybe$Just(globalStringList);
		case 'BaseGlobalAnyList':
			var globalAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalAnyListToStringList(globalAnyList));
		case 'BaseGlobalCompList':
			var globalCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$globalCompListToStringList(globalCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$ExpressionInput$selectAnyFieldName = function (proto) {
	if (proto.$ === 'BaseFieldName') {
		switch (proto.a.$) {
			case 'StringType':
				var _v1 = proto.a;
				var fieldName = proto.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2($author$project$FieldType$StringType, fieldName));
			case 'NumberType':
				var _v2 = proto.a;
				var fieldName = proto.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2($author$project$FieldType$NumberType, fieldName));
			case 'DateType':
				var _v3 = proto.a;
				var fieldName = proto.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2($author$project$FieldType$DateType, fieldName));
			case 'DateTimeType':
				var _v4 = proto.a;
				var fieldName = proto.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2($author$project$FieldType$DateTimeType, fieldName));
			default:
				var _v5 = proto.a;
				var fieldName = proto.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2($author$project$FieldType$BoolType, fieldName));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Debug$log = _Debug_log;
var $Kurren123$k_dropdown_container$DropdownContainer$Open = {$: 'Open'};
var $Kurren123$k_dropdown_container$DropdownContainer$dropDownCurrentlyClicked = function (_v0) {
	var c = _v0.a;
	return c;
};
var $author$project$ExpressionInput$updateInputState = F2(
	function (msg, input) {
		if (input.$ === 'Unselected') {
			var inputState = input.a;
			switch (msg.$) {
				case 'UserTyped':
					var words = msg.a;
					return $author$project$Input$Unselected(
						_Utils_update(
							inputState,
							{text: words}));
				case 'OpenSearchList':
					return $author$project$Input$Unselected(
						_Utils_update(
							inputState,
							{open: $Kurren123$k_dropdown_container$DropdownContainer$Open}));
				case 'CloseSearchList':
					return $author$project$Input$Unselected(
						_Utils_update(
							inputState,
							{
								open: $Kurren123$k_dropdown_container$DropdownContainer$dropDownCurrentlyClicked(inputState.dropdownState) ? inputState.open : $Kurren123$k_dropdown_container$DropdownContainer$Closed
							}));
				default:
					var newState = msg.a;
					return $author$project$Input$Unselected(
						_Utils_update(
							inputState,
							{dropdownState: newState}));
			}
		} else {
			return input;
		}
	});
var $author$project$ExpressionInput$updateInputGeneric = F3(
	function (conf, inputMsg, input) {
		switch (inputMsg.$) {
			case 'MsgForInputState':
				var inputStateMsg = inputMsg.a;
				return A2(
					$author$project$Input$map,
					conf.convert,
					A2($author$project$ExpressionInput$updateInputState, inputStateMsg, input));
			case 'Reset':
				return $author$project$Input$empty;
			case 'Select':
				var baseProto = inputMsg.a;
				var _v1 = conf.select(baseProto);
				if (_v1.$ === 'Just') {
					var b = _v1.a;
					return $author$project$Input$Selected(b);
				} else {
					return A2(
						$elm$core$Debug$log,
						'mismatch in ' + conf.tag,
						A2($author$project$Input$map, conf.convert, input));
				}
			case 'InnerMsg':
				var child = inputMsg.a;
				var innerMsg = inputMsg.b;
				return A2(
					$author$project$Input$map,
					A2(conf.updateChild, child, innerMsg),
					input);
			default:
				var dragMsg = inputMsg.a;
				return A2(
					$author$project$Input$map,
					A2(
						$elm$core$Basics$composeR,
						conf.updateDrag(dragMsg),
						conf.convert),
					input);
		}
	});
var $author$project$ExpressionInput$updateAnyFieldNameState = F2(
	function (inputMsg, state) {
		return A3(
			$author$project$ExpressionInput$updateInputGeneric,
			{
				convert: $elm$core$Basics$identity,
				select: $author$project$ExpressionInput$selectAnyFieldName,
				tag: 'Update Any Field Name',
				updateChild: F3(
					function (_v0, _v1, input) {
						return input;
					}),
				updateDrag: function (_v2) {
					return $elm$core$Basics$identity;
				}
			},
			inputMsg,
			$author$project$Input$Unselected(state));
	});
var $author$project$ExpressionInput$selectBoolFieldName = function (proto) {
	if ((proto.$ === 'BaseFieldName') && (proto.a.$ === 'BoolType')) {
		var _v1 = proto.a;
		var fieldName = proto.b;
		return $elm$core$Maybe$Just(fieldName);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$updateBoolFieldNameInput = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectBoolFieldName,
		tag: 'Update Bool Field Name',
		updateChild: F3(
			function (_v0, _v1, input) {
				return input;
			}),
		updateDrag: function (_v2) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$ExpressionInput$selectCompFieldName = function (proto) {
	_v0$4:
	while (true) {
		if (proto.$ === 'BaseFieldName') {
			switch (proto.a.$) {
				case 'StringType':
					var _v1 = proto.a;
					var fieldName = proto.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2($author$project$ComparableType$StringComp, fieldName));
				case 'NumberType':
					var _v2 = proto.a;
					var fieldName = proto.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2($author$project$ComparableType$NumberComp, fieldName));
				case 'DateType':
					var _v3 = proto.a;
					var fieldName = proto.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2($author$project$ComparableType$DateComp, fieldName));
				case 'DateTimeType':
					var _v4 = proto.a;
					var fieldName = proto.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2($author$project$ComparableType$DateTimeComp, fieldName));
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$ExpressionInput$updateCompFieldNameState = F2(
	function (inputMsg, state) {
		return A3(
			$author$project$ExpressionInput$updateInputGeneric,
			{
				convert: $elm$core$Basics$identity,
				select: $author$project$ExpressionInput$selectCompFieldName,
				tag: 'Update Comparable Field Name',
				updateChild: F3(
					function (_v0, _v1, input) {
						return input;
					}),
				updateDrag: function (_v2) {
					return $elm$core$Basics$identity;
				}
			},
			inputMsg,
			$author$project$Input$Unselected(state));
	});
var $author$project$ExpressionInput$selectDateFieldName = function (proto) {
	if ((proto.$ === 'BaseFieldName') && (proto.a.$ === 'DateType')) {
		var _v1 = proto.a;
		var fieldName = proto.b;
		return $elm$core$Maybe$Just(fieldName);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$updateDateFieldNameInput = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectDateFieldName,
		tag: 'Update Date Field Name',
		updateChild: F3(
			function (_v0, _v1, input) {
				return input;
			}),
		updateDrag: function (_v2) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$ExpressionInput$selectDateTimeFieldName = function (proto) {
	if ((proto.$ === 'BaseFieldName') && (proto.a.$ === 'DateTimeType')) {
		var _v1 = proto.a;
		var fieldName = proto.b;
		return $elm$core$Maybe$Just(fieldName);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$updateDateTimeFieldNameInput = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectDateTimeFieldName,
		tag: 'Update DateTime Field Name',
		updateChild: F3(
			function (_v0, _v1, input) {
				return input;
			}),
		updateDrag: function (_v2) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$ExpressionInput$updateDragGlobalAnyList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoGlobalAnysAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragGlobalBoolList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoGlobalBoolsAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalBoolsAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragGlobalCompFieldList = F2(
	function (dragMsg, proto) {
		_v0$5:
		while (true) {
			switch (proto.$) {
				case 'ProtoGlobalCompStringList':
					if (proto.a.$ === 'ProtoGlobalStringsAsList') {
						var _v1 = proto.a;
						var listOfInputs = _v1.a;
						var dragModel = _v1.b;
						var _v2 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
						var newModel = _v2.a;
						var newList = _v2.b;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompStringList(
							A2($author$project$DataElement$ProtoExpression$ProtoGlobalStringsAsList, newList, newModel));
					} else {
						break _v0$5;
					}
				case 'ProtoGlobalCompNumberList':
					if (proto.a.$ === 'ProtoGlobalNumbersAsList') {
						var _v3 = proto.a;
						var listOfInputs = _v3.a;
						var dragModel = _v3.b;
						var _v4 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
						var newModel = _v4.a;
						var newList = _v4.b;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompNumberList(
							A2($author$project$DataElement$ProtoExpression$ProtoGlobalNumbersAsList, newList, newModel));
					} else {
						break _v0$5;
					}
				case 'ProtoGlobalCompDateList':
					if (proto.a.$ === 'ProtoGlobalDatesAsList') {
						var _v5 = proto.a;
						var listOfInputs = _v5.a;
						var dragModel = _v5.b;
						var _v6 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
						var newModel = _v6.a;
						var newList = _v6.b;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateList(
							A2($author$project$DataElement$ProtoExpression$ProtoGlobalDatesAsList, newList, newModel));
					} else {
						break _v0$5;
					}
				case 'ProtoGlobalCompDateTimeList':
					if (proto.a.$ === 'ProtoGlobalDateTimesAsList') {
						var _v7 = proto.a;
						var listOfInputs = _v7.a;
						var dragModel = _v7.b;
						var _v8 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
						var newModel = _v8.a;
						var newList = _v8.b;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateTimeList(
							A2($author$project$DataElement$ProtoExpression$ProtoGlobalDateTimesAsList, newList, newModel));
					} else {
						break _v0$5;
					}
				default:
					if (proto.a.$ === 'ProtoGlobalCompsAsList') {
						var _v9 = proto.a;
						var listOfInputs = _v9.a;
						var dragModel = _v9.b;
						var _v10 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
						var newModel = _v10.a;
						var newList = _v10.b;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
							A2($author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList, newList, newModel));
					} else {
						break _v0$5;
					}
			}
		}
		return proto;
	});
var $author$project$ExpressionInput$updateDragGlobalCompList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoGlobalCompsAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragGlobalDateList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoGlobalDatesAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalDatesAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragGlobalDateTimeList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoGlobalDateTimesAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalDateTimesAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragGlobalNumberList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoGlobalNumbersAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalNumbersAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragGlobalStringList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoGlobalStringsAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalStringsAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$selectDateInterval = function (proto) {
	if (proto.$ === 'BaseDateInterval') {
		var dateInterval = proto.a;
		return $elm$core$Maybe$Just(dateInterval);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$updateInputDateInterval = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectDateInterval,
		tag: 'Update Date Interval',
		updateChild: F3(
			function (_v0, _v1, input) {
				return input;
			}),
		updateDrag: function (_v2) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$ExpressionInput$selectDateUnit = function (proto) {
	if (proto.$ === 'BaseDateUnit') {
		var dateUnit = proto.a;
		return $elm$core$Maybe$Just(dateUnit);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$updateInputDateUnit = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectDateUnit,
		tag: 'Update Date Unit',
		updateChild: F3(
			function (_v0, _v1, input) {
				return input;
			}),
		updateDrag: function (_v2) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$ExpressionInput$selectListReference = function (proto) {
	if (proto.$ === 'BaseListRef') {
		var listRef = proto.a;
		return $elm$core$Maybe$Just(listRef);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$updateInputListReference = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectListReference,
		tag: 'Update List Reference',
		updateChild: F3(
			function (_v0, _v1, input) {
				return input;
			}),
		updateDrag: function (_v2) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$IntInput$Empty = {$: 'Empty'};
var $author$project$IntInput$Dash = {$: 'Dash'};
var $author$project$IntInput$Selected = function (a) {
	return {$: 'Selected', a: a};
};
var $author$project$IntInput$fromString = function (word) {
	switch (word) {
		case '':
			return $elm$core$Maybe$Just($author$project$IntInput$Empty);
		case '-':
			return $elm$core$Maybe$Just($author$project$IntInput$Dash);
		default:
			return A2(
				$elm$core$Maybe$map,
				$author$project$IntInput$Selected,
				$elm$core$String$toInt(word));
	}
};
var $author$project$ExpressionInput$updateIntInput = F2(
	function (inputMsg, intInput) {
		switch (inputMsg.$) {
			case 'Reset':
				return $author$project$IntInput$Empty;
			case 'Select':
				return intInput;
			case 'InnerMsg':
				return intInput;
			case 'MsgForInputState':
				switch (inputMsg.a.$) {
					case 'CloseSearchList':
						var _v1 = inputMsg.a;
						return intInput;
					case 'OpenSearchList':
						var _v2 = inputMsg.a;
						return intInput;
					case 'UserTyped':
						var word = inputMsg.a.a;
						return A2(
							$elm$core$Maybe$withDefault,
							intInput,
							$author$project$IntInput$fromString(word));
					default:
						return intInput;
				}
			default:
				return intInput;
		}
	});
var $author$project$ExpressionInput$selectNumberFieldName = function (proto) {
	if ((proto.$ === 'BaseFieldName') && (proto.a.$ === 'NumberType')) {
		var _v1 = proto.a;
		var fieldName = proto.b;
		return $elm$core$Maybe$Just(fieldName);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$updateNumberFieldNameInput = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectNumberFieldName,
		tag: 'Update Number Field Name',
		updateChild: F3(
			function (_v0, _v1, input) {
				return input;
			}),
		updateDrag: function (_v2) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$ExpressionInput$selectStringFieldName = function (proto) {
	if ((proto.$ === 'BaseFieldName') && (proto.a.$ === 'StringType')) {
		var _v1 = proto.a;
		var fieldName = proto.b;
		return $elm$core$Maybe$Just(fieldName);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$updateStringFieldNameInput = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectStringFieldName,
		tag: 'Update String Field Name',
		updateChild: F3(
			function (_v0, _v1, input) {
				return input;
			}),
		updateDrag: function (_v2) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$ExpressionInput$wrapGlobalBool = function (globalBool) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalBoolToAny(globalBool);
	if (_v0.$ === 'Just') {
		var globalAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolField(globalBool);
	}
};
var $author$project$DataElement$ProtoExpression$globalDateListToAnyList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateListToAnyList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateListToAnyList, elseInput)));
		case 'ProtoGlobalDatesAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$globalDateToAny),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (proto.b.$ === 'Unselected') {
				var refInput = proto.a;
				var fieldState = proto.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$globalDateToAny = function (globalDate) {
	switch (globalDate.$) {
		case 'ProtoGlobalDateIf':
			var ifInput = globalDate.a;
			var thenInput = globalDate.b;
			var elseInput = globalDate.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateToAny, elseInput)));
		case 'ProtoGlobalPickDate':
			var anyList = globalDate.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateListToAnyList, anyList)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapGlobalDate = function (globalDate) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalDateToAny(globalDate);
	if (_v0.$ === 'Just') {
		var globalAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny);
	} else {
		var _v1 = $author$project$DataElement$ProtoExpression$globalDateToComp(globalDate);
		if (_v1.$ === 'Just') {
			var globalComp = _v1.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(globalComp);
		} else {
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateField(globalDate);
		}
	}
};
var $author$project$ExpressionInput$wrapGlobalDateListAsComp = function (dateList) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalDateListToCompList(dateList);
	if (_v0.$ === 'Just') {
		var compList = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(compList);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateList(dateList);
	}
};
var $author$project$DataElement$ProtoExpression$globalDateTimeListToAnyList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateTimeListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeListToAnyList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeListToAnyList, elseInput)));
		case 'ProtoGlobalDateTimesAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$globalDateTimeToAny),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (proto.b.$ === 'Unselected') {
				var refInput = proto.a;
				var fieldState = proto.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$globalDateTimeToAny = function (globalDateTime) {
	switch (globalDateTime.$) {
		case 'ProtoGlobalDateTimeIf':
			var ifInput = globalDateTime.a;
			var thenInput = globalDateTime.b;
			var elseInput = globalDateTime.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeToAny, elseInput)));
		case 'ProtoGlobalPickDateTime':
			var anyList = globalDateTime.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalDateTimeListToAnyList, anyList)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapGlobalDateTime = function (globalDateTime) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalDateTimeToAny(globalDateTime);
	if (_v0.$ === 'Just') {
		var globalAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny);
	} else {
		var _v1 = $author$project$DataElement$ProtoExpression$globalDateTimeToComp(globalDateTime);
		if (_v1.$ === 'Just') {
			var globalComp = _v1.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(globalComp);
		} else {
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeField(globalDateTime);
		}
	}
};
var $author$project$ExpressionInput$wrapGlobalDateTimeListAsComp = function (dateList) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalDateTimeListToCompList(dateList);
	if (_v0.$ === 'Just') {
		var compList = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(compList);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateTimeList(dateList);
	}
};
var $author$project$DataElement$ProtoExpression$globalNumberListToAnyList = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalNumberListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberListToAnyList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberListToAnyList, elseInput)));
		case 'ProtoGlobalNumbersAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$globalNumberToAny),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (proto.b.$ === 'Unselected') {
				var refInput = proto.a;
				var fieldState = proto.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$globalNumberToAny = function (globalNumber) {
	switch (globalNumber.$) {
		case 'ProtoGlobalNumberIf':
			var ifInput = globalNumber.a;
			var thenInput = globalNumber.b;
			var elseInput = globalNumber.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberToAny, elseInput)));
		case 'ProtoGlobalPickNumber':
			var anyList = globalNumber.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalNumberListToAnyList, anyList)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapGlobalNumber = function (globalNumber) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalNumberToAny(globalNumber);
	if (_v0.$ === 'Just') {
		var globalAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny);
	} else {
		var _v1 = $author$project$DataElement$ProtoExpression$globalNumberToComp(globalNumber);
		if (_v1.$ === 'Just') {
			var globalComp = _v1.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(globalComp);
		} else {
			return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberField(globalNumber);
		}
	}
};
var $author$project$ExpressionInput$wrapGlobalNumberListAsComp = function (numberList) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalNumberListToCompList(numberList);
	if (_v0.$ === 'Just') {
		var compList = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(compList);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompNumberList(numberList);
	}
};
var $author$project$DataElement$ProtoExpression$globalStringListToAnyList = function (proto) {
	_v1$3:
	while (true) {
		switch (proto.$) {
			case 'ProtoGlobalStringListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf(ifInput),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringListToAnyList, thenInput)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringListToAnyList, elseInput)));
			case 'ProtoGlobalStringsAsList':
				var listOfExprs = proto.a;
				var dragModel = proto.b;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Input$map($author$project$DataElement$ProtoExpression$globalStringToAny),
								$author$project$Input$maybe),
							listOfExprs)),
					$elm$core$Maybe$Just(dragModel));
			case 'ProtoGlobalAllStringsInField':
				if (proto.b.$ === 'Unselected') {
					var refInput = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField, refInput, fieldState));
				} else {
					break _v1$3;
				}
			default:
				break _v1$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$DataElement$ProtoExpression$globalStringToAny = function (globalString) {
	switch (globalString.$) {
		case 'ProtoGlobalStringIf':
			var ifInput = globalString.a;
			var thenInput = globalString.b;
			var elseInput = globalString.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringToAny, elseInput)));
		case 'ProtoGlobalPickString':
			var stringList = globalString.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoGlobalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalStringListToAnyList, stringList)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapGlobalString = function (globalString) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalStringToAny(globalString);
	if (_v0.$ === 'Just') {
		var globalAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny);
	} else {
		var _v1 = $author$project$DataElement$ProtoExpression$globalStringToComp(globalString);
		if (_v1.$ === 'Just') {
			var globalComp = _v1.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(globalComp);
		} else {
			return $author$project$DataElement$ProtoExpression$ProtoGlobalStringField(globalString);
		}
	}
};
var $author$project$ExpressionInput$wrapGlobalStringListAsComp = function (stringList) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalStringListToCompList(stringList);
	if (_v0.$ === 'Just') {
		var compList = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(compList);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompStringList(stringList);
	}
};
var $author$project$ExpressionInput$updateInputGlobalAnyChild = F3(
	function (child, inputMsg, globalAny) {
		var _v297 = _Utils_Tuple2(globalAny, child);
		if (_v297.a.$ === 'ProtoGlobalAnyIf') {
			switch (_v297.b) {
				case 0:
					var _v298 = _v297.a;
					var condInput = _v298.a;
					var thenInput = _v298.b;
					var elseInput = _v298.c;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(
						A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput));
				case 1:
					var _v299 = _v297.a;
					var condInput = _v299.a;
					var thenInput = _v299.b;
					var elseInput = _v299.c;
					var _v300 = A2(
						$author$project$ExpressionInput$cyclic$updateInputGlobalAny(),
						inputMsg,
						thenInput);
					if (_v300.$ === 'Selected') {
						switch (_v300.a.$) {
							case 'ProtoGlobalStringField':
								var newThenInput = _v300.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalStringField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToString, elseInput)));
							case 'ProtoGlobalNumberField':
								var newThenInput = _v300.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToNumber, elseInput)));
							case 'ProtoGlobalDateField':
								var newThenInput = _v300.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDate, elseInput)));
							case 'ProtoGlobalDateTimeField':
								var newThenInput = _v300.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDateTime, elseInput)));
							case 'ProtoGlobalBoolField':
								var newThenInput = _v300.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalBoolIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToBool, elseInput)));
							case 'ProtoGlobalAnyField':
								var newThenInput = _v300.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										elseInput));
							default:
								var newThenInput = _v300.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToComp, elseInput)));
						}
					} else {
						var state = _v300.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf,
								condInput,
								$author$project$Input$Unselected(state),
								elseInput));
					}
				case 2:
					var _v301 = _v297.a;
					var condInput = _v301.a;
					var thenInput = _v301.b;
					var elseInput = _v301.c;
					var _v302 = A2(
						$author$project$ExpressionInput$cyclic$updateInputGlobalAny(),
						inputMsg,
						elseInput);
					if (_v302.$ === 'Selected') {
						switch (_v302.a.$) {
							case 'ProtoGlobalStringField':
								var newElseInput = _v302.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalStringField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToString, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoGlobalNumberField':
								var newElseInput = _v302.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToNumber, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoGlobalDateField':
								var newElseInput = _v302.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDate, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoGlobalDateTimeField':
								var newElseInput = _v302.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDateTime, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoGlobalBoolField':
								var newElseInput = _v302.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalBoolIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToBool, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoGlobalAnyField':
								var newElseInput = _v302.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf,
										condInput,
										thenInput,
										$author$project$Input$Selected(newElseInput)));
							default:
								var newElseInput = _v302.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToComp, thenInput),
										$author$project$Input$Selected(newElseInput)));
						}
					} else {
						var elseState = _v302.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf,
								condInput,
								thenInput,
								$author$project$Input$Unselected(elseState)));
					}
				default:
					var _v303 = _v297.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny);
			}
		} else {
			if (!_v297.b) {
				var listInput = _v297.a.a;
				var _v304 = A2(
					$author$project$ExpressionInput$cyclic$updateInputGlobalAnyList(),
					inputMsg,
					listInput);
				if (_v304.$ === 'Selected') {
					switch (_v304.a.$) {
						case 'ProtoGlobalStringFieldList':
							var newListInput = _v304.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalStringField(
								$author$project$DataElement$ProtoExpression$ProtoGlobalPickString(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoGlobalNumberFieldList':
							var newListInput = _v304.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberField(
								$author$project$DataElement$ProtoExpression$ProtoGlobalPickNumber(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoGlobalDateFieldList':
							var newListInput = _v304.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalDateField(
								$author$project$DataElement$ProtoExpression$ProtoGlobalPickDate(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoGlobalDateTimeFieldList':
							var newListInput = _v304.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeField(
								$author$project$DataElement$ProtoExpression$ProtoGlobalPickDateTime(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoGlobalBoolFieldList':
							var newListInput = _v304.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolField(
								$author$project$DataElement$ProtoExpression$ProtoGlobalPickBool(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoGlobalFieldList':
							var newListInput = _v304.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(
								$author$project$DataElement$ProtoExpression$ProtoGlobalPickAny(
									$author$project$Input$Selected(newListInput)));
						default:
							var newListInput = _v304.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsField(
								$author$project$DataElement$ProtoExpression$ProtoGlobalPickComp(
									$author$project$Input$Selected(newListInput)));
					}
				} else {
					var elseState = _v304.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(
						$author$project$DataElement$ProtoExpression$ProtoGlobalPickAny(
							$author$project$Input$Unselected(elseState)));
				}
			} else {
				return $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField(globalAny);
			}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalAnyListChild = F3(
	function (child, inputMsg, proto) {
		var _v274 = _Utils_Tuple2(proto, child);
		switch (_v274.a.$) {
			case 'ProtoGlobalAnyListIf':
				switch (_v274.b) {
					case 0:
						var _v275 = _v274.a;
						var condInput = _v275.a;
						var thenInput = _v275.b;
						var elseInput = _v275.c;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf,
								A2(
									$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
									inputMsg,
									condInput),
								thenInput,
								elseInput));
					case 1:
						var _v276 = _v274.a;
						var condInput = _v276.a;
						var thenInput = _v276.b;
						var elseInput = _v276.c;
						var _v277 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalAnyList(),
							inputMsg,
							thenInput);
						if (_v277.$ === 'Selected') {
							switch (_v277.a.$) {
								case 'ProtoGlobalStringFieldList':
									var newThenInput = _v277.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalStringFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToStringList, elseInput)));
								case 'ProtoGlobalNumberFieldList':
									var newThenInput = _v277.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToNumberList, elseInput)));
								case 'ProtoGlobalDateFieldList':
									var newThenInput = _v277.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateList, elseInput)));
								case 'ProtoGlobalDateTimeFieldList':
									var newThenInput = _v277.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateTimeList, elseInput)));
								case 'ProtoGlobalBoolFieldList':
									var newThenInput = _v277.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalBoolListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToBoolList, elseInput)));
								case 'ProtoGlobalFieldList':
									var newThenInput = _v277.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											elseInput));
								default:
									var newThenInput = _v277.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompListAsFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToCompList, elseInput)));
							}
						} else {
							var state = _v277.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf,
									condInput,
									$author$project$Input$Unselected(state),
									elseInput));
						}
					case 2:
						var _v278 = _v274.a;
						var condInput = _v278.a;
						var thenInput = _v278.b;
						var elseInput = _v278.c;
						var _v279 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalAnyList(),
							inputMsg,
							elseInput);
						if (_v279.$ === 'Selected') {
							switch (_v279.a.$) {
								case 'ProtoGlobalStringFieldList':
									var newElseInput = _v279.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalStringFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToStringList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoGlobalNumberFieldList':
									var newElseInput = _v279.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToNumberList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoGlobalDateFieldList':
									var newElseInput = _v279.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoGlobalDateTimeFieldList':
									var newElseInput = _v279.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToDateTimeList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoGlobalBoolFieldList':
									var newElseInput = _v279.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalBoolListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToBoolList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoGlobalFieldList':
									var newElseInput = _v279.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf,
											condInput,
											thenInput,
											$author$project$Input$Selected(newElseInput)));
								default:
									var newElseInput = _v279.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompListAsFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyListToCompList, thenInput),
											$author$project$Input$Selected(newElseInput)));
							}
						} else {
							var elseState = _v279.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf,
									condInput,
									thenInput,
									$author$project$Input$Unselected(elseState)));
						}
					default:
						var _v280 = _v274.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(proto);
				}
			case 'ProtoGlobalAnysAsList':
				var _v281 = _v274.a;
				var listOfExpr = _v281.a;
				var dragModel = _v281.b;
				var _v282 = A2(
					$elm$core$Maybe$map,
					$author$project$ExpressionInput$cyclic$updateInputGlobalAny()(inputMsg),
					A2($elm_community$list_extra$List$Extra$getAt, child, listOfExpr));
				if (_v282.$ === 'Nothing') {
					return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList, listOfExpr, dragModel));
				} else {
					if (_v282.a.$ === 'Unselected') {
						var inputState = _v282.a.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList,
								$author$project$ExpressionInput$resizeInputList(
									A3(
										$elm_community$list_extra$List$Extra$setAt,
										child,
										$author$project$Input$Unselected(inputState),
										listOfExpr)),
								dragModel));
					} else {
						switch (_v282.a.a.$) {
							case 'ProtoGlobalStringField':
								var globalString = _v282.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalStringFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalStringsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalString),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToString),
													listOfExpr))),
										dragModel));
							case 'ProtoGlobalNumberField':
								var globalNumber = _v282.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNumbersAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalNumber),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToNumber),
													listOfExpr))),
										dragModel));
							case 'ProtoGlobalDateField':
								var globalDate = _v282.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalDatesAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalDate),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToDate),
													listOfExpr))),
										dragModel));
							case 'ProtoGlobalDateTimeField':
								var globalDateTime = _v282.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimesAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalDateTime),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToDateTime),
													listOfExpr))),
										dragModel));
							case 'ProtoGlobalBoolField':
								var globalBool = _v282.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalBoolsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalBool),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToBool),
													listOfExpr))),
										dragModel));
							case 'ProtoGlobalAnyField':
								var globalAny = _v282.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalAny),
												listOfExpr)),
										dragModel));
							default:
								var globalComp = _v282.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompListAsFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalComp),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalAnyToComp),
													listOfExpr))),
										dragModel));
						}
					}
				}
			default:
				switch (_v274.b) {
					case 0:
						var _v283 = _v274.a;
						var refInput = _v283.a;
						var fieldNameState = _v283.b;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField,
								A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
								fieldNameState));
					case 1:
						var _v284 = _v274.a;
						var refInput = _v284.a;
						var fieldNameState = _v284.b;
						var _v285 = A2($author$project$ExpressionInput$updateAnyFieldNameState, inputMsg, fieldNameState);
						if (_v285.$ === 'Unselected') {
							var newState = _v285.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(
								A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField, refInput, newState));
						} else {
							switch (_v285.a.a.$) {
								case 'StringType':
									var _v286 = _v285.a;
									var _v287 = _v286.a;
									var fieldName = _v286.b;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalStringFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAllStringsInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'NumberType':
									var _v288 = _v285.a;
									var _v289 = _v288.a;
									var fieldName = _v288.b;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAllNumbersInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'DateType':
									var _v290 = _v285.a;
									var _v291 = _v290.a;
									var fieldName = _v290.b;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAllDatesInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'DateTimeType':
									var _v292 = _v285.a;
									var _v293 = _v292.a;
									var fieldName = _v292.b;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAllDateTimesInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								default:
									var _v294 = _v285.a;
									var _v295 = _v294.a;
									var fieldName = _v294.b;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAllBoolsInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
							}
						}
					default:
						var _v296 = _v274.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList(proto);
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalBoolChild = F3(
	function (child, inputMsg, globalBool) {
		return $author$project$ExpressionInput$adjustGlobalBoolComparisons(
			A3($author$project$ExpressionInput$updateInputGlobalBoolChildHelper, child, inputMsg, globalBool));
	});
var $author$project$ExpressionInput$updateInputGlobalBoolChildHelper = F3(
	function (child, inputMsg, globalBool) {
		var _v143 = _Utils_Tuple2(globalBool, child);
		switch (_v143.a.$) {
			case 'ProtoGlobalBoolLookup':
				var _v144 = _v143.a;
				return globalBool;
			case 'ProtoGlobalBoolHardcoded':
				return globalBool;
			case 'ProtoGlobalGTString':
				switch (_v143.b) {
					case 0:
						var _v145 = _v143.a;
						var stringA = _v145.a;
						var stringB = _v145.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v146 = _v143.a;
						var stringA = _v146.a;
						var stringB = _v146.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringB));
					default:
						var _v147 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalGTNumber':
				switch (_v143.b) {
					case 0:
						var _v148 = _v143.a;
						var stringA = _v148.a;
						var stringB = _v148.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTNumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v149 = _v143.a;
						var stringA = _v149.a;
						var stringB = _v149.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTNumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringB));
					default:
						var _v150 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalGTDate':
				switch (_v143.b) {
					case 0:
						var _v151 = _v143.a;
						var dateA = _v151.a;
						var dateB = _v151.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v152 = _v143.a;
						var dateA = _v152.a;
						var dateB = _v152.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateB));
					default:
						var _v153 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalGTDateTime':
				switch (_v143.b) {
					case 0:
						var _v154 = _v143.a;
						var dateA = _v154.a;
						var dateB = _v154.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v155 = _v143.a;
						var dateA = _v155.a;
						var dateB = _v155.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v156 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalGTComp':
				switch (_v143.b) {
					case 0:
						var _v157 = _v143.a;
						var compA = _v157.a;
						var compB = _v157.b;
						var _v158 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compA);
						if (_v158.$ === 'Unselected') {
							var inputState = _v158.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalGTComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v158.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v158.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTString,
										$author$project$Input$Selected(protoGlobalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compB));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v158.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTNumber,
										$author$project$Input$Selected(protoGlobalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compB));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v158.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTDate,
										$author$project$Input$Selected(protoGlobalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compB));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v158.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTDateTime,
										$author$project$Input$Selected(protoGlobalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compB));
								default:
									var protoGlobalCompField = _v158.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTComp,
										$author$project$Input$Selected(protoGlobalCompField),
										compB);
							}
						}
					case 2:
						var _v159 = _v143.a;
						var compA = _v159.a;
						var compB = _v159.b;
						var _v160 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compB);
						if (_v160.$ === 'Unselected') {
							var inputState = _v160.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalGTComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v160.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v160.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compA),
										$author$project$Input$Selected(protoGlobalString));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v160.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compA),
										$author$project$Input$Selected(protoGlobalNumber));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v160.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compA),
										$author$project$Input$Selected(protoGlobalDate));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v160.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compA),
										$author$project$Input$Selected(protoGlobalDateTime));
								default:
									var protoGlobalCompField = _v160.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTComp,
										compA,
										$author$project$Input$Selected(protoGlobalCompField));
							}
						}
					default:
						var _v161 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalGTEString':
				switch (_v143.b) {
					case 0:
						var _v162 = _v143.a;
						var stringA = _v162.a;
						var stringB = _v162.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTEString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v163 = _v143.a;
						var stringA = _v163.a;
						var stringB = _v163.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTEString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringB));
					default:
						var _v164 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalGTENumber':
				switch (_v143.b) {
					case 0:
						var _v165 = _v143.a;
						var stringA = _v165.a;
						var stringB = _v165.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTENumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v166 = _v143.a;
						var stringA = _v166.a;
						var stringB = _v166.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTENumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringB));
					default:
						var _v167 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalGTEDate':
				switch (_v143.b) {
					case 0:
						var _v168 = _v143.a;
						var dateA = _v168.a;
						var dateB = _v168.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v169 = _v143.a;
						var dateA = _v169.a;
						var dateB = _v169.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateB));
					default:
						var _v170 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalGTEDateTime':
				switch (_v143.b) {
					case 0:
						var _v171 = _v143.a;
						var dateA = _v171.a;
						var dateB = _v171.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v172 = _v143.a;
						var dateA = _v172.a;
						var dateB = _v172.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v173 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalGTEComp':
				switch (_v143.b) {
					case 0:
						var _v174 = _v143.a;
						var compA = _v174.a;
						var compB = _v174.b;
						var _v175 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compA);
						if (_v175.$ === 'Unselected') {
							var inputState = _v175.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v175.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v175.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTEString,
										$author$project$Input$Selected(protoGlobalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compB));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v175.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTENumber,
										$author$project$Input$Selected(protoGlobalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compB));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v175.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDate,
										$author$project$Input$Selected(protoGlobalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compB));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v175.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDateTime,
										$author$project$Input$Selected(protoGlobalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compB));
								default:
									var protoGlobalCompField = _v175.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp,
										$author$project$Input$Selected(protoGlobalCompField),
										compB);
							}
						}
					case 2:
						var _v176 = _v143.a;
						var compA = _v176.a;
						var compB = _v176.b;
						var _v177 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compB);
						if (_v177.$ === 'Unselected') {
							var inputState = _v177.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v177.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v177.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTEString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compA),
										$author$project$Input$Selected(protoGlobalString));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v177.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTENumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compA),
										$author$project$Input$Selected(protoGlobalNumber));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v177.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compA),
										$author$project$Input$Selected(protoGlobalDate));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v177.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compA),
										$author$project$Input$Selected(protoGlobalDateTime));
								default:
									var protoGlobalCompField = _v177.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp,
										compA,
										$author$project$Input$Selected(protoGlobalCompField));
							}
						}
					default:
						var _v178 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTString':
				switch (_v143.b) {
					case 0:
						var _v179 = _v143.a;
						var stringA = _v179.a;
						var stringB = _v179.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v180 = _v143.a;
						var stringA = _v180.a;
						var stringB = _v180.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringB));
					default:
						var _v181 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTNumber':
				switch (_v143.b) {
					case 0:
						var _v182 = _v143.a;
						var stringA = _v182.a;
						var stringB = _v182.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTNumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v183 = _v143.a;
						var stringA = _v183.a;
						var stringB = _v183.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTNumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringB));
					default:
						var _v184 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTDate':
				switch (_v143.b) {
					case 0:
						var _v185 = _v143.a;
						var dateA = _v185.a;
						var dateB = _v185.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v186 = _v143.a;
						var dateA = _v186.a;
						var dateB = _v186.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateB));
					default:
						var _v187 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTDateTime':
				switch (_v143.b) {
					case 0:
						var _v188 = _v143.a;
						var dateA = _v188.a;
						var dateB = _v188.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v189 = _v143.a;
						var dateA = _v189.a;
						var dateB = _v189.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v190 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTComp':
				switch (_v143.b) {
					case 0:
						var _v191 = _v143.a;
						var compA = _v191.a;
						var compB = _v191.b;
						var _v192 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compA);
						if (_v192.$ === 'Unselected') {
							var inputState = _v192.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalLTComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v192.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v192.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTString,
										$author$project$Input$Selected(protoGlobalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compB));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v192.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTNumber,
										$author$project$Input$Selected(protoGlobalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compB));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v192.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTDate,
										$author$project$Input$Selected(protoGlobalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compB));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v192.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTDateTime,
										$author$project$Input$Selected(protoGlobalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compB));
								default:
									var protoGlobalCompField = _v192.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTComp,
										$author$project$Input$Selected(protoGlobalCompField),
										compB);
							}
						}
					case 2:
						var _v193 = _v143.a;
						var compA = _v193.a;
						var compB = _v193.b;
						var _v194 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compB);
						if (_v194.$ === 'Unselected') {
							var inputState = _v194.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalLTComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v194.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v194.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compA),
										$author$project$Input$Selected(protoGlobalString));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v194.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compA),
										$author$project$Input$Selected(protoGlobalNumber));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v194.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compA),
										$author$project$Input$Selected(protoGlobalDate));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v194.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compA),
										$author$project$Input$Selected(protoGlobalDateTime));
								default:
									var protoGlobalCompField = _v194.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTComp,
										compA,
										$author$project$Input$Selected(protoGlobalCompField));
							}
						}
					default:
						var _v195 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTEString':
				switch (_v143.b) {
					case 0:
						var _v196 = _v143.a;
						var stringA = _v196.a;
						var stringB = _v196.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTEString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v197 = _v143.a;
						var stringA = _v197.a;
						var stringB = _v197.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTEString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringB));
					default:
						var _v198 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTENumber':
				switch (_v143.b) {
					case 0:
						var _v199 = _v143.a;
						var stringA = _v199.a;
						var stringB = _v199.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTENumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v200 = _v143.a;
						var stringA = _v200.a;
						var stringB = _v200.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTENumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringB));
					default:
						var _v201 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTEDate':
				switch (_v143.b) {
					case 0:
						var _v202 = _v143.a;
						var dateA = _v202.a;
						var dateB = _v202.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v203 = _v143.a;
						var dateA = _v203.a;
						var dateB = _v203.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateB));
					default:
						var _v204 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTEDateTime':
				switch (_v143.b) {
					case 0:
						var _v205 = _v143.a;
						var dateA = _v205.a;
						var dateB = _v205.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v206 = _v143.a;
						var dateA = _v206.a;
						var dateB = _v206.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v207 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalLTEComp':
				switch (_v143.b) {
					case 0:
						var _v208 = _v143.a;
						var compA = _v208.a;
						var compB = _v208.b;
						var _v209 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compA);
						if (_v209.$ === 'Unselected') {
							var inputState = _v209.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v209.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v209.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTEString,
										$author$project$Input$Selected(protoGlobalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compB));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v209.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTENumber,
										$author$project$Input$Selected(protoGlobalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compB));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v209.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDate,
										$author$project$Input$Selected(protoGlobalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compB));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v209.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDateTime,
										$author$project$Input$Selected(protoGlobalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compB));
								default:
									var protoGlobalCompField = _v209.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp,
										$author$project$Input$Selected(protoGlobalCompField),
										compB);
							}
						}
					case 2:
						var _v210 = _v143.a;
						var compA = _v210.a;
						var compB = _v210.b;
						var _v211 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compB);
						if (_v211.$ === 'Unselected') {
							var inputState = _v211.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v211.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v211.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTEString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compA),
										$author$project$Input$Selected(protoGlobalString));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v211.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTENumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compA),
										$author$project$Input$Selected(protoGlobalNumber));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v211.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compA),
										$author$project$Input$Selected(protoGlobalDate));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v211.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compA),
										$author$project$Input$Selected(protoGlobalDateTime));
								default:
									var protoGlobalCompField = _v211.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp,
										compA,
										$author$project$Input$Selected(protoGlobalCompField));
							}
						}
					default:
						var _v212 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalEqualString':
				switch (_v143.b) {
					case 0:
						var _v213 = _v143.a;
						var stringA = _v213.a;
						var stringB = _v213.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v214 = _v143.a;
						var stringA = _v214.a;
						var stringB = _v214.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringB));
					default:
						var _v215 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalEqualNumber':
				switch (_v143.b) {
					case 0:
						var _v216 = _v143.a;
						var stringA = _v216.a;
						var stringB = _v216.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualNumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v217 = _v143.a;
						var stringA = _v217.a;
						var stringB = _v217.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualNumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringB));
					default:
						var _v218 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalEqualDate':
				switch (_v143.b) {
					case 0:
						var _v219 = _v143.a;
						var dateA = _v219.a;
						var dateB = _v219.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v220 = _v143.a;
						var dateA = _v220.a;
						var dateB = _v220.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateB));
					default:
						var _v221 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalEqualDateTime':
				switch (_v143.b) {
					case 0:
						var _v222 = _v143.a;
						var dateA = _v222.a;
						var dateB = _v222.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v223 = _v143.a;
						var dateA = _v223.a;
						var dateB = _v223.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v224 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalEqualBool':
				switch (_v143.b) {
					case 0:
						var _v225 = _v143.a;
						var boolA = _v225.a;
						var boolB = _v225.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualBool,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								boolA),
							boolB);
					case 2:
						var _v226 = _v143.a;
						var boolA = _v226.a;
						var boolB = _v226.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalEqualBool,
							boolA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								boolB));
					default:
						var _v227 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalEqualComp':
				switch (_v143.b) {
					case 0:
						var _v228 = _v143.a;
						var compA = _v228.a;
						var compB = _v228.b;
						var _v229 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compA);
						if (_v229.$ === 'Unselected') {
							var inputState = _v229.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v229.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v229.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualString,
										$author$project$Input$Selected(protoGlobalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compB));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v229.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualNumber,
										$author$project$Input$Selected(protoGlobalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compB));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v229.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDate,
										$author$project$Input$Selected(protoGlobalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compB));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v229.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDateTime,
										$author$project$Input$Selected(protoGlobalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compB));
								default:
									var protoGlobalCompField = _v229.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
										$author$project$Input$Selected(protoGlobalCompField),
										compB);
							}
						}
					case 2:
						var _v230 = _v143.a;
						var compA = _v230.a;
						var compB = _v230.b;
						var _v231 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compB);
						if (_v231.$ === 'Unselected') {
							var inputState = _v231.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v231.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v231.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compA),
										$author$project$Input$Selected(protoGlobalString));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v231.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compA),
										$author$project$Input$Selected(protoGlobalNumber));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v231.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compA),
										$author$project$Input$Selected(protoGlobalDate));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v231.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compA),
										$author$project$Input$Selected(protoGlobalDateTime));
								default:
									var protoGlobalCompField = _v231.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
										compA,
										$author$project$Input$Selected(protoGlobalCompField));
							}
						}
					default:
						var _v232 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalEqualAny':
				switch (_v143.b) {
					case 0:
						var _v233 = _v143.a;
						var compA = _v233.a;
						var compB = _v233.b;
						var _v234 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalAny(),
							inputMsg,
							compA);
						if (_v234.$ === 'Unselected') {
							var inputState = _v234.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalEqualAny,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v234.a.$) {
								case 'ProtoGlobalStringField':
									var protoGlobalString = _v234.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualString,
										$author$project$Input$Selected(protoGlobalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToString, compB));
								case 'ProtoGlobalNumberField':
									var protoGlobalNumber = _v234.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualNumber,
										$author$project$Input$Selected(protoGlobalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToNumber, compB));
								case 'ProtoGlobalDateField':
									var protoGlobalDate = _v234.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDate,
										$author$project$Input$Selected(protoGlobalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDate, compB));
								case 'ProtoGlobalAnyField':
									var protoGlobalAnyField = _v234.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualAny,
										$author$project$Input$Selected(protoGlobalAnyField),
										compB);
								case 'ProtoGlobalDateTimeField':
									var protoGlobalDateTime = _v234.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDateTime,
										$author$project$Input$Selected(protoGlobalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDateTime, compB));
								case 'ProtoGlobalBoolField':
									var protoGlobalBool = _v234.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualBool,
										$author$project$Input$Selected(protoGlobalBool),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToBool, compB));
								default:
									var protoGlobalComp = _v234.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
										$author$project$Input$Selected(protoGlobalComp),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToComp, compB));
							}
						}
					case 2:
						var _v235 = _v143.a;
						var compA = _v235.a;
						var compB = _v235.b;
						var _v236 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalAny(),
							inputMsg,
							compB);
						if (_v236.$ === 'Unselected') {
							var inputState = _v236.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalEqualAny,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v236.a.$) {
								case 'ProtoGlobalStringField':
									var protoGlobalString = _v236.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToString, compA),
										$author$project$Input$Selected(protoGlobalString));
								case 'ProtoGlobalNumberField':
									var protoGlobalNumber = _v236.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToNumber, compA),
										$author$project$Input$Selected(protoGlobalNumber));
								case 'ProtoGlobalDateField':
									var protoGlobalDate = _v236.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDate, compA),
										$author$project$Input$Selected(protoGlobalDate));
								case 'ProtoGlobalAnyField':
									var protoGlobalAnyField = _v236.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualAny,
										compA,
										$author$project$Input$Selected(protoGlobalAnyField));
								case 'ProtoGlobalDateTimeField':
									var protoGlobalDateTime = _v236.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDateTime, compA),
										$author$project$Input$Selected(protoGlobalDateTime));
								case 'ProtoGlobalBoolField':
									var protoGlobalBool = _v236.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualBool,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToBool, compA),
										$author$project$Input$Selected(protoGlobalBool));
								default:
									var protoGlobalComp = _v236.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalEqualComp,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToComp, compA),
										$author$project$Input$Selected(protoGlobalComp));
							}
						}
					default:
						var _v237 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalNotEqualString':
				switch (_v143.b) {
					case 0:
						var _v238 = _v143.a;
						var stringA = _v238.a;
						var stringB = _v238.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v239 = _v143.a;
						var stringA = _v239.a;
						var stringB = _v239.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringB));
					default:
						var _v240 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalNotEqualNumber':
				switch (_v143.b) {
					case 0:
						var _v241 = _v143.a;
						var stringA = _v241.a;
						var stringB = _v241.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualNumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v242 = _v143.a;
						var stringA = _v242.a;
						var stringB = _v242.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualNumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								stringB));
					default:
						var _v243 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalNotEqualDate':
				switch (_v143.b) {
					case 0:
						var _v244 = _v143.a;
						var dateA = _v244.a;
						var dateB = _v244.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v245 = _v143.a;
						var dateA = _v245.a;
						var dateB = _v245.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateB));
					default:
						var _v246 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalNotEqualDateTime':
				switch (_v143.b) {
					case 0:
						var _v247 = _v143.a;
						var dateA = _v247.a;
						var dateB = _v247.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v248 = _v143.a;
						var dateA = _v248.a;
						var dateB = _v248.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v249 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalNotEqualBool':
				switch (_v143.b) {
					case 0:
						var _v250 = _v143.a;
						var boolA = _v250.a;
						var boolB = _v250.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualBool,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								boolA),
							boolB);
					case 2:
						var _v251 = _v143.a;
						var boolA = _v251.a;
						var boolB = _v251.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualBool,
							boolA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								boolB));
					default:
						var _v252 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalNotEqualComp':
				switch (_v143.b) {
					case 0:
						var _v253 = _v143.a;
						var compA = _v253.a;
						var compB = _v253.b;
						var _v254 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compA);
						if (_v254.$ === 'Unselected') {
							var inputState = _v254.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v254.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualString,
										$author$project$Input$Selected(protoGlobalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compB));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualNumber,
										$author$project$Input$Selected(protoGlobalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compB));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDate,
										$author$project$Input$Selected(protoGlobalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compB));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDateTime,
										$author$project$Input$Selected(protoGlobalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compB));
								default:
									var protoGlobalCompField = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
										$author$project$Input$Selected(protoGlobalCompField),
										compB);
							}
						}
					case 2:
						var _v255 = _v143.a;
						var compA = _v255.a;
						var compB = _v255.b;
						var _v256 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							compB);
						if (_v256.$ === 'Unselected') {
							var inputState = _v256.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v256.a.$) {
								case 'ProtoGlobalStringComp':
									var protoGlobalString = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, compA),
										$author$project$Input$Selected(protoGlobalString));
								case 'ProtoGlobalNumberComp':
									var protoGlobalNumber = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, compA),
										$author$project$Input$Selected(protoGlobalNumber));
								case 'ProtoGlobalDateComp':
									var protoGlobalDate = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, compA),
										$author$project$Input$Selected(protoGlobalDate));
								case 'ProtoGlobalDateTimeComp':
									var protoGlobalDateTime = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, compA),
										$author$project$Input$Selected(protoGlobalDateTime));
								default:
									var protoGlobalCompField = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
										compA,
										$author$project$Input$Selected(protoGlobalCompField));
							}
						}
					default:
						var _v257 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalNotEqualAny':
				switch (_v143.b) {
					case 0:
						var _v258 = _v143.a;
						var compA = _v258.a;
						var compB = _v258.b;
						var _v259 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalAny(),
							inputMsg,
							compA);
						if (_v259.$ === 'Unselected') {
							var inputState = _v259.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualAny,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v259.a.$) {
								case 'ProtoGlobalStringField':
									var protoGlobalString = _v259.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualString,
										$author$project$Input$Selected(protoGlobalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToString, compB));
								case 'ProtoGlobalNumberField':
									var protoGlobalNumber = _v259.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualNumber,
										$author$project$Input$Selected(protoGlobalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToNumber, compB));
								case 'ProtoGlobalDateField':
									var protoGlobalDate = _v259.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDate,
										$author$project$Input$Selected(protoGlobalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDate, compB));
								case 'ProtoGlobalDateTimeField':
									var protoGlobalDateTime = _v259.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDateTime,
										$author$project$Input$Selected(protoGlobalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDateTime, compB));
								case 'ProtoGlobalBoolField':
									var protoGlobalBool = _v259.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualBool,
										$author$project$Input$Selected(protoGlobalBool),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToBool, compB));
								case 'ProtoGlobalAnyField':
									var protoGlobalAnyField = _v259.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualAny,
										$author$project$Input$Selected(protoGlobalAnyField),
										compB);
								default:
									var protoGlobalComp = _v259.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
										$author$project$Input$Selected(protoGlobalComp),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToComp, compB));
							}
						}
					case 2:
						var _v260 = _v143.a;
						var compA = _v260.a;
						var compB = _v260.b;
						var _v261 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalAny(),
							inputMsg,
							compB);
						if (_v261.$ === 'Unselected') {
							var inputState = _v261.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualAny,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v261.a.$) {
								case 'ProtoGlobalStringField':
									var protoGlobalString = _v261.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToString, compA),
										$author$project$Input$Selected(protoGlobalString));
								case 'ProtoGlobalNumberField':
									var protoGlobalNumber = _v261.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToNumber, compA),
										$author$project$Input$Selected(protoGlobalNumber));
								case 'ProtoGlobalDateField':
									var protoGlobalDate = _v261.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDate, compA),
										$author$project$Input$Selected(protoGlobalDate));
								case 'ProtoGlobalDateTimeField':
									var protoGlobalDateTime = _v261.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToDateTime, compA),
										$author$project$Input$Selected(protoGlobalDateTime));
								case 'ProtoGlobalBoolField':
									var protoGlobalBool = _v261.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualBool,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToBool, compA),
										$author$project$Input$Selected(protoGlobalBool));
								case 'ProtoGlobalAnyField':
									var protoGlobalAnyField = _v261.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualAny,
										compA,
										$author$project$Input$Selected(protoGlobalAnyField));
								default:
									var protoGlobalComp = _v261.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualComp,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalAnyToComp, compA),
										$author$project$Input$Selected(protoGlobalComp));
							}
						}
					default:
						var _v262 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalStringIn':
				switch (_v143.b) {
					case 0:
						var _v263 = _v143.a;
						var string = _v263.a;
						var stringList = _v263.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringIn,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								string),
							stringList);
					case 2:
						var _v264 = _v143.a;
						var string = _v264.a;
						var stringList = _v264.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringIn,
							string,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalStringList(),
								inputMsg,
								stringList));
					default:
						var _v265 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalStringNotIn':
				switch (_v143.b) {
					case 0:
						var _v266 = _v143.a;
						var string = _v266.a;
						var stringList = _v266.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringNotIn,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								string),
							stringList);
					case 2:
						var _v267 = _v143.a;
						var string = _v267.a;
						var stringList = _v267.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringNotIn,
							string,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalStringList(),
								inputMsg,
								stringList));
					default:
						var _v268 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalNot':
				if (!_v143.b) {
					var boolInput = _v143.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalNot(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
							inputMsg,
							boolInput));
				} else {
					return globalBool;
				}
			case 'ProtoGlobalBoolIf':
				switch (_v143.b) {
					case 0:
						var _v269 = _v143.a;
						var condInput = _v269.a;
						var thenInput = _v269.b;
						var elseInput = _v269.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalBoolIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v270 = _v143.a;
						var condInput = _v270.a;
						var thenInput = _v270.b;
						var elseInput = _v270.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalBoolIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v271 = _v143.a;
						var condInput = _v271.a;
						var thenInput = _v271.b;
						var elseInput = _v271.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalBoolIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								elseInput));
					default:
						var _v272 = _v143.a;
						return globalBool;
				}
			case 'ProtoGlobalPickBool':
				if (!_v143.b) {
					var listInput = _v143.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalPickBool(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalBoolList(),
							inputMsg,
							listInput));
				} else {
					return globalBool;
				}
			case 'ProtoGlobalAll':
				if (!_v143.b) {
					var listInput = _v143.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalAll(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalBoolList(),
							inputMsg,
							listInput));
				} else {
					return globalBool;
				}
			case 'ProtoGlobalAny':
				if (!_v143.b) {
					var listInput = _v143.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalAny(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalBoolList(),
							inputMsg,
							listInput));
				} else {
					return globalBool;
				}
			case 'ProtoGlobalIsNull':
				if (!_v143.b) {
					var fieldInput = _v143.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalIsNull(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalField(),
							inputMsg,
							fieldInput));
				} else {
					return globalBool;
				}
			default:
				if (!_v143.b) {
					var fieldInput = _v143.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalIsNotNull(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalField(),
							inputMsg,
							fieldInput));
				} else {
					return globalBool;
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalBoolListChild = F3(
	function (child, inputMsg, proto) {
		var _v134 = _Utils_Tuple2(proto, child);
		switch (_v134.a.$) {
			case 'ProtoGlobalBoolListIf':
				switch (_v134.b) {
					case 0:
						var _v135 = _v134.a;
						var condInput = _v135.a;
						var thenInput = _v135.b;
						var elseInput = _v135.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalBoolListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v136 = _v134.a;
						var condInput = _v136.a;
						var thenInput = _v136.b;
						var elseInput = _v136.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalBoolListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBoolList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v137 = _v134.a;
						var condInput = _v137.a;
						var thenInput = _v137.b;
						var elseInput = _v137.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalBoolListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBoolList(),
								inputMsg,
								elseInput));
					default:
						var _v138 = _v134.a;
						return proto;
				}
			case 'ProtoGlobalBoolsAsList':
				var _v139 = _v134.a;
				var listOfExpr = _v139.a;
				var dragModel = _v139.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoGlobalBoolsAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputGlobalBool()(inputMsg),
							listOfExpr)),
					dragModel);
			default:
				switch (_v134.b) {
					case 0:
						var _v140 = _v134.a;
						var refInput = _v140.a;
						var fieldNameInput = _v140.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllBoolsInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v141 = _v134.a;
						var refInput = _v141.a;
						var fieldNameInput = _v141.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllBoolsInField,
							refInput,
							A2($author$project$ExpressionInput$updateBoolFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v142 = _v134.a;
						return proto;
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalCompChild = F3(
	function (child, inputMsg, globalComp) {
		var _v123 = _Utils_Tuple2(globalComp, child);
		switch (_v123.a.$) {
			case 'ProtoGlobalMaxComp':
				if (!_v123.b) {
					var listInput = _v123.a.a;
					var _v124 = A2(
						$author$project$ExpressionInput$cyclic$updateInputGlobalCompList(),
						inputMsg,
						listInput);
					if (_v124.$ === 'Selected') {
						switch (_v124.a.$) {
							case 'ProtoGlobalCompStringList':
								var globalStringList = _v124.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalStringComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMaxString(
										$author$project$Input$Selected(globalStringList)));
							case 'ProtoGlobalCompNumberList':
								var globalNumberList = _v124.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMaxNumber(
										$author$project$Input$Selected(globalNumberList)));
							case 'ProtoGlobalCompDateList':
								var globalDateList = _v124.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMaxDate(
										$author$project$Input$Selected(globalDateList)));
							case 'ProtoGlobalCompDateTimeList':
								var globalDateTimeList = _v124.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMaxDateTime(
										$author$project$Input$Selected(globalDateTimeList)));
							default:
								var globalCompList = _v124.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMaxComp(
										$author$project$Input$Selected(globalCompList)));
						}
					} else {
						var listState = _v124.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
							$author$project$DataElement$ProtoExpression$ProtoGlobalMaxComp(
								$author$project$Input$Unselected(listState)));
					}
				} else {
					return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp);
				}
			case 'ProtoGlobalMinComp':
				if (!_v123.b) {
					var listInput = _v123.a.a;
					var _v125 = A2(
						$author$project$ExpressionInput$cyclic$updateInputGlobalCompList(),
						inputMsg,
						listInput);
					if (_v125.$ === 'Selected') {
						switch (_v125.a.$) {
							case 'ProtoGlobalCompStringList':
								var globalStringList = _v125.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalStringComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMinString(
										$author$project$Input$Selected(globalStringList)));
							case 'ProtoGlobalCompNumberList':
								var globalNumberList = _v125.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMinNumber(
										$author$project$Input$Selected(globalNumberList)));
							case 'ProtoGlobalCompDateList':
								var globalDateList = _v125.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMinDate(
										$author$project$Input$Selected(globalDateList)));
							case 'ProtoGlobalCompDateTimeList':
								var globalDateTimeList = _v125.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMinDateTime(
										$author$project$Input$Selected(globalDateTimeList)));
							default:
								var globalCompList = _v125.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
									$author$project$DataElement$ProtoExpression$ProtoGlobalMinComp(
										$author$project$Input$Selected(globalCompList)));
						}
					} else {
						var listState = _v125.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
							$author$project$DataElement$ProtoExpression$ProtoGlobalMinComp(
								$author$project$Input$Unselected(listState)));
					}
				} else {
					return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp);
				}
			case 'ProtoGlobalCompIf':
				switch (_v123.b) {
					case 0:
						var _v126 = _v123.a;
						var ifInput = _v126.a;
						var thenInput = _v126.b;
						var elseInput = _v126.c;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf,
								A2(
									$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
									inputMsg,
									ifInput),
								thenInput,
								elseInput));
					case 1:
						var _v127 = _v123.a;
						var ifInput = _v127.a;
						var thenInput = _v127.b;
						var elseInput = _v127.c;
						var _v128 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							thenInput);
						if (_v128.$ === 'Selected') {
							switch (_v128.a.$) {
								case 'ProtoGlobalStringComp':
									var globalString = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalStringComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
											ifInput,
											$author$project$Input$Selected(globalString),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, elseInput)));
								case 'ProtoGlobalNumberComp':
									var globalNumber = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
											ifInput,
											$author$project$Input$Selected(globalNumber),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, elseInput)));
								case 'ProtoGlobalDateComp':
									var globalDate = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
											ifInput,
											$author$project$Input$Selected(globalDate),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, elseInput)));
								case 'ProtoGlobalDateTimeComp':
									var globalDateTime = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
											ifInput,
											$author$project$Input$Selected(globalDateTime),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, elseInput)));
								default:
									var newGlobalComp = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf,
											ifInput,
											$author$project$Input$Selected(newGlobalComp),
											elseInput));
							}
						} else {
							var thenState = _v128.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf,
									ifInput,
									$author$project$Input$Unselected(thenState),
									elseInput));
						}
					case 2:
						var _v129 = _v123.a;
						var ifInput = _v129.a;
						var thenInput = _v129.b;
						var elseInput = _v129.c;
						var _v130 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalComp(),
							inputMsg,
							elseInput);
						if (_v130.$ === 'Selected') {
							switch (_v130.a.$) {
								case 'ProtoGlobalStringComp':
									var globalString = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalStringComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
											ifInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToString, thenInput),
											$author$project$Input$Selected(globalString)));
								case 'ProtoGlobalNumberComp':
									var globalNumber = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
											ifInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToNumber, thenInput),
											$author$project$Input$Selected(globalNumber)));
								case 'ProtoGlobalDateComp':
									var globalDate = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
											ifInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDate, thenInput),
											$author$project$Input$Selected(globalDate)));
								case 'ProtoGlobalDateTimeComp':
									var globalDateTime = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
											ifInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompToDateTime, thenInput),
											$author$project$Input$Selected(globalDateTime)));
								default:
									var newGlobalComp = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf,
											ifInput,
											thenInput,
											$author$project$Input$Selected(newGlobalComp)));
							}
						} else {
							var elseState = _v130.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoGlobalCompIf,
									ifInput,
									thenInput,
									$author$project$Input$Unselected(elseState)));
						}
					default:
						var _v131 = _v123.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp);
				}
			default:
				if (!_v123.b) {
					var listInput = _v123.a.a;
					var _v132 = A2(
						$author$project$ExpressionInput$cyclic$updateInputGlobalCompList(),
						inputMsg,
						listInput);
					if (_v132.$ === 'Selected') {
						switch (_v132.a.$) {
							case 'ProtoGlobalCompStringList':
								var globalStringList = _v132.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalStringComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalPickString(
										$author$project$Input$Selected(globalStringList)));
							case 'ProtoGlobalCompNumberList':
								var globalNumberList = _v132.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalPickNumber(
										$author$project$Input$Selected(globalNumberList)));
							case 'ProtoGlobalCompDateList':
								var globalDateList = _v132.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalPickDate(
										$author$project$Input$Selected(globalDateList)));
							case 'ProtoGlobalCompDateTimeList':
								var globalDateTimeList = _v132.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp(
									$author$project$DataElement$ProtoExpression$ProtoGlobalPickDateTime(
										$author$project$Input$Selected(globalDateTimeList)));
							default:
								var newGlobalCompList = _v132.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
									$author$project$DataElement$ProtoExpression$ProtoGlobalPickComp(
										$author$project$Input$Selected(newGlobalCompList)));
						}
					} else {
						var listState = _v132.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
							$author$project$DataElement$ProtoExpression$ProtoGlobalPickComp(
								$author$project$Input$Unselected(listState)));
					}
				} else {
					return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp);
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalCompFieldListChild = F3(
	function (child, inputMsg, proto) {
		switch (proto.$) {
			case 'ProtoGlobalCompStringList':
				var stringList = proto.a;
				return $author$project$ExpressionInput$wrapGlobalStringListAsComp(
					A3($author$project$ExpressionInput$updateInputGlobalStringListChild, child, inputMsg, stringList));
			case 'ProtoGlobalCompNumberList':
				var numberList = proto.a;
				return $author$project$ExpressionInput$wrapGlobalNumberListAsComp(
					A3($author$project$ExpressionInput$updateInputGlobalNumberListChild, child, inputMsg, numberList));
			case 'ProtoGlobalCompDateList':
				var dateList = proto.a;
				return $author$project$ExpressionInput$wrapGlobalDateListAsComp(
					A3($author$project$ExpressionInput$updateInputGlobalDateListChild, child, inputMsg, dateList));
			case 'ProtoGlobalCompDateTimeList':
				var dateList = proto.a;
				return $author$project$ExpressionInput$wrapGlobalDateTimeListAsComp(
					A3($author$project$ExpressionInput$updateInputGlobalDateTimeListChild, child, inputMsg, dateList));
			default:
				var compList = proto.a;
				return A3($author$project$ExpressionInput$updateInputGlobalCompListChild, child, inputMsg, compList);
		}
	});
var $author$project$ExpressionInput$updateInputGlobalCompListChild = F3(
	function (child, inputMsg, proto) {
		var _v101 = _Utils_Tuple2(proto, child);
		switch (_v101.a.$) {
			case 'ProtoGlobalCompListIf':
				switch (_v101.b) {
					case 0:
						var _v102 = _v101.a;
						var condInput = _v102.a;
						var thenInput = _v102.b;
						var elseInput = _v102.c;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf,
								A2(
									$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
									inputMsg,
									condInput),
								thenInput,
								elseInput));
					case 1:
						var _v103 = _v101.a;
						var condInput = _v103.a;
						var thenInput = _v103.b;
						var elseInput = _v103.c;
						var _v104 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalCompList(),
							inputMsg,
							thenInput);
						if (_v104.$ === 'Selected') {
							switch (_v104.a.$) {
								case 'ProtoGlobalCompStringList':
									var newThenInput = _v104.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompStringList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToStringList, elseInput)));
								case 'ProtoGlobalCompNumberList':
									var newThenInput = _v104.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompNumberList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToNumberList, elseInput)));
								case 'ProtoGlobalCompDateList':
									var newThenInput = _v104.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateList, elseInput)));
								case 'ProtoGlobalCompDateTimeList':
									var newThenInput = _v104.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateTimeList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateTimeList, elseInput)));
								default:
									var newThenInput = _v104.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											elseInput));
							}
						} else {
							var state = _v104.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf,
									condInput,
									$author$project$Input$Unselected(state),
									elseInput));
						}
					case 2:
						var _v105 = _v101.a;
						var condInput = _v105.a;
						var thenInput = _v105.b;
						var elseInput = _v105.c;
						var _v106 = A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalCompList(),
							inputMsg,
							elseInput);
						if (_v106.$ === 'Selected') {
							switch (_v106.a.$) {
								case 'ProtoGlobalCompStringList':
									var newElseInput = _v106.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompStringList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToStringList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoGlobalCompNumberList':
									var newElseInput = _v106.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompNumberList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToNumberList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoGlobalCompDateList':
									var newElseInput = _v106.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoGlobalCompDateTimeList':
									var newElseInput = _v106.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateTimeList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$globalCompListToDateTimeList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								default:
									var newElseInput = _v106.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf,
											condInput,
											thenInput,
											$author$project$Input$Selected(newElseInput)));
							}
						} else {
							var elseState = _v106.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoGlobalCompListIf,
									condInput,
									thenInput,
									$author$project$Input$Unselected(elseState)));
						}
					default:
						var _v107 = _v101.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(proto);
				}
			case 'ProtoGlobalCompsAsList':
				var _v108 = _v101.a;
				var listOfExpr = _v108.a;
				var dragModel = _v108.b;
				var _v109 = A2(
					$elm$core$Maybe$map,
					$author$project$ExpressionInput$cyclic$updateInputGlobalComp()(inputMsg),
					A2($elm_community$list_extra$List$Extra$getAt, child, listOfExpr));
				if (_v109.$ === 'Nothing') {
					return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList, listOfExpr, dragModel));
				} else {
					if (_v109.a.$ === 'Unselected') {
						var inputState = _v109.a.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList,
								$author$project$ExpressionInput$resizeInputList(
									A3(
										$elm_community$list_extra$List$Extra$setAt,
										child,
										$author$project$Input$Unselected(inputState),
										listOfExpr)),
								dragModel));
					} else {
						switch (_v109.a.a.$) {
							case 'ProtoGlobalStringComp':
								var globalString = _v109.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompStringList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalStringsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalString),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalCompToString),
													listOfExpr))),
										dragModel));
							case 'ProtoGlobalNumberComp':
								var globalNumber = _v109.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompNumberList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalNumbersAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalNumber),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalCompToNumber),
													listOfExpr))),
										dragModel));
							case 'ProtoGlobalDateComp':
								var globalDate = _v109.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalDatesAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalDate),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalCompToDate),
													listOfExpr))),
										dragModel));
							case 'ProtoGlobalDateTimeComp':
								var globalDateTime = _v109.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateTimeList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimesAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalDateTime),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$globalCompToDateTime),
													listOfExpr))),
										dragModel));
							default:
								var globalComp = _v109.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoGlobalCompsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(globalComp),
												listOfExpr)),
										dragModel));
						}
					}
				}
			default:
				switch (_v101.b) {
					case 0:
						var _v110 = _v101.a;
						var refInput = _v110.a;
						var fieldNameState = _v110.b;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoGlobalAllCompsInField,
								A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
								fieldNameState));
					case 1:
						var _v111 = _v101.a;
						var refInput = _v111.a;
						var fieldNameState = _v111.b;
						var _v112 = A2($author$project$ExpressionInput$updateCompFieldNameState, inputMsg, fieldNameState);
						if (_v112.$ === 'Unselected') {
							var newState = _v112.a;
							return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(
								A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllCompsInField, refInput, newState));
						} else {
							switch (_v112.a.a.$) {
								case 'StringComp':
									var _v113 = _v112.a;
									var _v114 = _v113.a;
									var fieldName = _v113.b;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompStringList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAllStringsInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'NumberComp':
									var _v115 = _v112.a;
									var _v116 = _v115.a;
									var fieldName = _v115.b;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompNumberList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAllNumbersInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'DateComp':
									var _v117 = _v112.a;
									var _v118 = _v117.a;
									var fieldName = _v117.b;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAllDatesInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								default:
									var _v119 = _v112.a;
									var _v120 = _v119.a;
									var fieldName = _v119.b;
									return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateTimeList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoGlobalAllDateTimesInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
							}
						}
					default:
						var _v121 = _v101.a;
						return $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList(proto);
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalDateChild = F3(
	function (child, inputMsg, globalDate) {
		var _v80 = _Utils_Tuple2(globalDate, child);
		switch (_v80.a.$) {
			case 'ProtoGlobalDateLookup':
				var _v81 = _v80.a;
				return globalDate;
			case 'ProtoGlobalDateHardcoded':
				return globalDate;
			case 'ProtoGlobalDateTimeToDate':
				if (!_v80.b) {
					var dateTime = _v80.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeToDate(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
							inputMsg,
							dateTime));
				} else {
					return globalDate;
				}
			case 'ProtoGlobalDateCeiling':
				switch (_v80.b) {
					case 0:
						var _v82 = _v80.a;
						var dateIntervalInput = _v82.a;
						var dateInput = _v82.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateCeiling,
							dateIntervalInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateInput));
					case 1:
						var _v83 = _v80.a;
						var dateIntervalInput = _v83.a;
						var dateInput = _v83.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateCeiling,
							A2($author$project$ExpressionInput$updateInputDateInterval, inputMsg, dateIntervalInput),
							dateInput);
					default:
						var _v84 = _v80.a;
						return globalDate;
				}
			case 'ProtoGlobalDateFloor':
				switch (_v80.b) {
					case 0:
						var _v85 = _v80.a;
						var dateIntervalInput = _v85.a;
						var dateInput = _v85.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateFloor,
							dateIntervalInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateInput));
					case 1:
						var _v86 = _v80.a;
						var dateIntervalInput = _v86.a;
						var dateInput = _v86.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateFloor,
							A2($author$project$ExpressionInput$updateInputDateInterval, inputMsg, dateIntervalInput),
							dateInput);
					default:
						var _v87 = _v80.a;
						return globalDate;
				}
			case 'ProtoGlobalDateAdd':
				switch (_v80.b) {
					case 0:
						var _v88 = _v80.a;
						var dateUnitInput = _v88.a;
						var numberInput = _v88.b;
						var dateInput = _v88.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateAdd,
							dateUnitInput,
							numberInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateInput));
					case 2:
						var _v89 = _v80.a;
						var dateUnitInput = _v89.a;
						var numberInput = _v89.b;
						var dateInput = _v89.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateAdd,
							dateUnitInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberInput),
							dateInput);
					case 3:
						var _v90 = _v80.a;
						var dateUnitInput = _v90.a;
						var numberInput = _v90.b;
						var dateInput = _v90.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateAdd,
							A2($author$project$ExpressionInput$updateInputDateUnit, inputMsg, dateUnitInput),
							numberInput,
							dateInput);
					default:
						var _v91 = _v80.a;
						return globalDate;
				}
			case 'ProtoGlobalDateSubtract':
				switch (_v80.b) {
					case 0:
						var _v92 = _v80.a;
						var dateUnitInput = _v92.a;
						var numberInput = _v92.b;
						var dateInput = _v92.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateSubtract,
							dateUnitInput,
							numberInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateInput));
					case 2:
						var _v93 = _v80.a;
						var dateUnitInput = _v93.a;
						var numberInput = _v93.b;
						var dateInput = _v93.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateSubtract,
							dateUnitInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberInput),
							dateInput);
					case 3:
						var _v94 = _v80.a;
						var dateUnitInput = _v94.a;
						var numberInput = _v94.b;
						var dateInput = _v94.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateSubtract,
							A2($author$project$ExpressionInput$updateInputDateUnit, inputMsg, dateUnitInput),
							numberInput,
							dateInput);
					default:
						var _v95 = _v80.a;
						return globalDate;
				}
			case 'ProtoGlobalDateIf':
				switch (_v80.b) {
					case 0:
						var _v96 = _v80.a;
						var condInput = _v96.a;
						var thenInput = _v96.b;
						var elseInput = _v96.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v97 = _v80.a;
						var condInput = _v97.a;
						var thenInput = _v97.b;
						var elseInput = _v97.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v98 = _v80.a;
						var condInput = _v98.a;
						var thenInput = _v98.b;
						var elseInput = _v98.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								elseInput));
					default:
						var _v99 = _v80.a;
						return globalDate;
				}
			case 'ProtoGlobalPickDate':
				if (!_v80.b) {
					var listInput = _v80.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalPickDate(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDateList(),
							inputMsg,
							listInput));
				} else {
					return globalDate;
				}
			case 'ProtoGlobalMaxDate':
				if (!_v80.b) {
					var listInput = _v80.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxDate(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDateList(),
							inputMsg,
							listInput));
				} else {
					return globalDate;
				}
			default:
				if (!_v80.b) {
					var listInput = _v80.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalMinDate(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDateList(),
							inputMsg,
							listInput));
				} else {
					return globalDate;
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalDateListChild = F3(
	function (child, inputMsg, proto) {
		var _v71 = _Utils_Tuple2(proto, child);
		switch (_v71.a.$) {
			case 'ProtoGlobalDateListIf':
				switch (_v71.b) {
					case 0:
						var _v72 = _v71.a;
						var condInput = _v72.a;
						var thenInput = _v72.b;
						var elseInput = _v72.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v73 = _v71.a;
						var condInput = _v73.a;
						var thenInput = _v73.b;
						var elseInput = _v73.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v74 = _v71.a;
						var condInput = _v74.a;
						var thenInput = _v74.b;
						var elseInput = _v74.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateList(),
								inputMsg,
								elseInput));
					default:
						var _v75 = _v71.a;
						return proto;
				}
			case 'ProtoGlobalDatesAsList':
				var _v76 = _v71.a;
				var listOfExpr = _v76.a;
				var dragModel = _v76.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoGlobalDatesAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputGlobalDate()(inputMsg),
							listOfExpr)),
					dragModel);
			default:
				switch (_v71.b) {
					case 0:
						var _v77 = _v71.a;
						var refInput = _v77.a;
						var fieldNameInput = _v77.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllDatesInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v78 = _v71.a;
						var refInput = _v78.a;
						var fieldNameInput = _v78.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllDatesInField,
							refInput,
							A2($author$project$ExpressionInput$updateDateFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v79 = _v71.a;
						return proto;
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalDateTimeChild = F3(
	function (child, inputMsg, globalDateTime) {
		var _v64 = _Utils_Tuple2(globalDateTime, child);
		switch (_v64.a.$) {
			case 'ProtoGlobalDateTimeLookup':
				var _v65 = _v64.a;
				return globalDateTime;
			case 'ProtoGlobalDateTimeHardcoded':
				return globalDateTime;
			case 'ProtoGlobalDateTimeIf':
				switch (_v64.b) {
					case 0:
						var _v66 = _v64.a;
						var condInput = _v66.a;
						var thenInput = _v66.b;
						var elseInput = _v66.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v67 = _v64.a;
						var condInput = _v67.a;
						var thenInput = _v67.b;
						var elseInput = _v67.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v68 = _v64.a;
						var condInput = _v68.a;
						var thenInput = _v68.b;
						var elseInput = _v68.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
								inputMsg,
								elseInput));
					default:
						var _v69 = _v64.a;
						return globalDateTime;
				}
			case 'ProtoGlobalPickDateTime':
				if (!_v64.b) {
					var listInput = _v64.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalPickDateTime(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDateTimeList(),
							inputMsg,
							listInput));
				} else {
					return globalDateTime;
				}
			case 'ProtoGlobalMaxDateTime':
				if (!_v64.b) {
					var listInput = _v64.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxDateTime(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDateTimeList(),
							inputMsg,
							listInput));
				} else {
					return globalDateTime;
				}
			default:
				if (!_v64.b) {
					var listInput = _v64.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalMinDateTime(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDateTimeList(),
							inputMsg,
							listInput));
				} else {
					return globalDateTime;
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalDateTimeListChild = F3(
	function (child, inputMsg, proto) {
		var _v55 = _Utils_Tuple2(proto, child);
		switch (_v55.a.$) {
			case 'ProtoGlobalDateTimeListIf':
				switch (_v55.b) {
					case 0:
						var _v56 = _v55.a;
						var condInput = _v56.a;
						var thenInput = _v56.b;
						var elseInput = _v56.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v57 = _v55.a;
						var condInput = _v57.a;
						var thenInput = _v57.b;
						var elseInput = _v57.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTimeList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v58 = _v55.a;
						var condInput = _v58.a;
						var thenInput = _v58.b;
						var elseInput = _v58.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDateTimeList(),
								inputMsg,
								elseInput));
					default:
						var _v59 = _v55.a;
						return proto;
				}
			case 'ProtoGlobalDateTimesAsList':
				var _v60 = _v55.a;
				var listOfExpr = _v60.a;
				var dragModel = _v60.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimesAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime()(inputMsg),
							listOfExpr)),
					dragModel);
			default:
				switch (_v55.b) {
					case 0:
						var _v61 = _v55.a;
						var refInput = _v61.a;
						var fieldNameInput = _v61.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllDateTimesInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v62 = _v55.a;
						var refInput = _v62.a;
						var fieldNameInput = _v62.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllDateTimesInField,
							refInput,
							A2($author$project$ExpressionInput$updateDateTimeFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v63 = _v55.a;
						return proto;
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalFieldChild = F3(
	function (child, inputMsg, globalField) {
		switch (globalField.$) {
			case 'ProtoGlobalStringField':
				var globalString = globalField.a;
				return $author$project$ExpressionInput$wrapGlobalString(
					A3($author$project$ExpressionInput$updateInputGlobalStringChild, child, inputMsg, globalString));
			case 'ProtoGlobalNumberField':
				var globalNumber = globalField.a;
				return $author$project$ExpressionInput$wrapGlobalNumber(
					A3($author$project$ExpressionInput$updateInputGlobalNumberChild, child, inputMsg, globalNumber));
			case 'ProtoGlobalDateField':
				var globalDate = globalField.a;
				return $author$project$ExpressionInput$wrapGlobalDate(
					A3($author$project$ExpressionInput$updateInputGlobalDateChild, child, inputMsg, globalDate));
			case 'ProtoGlobalDateTimeField':
				var globalDateTime = globalField.a;
				return $author$project$ExpressionInput$wrapGlobalDateTime(
					A3($author$project$ExpressionInput$updateInputGlobalDateTimeChild, child, inputMsg, globalDateTime));
			case 'ProtoGlobalBoolField':
				var globalBool = globalField.a;
				return $author$project$ExpressionInput$wrapGlobalBool(
					A3($author$project$ExpressionInput$updateInputGlobalBoolChild, child, inputMsg, globalBool));
			case 'ProtoGlobalAnyField':
				var globalAny = globalField.a;
				return A3($author$project$ExpressionInput$updateInputGlobalAnyChild, child, inputMsg, globalAny);
			default:
				var globalComp = globalField.a;
				return $author$project$ExpressionInput$convertGlobalCompFieldToGlobalField(
					A3($author$project$ExpressionInput$updateInputGlobalCompChild, child, inputMsg, globalComp));
		}
	});
var $author$project$ExpressionInput$updateInputGlobalNumberChild = F3(
	function (child, inputMsg, globalNumber) {
		var _v34 = _Utils_Tuple2(globalNumber, child);
		switch (_v34.a.$) {
			case 'ProtoGlobalNumberLookup':
				var _v35 = _v34.a;
				return globalNumber;
			case 'ProtoGlobalNumberHardcoded':
				return globalNumber;
			case 'ProtoGlobalRoundNumber':
				if (!_v34.b) {
					var numberInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalRoundNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
							inputMsg,
							numberInput));
				} else {
					return globalNumber;
				}
			case 'ProtoGlobalSum':
				if (!_v34.b) {
					var listInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalSum(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalNumberList(),
							inputMsg,
							listInput));
				} else {
					return globalNumber;
				}
			case 'ProtoGlobalProduct':
				if (!_v34.b) {
					var listInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalProduct(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalNumberList(),
							inputMsg,
							listInput));
				} else {
					return globalNumber;
				}
			case 'ProtoGlobalAdd':
				switch (_v34.b) {
					case 0:
						var _v36 = _v34.a;
						var numberA = _v36.a;
						var numberB = _v36.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAdd,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberA),
							numberB);
					case 2:
						var _v37 = _v34.a;
						var numberA = _v37.a;
						var numberB = _v37.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAdd,
							numberA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberB));
					default:
						var _v38 = _v34.a;
						return globalNumber;
				}
			case 'ProtoGlobalSubtract':
				switch (_v34.b) {
					case 0:
						var _v39 = _v34.a;
						var numberA = _v39.a;
						var numberB = _v39.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalSubtract,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberA),
							numberB);
					case 2:
						var _v40 = _v34.a;
						var numberA = _v40.a;
						var numberB = _v40.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalSubtract,
							numberA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberB));
					default:
						var _v41 = _v34.a;
						return globalNumber;
				}
			case 'ProtoGlobalMultiply':
				switch (_v34.b) {
					case 0:
						var _v42 = _v34.a;
						var numberA = _v42.a;
						var numberB = _v42.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalMultiply,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberA),
							numberB);
					case 2:
						var _v43 = _v34.a;
						var numberA = _v43.a;
						var numberB = _v43.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalMultiply,
							numberA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberB));
					default:
						var _v44 = _v34.a;
						return globalNumber;
				}
			case 'ProtoGlobalDivide':
				switch (_v34.b) {
					case 0:
						var _v45 = _v34.a;
						var numberA = _v45.a;
						var numberB = _v45.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDivide,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberA),
							numberB);
					case 2:
						var _v46 = _v34.a;
						var numberA = _v46.a;
						var numberB = _v46.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalDivide,
							numberA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberB));
					default:
						var _v47 = _v34.a;
						return globalNumber;
				}
			case 'ProtoGlobalMonthNumber':
				if (!_v34.b) {
					var dateInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalMonthNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
							inputMsg,
							dateInput));
				} else {
					return globalNumber;
				}
			case 'ProtoGlobalYearNumber':
				if (!_v34.b) {
					var dateInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalYearNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
							inputMsg,
							dateInput));
				} else {
					return globalNumber;
				}
			case 'ProtoGlobalDayInMonth':
				if (!_v34.b) {
					var dateInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalDayInMonth(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
							inputMsg,
							dateInput));
				} else {
					return globalNumber;
				}
			case 'ProtoGlobalNumberIf':
				switch (_v34.b) {
					case 0:
						var _v48 = _v34.a;
						var condInput = _v48.a;
						var thenInput = _v48.b;
						var elseInput = _v48.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v49 = _v34.a;
						var condInput = _v49.a;
						var thenInput = _v49.b;
						var elseInput = _v49.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v50 = _v34.a;
						var condInput = _v50.a;
						var thenInput = _v50.b;
						var elseInput = _v50.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								elseInput));
					default:
						var _v51 = _v34.a;
						return globalNumber;
				}
			case 'ProtoGlobalPickNumber':
				if (!_v34.b) {
					var listInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalPickNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalNumberList(),
							inputMsg,
							listInput));
				} else {
					return globalNumber;
				}
			case 'ProtoGlobalMaxNumber':
				if (!_v34.b) {
					var listInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalNumberList(),
							inputMsg,
							listInput));
				} else {
					return globalNumber;
				}
			case 'ProtoGlobalMinNumber':
				if (!_v34.b) {
					var listInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalMinNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalNumberList(),
							inputMsg,
							listInput));
				} else {
					return globalNumber;
				}
			default:
				if (!_v34.b) {
					var listInput = _v34.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalCountUnique(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalCompFieldList(),
							inputMsg,
							listInput));
				} else {
					return globalNumber;
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalNumberListChild = F3(
	function (child, inputMsg, proto) {
		var _v25 = _Utils_Tuple2(proto, child);
		switch (_v25.a.$) {
			case 'ProtoGlobalNumberListIf':
				switch (_v25.b) {
					case 0:
						var _v26 = _v25.a;
						var condInput = _v26.a;
						var thenInput = _v26.b;
						var elseInput = _v26.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v27 = _v25.a;
						var condInput = _v27.a;
						var thenInput = _v27.b;
						var elseInput = _v27.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumberList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v28 = _v25.a;
						var condInput = _v28.a;
						var thenInput = _v28.b;
						var elseInput = _v28.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumberList(),
								inputMsg,
								elseInput));
					default:
						var _v29 = _v25.a;
						return proto;
				}
			case 'ProtoGlobalNumbersAsList':
				var _v30 = _v25.a;
				var listOfExpr = _v30.a;
				var dragModel = _v30.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoGlobalNumbersAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputGlobalNumber()(inputMsg),
							listOfExpr)),
					dragModel);
			default:
				switch (_v25.b) {
					case 0:
						var _v31 = _v25.a;
						var refInput = _v31.a;
						var fieldNameInput = _v31.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllNumbersInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v32 = _v25.a;
						var refInput = _v32.a;
						var fieldNameInput = _v32.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllNumbersInField,
							refInput,
							A2($author$project$ExpressionInput$updateNumberFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v33 = _v25.a;
						return proto;
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalStringChild = F3(
	function (child, inputMsg, globalString) {
		var _v9 = _Utils_Tuple2(globalString, child);
		switch (_v9.a.$) {
			case 'ProtoGlobalStringLookup':
				var _v10 = _v9.a;
				return globalString;
			case 'ProtoGlobalStringHardcoded':
				return globalString;
			case 'ProtoGlobalFormatDate':
				switch (_v9.b) {
					case 0:
						var _v11 = _v9.a;
						var stringInput = _v11.a;
						var dateInput = _v11.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalFormatDate,
							stringInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalDate(),
								inputMsg,
								dateInput));
					case 1:
						var _v12 = _v9.a;
						var stringInput = _v12.a;
						var dateInput = _v12.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalFormatDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								stringInput),
							dateInput);
					default:
						var _v13 = _v9.a;
						return globalString;
				}
			case 'ProtoGlobalFormatNumber':
				switch (_v9.b) {
					case 0:
						var _v14 = _v9.a;
						var decimalInput = _v14.a;
						var numberInput = _v14.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalFormatNumber,
							decimalInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalNumber(),
								inputMsg,
								numberInput));
					case 1:
						var _v15 = _v9.a;
						var decimalInput = _v15.a;
						var numberInput = _v15.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalFormatNumber,
							A2($author$project$ExpressionInput$updateIntInput, inputMsg, decimalInput),
							numberInput);
					default:
						var _v16 = _v9.a;
						return globalString;
				}
			case 'ProtoGlobalStringIf':
				switch (_v9.b) {
					case 0:
						var _v17 = _v9.a;
						var condInput = _v17.a;
						var thenInput = _v17.b;
						var elseInput = _v17.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v18 = _v9.a;
						var condInput = _v18.a;
						var thenInput = _v18.b;
						var elseInput = _v18.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v19 = _v9.a;
						var condInput = _v19.a;
						var thenInput = _v19.b;
						var elseInput = _v19.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								elseInput));
					default:
						var _v20 = _v9.a;
						return globalString;
				}
			case 'ProtoGlobalPickString':
				if (!_v9.b) {
					var listInput = _v9.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalPickString(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalStringList(),
							inputMsg,
							listInput));
				} else {
					return globalString;
				}
			case 'ProtoGlobalConcat':
				switch (_v9.b) {
					case 0:
						var _v21 = _v9.a;
						var joinInput = _v21.a;
						var listInput = _v21.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalConcat,
							joinInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalStringList(),
								inputMsg,
								listInput));
					case 1:
						var _v22 = _v9.a;
						var joinInput = _v22.a;
						var listInput = _v22.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalConcat,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
								inputMsg,
								joinInput),
							listInput);
					default:
						var _v23 = _v9.a;
						return globalString;
				}
			case 'ProtoGlobalMaxString':
				if (!_v9.b) {
					var listInput = _v9.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxString(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalStringList(),
							inputMsg,
							listInput));
				} else {
					return globalString;
				}
			case 'ProtoGlobalFormatDateTime':
				if (!_v9.b) {
					var input = _v9.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalFormatDateTime(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime(),
							inputMsg,
							input));
				} else {
					return globalString;
				}
			default:
				if (!_v9.b) {
					var listInput = _v9.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalMinString(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalStringList(),
							inputMsg,
							listInput));
				} else {
					return globalString;
				}
		}
	});
var $author$project$ExpressionInput$updateInputGlobalStringListChild = F3(
	function (child, inputMsg, proto) {
		var _v0 = _Utils_Tuple2(proto, child);
		switch (_v0.a.$) {
			case 'ProtoGlobalStringListIf':
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.a;
						var condInput = _v1.a;
						var thenInput = _v1.b;
						var elseInput = _v1.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v2 = _v0.a;
						var condInput = _v2.a;
						var thenInput = _v2.b;
						var elseInput = _v2.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalStringList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v3 = _v0.a;
						var condInput = _v3.a;
						var thenInput = _v3.b;
						var elseInput = _v3.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputGlobalStringList(),
								inputMsg,
								elseInput));
					default:
						var _v4 = _v0.a;
						return proto;
				}
			case 'ProtoGlobalStringsAsList':
				var _v5 = _v0.a;
				var listOfExpr = _v5.a;
				var dragModel = _v5.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoGlobalStringsAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputGlobalString()(inputMsg),
							listOfExpr)),
					dragModel);
			case 'ProtoGlobalAllStringsInField':
				switch (_v0.b) {
					case 0:
						var _v6 = _v0.a;
						var refInput = _v6.a;
						var fieldNameInput = _v6.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllStringsInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v7 = _v0.a;
						var refInput = _v7.a;
						var fieldNameInput = _v7.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoGlobalAllStringsInField,
							refInput,
							A2($author$project$ExpressionInput$updateStringFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v8 = _v0.a;
						return proto;
				}
			case 'ProtoGlobalChallengeReasons':
				if (!_v0.b) {
					var acctIdInput = _v0.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalChallengeReasons(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
							inputMsg,
							acctIdInput));
				} else {
					return proto;
				}
			default:
				if (!_v0.b) {
					var acctIdInput = _v0.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoGlobalTargetChallengeReasons(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputGlobalString(),
							inputMsg,
							acctIdInput));
				} else {
					return proto;
				}
		}
	});
function $author$project$ExpressionInput$cyclic$updateInputGlobalAny() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $author$project$DataElement$ProtoExpression$ProtoGlobalAnyField,
			select: $author$project$ExpressionInput$selectGlobalAny,
			tag: 'Update Global Any',
			updateChild: $author$project$ExpressionInput$updateInputGlobalAnyChild,
			updateDrag: function (_v305) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalAnyList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $author$project$DataElement$ProtoExpression$ProtoGlobalFieldList, select: $author$project$ExpressionInput$selectGlobalAnyList, tag: 'Update Global Any List', updateChild: $author$project$ExpressionInput$updateInputGlobalAnyListChild, updateDrag: $author$project$ExpressionInput$updateDragGlobalAnyList});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalBool() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectGlobalBool,
			tag: 'Update Global Bool',
			updateChild: $author$project$ExpressionInput$updateInputGlobalBoolChild,
			updateDrag: function (_v273) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalBoolList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectGlobalBoolList, tag: 'Update Global Bool List', updateChild: $author$project$ExpressionInput$updateInputGlobalBoolListChild, updateDrag: $author$project$ExpressionInput$updateDragGlobalBoolList});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalComp() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField,
			select: $author$project$ExpressionInput$selectGlobalComp,
			tag: 'Update Global Comparable',
			updateChild: $author$project$ExpressionInput$updateInputGlobalCompChild,
			updateDrag: function (_v133) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalCompFieldList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectGlobalCompList, tag: 'Update Global Comp Field List', updateChild: $author$project$ExpressionInput$updateInputGlobalCompFieldListChild, updateDrag: $author$project$ExpressionInput$updateDragGlobalCompFieldList});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalCompList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $author$project$DataElement$ProtoExpression$ProtoGlobalCompFieldList, select: $author$project$ExpressionInput$selectGlobalCompList, tag: 'Update Global Comparable List', updateChild: $author$project$ExpressionInput$updateInputGlobalCompListChild, updateDrag: $author$project$ExpressionInput$updateDragGlobalCompList});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalDate() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectGlobalDate,
			tag: 'Update Global Date',
			updateChild: $author$project$ExpressionInput$updateInputGlobalDateChild,
			updateDrag: function (_v100) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalDateList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectGlobalDateList, tag: 'Update Global Date List', updateChild: $author$project$ExpressionInput$updateInputGlobalDateListChild, updateDrag: $author$project$ExpressionInput$updateDragGlobalDateList});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalDateTime() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectGlobalDateTime,
			tag: 'Update Global DateTime',
			updateChild: $author$project$ExpressionInput$updateInputGlobalDateTimeChild,
			updateDrag: function (_v70) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalDateTimeList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectGlobalDateTimeList, tag: 'Update Global DateTime List', updateChild: $author$project$ExpressionInput$updateInputGlobalDateTimeListChild, updateDrag: $author$project$ExpressionInput$updateDragGlobalDateTimeList});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalField() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectGlobalField,
			tag: 'Update Global Field',
			updateChild: $author$project$ExpressionInput$updateInputGlobalFieldChild,
			updateDrag: function (_v54) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalNumber() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectGlobalNumber,
			tag: 'Update Global Number',
			updateChild: $author$project$ExpressionInput$updateInputGlobalNumberChild,
			updateDrag: function (_v52) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalNumberList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectGlobalNumberList, tag: 'Update Global Number List', updateChild: $author$project$ExpressionInput$updateInputGlobalNumberListChild, updateDrag: $author$project$ExpressionInput$updateDragGlobalNumberList});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalString() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectGlobalString,
			tag: 'Update Global String',
			updateChild: $author$project$ExpressionInput$updateInputGlobalStringChild,
			updateDrag: function (_v24) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputGlobalStringList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectGlobalStringList, tag: 'Update Global String List', updateChild: $author$project$ExpressionInput$updateInputGlobalStringListChild, updateDrag: $author$project$ExpressionInput$updateDragGlobalStringList});
}
try {
	var $author$project$ExpressionInput$updateInputGlobalAny = $author$project$ExpressionInput$cyclic$updateInputGlobalAny();
	$author$project$ExpressionInput$cyclic$updateInputGlobalAny = function () {
		return $author$project$ExpressionInput$updateInputGlobalAny;
	};
	var $author$project$ExpressionInput$updateInputGlobalAnyList = $author$project$ExpressionInput$cyclic$updateInputGlobalAnyList();
	$author$project$ExpressionInput$cyclic$updateInputGlobalAnyList = function () {
		return $author$project$ExpressionInput$updateInputGlobalAnyList;
	};
	var $author$project$ExpressionInput$updateInputGlobalBool = $author$project$ExpressionInput$cyclic$updateInputGlobalBool();
	$author$project$ExpressionInput$cyclic$updateInputGlobalBool = function () {
		return $author$project$ExpressionInput$updateInputGlobalBool;
	};
	var $author$project$ExpressionInput$updateInputGlobalBoolList = $author$project$ExpressionInput$cyclic$updateInputGlobalBoolList();
	$author$project$ExpressionInput$cyclic$updateInputGlobalBoolList = function () {
		return $author$project$ExpressionInput$updateInputGlobalBoolList;
	};
	var $author$project$ExpressionInput$updateInputGlobalComp = $author$project$ExpressionInput$cyclic$updateInputGlobalComp();
	$author$project$ExpressionInput$cyclic$updateInputGlobalComp = function () {
		return $author$project$ExpressionInput$updateInputGlobalComp;
	};
	var $author$project$ExpressionInput$updateInputGlobalCompFieldList = $author$project$ExpressionInput$cyclic$updateInputGlobalCompFieldList();
	$author$project$ExpressionInput$cyclic$updateInputGlobalCompFieldList = function () {
		return $author$project$ExpressionInput$updateInputGlobalCompFieldList;
	};
	var $author$project$ExpressionInput$updateInputGlobalCompList = $author$project$ExpressionInput$cyclic$updateInputGlobalCompList();
	$author$project$ExpressionInput$cyclic$updateInputGlobalCompList = function () {
		return $author$project$ExpressionInput$updateInputGlobalCompList;
	};
	var $author$project$ExpressionInput$updateInputGlobalDate = $author$project$ExpressionInput$cyclic$updateInputGlobalDate();
	$author$project$ExpressionInput$cyclic$updateInputGlobalDate = function () {
		return $author$project$ExpressionInput$updateInputGlobalDate;
	};
	var $author$project$ExpressionInput$updateInputGlobalDateList = $author$project$ExpressionInput$cyclic$updateInputGlobalDateList();
	$author$project$ExpressionInput$cyclic$updateInputGlobalDateList = function () {
		return $author$project$ExpressionInput$updateInputGlobalDateList;
	};
	var $author$project$ExpressionInput$updateInputGlobalDateTime = $author$project$ExpressionInput$cyclic$updateInputGlobalDateTime();
	$author$project$ExpressionInput$cyclic$updateInputGlobalDateTime = function () {
		return $author$project$ExpressionInput$updateInputGlobalDateTime;
	};
	var $author$project$ExpressionInput$updateInputGlobalDateTimeList = $author$project$ExpressionInput$cyclic$updateInputGlobalDateTimeList();
	$author$project$ExpressionInput$cyclic$updateInputGlobalDateTimeList = function () {
		return $author$project$ExpressionInput$updateInputGlobalDateTimeList;
	};
	var $author$project$ExpressionInput$updateInputGlobalField = $author$project$ExpressionInput$cyclic$updateInputGlobalField();
	$author$project$ExpressionInput$cyclic$updateInputGlobalField = function () {
		return $author$project$ExpressionInput$updateInputGlobalField;
	};
	var $author$project$ExpressionInput$updateInputGlobalNumber = $author$project$ExpressionInput$cyclic$updateInputGlobalNumber();
	$author$project$ExpressionInput$cyclic$updateInputGlobalNumber = function () {
		return $author$project$ExpressionInput$updateInputGlobalNumber;
	};
	var $author$project$ExpressionInput$updateInputGlobalNumberList = $author$project$ExpressionInput$cyclic$updateInputGlobalNumberList();
	$author$project$ExpressionInput$cyclic$updateInputGlobalNumberList = function () {
		return $author$project$ExpressionInput$updateInputGlobalNumberList;
	};
	var $author$project$ExpressionInput$updateInputGlobalString = $author$project$ExpressionInput$cyclic$updateInputGlobalString();
	$author$project$ExpressionInput$cyclic$updateInputGlobalString = function () {
		return $author$project$ExpressionInput$updateInputGlobalString;
	};
	var $author$project$ExpressionInput$updateInputGlobalStringList = $author$project$ExpressionInput$cyclic$updateInputGlobalStringList();
	$author$project$ExpressionInput$cyclic$updateInputGlobalStringList = function () {
		return $author$project$ExpressionInput$updateInputGlobalStringList;
	};
} catch ($) {
	throw 'Some top-level definitions from `ExpressionInput` are causing infinite recursion:\n\n  ┌─────┐\n  │    updateInputGlobalAny\n  │     ↓\n  │    updateInputGlobalAnyChild\n  │     ↓\n  │    updateInputGlobalAnyList\n  │     ↓\n  │    updateInputGlobalAnyListChild\n  │     ↓\n  │    updateInputGlobalBool\n  │     ↓\n  │    updateInputGlobalBoolChild\n  │     ↓\n  │    updateInputGlobalBoolChildHelper\n  │     ↓\n  │    updateInputGlobalBoolList\n  │     ↓\n  │    updateInputGlobalBoolListChild\n  │     ↓\n  │    updateInputGlobalComp\n  │     ↓\n  │    updateInputGlobalCompChild\n  │     ↓\n  │    updateInputGlobalCompFieldList\n  │     ↓\n  │    updateInputGlobalCompFieldListChild\n  │     ↓\n  │    updateInputGlobalCompList\n  │     ↓\n  │    updateInputGlobalCompListChild\n  │     ↓\n  │    updateInputGlobalDate\n  │     ↓\n  │    updateInputGlobalDateChild\n  │     ↓\n  │    updateInputGlobalDateList\n  │     ↓\n  │    updateInputGlobalDateListChild\n  │     ↓\n  │    updateInputGlobalDateTime\n  │     ↓\n  │    updateInputGlobalDateTimeChild\n  │     ↓\n  │    updateInputGlobalDateTimeList\n  │     ↓\n  │    updateInputGlobalDateTimeListChild\n  │     ↓\n  │    updateInputGlobalField\n  │     ↓\n  │    updateInputGlobalFieldChild\n  │     ↓\n  │    updateInputGlobalNumber\n  │     ↓\n  │    updateInputGlobalNumberChild\n  │     ↓\n  │    updateInputGlobalNumberList\n  │     ↓\n  │    updateInputGlobalNumberListChild\n  │     ↓\n  │    updateInputGlobalString\n  │     ↓\n  │    updateInputGlobalStringChild\n  │     ↓\n  │    updateInputGlobalStringList\n  │     ↓\n  │    updateInputGlobalStringListChild\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$StudioApp$Error$FieldNotFound = F2(
	function (a, b) {
		return {$: 'FieldNotFound', a: a, b: b};
	});
var $author$project$StudioApp$Error$WrongTypeError = F4(
	function (a, b, c, d) {
		return {$: 'WrongTypeError', a: a, b: b, c: c, d: d};
	});
var $author$project$FieldName$FieldName = function (a) {
	return {$: 'FieldName', a: a};
};
var $author$project$FieldName$fromString = $author$project$FieldName$FieldName;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$DataElement$AlignedTerritories$fieldList = A2(
	$elm$core$List$map,
	$elm$core$Tuple$mapFirst($author$project$FieldName$fromString),
	_List_fromArray(
		[
			_Utils_Tuple2('name', $author$project$FieldType$StringType),
			_Utils_Tuple2('id', $author$project$FieldType$StringType),
			_Utils_Tuple2('description', $author$project$FieldType$StringType),
			_Utils_Tuple2('developerName', $author$project$FieldType$StringType),
			_Utils_Tuple2('parentTerritoryId', $author$project$FieldType$StringType)
		]));
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0.a;
		return $pzp1997$assoc_list$AssocList$D(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(key, value),
				alteredAlist));
	});
var $pzp1997$assoc_list$AssocList$fromList = function (alist) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, result) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($pzp1997$assoc_list$AssocList$insert, key, value, result);
			}),
		$pzp1997$assoc_list$AssocList$D(_List_Nil),
		alist);
};
var $author$project$DataElement$AlignedTerritories$fields = $pzp1997$assoc_list$AssocList$fromList($author$project$DataElement$AlignedTerritories$fieldList);
var $author$project$DataElement$CallAttendees$fieldName = 'Account ID';
var $pzp1997$assoc_list$AssocList$singleton = F2(
	function (key, value) {
		return $pzp1997$assoc_list$AssocList$D(
			_List_fromArray(
				[
					_Utils_Tuple2(key, value)
				]));
	});
var $author$project$DataElement$CallAttendees$fields = A2(
	$pzp1997$assoc_list$AssocList$singleton,
	$author$project$FieldName$fromString($author$project$DataElement$CallAttendees$fieldName),
	$author$project$FieldType$StringType);
var $author$project$DataElement$CrmDataEngine$Field$toFieldName = function (field) {
	switch (field.$) {
		case 'PureField':
			var fieldName = field.a;
			return fieldName;
		case 'DimensionField':
			var fieldName = field.a;
			return fieldName;
		default:
			var fieldName = field.a;
			return fieldName;
	}
};
var $author$project$ComparableType$toFieldType = function (comp) {
	switch (comp.$) {
		case 'StringComp':
			return $author$project$FieldType$StringType;
		case 'NumberComp':
			return $author$project$FieldType$NumberType;
		case 'DateComp':
			return $author$project$FieldType$DateType;
		default:
			return $author$project$FieldType$DateTimeType;
	}
};
var $author$project$DataElement$CrmDataEngine$Field$toFieldType = function (field) {
	switch (field.$) {
		case 'PureField':
			var fieldType = field.b;
			return fieldType;
		case 'DimensionField':
			var dimension = field.b;
			switch (dimension.$) {
				case 'Concat':
					return $author$project$FieldType$StringType;
				case 'DateTruncate':
					return $author$project$FieldType$DateType;
				case 'DateTimeTruncate':
					return $author$project$FieldType$DateTimeType;
				case 'Divide':
					return $author$project$FieldType$NumberType;
				case 'Multiply':
					return $author$project$FieldType$NumberType;
				case 'Minus':
					return $author$project$FieldType$NumberType;
				default:
					return $author$project$FieldType$NumberType;
			}
		default:
			var metric = field.b;
			switch (metric.$) {
				case 'Sum':
					return $author$project$FieldType$NumberType;
				case 'Count':
					return $author$project$FieldType$NumberType;
				case 'CountDistinct':
					return $author$project$FieldType$NumberType;
				case 'Max':
					var comparableType = metric.b;
					return $author$project$ComparableType$toFieldType(comparableType);
				default:
					var comparableType = metric.b;
					return $author$project$ComparableType$toFieldType(comparableType);
			}
	}
};
var $author$project$DataElement$CrmDataEngineQuery$fieldToKvPair = function (field) {
	return _Utils_Tuple2(
		$author$project$DataElement$CrmDataEngine$Field$toFieldName(field),
		$author$project$DataElement$CrmDataEngine$Field$toFieldType(field));
};
var $mgold$elm_nonempty_list$List$Nonempty$Nonempty = F2(
	function (a, b) {
		return {$: 'Nonempty', a: a, b: b};
	});
var $mgold$elm_nonempty_list$List$Nonempty$map = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A2(
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			f(x),
			A2($elm$core$List$map, f, xs));
	});
var $mgold$elm_nonempty_list$List$Nonempty$toList = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return A2($elm$core$List$cons, x, xs);
};
var $author$project$DataElement$CrmDataEngineQuery$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$mgold$elm_nonempty_list$List$Nonempty$toList(
			A2($mgold$elm_nonempty_list$List$Nonempty$map, $author$project$DataElement$CrmDataEngineQuery$fieldToKvPair, info.fields)));
};
var $author$project$DataElement$FeedbackAccountChannelGoals$addAccountId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Account ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackAccountChannelGoals$fixChannelId = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return _Utils_eq(
		fieldName,
		$author$project$FieldName$fromString('channelOrProductId')) ? _Utils_Tuple2(
		$author$project$FieldName$fromString('Channel ID'),
		fieldType) : _Utils_Tuple2(fieldName, fieldType);
};
var $author$project$DataElement$FeedbackAccountChannelGoals$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$author$project$DataElement$FeedbackAccountChannelGoals$addAccountId(
			A2(
				$elm$core$List$map,
				$author$project$DataElement$FeedbackAccountChannelGoals$fixChannelId,
				$pzp1997$assoc_list$AssocList$toList(info.fields))));
};
var $author$project$DataElement$FeedbackAccountData$fields = function (info) {
	return info.fields;
};
var $author$project$DataElement$FeedbackAccountProductGoals$addAccountId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Account ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackAccountProductGoals$addChannelId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Channel ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackAccountProductGoals$fixProductId = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return _Utils_eq(
		fieldName,
		$author$project$FieldName$fromString('channelOrProductId')) ? _Utils_Tuple2(
		$author$project$FieldName$fromString('Product ID'),
		fieldType) : _Utils_Tuple2(fieldName, fieldType);
};
var $author$project$DataElement$FeedbackAccountProductGoals$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$author$project$DataElement$FeedbackAccountProductGoals$addAccountId(
			$author$project$DataElement$FeedbackAccountProductGoals$addChannelId(
				A2(
					$elm$core$List$map,
					$author$project$DataElement$FeedbackAccountProductGoals$fixProductId,
					$pzp1997$assoc_list$AssocList$toList(info.fields)))));
};
var $author$project$DataElement$FeedbackAccountProductMetrics$addAccountId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Account ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackAccountProductMetrics$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$author$project$DataElement$FeedbackAccountProductMetrics$addAccountId(
			$pzp1997$assoc_list$AssocList$toList(info.fields)));
};
var $author$project$DataElement$FeedbackChannelGoals$fixChannelId = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return _Utils_eq(
		fieldName,
		$author$project$FieldName$fromString('channelOrProductId')) ? _Utils_Tuple2(
		$author$project$FieldName$fromString('Channel ID'),
		fieldType) : _Utils_Tuple2(fieldName, fieldType);
};
var $author$project$DataElement$FeedbackChannelGoals$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		A2(
			$elm$core$List$map,
			$author$project$DataElement$FeedbackChannelGoals$fixChannelId,
			$pzp1997$assoc_list$AssocList$toList(info.fields)));
};
var $author$project$DataElement$FeedbackProductGoals$addChannelId = function (items) {
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			$author$project$FieldName$fromString('Channel ID'),
			$author$project$FieldType$StringType),
		items);
};
var $author$project$DataElement$FeedbackProductGoals$fixProductId = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return _Utils_eq(
		fieldName,
		$author$project$FieldName$fromString('channelOrProductId')) ? _Utils_Tuple2(
		$author$project$FieldName$fromString('Product ID'),
		fieldType) : _Utils_Tuple2(fieldName, fieldType);
};
var $author$project$DataElement$FeedbackProductGoals$fields = function (info) {
	return $pzp1997$assoc_list$AssocList$fromList(
		$author$project$DataElement$FeedbackProductGoals$addChannelId(
			A2(
				$elm$core$List$map,
				$author$project$DataElement$FeedbackProductGoals$fixProductId,
				$pzp1997$assoc_list$AssocList$toList(info.fields))));
};
var $author$project$DataElement$SalesQuery$fieldList = A2(
	$elm$core$List$map,
	$elm$core$Tuple$mapFirst($author$project$FieldName$fromString),
	_List_fromArray(
		[
			_Utils_Tuple2('Account_Id_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('ID_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Market_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Market_Id_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Product_Group_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Product_Group_Id_vod__c', $author$project$FieldType$StringType),
			_Utils_Tuple2('Sales_Date_vod__c', $author$project$FieldType$DateType),
			_Utils_Tuple2('Sales_Data_vod__c', $author$project$FieldType$NumberType)
		]));
var $author$project$DataElement$SalesQuery$fields = $pzp1997$assoc_list$AssocList$fromList($author$project$DataElement$SalesQuery$fieldList);
var $author$project$DataElement$Expression$localFieldDataType = function (localField) {
	switch (localField.$) {
		case 'LocalStringExpr':
			return $author$project$FieldType$StringType;
		case 'LocalNumberExpr':
			return $author$project$FieldType$NumberType;
		case 'LocalDateExpr':
			return $author$project$FieldType$DateType;
		case 'LocalDateTimeExpr':
			return $author$project$FieldType$DateTimeType;
		default:
			return $author$project$FieldType$BoolType;
	}
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$DataElement$unwrapElement = function (_v0) {
	var el = _v0.b;
	return el;
};
var $author$project$DataElement$getFieldTypeByRefAndName = F3(
	function (elementCollection, listRef, fieldName) {
		getFieldTypeByRefAndName:
		while (true) {
			var _v2 = A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$unwrapElement,
				A2($author$project$DataElement$getDataElementFromReferenceElement, elementCollection, listRef));
			if (_v2.$ === 'Just') {
				if (_v2.a.$ === 'RecordList') {
					switch (_v2.a.a.$) {
						case 'CrmQuery':
							var queryInfo = _v2.a.a.a;
							return A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.fieldType;
								},
								A2($pzp1997$assoc_list$AssocList$get, fieldName, queryInfo.fields));
						case 'SalesQuery':
							return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$SalesQuery$fields);
						case 'NitroQuery':
							var queryInfo = _v2.a.a.a;
							return A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.fieldType;
								},
								A2($pzp1997$assoc_list$AssocList$get, fieldName, queryInfo.fields));
						case 'CrmDataEngineQuery':
							var queryInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$CrmDataEngineQuery$fields(queryInfo));
						case 'CalcOneForOne':
							var oneForOne = _v2.a.a.a;
							return A2(
								$elm$core$Maybe$map,
								$author$project$DataElement$Expression$localFieldDataType,
								A2($pzp1997$assoc_list$AssocList$get, fieldName, oneForOne.fields));
						case 'CalcSortList':
							var sortInfo = _v2.a.a.a;
							var $temp$elementCollection = elementCollection,
								$temp$listRef = sortInfo.original,
								$temp$fieldName = fieldName;
							elementCollection = $temp$elementCollection;
							listRef = $temp$listRef;
							fieldName = $temp$fieldName;
							continue getFieldTypeByRefAndName;
						case 'CalcFilterList':
							var filterInfo = _v2.a.a.a;
							var $temp$elementCollection = elementCollection,
								$temp$listRef = filterInfo.original,
								$temp$fieldName = fieldName;
							elementCollection = $temp$elementCollection;
							listRef = $temp$listRef;
							fieldName = $temp$fieldName;
							continue getFieldTypeByRefAndName;
						case 'CalcSublist':
							var sublistInfo = _v2.a.a.a;
							var $temp$elementCollection = elementCollection,
								$temp$listRef = sublistInfo.original,
								$temp$fieldName = fieldName;
							elementCollection = $temp$elementCollection;
							listRef = $temp$listRef;
							fieldName = $temp$fieldName;
							continue getFieldTypeByRefAndName;
						case 'CalcMergeList':
							var mergeListInfo = _v2.a.a.a;
							return A3($author$project$DataElement$getMergeListFieldTypeByRefAndName, mergeListInfo, elementCollection, fieldName);
						case 'AlignedTerritories':
							return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$AlignedTerritories$fields);
						case 'FeedbackChannelGoals':
							var feedbackChannelGoalsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackChannelGoals$fields(feedbackChannelGoalsInfo));
						case 'FeedbackProductGoals':
							var feedbackProductGoalsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackProductGoals$fields(feedbackProductGoalsInfo));
						case 'FeedbackAccountData':
							var feedbackAccountDataInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackAccountData$fields(feedbackAccountDataInfo));
						case 'FeedbackAccountChannelGoals':
							var feedbackAccountChannelGoalsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackAccountChannelGoals$fields(feedbackAccountChannelGoalsInfo));
						case 'FeedbackAccountProductGoals':
							var feedbackAccountProductGoalsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackAccountProductGoals$fields(feedbackAccountProductGoalsInfo));
						case 'FeedbackAccountProductMetrics':
							var feedbackAccountProductMetricsInfo = _v2.a.a.a;
							return A2(
								$pzp1997$assoc_list$AssocList$get,
								fieldName,
								$author$project$DataElement$FeedbackAccountProductMetrics$fields(feedbackAccountProductMetricsInfo));
						default:
							var _v3 = _v2.a.a;
							return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$CallAttendees$fields);
					}
				} else {
					if (_v2.a.a.$ === 'FeedbackOverview') {
						var feedbackOverviewInfo = _v2.a.a.a;
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, feedbackOverviewInfo.fields);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$DataElement$getMergeListFieldTypeByRefAndName = F3(
	function (info, elementDict, fieldName) {
		var fieldTypePerUuid = function (_v1) {
			var listRef = _v1.a;
			var inputFieldName = _v1.b;
			return A3($author$project$DataElement$getFieldTypeByRefAndName, elementDict, listRef, inputFieldName);
		};
		var checkSameFieldType = function (fieldTypes) {
			var _v0 = $elm_community$list_extra$List$Extra$unique(fieldTypes);
			if (_v0.b && (!_v0.b.b)) {
				var item = _v0.a;
				return item;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var getFieldType = function (fieldsByUuids) {
			return checkSameFieldType(
				A2($elm$core$List$map, fieldTypePerUuid, fieldsByUuids));
		};
		return A2(
			$elm$core$Maybe$andThen,
			getFieldType,
			A2(
				$pzp1997$assoc_list$AssocList$get,
				fieldName,
				$author$project$DataElement$MergeList$fields(info)));
	});
var $author$project$FieldName$toString = function (_v0) {
	var name = _v0.a;
	return name;
};
var $author$project$DataElement$validateFieldTypeByRefAndName = F5(
	function (elementCollection, context, listRef, expectedType, fieldName) {
		var _v0 = A3($author$project$DataElement$getFieldTypeByRefAndName, elementCollection, listRef, fieldName);
		if (_v0.$ === 'Just') {
			var fieldType = _v0.a;
			return _Utils_eq(fieldType, expectedType) ? _List_Nil : _List_fromArray(
				[
					A4(
					$author$project$StudioApp$Error$WrongTypeError,
					context,
					$author$project$FieldName$toString(fieldName),
					expectedType,
					fieldType)
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$StudioApp$Error$FieldNotFound,
					context,
					$author$project$FieldName$toString(fieldName))
				]);
		}
	});
var $author$project$StudioApp$Error$InvalidRecordListReference = F2(
	function (a, b) {
		return {$: 'InvalidRecordListReference', a: a, b: b};
	});
var $author$project$StudioApp$Error$RecordListReferenceNotFound = F2(
	function (a, b) {
		return {$: 'RecordListReferenceNotFound', a: a, b: b};
	});
var $author$project$DataElement$validateRecordListReference = F3(
	function (allDataElements, ref, context) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$unwrapElement,
			A2($author$project$DataElement$getDataElementFromReferenceElement, allDataElements, ref));
		if (_v0.$ === 'Just') {
			if (_v0.a.$ === 'RecordList') {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					A2($author$project$StudioApp$Error$InvalidRecordListReference, context, ref));
			}
		} else {
			return $elm$core$Maybe$Just(
				A2($author$project$StudioApp$Error$RecordListReferenceNotFound, context, ref));
		}
	});
var $author$project$DataElement$validateAllValuesInField = F5(
	function (elementsByName, context, fieldType, listRef, fieldName) {
		var refError = A3($author$project$DataElement$validateRecordListReference, elementsByName, listRef, context);
		var fieldErrors = A5($author$project$DataElement$validateFieldTypeByRefAndName, elementsByName, context, listRef, fieldType, fieldName);
		return _Utils_ap(
			$elm_community$maybe_extra$Maybe$Extra$toList(refError),
			fieldErrors);
	});
var $author$project$DataElement$Datepicker$fieldName = $author$project$FieldName$fromString('Selection');
var $author$project$DataElement$Datepicker$fields = $pzp1997$assoc_list$AssocList$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Datepicker$fieldName, $author$project$FieldType$DateType)
		]));
var $author$project$DataElement$Dropdown$fieldName = $author$project$FieldName$fromString('Selection');
var $author$project$DataElement$Dropdown$fields = $pzp1997$assoc_list$AssocList$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Dropdown$fieldName, $author$project$FieldType$StringType)
		]));
var $author$project$DataElement$FieldTranslation$fieldNames = function (info) {
	return $mgold$elm_nonempty_list$List$Nonempty$toList(info.fields);
};
var $author$project$DataElement$FieldTranslation$fields = A2(
	$elm$core$Basics$composeR,
	$author$project$DataElement$FieldTranslation$fieldNames,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (innerName) {
				return _Utils_Tuple2(innerName, $author$project$FieldType$StringType);
			}),
		$pzp1997$assoc_list$AssocList$fromList));
var $author$project$DataElement$Now$fieldName = $author$project$FieldName$fromString('Now');
var $author$project$DataElement$Now$fields = $pzp1997$assoc_list$AssocList$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Now$fieldName, $author$project$FieldType$DateTimeType)
		]));
var $author$project$DataElement$ObjectTranslation$fieldNames = A2(
	$elm$core$List$map,
	$author$project$FieldName$fromString,
	_List_fromArray(
		['Singular', 'Plural']));
var $author$project$DataElement$ObjectTranslation$fields = $pzp1997$assoc_list$AssocList$fromList(
	A2(
		$elm$core$List$map,
		function (name) {
			return _Utils_Tuple2(name, $author$project$FieldType$StringType);
		},
		$author$project$DataElement$ObjectTranslation$fieldNames));
var $author$project$DataElement$Today$fieldName = $author$project$FieldName$fromString('Today');
var $author$project$DataElement$Today$fields = $pzp1997$assoc_list$AssocList$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$DataElement$Today$fieldName, $author$project$FieldType$DateType)
		]));
var $author$project$DataElement$VeevaMessages$tokenToFieldName = function (_v0) {
	var name = _v0.name;
	var category = _v0.category;
	return $author$project$FieldName$fromString(name + (';;' + category));
};
var $author$project$DataElement$VeevaMessages$fieldNames = function (_v0) {
	var tokens = _v0.tokens;
	return A2($elm$core$List$map, $author$project$DataElement$VeevaMessages$tokenToFieldName, tokens);
};
var $author$project$DataElement$VeevaMessages$fields = A2(
	$elm$core$Basics$composeR,
	$author$project$DataElement$VeevaMessages$fieldNames,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (innerName) {
				return _Utils_Tuple2(innerName, $author$project$FieldType$StringType);
			}),
		$pzp1997$assoc_list$AssocList$fromList));
var $author$project$DataElement$Expression$globalFieldDataType = function (globalField) {
	switch (globalField.$) {
		case 'GlobalStringExpr':
			return $author$project$FieldType$StringType;
		case 'GlobalNumberExpr':
			return $author$project$FieldType$NumberType;
		case 'GlobalDateExpr':
			return $author$project$FieldType$DateType;
		case 'GlobalDateTimeExpr':
			return $author$project$FieldType$DateTimeType;
		default:
			return $author$project$FieldType$BoolType;
	}
};
var $author$project$DataElement$getSingletonFieldTypeByRefAndName = F3(
	function (allElements, ref, fieldName) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$author$project$DataElement$unwrapElement,
			A2($author$project$DataElement$getDataElementFromReferenceElement, allElements, ref));
		if (_v0.$ === 'Just') {
			if (_v0.a.$ === 'Singleton') {
				switch (_v0.a.a.$) {
					case 'ContextQuery':
						var contextInfo = _v0.a.a.a;
						return _Utils_eq(contextInfo.fieldName, fieldName) ? $elm$core$Maybe$Just(contextInfo.fieldType) : $elm$core$Maybe$Nothing;
					case 'LimitOneCrmQuery':
						var queryInfo = _v0.a.a.a;
						return A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fieldType;
							},
							A2($pzp1997$assoc_list$AssocList$get, fieldName, queryInfo.fields));
					case 'LimitOneSalesQuery':
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$SalesQuery$fields);
					case 'LimitOneNitroQuery':
						var queryInfo = _v0.a.a.a;
						return A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fieldType;
							},
							A2($pzp1997$assoc_list$AssocList$get, fieldName, queryInfo.fields));
					case 'LimitOneCrmDataEngineQuery':
						var queryInfo = _v0.a.a.a;
						return A2(
							$pzp1997$assoc_list$AssocList$get,
							fieldName,
							$author$project$DataElement$CrmDataEngineQuery$fields(queryInfo));
					case 'Today':
						var _v1 = _v0.a.a;
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$Today$fields);
					case 'Now':
						var _v2 = _v0.a.a;
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$Now$fields);
					case 'CalcSummarize':
						var summarizeInfo = _v0.a.a.a;
						return A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$globalFieldDataType,
							A2($pzp1997$assoc_list$AssocList$get, fieldName, summarizeInfo.fields));
					case 'ObjectTranslation':
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$ObjectTranslation$fields);
					case 'FieldTranslation':
						var fieldTranslationInfo = _v0.a.a.a;
						return A2(
							$pzp1997$assoc_list$AssocList$get,
							fieldName,
							$author$project$DataElement$FieldTranslation$fields(fieldTranslationInfo));
					case 'VeevaMessages':
						var vmInfo = _v0.a.a.a;
						return A2(
							$pzp1997$assoc_list$AssocList$get,
							fieldName,
							$author$project$DataElement$VeevaMessages$fields(vmInfo));
					case 'DatepickerSelection':
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$Datepicker$fields);
					case 'InteractiveSelectSelection':
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, $author$project$DataElement$Dropdown$fields);
					default:
						var overviewInfo = _v0.a.a.a;
						return A2($pzp1997$assoc_list$AssocList$get, fieldName, overviewInfo.fields);
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$DataElement$validateSingletonFieldByRefAndName = F5(
	function (elementsByName, context, expectedType, ref, fieldName) {
		var _v0 = A3($author$project$DataElement$getSingletonFieldTypeByRefAndName, elementsByName, ref, fieldName);
		if (_v0.$ === 'Just') {
			var fieldType = _v0.a;
			return _Utils_eq(fieldType, expectedType) ? _List_Nil : _List_fromArray(
				[
					A4(
					$author$project$StudioApp$Error$WrongTypeError,
					context,
					$author$project$FieldName$toString(fieldName),
					expectedType,
					fieldType)
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$StudioApp$Error$FieldNotFound,
					context,
					$author$project$FieldName$toString(fieldName))
				]);
		}
	});
var $author$project$DataElement$validateGlobalTransformer = F2(
	function (elementsByName, context) {
		return {
			add: $elm$core$Basics$append,
			all: $elm$core$Basics$identity,
			allBoolsInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$BoolType),
			allDateTimesInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$DateTimeType),
			allDatesInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$DateType),
			allNumbersInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$NumberType),
			allStringsInField: A3($author$project$DataElement$validateAllValuesInField, elementsByName, context, $author$project$FieldType$StringType),
			any: $elm$core$Basics$identity,
			boolsAsList: $elm$core$List$concat,
			challengeReasons: $elm$core$Basics$identity,
			comparableEqual: function (_v0) {
				return $elm$core$Basics$append;
			},
			comparableNotEqual: function (_v1) {
				return $elm$core$Basics$append;
			},
			concat: $elm$core$Basics$append,
			countUnique: $elm$core$Basics$always($elm$core$Basics$identity),
			dateAdd: function (_v2) {
				return $elm$core$Basics$append;
			},
			dateCeiling: F2(
				function (_v3, errors) {
					return errors;
				}),
			dateFloor: F2(
				function (_v4, errors) {
					return errors;
				}),
			dateSubtract: function (_v5) {
				return $elm$core$Basics$append;
			},
			dateTimeToDate: $elm$core$Basics$identity,
			dateTimesAsList: $elm$core$List$concat,
			datesAsList: $elm$core$List$concat,
			dayInMonth: $elm$core$Basics$identity,
			divide: $elm$core$Basics$append,
			equal: function (_v6) {
				return $elm$core$Basics$append;
			},
			formatDate: $elm$core$Basics$append,
			formatDateLocaleAware: $elm$core$Basics$identity,
			formatDateTime: $elm$core$Basics$identity,
			formatNumber: function (_v7) {
				return $elm$core$Basics$identity;
			},
			globalBoolLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$BoolType),
			globalDateLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$DateType),
			globalDateTimeLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$DateTimeType),
			globalNumberLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$NumberType),
			globalStringLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, elementsByName, context, $author$project$FieldType$StringType),
			greaterThan: function (_v8) {
				return $elm$core$Basics$append;
			},
			greaterThanOrEqual: function (_v9) {
				return $elm$core$Basics$append;
			},
			hardcodedBool: function (_v10) {
				return _List_Nil;
			},
			hardcodedDate: function (_v11) {
				return _List_Nil;
			},
			hardcodedDateTime: function (_v12) {
				return _List_Nil;
			},
			hardcodedNumber: function (_v13) {
				return _List_Nil;
			},
			hardcodedString: function (_v14) {
				return _List_Nil;
			},
			if_: F4(
				function (_v15, a, b, c) {
					return _Utils_ap(
						a,
						_Utils_ap(b, c));
				}),
			isNotNull: $elm$core$Basics$identity,
			isNull: $elm$core$Basics$identity,
			lessThan: function (_v16) {
				return $elm$core$Basics$append;
			},
			lessThanOrEqual: function (_v17) {
				return $elm$core$Basics$append;
			},
			max: function (_v18) {
				return $elm$core$Basics$identity;
			},
			min: function (_v19) {
				return $elm$core$Basics$identity;
			},
			monthNumber: $elm$core$Basics$identity,
			multiply: $elm$core$Basics$append,
			not: $elm$core$Basics$identity,
			notEqual: function (_v20) {
				return $elm$core$Basics$append;
			},
			numbersAsList: $elm$core$List$concat,
			pickOne: function (_v21) {
				return $elm$core$Basics$identity;
			},
			product: $elm$core$Basics$identity,
			round: $elm$core$Basics$identity,
			stringIn: $elm$core$Basics$append,
			stringNotIn: $elm$core$Basics$append,
			stringsAsList: $elm$core$List$concat,
			subtract: $elm$core$Basics$append,
			sum: $elm$core$Basics$identity,
			targetChallengeReasons: $elm$core$Basics$identity,
			yearNumber: $elm$core$Basics$identity
		};
	});
var $author$project$ExpressionInput$globalBoolInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalBool($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalBool(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalBool,
		toDragCmds: $author$project$ExpressionInput$protoGlobalBoolDragCmds,
		toModel: $author$project$ExpressionInput$GlobalBoolInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalBool,
		validate: $author$project$DataElement$Expression$applyGlobalBool(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalBoolListInput = F2(
	function (a, b) {
		return {$: 'GlobalBoolListInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalBoolListInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalBoolList($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalBoolList(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalBoolList,
		toDragCmds: $author$project$ExpressionInput$protoGlobalBoolListDragCmds,
		toModel: $author$project$ExpressionInput$GlobalBoolListInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalBoolList,
		validate: $author$project$DataElement$Expression$applyGlobalBoolList(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalCompInput = F2(
	function (a, b) {
		return {$: 'GlobalCompInput', a: a, b: b};
	});
var $author$project$DataElement$Expression$applyGlobalComparable = F2(
	function (transformers, globalComparable) {
		switch (globalComparable.$) {
			case 'GlobalCompStringExpr':
				var globalString = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyGlobalString, transformers, globalString);
			case 'GlobalCompNumberExpr':
				var globalNumber = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyGlobalNumber, transformers, globalNumber);
			case 'GlobalCompDateExpr':
				var globalDate = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyGlobalDate, transformers, globalDate);
			default:
				var globalDateTime = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyGlobalDateTime, transformers, globalDateTime);
		}
	});
var $author$project$DataElement$Expression$GlobalCompDateExpr = function (a) {
	return {$: 'GlobalCompDateExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompDateTimeExpr = function (a) {
	return {$: 'GlobalCompDateTimeExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompNumberExpr = function (a) {
	return {$: 'GlobalCompNumberExpr', a: a};
};
var $author$project$DataElement$Expression$GlobalCompStringExpr = function (a) {
	return {$: 'GlobalCompStringExpr', a: a};
};
var $author$project$DataElement$ProtoElement$Parse$globalCompHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringComp':
			var stringProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalCompStringExpr,
				$author$project$DataElement$ProtoElement$Parse$globalStringHelper(stringProto));
		case 'ProtoGlobalNumberComp':
			var numberProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalCompNumberExpr,
				$author$project$DataElement$ProtoElement$Parse$globalNumberHelper(numberProto));
		case 'ProtoGlobalDateComp':
			var dateProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalCompDateExpr,
				$author$project$DataElement$ProtoElement$Parse$globalDateHelper(dateProto));
		case 'ProtoGlobalDateTimeComp':
			var dateTimeProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$GlobalCompDateTimeExpr,
				$author$project$DataElement$ProtoElement$Parse$globalDateTimeHelper(dateTimeProto));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoElement$Parse$globalComp = $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$globalCompHelper);
var $author$project$ExpressionInput$protoGlobalCompFieldDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringComp':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalStringDragCmds(innerProto);
		case 'ProtoGlobalNumberComp':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalNumberDragCmds(innerProto);
		case 'ProtoGlobalDateComp':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateDragCmds(innerProto);
		case 'ProtoGlobalDateTimeComp':
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateTimeDragCmds(innerProto);
		default:
			var innerProto = proto.a;
			return $author$project$ExpressionInput$protoGlobalCompDragCmds(innerProto);
	}
};
var $author$project$ExpressionInput$selectGlobalCompField = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalString':
			var globalString = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringComp(globalString));
		case 'BaseGlobalNumber':
			var globalNumber = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp(globalNumber));
		case 'BaseGlobalDate':
			var globalDate = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateComp(globalDate));
		case 'BaseGlobalDateTime':
			var globalDateTime = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp(globalDateTime));
		case 'BaseGlobalAny':
			var globalAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(
					$author$project$DataElement$ProtoExpression$globalAnyToComp(globalAny)));
		case 'BaseGlobalComp':
			var globalComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapGlobalDateCompField = function (globalDate) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalDateToComp(globalDate);
	if (_v0.$ === 'Just') {
		var globalComp = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoGlobalDateComp(globalDate);
	}
};
var $author$project$ExpressionInput$wrapGlobalDateTimeCompField = function (globalDateTime) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalDateTimeToComp(globalDateTime);
	if (_v0.$ === 'Just') {
		var globalComp = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp(globalDateTime);
	}
};
var $author$project$ExpressionInput$wrapGlobalNumberCompField = function (globalNumber) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalNumberToComp(globalNumber);
	if (_v0.$ === 'Just') {
		var globalComp = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp(globalNumber);
	}
};
var $author$project$ExpressionInput$wrapGlobalStringCompField = function (globalString) {
	var _v0 = $author$project$DataElement$ProtoExpression$globalStringToComp(globalString);
	if (_v0.$ === 'Just') {
		var globalComp = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoGlobalCompAsCompField(globalComp);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoGlobalStringComp(globalString);
	}
};
var $author$project$ExpressionInput$updateInputGlobalCompFieldChild = F3(
	function (child, inputMsg, globalCompField) {
		switch (globalCompField.$) {
			case 'ProtoGlobalStringComp':
				var globalString = globalCompField.a;
				return $author$project$ExpressionInput$wrapGlobalStringCompField(
					A3($author$project$ExpressionInput$updateInputGlobalStringChild, child, inputMsg, globalString));
			case 'ProtoGlobalNumberComp':
				var globalNumber = globalCompField.a;
				return $author$project$ExpressionInput$wrapGlobalNumberCompField(
					A3($author$project$ExpressionInput$updateInputGlobalNumberChild, child, inputMsg, globalNumber));
			case 'ProtoGlobalDateComp':
				var globalDate = globalCompField.a;
				return $author$project$ExpressionInput$wrapGlobalDateCompField(
					A3($author$project$ExpressionInput$updateInputGlobalDateChild, child, inputMsg, globalDate));
			case 'ProtoGlobalDateTimeComp':
				var globalDateTime = globalCompField.a;
				return $author$project$ExpressionInput$wrapGlobalDateTimeCompField(
					A3($author$project$ExpressionInput$updateInputGlobalDateTimeChild, child, inputMsg, globalDateTime));
			default:
				var globalComp = globalCompField.a;
				return A3($author$project$ExpressionInput$updateInputGlobalCompChild, child, inputMsg, globalComp);
		}
	});
var $author$project$ExpressionInput$updateInputGlobalCompField = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectGlobalCompField,
		tag: 'Update Global Comp Field',
		updateChild: $author$project$ExpressionInput$updateInputGlobalCompFieldChild,
		updateDrag: function (_v0) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$ExpressionInput$globalCompInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalComparable($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalComparable(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalComp,
		toDragCmds: $author$project$ExpressionInput$protoGlobalCompFieldDragCmds,
		toModel: $author$project$ExpressionInput$GlobalCompInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalCompField,
		validate: $author$project$DataElement$Expression$applyGlobalComparable(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalDateInput = F2(
	function (a, b) {
		return {$: 'GlobalDateInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalDateInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalDate($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalDate(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalDate,
		toDragCmds: $author$project$ExpressionInput$protoGlobalDateDragCmds,
		toModel: $author$project$ExpressionInput$GlobalDateInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalDate,
		validate: $author$project$DataElement$Expression$applyGlobalDate(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalDateListInput = F2(
	function (a, b) {
		return {$: 'GlobalDateListInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalDateListInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalDateList($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalDateList(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalDateList,
		toDragCmds: $author$project$ExpressionInput$protoGlobalDateListDragCmds,
		toModel: $author$project$ExpressionInput$GlobalDateListInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalDateList,
		validate: $author$project$DataElement$Expression$applyGlobalDateList(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalDateTimeInput = F2(
	function (a, b) {
		return {$: 'GlobalDateTimeInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalDateTimeInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalDateTime($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalDateTime(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalDateTime,
		toDragCmds: $author$project$ExpressionInput$protoGlobalDateTimeDragCmds,
		toModel: $author$project$ExpressionInput$GlobalDateTimeInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalDateTime,
		validate: $author$project$DataElement$Expression$applyGlobalDateTime(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalDateTimeListInput = F2(
	function (a, b) {
		return {$: 'GlobalDateTimeListInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalDateTimeListInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalDateTimeList($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalDateTimeList(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalDateTimeList,
		toDragCmds: $author$project$ExpressionInput$protoGlobalDateTimeListDragCmds,
		toModel: $author$project$ExpressionInput$GlobalDateTimeListInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalDateTimeList,
		validate: $author$project$DataElement$Expression$applyGlobalDateTimeList(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalFieldInput = F2(
	function (a, b) {
		return {$: 'GlobalFieldInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalFieldInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalField($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalField(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalField,
		toDragCmds: $author$project$ExpressionInput$protoGlobalFieldDragCmds,
		toModel: $author$project$ExpressionInput$GlobalFieldInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalField,
		validate: $author$project$DataElement$Expression$applyGlobalField(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalNumberInput = F2(
	function (a, b) {
		return {$: 'GlobalNumberInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalNumberInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalNumber($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalNumber(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalNumber,
		toDragCmds: $author$project$ExpressionInput$protoGlobalNumberDragCmds,
		toModel: $author$project$ExpressionInput$GlobalNumberInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalNumber,
		validate: $author$project$DataElement$Expression$applyGlobalNumber(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalNumberListInput = F2(
	function (a, b) {
		return {$: 'GlobalNumberListInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalNumberListInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalNumberList($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalNumberList(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalNumberList,
		toDragCmds: $author$project$ExpressionInput$protoGlobalNumberListDragCmds,
		toModel: $author$project$ExpressionInput$GlobalNumberListInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalNumberList,
		validate: $author$project$DataElement$Expression$applyGlobalNumberList(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalStringInput = F2(
	function (a, b) {
		return {$: 'GlobalStringInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalStringInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalString($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalString(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalString,
		toDragCmds: $author$project$ExpressionInput$protoGlobalStringDragCmds,
		toModel: $author$project$ExpressionInput$GlobalStringInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalString,
		validate: $author$project$DataElement$Expression$applyGlobalString(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$GlobalStringListInput = F2(
	function (a, b) {
		return {$: 'GlobalStringListInput', a: a, b: b};
	});
var $author$project$ExpressionInput$globalStringListInputPipeline = function (viewInfo) {
	return {
		encode: $author$project$DataElement$Expression$applyGlobalStringList($author$project$DataElement$Expression$encodeTransformer),
		objectTags: $author$project$DataElement$Expression$applyGlobalStringList(
			$author$project$DataElement$objectTagGlobalTransformer(viewInfo.dataElements)),
		parse: $author$project$DataElement$ProtoElement$Parse$globalStringList,
		toDragCmds: $author$project$ExpressionInput$protoGlobalStringListDragCmds,
		toModel: $author$project$ExpressionInput$GlobalStringListInput(viewInfo),
		updateHelper: $author$project$ExpressionInput$updateInputGlobalStringList,
		validate: $author$project$DataElement$Expression$applyGlobalStringList(
			A2($author$project$DataElement$validateGlobalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput))
	};
};
var $author$project$ExpressionInput$LocalBoolInput = F3(
	function (a, b, c) {
		return {$: 'LocalBoolInput', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalAdd = F2(
	function (a, b) {
		return {$: 'LocalAdd', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAll = function (a) {
	return {$: 'LocalAll', a: a};
};
var $author$project$DataElement$Expression$LocalAllBoolsInField = F2(
	function (a, b) {
		return {$: 'LocalAllBoolsInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAllDateTimesInField = F2(
	function (a, b) {
		return {$: 'LocalAllDateTimesInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAllDatesInField = F2(
	function (a, b) {
		return {$: 'LocalAllDatesInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAllNumbersInField = F2(
	function (a, b) {
		return {$: 'LocalAllNumbersInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAllStringsInField = F2(
	function (a, b) {
		return {$: 'LocalAllStringsInField', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalAny = function (a) {
	return {$: 'LocalAny', a: a};
};
var $author$project$DataElement$Expression$LocalBool = function (a) {
	return {$: 'LocalBool', a: a};
};
var $author$project$DataElement$Expression$LocalBoolExpr = function (a) {
	return {$: 'LocalBoolExpr', a: a};
};
var $author$project$DataElement$Expression$LocalBoolHardcoded = function (a) {
	return {$: 'LocalBoolHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalBoolIf = F3(
	function (a, b, c) {
		return {$: 'LocalBoolIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalBoolListIf = F3(
	function (a, b, c) {
		return {$: 'LocalBoolListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalBoolsAsList = function (a) {
	return {$: 'LocalBoolsAsList', a: a};
};
var $author$project$DataElement$Expression$LocalChallengeReasons = function (a) {
	return {$: 'LocalChallengeReasons', a: a};
};
var $author$project$DataElement$Expression$LocalCompDateListExpr = function (a) {
	return {$: 'LocalCompDateListExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompDateTimeListExpr = function (a) {
	return {$: 'LocalCompDateTimeListExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompNumberListExpr = function (a) {
	return {$: 'LocalCompNumberListExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompStringListExpr = function (a) {
	return {$: 'LocalCompStringListExpr', a: a};
};
var $author$project$DataElement$Expression$LocalConcat = F2(
	function (a, b) {
		return {$: 'LocalConcat', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalCountUnique = function (a) {
	return {$: 'LocalCountUnique', a: a};
};
var $author$project$DataElement$Expression$LocalDate = function (a) {
	return {$: 'LocalDate', a: a};
};
var $author$project$DataElement$Expression$LocalDateAdd = F3(
	function (a, b, c) {
		return {$: 'LocalDateAdd', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateCeiling = F2(
	function (a, b) {
		return {$: 'LocalDateCeiling', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalDateExpr = function (a) {
	return {$: 'LocalDateExpr', a: a};
};
var $author$project$DataElement$Expression$LocalDateFloor = F2(
	function (a, b) {
		return {$: 'LocalDateFloor', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalDateHardcoded = function (a) {
	return {$: 'LocalDateHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalDateIf = F3(
	function (a, b, c) {
		return {$: 'LocalDateIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateListIf = F3(
	function (a, b, c) {
		return {$: 'LocalDateListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateSubtract = F3(
	function (a, b, c) {
		return {$: 'LocalDateSubtract', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateTime = function (a) {
	return {$: 'LocalDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalDateTimeExpr = function (a) {
	return {$: 'LocalDateTimeExpr', a: a};
};
var $author$project$DataElement$Expression$LocalDateTimeHardcoded = function (a) {
	return {$: 'LocalDateTimeHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalDateTimeIf = F3(
	function (a, b, c) {
		return {$: 'LocalDateTimeIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateTimeListIf = F3(
	function (a, b, c) {
		return {$: 'LocalDateTimeListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalDateTimeToDate = function (a) {
	return {$: 'LocalDateTimeToDate', a: a};
};
var $author$project$DataElement$Expression$LocalDateTimesAsList = function (a) {
	return {$: 'LocalDateTimesAsList', a: a};
};
var $author$project$DataElement$Expression$LocalDatesAsList = function (a) {
	return {$: 'LocalDatesAsList', a: a};
};
var $author$project$DataElement$Expression$LocalDayInMonth = function (a) {
	return {$: 'LocalDayInMonth', a: a};
};
var $author$project$DataElement$Expression$LocalDivide = F2(
	function (a, b) {
		return {$: 'LocalDivide', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualBool = F2(
	function (a, b) {
		return {$: 'LocalEqualBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualDate = F2(
	function (a, b) {
		return {$: 'LocalEqualDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualDateTime = F2(
	function (a, b) {
		return {$: 'LocalEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualNumber = F2(
	function (a, b) {
		return {$: 'LocalEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalEqualString = F2(
	function (a, b) {
		return {$: 'LocalEqualString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalFormatDate = F2(
	function (a, b) {
		return {$: 'LocalFormatDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalFormatDateLocaleAware = function (a) {
	return {$: 'LocalFormatDateLocaleAware', a: a};
};
var $author$project$DataElement$Expression$LocalFormatDateTime = function (a) {
	return {$: 'LocalFormatDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalFormatNumber = F2(
	function (a, b) {
		return {$: 'LocalFormatNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTDate = F2(
	function (a, b) {
		return {$: 'LocalGTDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTDateTime = F2(
	function (a, b) {
		return {$: 'LocalGTDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTEDate = F2(
	function (a, b) {
		return {$: 'LocalGTEDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTEDateTime = F2(
	function (a, b) {
		return {$: 'LocalGTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTENumber = F2(
	function (a, b) {
		return {$: 'LocalGTENumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTEString = F2(
	function (a, b) {
		return {$: 'LocalGTEString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTNumber = F2(
	function (a, b) {
		return {$: 'LocalGTNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalGTString = F2(
	function (a, b) {
		return {$: 'LocalGTString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalIsNotNull = function (a) {
	return {$: 'LocalIsNotNull', a: a};
};
var $author$project$DataElement$Expression$LocalIsNull = function (a) {
	return {$: 'LocalIsNull', a: a};
};
var $author$project$DataElement$Expression$LocalLTDate = F2(
	function (a, b) {
		return {$: 'LocalLTDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTDateTime = F2(
	function (a, b) {
		return {$: 'LocalLTDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTEDate = F2(
	function (a, b) {
		return {$: 'LocalLTEDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTEDateTime = F2(
	function (a, b) {
		return {$: 'LocalLTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTENumber = F2(
	function (a, b) {
		return {$: 'LocalLTENumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTEString = F2(
	function (a, b) {
		return {$: 'LocalLTEString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTNumber = F2(
	function (a, b) {
		return {$: 'LocalLTNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalLTString = F2(
	function (a, b) {
		return {$: 'LocalLTString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalMaxDate = function (a) {
	return {$: 'LocalMaxDate', a: a};
};
var $author$project$DataElement$Expression$LocalMaxDateTime = function (a) {
	return {$: 'LocalMaxDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalMaxNumber = function (a) {
	return {$: 'LocalMaxNumber', a: a};
};
var $author$project$DataElement$Expression$LocalMaxString = function (a) {
	return {$: 'LocalMaxString', a: a};
};
var $author$project$DataElement$Expression$LocalMinDate = function (a) {
	return {$: 'LocalMinDate', a: a};
};
var $author$project$DataElement$Expression$LocalMinDateTime = function (a) {
	return {$: 'LocalMinDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalMinNumber = function (a) {
	return {$: 'LocalMinNumber', a: a};
};
var $author$project$DataElement$Expression$LocalMinString = function (a) {
	return {$: 'LocalMinString', a: a};
};
var $author$project$DataElement$Expression$LocalMonthNumber = function (a) {
	return {$: 'LocalMonthNumber', a: a};
};
var $author$project$DataElement$Expression$LocalMultiply = F2(
	function (a, b) {
		return {$: 'LocalMultiply', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNot = function (a) {
	return {$: 'LocalNot', a: a};
};
var $author$project$DataElement$Expression$LocalNotEqualBool = F2(
	function (a, b) {
		return {$: 'LocalNotEqualBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNotEqualDate = F2(
	function (a, b) {
		return {$: 'LocalNotEqualDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNotEqualDateTime = F2(
	function (a, b) {
		return {$: 'LocalNotEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNotEqualNumber = F2(
	function (a, b) {
		return {$: 'LocalNotEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNotEqualString = F2(
	function (a, b) {
		return {$: 'LocalNotEqualString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalNumber = function (a) {
	return {$: 'LocalNumber', a: a};
};
var $author$project$DataElement$Expression$LocalNumberExpr = function (a) {
	return {$: 'LocalNumberExpr', a: a};
};
var $author$project$DataElement$Expression$LocalNumberHardcoded = function (a) {
	return {$: 'LocalNumberHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalNumberIf = F3(
	function (a, b, c) {
		return {$: 'LocalNumberIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalNumberListIf = F3(
	function (a, b, c) {
		return {$: 'LocalNumberListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalNumbersAsList = function (a) {
	return {$: 'LocalNumbersAsList', a: a};
};
var $author$project$DataElement$Expression$LocalPickBool = function (a) {
	return {$: 'LocalPickBool', a: a};
};
var $author$project$DataElement$Expression$LocalPickDate = function (a) {
	return {$: 'LocalPickDate', a: a};
};
var $author$project$DataElement$Expression$LocalPickDateTime = function (a) {
	return {$: 'LocalPickDateTime', a: a};
};
var $author$project$DataElement$Expression$LocalPickNumber = function (a) {
	return {$: 'LocalPickNumber', a: a};
};
var $author$project$DataElement$Expression$LocalPickString = function (a) {
	return {$: 'LocalPickString', a: a};
};
var $author$project$DataElement$Expression$LocalProduct = function (a) {
	return {$: 'LocalProduct', a: a};
};
var $author$project$DataElement$Expression$LocalRound = function (a) {
	return {$: 'LocalRound', a: a};
};
var $author$project$DataElement$Expression$LocalSingletonBool = F2(
	function (a, b) {
		return {$: 'LocalSingletonBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSingletonDate = F2(
	function (a, b) {
		return {$: 'LocalSingletonDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSingletonDateTime = F2(
	function (a, b) {
		return {$: 'LocalSingletonDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSingletonNumber = F2(
	function (a, b) {
		return {$: 'LocalSingletonNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSingletonString = F2(
	function (a, b) {
		return {$: 'LocalSingletonString', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalString = function (a) {
	return {$: 'LocalString', a: a};
};
var $author$project$DataElement$Expression$LocalStringExpr = function (a) {
	return {$: 'LocalStringExpr', a: a};
};
var $author$project$DataElement$Expression$LocalStringHardcoded = function (a) {
	return {$: 'LocalStringHardcoded', a: a};
};
var $author$project$DataElement$Expression$LocalStringIf = F3(
	function (a, b, c) {
		return {$: 'LocalStringIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalStringIn = F2(
	function (a, b) {
		return {$: 'LocalStringIn', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalStringListIf = F3(
	function (a, b, c) {
		return {$: 'LocalStringListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$LocalStringNotIn = F2(
	function (a, b) {
		return {$: 'LocalStringNotIn', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalStringsAsList = function (a) {
	return {$: 'LocalStringsAsList', a: a};
};
var $author$project$DataElement$Expression$LocalSubtract = F2(
	function (a, b) {
		return {$: 'LocalSubtract', a: a, b: b};
	});
var $author$project$DataElement$Expression$LocalSum = function (a) {
	return {$: 'LocalSum', a: a};
};
var $author$project$DataElement$Expression$LocalTargetChallengeReasons = function (a) {
	return {$: 'LocalTargetChallengeReasons', a: a};
};
var $author$project$DataElement$Expression$LocalYearNumber = function (a) {
	return {$: 'LocalYearNumber', a: a};
};
var $author$project$DataElement$Expression$RelatedBool = F2(
	function (a, b) {
		return {$: 'RelatedBool', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelatedDate = F2(
	function (a, b) {
		return {$: 'RelatedDate', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelatedDateTime = F2(
	function (a, b) {
		return {$: 'RelatedDateTime', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelatedNumber = F2(
	function (a, b) {
		return {$: 'RelatedNumber', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelatedString = F2(
	function (a, b) {
		return {$: 'RelatedString', a: a, b: b};
	});
var $author$project$DataElement$Expression$RelationshipInfo = F4(
	function (nextElement, idToMatch, localIds, optionalFilter) {
		return {idToMatch: idToMatch, localIds: localIds, nextElement: nextElement, optionalFilter: optionalFilter};
	});
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 'Nothing') {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$DataElement$ProtoElement$Parse$wrapOptional = F2(
	function (innerFun, optionalInput) {
		if (optionalInput.$ === 'Unselected') {
			return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);
		} else {
			var innerProto = optionalInput.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Maybe$Just,
				innerFun(innerProto));
		}
	});
var $author$project$DataElement$ProtoElement$Parse$localBoolHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalBool':
			var fieldName = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalBool(fieldName));
		case 'ProtoLocalBoolLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$LocalSingletonBool, ref, fieldName));
		case 'ProtoLocalBoolHardcoded':
			var bool = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalBoolHardcoded(bool));
		case 'ProtoLocalGTString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalGTString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringBInput));
		case 'ProtoLocalGTNumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalGTNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberBInput));
		case 'ProtoLocalGTDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalGTDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateB));
		case 'ProtoLocalGTDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalGTDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateB));
		case 'ProtoLocalGTComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalGTEString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalGTEString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringBInput));
		case 'ProtoLocalGTENumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalGTENumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberBInput));
		case 'ProtoLocalGTEDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalGTEDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateB));
		case 'ProtoLocalGTEDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalGTEDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateB));
		case 'ProtoLocalGTEComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalLTString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalLTString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringBInput));
		case 'ProtoLocalLTNumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalLTNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberBInput));
		case 'ProtoLocalLTDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalLTDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateB));
		case 'ProtoLocalLTDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalLTDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateB));
		case 'ProtoLocalLTComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalLTEString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalLTEString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringBInput));
		case 'ProtoLocalLTENumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalLTENumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberBInput));
		case 'ProtoLocalLTEDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalLTEDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateB));
		case 'ProtoLocalLTEDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalLTEDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateB));
		case 'ProtoLocalLTEComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalEqualString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalEqualString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringBInput));
		case 'ProtoLocalEqualNumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalEqualNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberBInput));
		case 'ProtoLocalEqualBool':
			var boolA = proto.a;
			var boolB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalEqualBool,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(boolA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(boolB));
		case 'ProtoLocalEqualDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalEqualDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateB));
		case 'ProtoLocalEqualDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalEqualDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateB));
		case 'ProtoLocalEqualComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalEqualAny':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalNotEqualString':
			var stringAInput = proto.a;
			var stringBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalNotEqualString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringBInput));
		case 'ProtoLocalNotEqualNumber':
			var numberAInput = proto.a;
			var numberBInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalNotEqualNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberAInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberBInput));
		case 'ProtoLocalNotEqualDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalNotEqualDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateB));
		case 'ProtoLocalNotEqualDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalNotEqualDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateB));
		case 'ProtoLocalNotEqualBool':
			var boolA = proto.a;
			var boolB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalNotEqualBool,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(boolA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(boolB));
		case 'ProtoLocalNotEqualComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalNotEqualAny':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalStringIn':
			var stringInput = proto.a;
			var stringListInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalStringIn,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList()(stringListInput));
		case 'ProtoLocalStringNotIn':
			var stringInput = proto.a;
			var stringListInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalStringNotIn,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList()(stringListInput));
		case 'ProtoLocalNot':
			var boolInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalNot,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(boolInput));
		case 'ProtoLocalBoolIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalBoolIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(elseInput));
		case 'ProtoLocalPickBool':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalPickBool,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBoolList()(listInput));
		case 'ProtoLocalAll':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalAll,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBoolList()(listInput));
		case 'ProtoLocalAny':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalAny,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBoolList()(listInput));
		case 'ProtoLocalIsNull':
			var field = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalIsNull,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localField()(field));
		default:
			var field = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalIsNotNull,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localField()(field));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localBoolListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalBoolListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalBoolListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBoolList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBoolList()(elseInput));
		case 'ProtoLocalAllBoolsInField':
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalAllBoolsInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
		case 'ProtoLocalBoolsAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v20 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v20.$ === 'Just') && (_v20.a.a.$ === 'Unselected')) {
				var _v21 = _v20.a;
				var inputState = _v21.a.a;
				var restOfList = _v21.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$LocalBoolsAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$localBool(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			var relationship = proto.a;
			var fieldName = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$RelatedBool,
				$author$project$DataElement$ProtoElement$Parse$parseRelationship(relationship),
				$author$project$Input$toMaybe(fieldName));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localComparableListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalCompStringList':
			var stringList = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalCompStringListExpr,
				$author$project$DataElement$ProtoElement$Parse$localStringListHelper(stringList));
		case 'ProtoLocalCompNumberList':
			var numberList = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalCompNumberListExpr,
				$author$project$DataElement$ProtoElement$Parse$localNumberListHelper(numberList));
		case 'ProtoLocalCompDateList':
			var dateList = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalCompDateListExpr,
				$author$project$DataElement$ProtoElement$Parse$localDateListHelper(dateList));
		case 'ProtoLocalCompFieldList':
			return $elm$core$Maybe$Nothing;
		default:
			var dateTimeList = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalCompDateTimeListExpr,
				$author$project$DataElement$ProtoElement$Parse$localDateTimeListHelper(dateTimeList));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localDateHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDate':
			var fieldName = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalDate(fieldName));
		case 'ProtoLocalDateLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$LocalSingletonDate, ref, fieldName));
		case 'ProtoLocalDateHardcoded':
			var date = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalDateHardcoded(date));
		case 'ProtoLocalDateTimeToDate':
			var dateTime = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalDateTimeToDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(dateTime));
		case 'ProtoLocalDateCeiling':
			var dateInterval = proto.a;
			var date = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalDateCeiling,
				$author$project$Input$toMaybe(dateInterval),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(date));
		case 'ProtoLocalDateFloor':
			var dateInterval = proto.a;
			var date = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalDateFloor,
				$author$project$Input$toMaybe(dateInterval),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(date));
		case 'ProtoLocalDateAdd':
			var dateUnit = proto.a;
			var number = proto.b;
			var date = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalDateAdd,
				$author$project$Input$toMaybe(dateUnit),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(number),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(date));
		case 'ProtoLocalDateSubtract':
			var dateUnit = proto.a;
			var number = proto.b;
			var date = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalDateSubtract,
				$author$project$Input$toMaybe(dateUnit),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(number),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(date));
		case 'ProtoLocalDateIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalDateIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(elseInput));
		case 'ProtoLocalPickDate':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalPickDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateList()(listInput));
		case 'ProtoLocalMaxDate':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalMaxDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateList()(listInput));
		default:
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalMinDate,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateList()(listInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localDateListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDateListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalDateListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateList()(elseInput));
		case 'ProtoLocalAllDatesInField':
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalAllDatesInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
		case 'ProtoLocalDatesAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v15 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v15.$ === 'Just') && (_v15.a.a.$ === 'Unselected')) {
				var _v16 = _v15.a;
				var inputState = _v16.a.a;
				var restOfList = _v16.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$LocalDatesAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$localDate(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			var relationship = proto.a;
			var fieldName = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$RelatedDate,
				$author$project$DataElement$ProtoElement$Parse$parseRelationship(relationship),
				$author$project$Input$toMaybe(fieldName));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localDateTimeHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDateTime':
			var fieldName = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalDateTime(fieldName));
		case 'ProtoLocalDateTimeLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$LocalSingletonDateTime, ref, fieldName));
		case 'ProtoLocalDateTimeHardcoded':
			var date = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalDateTimeHardcoded(date));
		case 'ProtoLocalDateTimeIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalDateTimeIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(elseInput));
		case 'ProtoLocalPickDateTime':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalPickDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTimeList()(listInput));
		case 'ProtoLocalMaxDateTime':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalMaxDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTimeList()(listInput));
		default:
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalMinDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTimeList()(listInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localDateTimeListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDateTimeListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalDateTimeListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTimeList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTimeList()(elseInput));
		case 'ProtoLocalAllDateTimesInField':
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalAllDateTimesInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
		case 'ProtoLocalDateTimesAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v11 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v11.$ === 'Just') && (_v11.a.a.$ === 'Unselected')) {
				var _v12 = _v11.a;
				var inputState = _v12.a.a;
				var restOfList = _v12.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$LocalDateTimesAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			var relationship = proto.a;
			var fieldName = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$RelatedDateTime,
				$author$project$DataElement$ProtoElement$Parse$parseRelationship(relationship),
				$author$project$Input$toMaybe(fieldName));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localFieldHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringField':
			var stringProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalStringExpr,
				$author$project$DataElement$ProtoElement$Parse$localStringHelper(stringProto));
		case 'ProtoLocalNumberField':
			var numberProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalNumberExpr,
				$author$project$DataElement$ProtoElement$Parse$localNumberHelper(numberProto));
		case 'ProtoLocalDateField':
			var dateProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalDateExpr,
				$author$project$DataElement$ProtoElement$Parse$localDateHelper(dateProto));
		case 'ProtoLocalDateTimeField':
			var dateTimeProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalDateTimeExpr,
				$author$project$DataElement$ProtoElement$Parse$localDateTimeHelper(dateTimeProto));
		case 'ProtoLocalBoolField':
			var boolProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalBoolExpr,
				$author$project$DataElement$ProtoElement$Parse$localBoolHelper(boolProto));
		case 'ProtoLocalAnyField':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoElement$Parse$localNumberHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalNumber':
			var fieldName = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalNumber(fieldName));
		case 'ProtoLocalNumberLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$LocalSingletonNumber, ref, fieldName));
		case 'ProtoLocalNumberHardcoded':
			var num = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalNumberHardcoded(num));
		case 'ProtoLocalRoundNumber':
			var numberInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalRound,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberInput));
		case 'ProtoLocalSum':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalSum,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList()(listInput));
		case 'ProtoLocalProduct':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalProduct,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList()(listInput));
		case 'ProtoLocalAdd':
			var numberA = proto.a;
			var numberB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalAdd,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberB));
		case 'ProtoLocalSubtract':
			var numberA = proto.a;
			var numberB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalSubtract,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberB));
		case 'ProtoLocalMultiply':
			var numberA = proto.a;
			var numberB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalMultiply,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberB));
		case 'ProtoLocalDivide':
			var numberA = proto.a;
			var numberB = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalDivide,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberA),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberB));
		case 'ProtoLocalMonthNumber':
			var dateInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalMonthNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateInput));
		case 'ProtoLocalYearNumber':
			var dateInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalYearNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateInput));
		case 'ProtoLocalDayInMonth':
			var dateInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalDayInMonth,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateInput));
		case 'ProtoLocalNumberIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalNumberIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(elseInput));
		case 'ProtoLocalPickNumber':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalPickNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList()(listInput));
		case 'ProtoLocalMaxNumber':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalMaxNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList()(listInput));
		case 'ProtoLocalMinNumber':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalMinNumber,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList()(listInput));
		default:
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalCountUnique,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localComparableList()(listInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localNumberListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalNumberListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalNumberListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList()(elseInput));
		case 'ProtoLocalAllNumbersInField':
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalAllNumbersInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
		case 'ProtoLocalNumbersAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v6 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v6.$ === 'Just') && (_v6.a.a.$ === 'Unselected')) {
				var _v7 = _v6.a;
				var inputState = _v7.a.a;
				var restOfList = _v7.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$LocalNumbersAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			var relationship = proto.a;
			var fieldName = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$RelatedNumber,
				$author$project$DataElement$ProtoElement$Parse$parseRelationship(relationship),
				$author$project$Input$toMaybe(fieldName));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localStringHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalString':
			var fieldName = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalString(fieldName));
		case 'ProtoLocalStringLookup':
			var ref = proto.a;
			var fieldName = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$Expression$LocalSingletonString, ref, fieldName));
		case 'ProtoLocalStringHardcoded':
			var words = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$Expression$LocalStringHardcoded(words));
		case 'ProtoLocalFormatDate':
			var stringInput = proto.a;
			var dateInput = proto.b;
			if (stringInput.$ === 'Unselected') {
				var inputState = stringInput.a;
				return _Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$LocalFormatDateLocaleAware,
					$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateInput)) : $elm$core$Maybe$Nothing;
			} else {
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$Expression$LocalFormatDate,
					$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(stringInput),
					$author$project$DataElement$ProtoElement$Parse$cyclic$localDate()(dateInput));
			}
		case 'ProtoLocalFormatNumber':
			var inputDecimal = proto.a;
			var numberInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalFormatNumber,
				$author$project$IntInput$toMaybe(inputDecimal),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber()(numberInput));
		case 'ProtoLocalStringIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalStringIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(elseInput));
		case 'ProtoLocalPickString':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalPickString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList()(listInput));
		case 'ProtoLocalConcat':
			var joinInput = proto.a;
			var listInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalConcat,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(joinInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList()(listInput));
		case 'ProtoLocalMaxString':
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalMaxString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList()(listInput));
		case 'ProtoLocalFormatDateTime':
			var input = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalFormatDateTime,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime()(input));
		default:
			var listInput = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalMinString,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList()(listInput));
	}
};
var $author$project$DataElement$ProtoElement$Parse$localStringListHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A4(
				$elm$core$Maybe$map3,
				$author$project$DataElement$Expression$LocalStringListIf,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localBool()(ifInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList()(thenInput),
				$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList()(elseInput));
		case 'ProtoLocalAllStringsInField':
			var refInput = proto.a;
			var fieldInput = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$LocalAllStringsInField,
				$author$project$Input$toMaybe(refInput),
				$author$project$Input$toMaybe(fieldInput));
		case 'ProtoLocalStringsAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			var _v1 = $elm_community$list_extra$List$Extra$unconsLast(listOfExprs);
			if ((_v1.$ === 'Just') && (_v1.a.a.$ === 'Unselected')) {
				var _v2 = _v1.a;
				var inputState = _v2.a.a;
				var restOfList = _v2.b;
				return (!$elm$core$List$length(restOfList)) ? $elm$core$Maybe$Nothing : (_Utils_eq(inputState, $author$project$Input$emptyState) ? A2(
					$elm$core$Maybe$map,
					$author$project$DataElement$Expression$LocalStringsAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$DataElement$ProtoElement$Parse$cyclic$localString(),
							restOfList))) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'ProtoRelatedString':
			var relationship = proto.a;
			var fieldName = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$Expression$RelatedString,
				$author$project$DataElement$ProtoElement$Parse$parseRelationship(relationship),
				$author$project$Input$toMaybe(fieldName));
		case 'ProtoLocalChallengeReasons':
			var acctId = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalChallengeReasons,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(acctId));
		default:
			var acctId = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalTargetChallengeReasons,
				$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(acctId));
	}
};
var $author$project$DataElement$ProtoElement$Parse$parseRelationship = function (proto) {
	return A5(
		$elm$core$Maybe$map4,
		$author$project$DataElement$Expression$RelationshipInfo,
		$author$project$Input$toMaybe(proto.nextElement),
		$author$project$DataElement$ProtoElement$Parse$cyclic$localString()(proto.idToMatch),
		$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList()(proto.localIds),
		A2($author$project$DataElement$ProtoElement$Parse$wrapOptional, $author$project$DataElement$ProtoElement$Parse$localBoolHelper, proto.optionalFilter));
};
function $author$project$DataElement$ProtoElement$Parse$cyclic$localBool() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localBoolHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localBoolList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localBoolListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localComparableList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localComparableListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localDate() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localDateHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localDateList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localDateListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localDateTimeHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localDateTimeList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localDateTimeListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localField() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localFieldHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localNumber() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localNumberHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localNumberListHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localString() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localStringHelper);
}
function $author$project$DataElement$ProtoElement$Parse$cyclic$localStringList() {
	return $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localStringListHelper);
}
try {
	var $author$project$DataElement$ProtoElement$Parse$localBool = $author$project$DataElement$ProtoElement$Parse$cyclic$localBool();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localBool = function () {
		return $author$project$DataElement$ProtoElement$Parse$localBool;
	};
	var $author$project$DataElement$ProtoElement$Parse$localBoolList = $author$project$DataElement$ProtoElement$Parse$cyclic$localBoolList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localBoolList = function () {
		return $author$project$DataElement$ProtoElement$Parse$localBoolList;
	};
	var $author$project$DataElement$ProtoElement$Parse$localComparableList = $author$project$DataElement$ProtoElement$Parse$cyclic$localComparableList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localComparableList = function () {
		return $author$project$DataElement$ProtoElement$Parse$localComparableList;
	};
	var $author$project$DataElement$ProtoElement$Parse$localDate = $author$project$DataElement$ProtoElement$Parse$cyclic$localDate();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localDate = function () {
		return $author$project$DataElement$ProtoElement$Parse$localDate;
	};
	var $author$project$DataElement$ProtoElement$Parse$localDateList = $author$project$DataElement$ProtoElement$Parse$cyclic$localDateList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localDateList = function () {
		return $author$project$DataElement$ProtoElement$Parse$localDateList;
	};
	var $author$project$DataElement$ProtoElement$Parse$localDateTime = $author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTime = function () {
		return $author$project$DataElement$ProtoElement$Parse$localDateTime;
	};
	var $author$project$DataElement$ProtoElement$Parse$localDateTimeList = $author$project$DataElement$ProtoElement$Parse$cyclic$localDateTimeList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localDateTimeList = function () {
		return $author$project$DataElement$ProtoElement$Parse$localDateTimeList;
	};
	var $author$project$DataElement$ProtoElement$Parse$localField = $author$project$DataElement$ProtoElement$Parse$cyclic$localField();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localField = function () {
		return $author$project$DataElement$ProtoElement$Parse$localField;
	};
	var $author$project$DataElement$ProtoElement$Parse$localNumber = $author$project$DataElement$ProtoElement$Parse$cyclic$localNumber();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localNumber = function () {
		return $author$project$DataElement$ProtoElement$Parse$localNumber;
	};
	var $author$project$DataElement$ProtoElement$Parse$localNumberList = $author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localNumberList = function () {
		return $author$project$DataElement$ProtoElement$Parse$localNumberList;
	};
	var $author$project$DataElement$ProtoElement$Parse$localString = $author$project$DataElement$ProtoElement$Parse$cyclic$localString();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localString = function () {
		return $author$project$DataElement$ProtoElement$Parse$localString;
	};
	var $author$project$DataElement$ProtoElement$Parse$localStringList = $author$project$DataElement$ProtoElement$Parse$cyclic$localStringList();
	$author$project$DataElement$ProtoElement$Parse$cyclic$localStringList = function () {
		return $author$project$DataElement$ProtoElement$Parse$localStringList;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.ProtoElement.Parse` are causing infinite recursion:\n\n  ┌─────┐\n  │    localBool\n  │     ↓\n  │    localBoolHelper\n  │     ↓\n  │    localBoolList\n  │     ↓\n  │    localBoolListHelper\n  │     ↓\n  │    localComparableList\n  │     ↓\n  │    localComparableListHelper\n  │     ↓\n  │    localDate\n  │     ↓\n  │    localDateHelper\n  │     ↓\n  │    localDateList\n  │     ↓\n  │    localDateListHelper\n  │     ↓\n  │    localDateTime\n  │     ↓\n  │    localDateTimeHelper\n  │     ↓\n  │    localDateTimeList\n  │     ↓\n  │    localDateTimeListHelper\n  │     ↓\n  │    localField\n  │     ↓\n  │    localFieldHelper\n  │     ↓\n  │    localNumber\n  │     ↓\n  │    localNumberHelper\n  │     ↓\n  │    localNumberList\n  │     ↓\n  │    localNumberListHelper\n  │     ↓\n  │    localString\n  │     ↓\n  │    localStringHelper\n  │     ↓\n  │    localStringList\n  │     ↓\n  │    localStringListHelper\n  │     ↓\n  │    parseRelationship\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$ExpressionInput$protoLocalAnyDragCmds = function (proto) {
	if (proto.$ === 'ProtoLocalAnyIf') {
		var inputIf = proto.a;
		var inputThen = proto.b;
		var inputElse = proto.c;
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$ExpressionInput$Msg$InnerMsg(0),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$ExpressionInput$Msg$InnerMsg(1),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyDragCmds, inputThen)))),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$ExpressionInput$Msg$InnerMsg(2),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyDragCmds, inputElse))))
				]));
	} else {
		var list = proto.a;
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$ExpressionInput$Msg$InnerMsg(0),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				$author$project$Input$toMaybe(
					A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoLocalAnyListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalAnyListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyListDragCmds, inputElse))))
					]));
		case 'ProtoLocalAllAnysInField':
			var ref = proto.a;
			var state = proto.b;
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalAnysAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedDragCmds(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalBoolDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalBool':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalBoolLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalBoolHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalGTString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputB))))
					]));
		case 'ProtoLocalGTNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalGTDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputB))))
					]));
		case 'ProtoLocalGTDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoLocalGTComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputB))))
					]));
		case 'ProtoLocalGTEString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputB))))
					]));
		case 'ProtoLocalGTENumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalGTEDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputB))))
					]));
		case 'ProtoLocalGTEDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoLocalGTEComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputB))))
					]));
		case 'ProtoLocalLTString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputB))))
					]));
		case 'ProtoLocalLTNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalLTDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputB))))
					]));
		case 'ProtoLocalLTDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoLocalLTComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputB))))
					]));
		case 'ProtoLocalLTEString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputB))))
					]));
		case 'ProtoLocalLTENumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalLTEDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputB))))
					]));
		case 'ProtoLocalLTEDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoLocalLTEComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputB))))
					]));
		case 'ProtoLocalEqualString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputB))))
					]));
		case 'ProtoLocalEqualNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalEqualDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputB))))
					]));
		case 'ProtoLocalEqualDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoLocalEqualBool':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputB))))
					]));
		case 'ProtoLocalEqualComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputB))))
					]));
		case 'ProtoLocalEqualAny':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyDragCmds, inputB))))
					]));
		case 'ProtoLocalNotEqualString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputB))))
					]));
		case 'ProtoLocalNotEqualNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalNotEqualDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputB))))
					]));
		case 'ProtoLocalNotEqualDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputB))))
					]));
		case 'ProtoLocalNotEqualBool':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputB))))
					]));
		case 'ProtoLocalNotEqualComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputB))))
					]));
		case 'ProtoLocalNotEqualAny':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyDragCmds, inputB))))
					]));
		case 'ProtoLocalStringIn':
			var inputString = proto.a;
			var inputList = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputString)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListDragCmds, inputList))))
					]));
		case 'ProtoLocalStringNotIn':
			var inputString = proto.a;
			var inputList = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputString)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListDragCmds, inputList))))
					]));
		case 'ProtoLocalNot':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, input))));
		case 'ProtoLocalBoolIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputElse))))
					]));
		case 'ProtoLocalPickBool':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListDragCmds, input))));
		case 'ProtoLocalAll':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListDragCmds, input))));
		case 'ProtoLocalAny':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListDragCmds, input))));
		case 'ProtoLocalIsNull':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldDragCmds, input))));
		default:
			var input = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldDragCmds, input))));
	}
};
var $author$project$ExpressionInput$protoLocalBoolListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalBoolListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListDragCmds, inputElse))))
					]));
		case 'ProtoLocalAllBoolsInField':
			var ref = proto.a;
			var state = proto.b;
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalBoolsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedDragCmds(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalCompDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalMaxComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldListDragCmds, list))));
		case 'ProtoLocalMinComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldListDragCmds, list))));
		case 'ProtoLocalCompIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompDragCmds, inputElse))))
					]));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoLocalCountUniqueListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalCompStringList':
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoLocalStringListDragCmds(stringList);
		case 'ProtoLocalCompNumberList':
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoLocalNumberListDragCmds(stringList);
		case 'ProtoLocalCompDateList':
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoLocalDateListDragCmds(stringList);
		case 'ProtoLocalCompDateTimeList':
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoLocalDateTimeListDragCmds(stringList);
		default:
			var stringList = proto.a;
			return $author$project$ExpressionInput$protoLocalFieldListDragCmds(stringList);
	}
};
var $author$project$ExpressionInput$protoLocalDateDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDate':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalDateLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalDateHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalDateTimeToDate':
			var inputDateTime = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputDateTime))));
		case 'ProtoLocalDateCeiling':
			var dateInterval = proto.a;
			var inputDate = proto.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputDate))));
		case 'ProtoLocalDateFloor':
			var dateInterval = proto.a;
			var inputDate = proto.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputDate))));
		case 'ProtoLocalDateAdd':
			var inputDateUnit = proto.a;
			var inputNumber = proto.b;
			var inputDate = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputDate)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputNumber))))
					]));
		case 'ProtoLocalDateSubtract':
			var inputDateUnit = proto.a;
			var inputNumber = proto.b;
			var inputDate = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputDate)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputNumber))))
					]));
		case 'ProtoLocalDateIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputElse))))
					]));
		case 'ProtoLocalPickDate':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListDragCmds, list))));
		case 'ProtoLocalMaxDate':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListDragCmds, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoLocalDateListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDateListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListDragCmds, inputElse))))
					]));
		case 'ProtoLocalAllDatesInField':
			var ref = proto.a;
			var state = proto.b;
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalDatesAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedDragCmds(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalDateTimeDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDateTime':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalDateTimeLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalDateTimeHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalDateTimeIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputElse))))
					]));
		case 'ProtoLocalPickDateTime':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListDragCmds, list))));
		case 'ProtoLocalMaxDateTime':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListDragCmds, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoLocalDateTimeListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDateTimeListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListDragCmds, inputElse))))
					]));
		case 'ProtoLocalAllDateTimesInField':
			var ref = proto.a;
			var state = proto.b;
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalDateTimesAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedDragCmds(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalFieldDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalStringDragCmds(fieldProto);
		case 'ProtoLocalNumberField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalNumberDragCmds(fieldProto);
		case 'ProtoLocalDateField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalDateDragCmds(fieldProto);
		case 'ProtoLocalDateTimeField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalDateTimeDragCmds(fieldProto);
		case 'ProtoLocalBoolField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalBoolDragCmds(fieldProto);
		case 'ProtoLocalAnyField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalAnyDragCmds(fieldProto);
		default:
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalCompDragCmds(fieldProto);
	}
};
var $author$project$ExpressionInput$protoLocalFieldListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalCompListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldListDragCmds, inputElse))))
					]));
		case 'ProtoLocalAllCompsInField':
			var ref = proto.a;
			var state = proto.b;
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalCompsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedDragCmds(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalNumberDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalNumber':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalNumberLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalNumberHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalCountUnique':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCountUniqueListDragCmds, list))));
		case 'ProtoLocalRoundNumber':
			var inputNumber = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputNumber))));
		case 'ProtoLocalSum':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListDragCmds, list))));
		case 'ProtoLocalProduct':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListDragCmds, list))));
		case 'ProtoLocalAdd':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalSubtract':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalMultiply':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalDivide':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputA)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputB))))
					]));
		case 'ProtoLocalMonthNumber':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputDate))));
		case 'ProtoLocalYearNumber':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputDate))));
		case 'ProtoLocalDayInMonth':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputDate))));
		case 'ProtoLocalNumberIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputElse))))
					]));
		case 'ProtoLocalPickNumber':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListDragCmds, list))));
		case 'ProtoLocalMaxNumber':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListDragCmds, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoLocalNumberListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalNumberListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListDragCmds, inputElse))))
					]));
		case 'ProtoLocalAllNumbersInField':
			var ref = proto.a;
			var state = proto.b;
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalNumbersAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedDragCmds(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalRelatedDragCmds = function (_v2) {
	var localIds = _v2.localIds;
	var nextElement = _v2.nextElement;
	var idToMatch = _v2.idToMatch;
	var optionalFilter = _v2.optionalFilter;
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(2),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, idToMatch)))),
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(3),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListDragCmds, localIds)))),
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(4),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, optionalFilter))))
			]));
};
var $author$project$ExpressionInput$protoLocalStringDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalString':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalStringLookup':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalStringHardcoded':
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalFormatDate':
			var inputString = proto.a;
			var inputDate = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateDragCmds, inputDate)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputString))))
					]));
		case 'ProtoLocalFormatDateTime':
			var inputDateTime = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeDragCmds, inputDateTime))));
		case 'ProtoLocalFormatNumber':
			var intInput = proto.a;
			var inputNumber = proto.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberDragCmds, inputNumber))));
		case 'ProtoLocalStringIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputElse))))
					]));
		case 'ProtoLocalPickString':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListDragCmds, list))));
		case 'ProtoLocalConcat':
			var inputString = proto.a;
			var list = proto.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListDragCmds, list)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, inputString))))
					]));
		case 'ProtoLocalMaxString':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListDragCmds, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListDragCmds, list))));
	}
};
var $author$project$ExpressionInput$protoLocalStringListDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolDragCmds, inputIf)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListDragCmds, inputThen)))),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListDragCmds, inputElse))))
					]));
		case 'ProtoLocalAllStringsInField':
			var ref = proto.a;
			var state = proto.b;
			return $elm$core$Platform$Cmd$none;
		case 'ProtoLocalStringsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.commands(dragModel);
		case 'ProtoRelatedString':
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedDragCmds(relationship);
		case 'ProtoLocalChallengeReasons':
			var acctIdInput = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, acctIdInput))));
		default:
			var acctIdInput = proto.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringDragCmds, acctIdInput))));
	}
};
var $author$project$DataElement$ProtoExpression$ProtoLocalAdd = F2(
	function (a, b) {
		return {$: 'ProtoLocalAdd', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAll = function (a) {
	return {$: 'ProtoLocalAll', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField = F2(
	function (a, b) {
		return {$: 'ProtoLocalAllAnysInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAllBoolsInField = F2(
	function (a, b) {
		return {$: 'ProtoLocalAllBoolsInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAllCompsInField = F2(
	function (a, b) {
		return {$: 'ProtoLocalAllCompsInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAllDateTimesInField = F2(
	function (a, b) {
		return {$: 'ProtoLocalAllDateTimesInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAllDatesInField = F2(
	function (a, b) {
		return {$: 'ProtoLocalAllDatesInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAllNumbersInField = F2(
	function (a, b) {
		return {$: 'ProtoLocalAllNumbersInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAllStringsInField = F2(
	function (a, b) {
		return {$: 'ProtoLocalAllStringsInField', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAny = function (a) {
	return {$: 'ProtoLocalAny', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalAnyField = function (a) {
	return {$: 'ProtoLocalAnyField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalAnyIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalAnyIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalAnyListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList = F2(
	function (a, b) {
		return {$: 'ProtoLocalAnysAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalBoolField = function (a) {
	return {$: 'ProtoLocalBoolField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalBoolFieldList = function (a) {
	return {$: 'ProtoLocalBoolFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalBoolIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalBoolIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalBoolListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalBoolListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalBoolsAsList = F2(
	function (a, b) {
		return {$: 'ProtoLocalBoolsAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalChallengeReasons = function (a) {
	return {$: 'ProtoLocalChallengeReasons', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField = function (a) {
	return {$: 'ProtoLocalCompAsCompField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalCompAsField = function (a) {
	return {$: 'ProtoLocalCompAsField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalCompDateList = function (a) {
	return {$: 'ProtoLocalCompDateList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalCompDateTimeList = function (a) {
	return {$: 'ProtoLocalCompDateTimeList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList = function (a) {
	return {$: 'ProtoLocalCompFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalCompIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalCompIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalCompListAsFieldList = function (a) {
	return {$: 'ProtoLocalCompListAsFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalCompListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalCompListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalCompNumberList = function (a) {
	return {$: 'ProtoLocalCompNumberList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalCompStringList = function (a) {
	return {$: 'ProtoLocalCompStringList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList = F2(
	function (a, b) {
		return {$: 'ProtoLocalCompsAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalConcat = F2(
	function (a, b) {
		return {$: 'ProtoLocalConcat', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalCountUnique = function (a) {
	return {$: 'ProtoLocalCountUnique', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateAdd = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalDateAdd', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDateCeiling = F2(
	function (a, b) {
		return {$: 'ProtoLocalDateCeiling', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDateComp = function (a) {
	return {$: 'ProtoLocalDateComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateField = function (a) {
	return {$: 'ProtoLocalDateField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateFieldList = function (a) {
	return {$: 'ProtoLocalDateFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateFloor = F2(
	function (a, b) {
		return {$: 'ProtoLocalDateFloor', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDateIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalDateIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDateListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalDateListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDateSubtract = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalDateSubtract', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp = function (a) {
	return {$: 'ProtoLocalDateTimeComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeField = function (a) {
	return {$: 'ProtoLocalDateTimeField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeFieldList = function (a) {
	return {$: 'ProtoLocalDateTimeFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalDateTimeIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalDateTimeListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeToDate = function (a) {
	return {$: 'ProtoLocalDateTimeToDate', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTimesAsList = F2(
	function (a, b) {
		return {$: 'ProtoLocalDateTimesAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDatesAsList = F2(
	function (a, b) {
		return {$: 'ProtoLocalDatesAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDayInMonth = function (a) {
	return {$: 'ProtoLocalDayInMonth', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDivide = F2(
	function (a, b) {
		return {$: 'ProtoLocalDivide', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalEqualAny = F2(
	function (a, b) {
		return {$: 'ProtoLocalEqualAny', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalEqualBool = F2(
	function (a, b) {
		return {$: 'ProtoLocalEqualBool', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalEqualComp = F2(
	function (a, b) {
		return {$: 'ProtoLocalEqualComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalEqualDate = F2(
	function (a, b) {
		return {$: 'ProtoLocalEqualDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalEqualDateTime = F2(
	function (a, b) {
		return {$: 'ProtoLocalEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalEqualNumber = F2(
	function (a, b) {
		return {$: 'ProtoLocalEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalEqualString = F2(
	function (a, b) {
		return {$: 'ProtoLocalEqualString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalFieldList = function (a) {
	return {$: 'ProtoLocalFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalFormatDate = F2(
	function (a, b) {
		return {$: 'ProtoLocalFormatDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalFormatDateTime = function (a) {
	return {$: 'ProtoLocalFormatDateTime', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalFormatNumber = F2(
	function (a, b) {
		return {$: 'ProtoLocalFormatNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTComp = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTDate = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTDateTime = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTEComp = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTEComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTEDate = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTEDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTEDateTime = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTENumber = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTENumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTEString = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTEString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTNumber = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalGTString = F2(
	function (a, b) {
		return {$: 'ProtoLocalGTString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalIsNotNull = function (a) {
	return {$: 'ProtoLocalIsNotNull', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalIsNull = function (a) {
	return {$: 'ProtoLocalIsNull', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalLTComp = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalLTDate = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalLTDateTime = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalLTEComp = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTEComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalLTEDate = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTEDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalLTEDateTime = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTEDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalLTENumber = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTENumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalLTEString = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTEString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalLTNumber = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalLTString = F2(
	function (a, b) {
		return {$: 'ProtoLocalLTString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalMaxComp = function (a) {
	return {$: 'ProtoLocalMaxComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMaxDate = function (a) {
	return {$: 'ProtoLocalMaxDate', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMaxDateTime = function (a) {
	return {$: 'ProtoLocalMaxDateTime', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMaxNumber = function (a) {
	return {$: 'ProtoLocalMaxNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMaxString = function (a) {
	return {$: 'ProtoLocalMaxString', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMinComp = function (a) {
	return {$: 'ProtoLocalMinComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMinDate = function (a) {
	return {$: 'ProtoLocalMinDate', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMinDateTime = function (a) {
	return {$: 'ProtoLocalMinDateTime', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMinNumber = function (a) {
	return {$: 'ProtoLocalMinNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMinString = function (a) {
	return {$: 'ProtoLocalMinString', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMonthNumber = function (a) {
	return {$: 'ProtoLocalMonthNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalMultiply = F2(
	function (a, b) {
		return {$: 'ProtoLocalMultiply', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNot = function (a) {
	return {$: 'ProtoLocalNot', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalNotEqualAny = F2(
	function (a, b) {
		return {$: 'ProtoLocalNotEqualAny', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNotEqualBool = F2(
	function (a, b) {
		return {$: 'ProtoLocalNotEqualBool', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp = F2(
	function (a, b) {
		return {$: 'ProtoLocalNotEqualComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDate = F2(
	function (a, b) {
		return {$: 'ProtoLocalNotEqualDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDateTime = F2(
	function (a, b) {
		return {$: 'ProtoLocalNotEqualDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNotEqualNumber = F2(
	function (a, b) {
		return {$: 'ProtoLocalNotEqualNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNotEqualString = F2(
	function (a, b) {
		return {$: 'ProtoLocalNotEqualString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNumberComp = function (a) {
	return {$: 'ProtoLocalNumberComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalNumberField = function (a) {
	return {$: 'ProtoLocalNumberField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalNumberFieldList = function (a) {
	return {$: 'ProtoLocalNumberFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalNumberIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalNumberIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalNumberListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNumbersAsList = F2(
	function (a, b) {
		return {$: 'ProtoLocalNumbersAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalPickAny = function (a) {
	return {$: 'ProtoLocalPickAny', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalPickBool = function (a) {
	return {$: 'ProtoLocalPickBool', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalPickComp = function (a) {
	return {$: 'ProtoLocalPickComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalPickDate = function (a) {
	return {$: 'ProtoLocalPickDate', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalPickDateTime = function (a) {
	return {$: 'ProtoLocalPickDateTime', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalPickNumber = function (a) {
	return {$: 'ProtoLocalPickNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalPickString = function (a) {
	return {$: 'ProtoLocalPickString', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalProduct = function (a) {
	return {$: 'ProtoLocalProduct', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny = F2(
	function (a, b) {
		return {$: 'ProtoLocalRelatedAny', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp = F2(
	function (a, b) {
		return {$: 'ProtoLocalRelatedComp', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalRoundNumber = function (a) {
	return {$: 'ProtoLocalRoundNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalStringComp = function (a) {
	return {$: 'ProtoLocalStringComp', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalStringField = function (a) {
	return {$: 'ProtoLocalStringField', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalStringFieldList = function (a) {
	return {$: 'ProtoLocalStringFieldList', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalStringIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalStringIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalStringIn = F2(
	function (a, b) {
		return {$: 'ProtoLocalStringIn', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalStringListIf = F3(
	function (a, b, c) {
		return {$: 'ProtoLocalStringListIf', a: a, b: b, c: c};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalStringNotIn = F2(
	function (a, b) {
		return {$: 'ProtoLocalStringNotIn', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalStringsAsList = F2(
	function (a, b) {
		return {$: 'ProtoLocalStringsAsList', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalSubtract = F2(
	function (a, b) {
		return {$: 'ProtoLocalSubtract', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalSum = function (a) {
	return {$: 'ProtoLocalSum', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalTargetChallengeReasons = function (a) {
	return {$: 'ProtoLocalTargetChallengeReasons', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalYearNumber = function (a) {
	return {$: 'ProtoLocalYearNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoRelatedBool = F2(
	function (a, b) {
		return {$: 'ProtoRelatedBool', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoRelatedDate = F2(
	function (a, b) {
		return {$: 'ProtoRelatedDate', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoRelatedDateTime = F2(
	function (a, b) {
		return {$: 'ProtoRelatedDateTime', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoRelatedNumber = F2(
	function (a, b) {
		return {$: 'ProtoRelatedNumber', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoRelatedString = F2(
	function (a, b) {
		return {$: 'ProtoRelatedString', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$localBoolListToAnyList = function (proto) {
	_v1$4:
	while (true) {
		switch (proto.$) {
			case 'ProtoLocalBoolListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf(ifInput),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localBoolListToAnyList, thenInput)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localBoolListToAnyList, elseInput)));
			case 'ProtoLocalAllBoolsInField':
				if (proto.b.$ === 'Unselected') {
					var refInput = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField, refInput, fieldState));
				} else {
					break _v1$4;
				}
			case 'ProtoLocalBoolsAsList':
				var listOfExprs = proto.a;
				var dragModel = proto.b;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Input$map($author$project$DataElement$ProtoExpression$localBoolToAny),
								$author$project$Input$maybe),
							listOfExprs)),
					$elm$core$Maybe$Just(dragModel));
			default:
				if (proto.b.$ === 'Unselected') {
					var relationship = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny, relationship, fieldState));
				} else {
					break _v1$4;
				}
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$DataElement$ProtoExpression$localBoolToAny = function (localBool) {
	switch (localBool.$) {
		case 'ProtoLocalBoolIf':
			var ifInput = localBool.a;
			var thenInput = localBool.b;
			var elseInput = localBool.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localBoolToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localBoolToAny, elseInput)));
		case 'ProtoLocalPickBool':
			var listInput = localBool.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localBoolListToAnyList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$localDateTimeListToCompList = function (localDateTimeList) {
	switch (localDateTimeList.$) {
		case 'ProtoLocalDateTimeListIf':
			var ifInput = localDateTimeList.a;
			var thenInput = localDateTimeList.b;
			var elseInput = localDateTimeList.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeListToCompList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeListToCompList, elseInput)));
		case 'ProtoLocalAllDateTimesInField':
			if (localDateTimeList.b.$ === 'Unselected') {
				var refInput = localDateTimeList.a;
				var fieldState = localDateTimeList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoLocalAllCompsInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'ProtoLocalDateTimesAsList':
			var listOfExprs = localDateTimeList.a;
			var dragModel = localDateTimeList.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$localDateTimeToComp),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (localDateTimeList.b.$ === 'Unselected') {
				var relationship = localDateTimeList.a;
				var fieldState = localDateTimeList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp, relationship, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$localDateTimeToComp = function (localDateTime) {
	switch (localDateTime.$) {
		case 'ProtoLocalMaxDateTime':
			var listInput = localDateTime.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalMaxComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeListToCompList, listInput)));
		case 'ProtoLocalMinDateTime':
			var listInput = localDateTime.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalMinComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeListToCompList, listInput)));
		case 'ProtoLocalDateTimeIf':
			var ifInput = localDateTime.a;
			var thenInput = localDateTime.b;
			var elseInput = localDateTime.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, elseInput)));
		case 'ProtoLocalPickDateTime':
			var listInput = localDateTime.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeListToCompList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$localDateListToCompList = function (localDateList) {
	switch (localDateList.$) {
		case 'ProtoLocalDateListIf':
			var ifInput = localDateList.a;
			var thenInput = localDateList.b;
			var elseInput = localDateList.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateListToCompList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateListToCompList, elseInput)));
		case 'ProtoLocalAllDatesInField':
			if (localDateList.b.$ === 'Unselected') {
				var refInput = localDateList.a;
				var fieldState = localDateList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoLocalAllCompsInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'ProtoLocalDatesAsList':
			var listOfExprs = localDateList.a;
			var dragModel = localDateList.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$localDateToComp),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (localDateList.b.$ === 'Unselected') {
				var relationship = localDateList.a;
				var fieldState = localDateList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp, relationship, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$localDateToComp = function (localDate) {
	switch (localDate.$) {
		case 'ProtoLocalMaxDate':
			var listInput = localDate.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalMaxComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateListToCompList, listInput)));
		case 'ProtoLocalMinDate':
			var listInput = localDate.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalMinComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateListToCompList, listInput)));
		case 'ProtoLocalDateIf':
			var ifInput = localDate.a;
			var thenInput = localDate.b;
			var elseInput = localDate.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, elseInput)));
		case 'ProtoLocalPickDate':
			var listInput = localDate.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateListToCompList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$localNumberListToCompList = function (localNumberList) {
	switch (localNumberList.$) {
		case 'ProtoLocalNumberListIf':
			var ifInput = localNumberList.a;
			var thenInput = localNumberList.b;
			var elseInput = localNumberList.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberListToCompList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberListToCompList, elseInput)));
		case 'ProtoLocalAllNumbersInField':
			if (localNumberList.b.$ === 'Unselected') {
				var refInput = localNumberList.a;
				var fieldState = localNumberList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoLocalAllCompsInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'ProtoLocalNumbersAsList':
			var listOfExprs = localNumberList.a;
			var dragModel = localNumberList.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$localNumberToComp),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			if (localNumberList.b.$ === 'Unselected') {
				var relationship = localNumberList.a;
				var fieldState = localNumberList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp, relationship, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$DataElement$ProtoExpression$localNumberToComp = function (localNumber) {
	switch (localNumber.$) {
		case 'ProtoLocalMaxNumber':
			var listInput = localNumber.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalMaxComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberListToCompList, listInput)));
		case 'ProtoLocalMinNumber':
			var listInput = localNumber.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalMinComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberListToCompList, listInput)));
		case 'ProtoLocalNumberIf':
			var ifInput = localNumber.a;
			var thenInput = localNumber.b;
			var elseInput = localNumber.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, elseInput)));
		case 'ProtoLocalPickNumber':
			var listInput = localNumber.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberListToCompList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$localStringListToCompList = function (localStringList) {
	switch (localStringList.$) {
		case 'ProtoLocalStringListIf':
			var ifInput = localStringList.a;
			var thenInput = localStringList.b;
			var elseInput = localStringList.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringListToCompList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringListToCompList, elseInput)));
		case 'ProtoLocalAllStringsInField':
			if (localStringList.b.$ === 'Unselected') {
				var refInput = localStringList.a;
				var fieldState = localStringList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoLocalAllCompsInField, refInput, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'ProtoLocalStringsAsList':
			var listOfExprs = localStringList.a;
			var dragModel = localStringList.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$localStringToComp),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		case 'ProtoRelatedString':
			if (localStringList.b.$ === 'Unselected') {
				var relationship = localStringList.a;
				var fieldState = localStringList.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp, relationship, fieldState));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'ProtoLocalChallengeReasons':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoExpression$localStringToComp = function (localString) {
	switch (localString.$) {
		case 'ProtoLocalMaxString':
			var listInput = localString.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalMaxComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringListToCompList, listInput)));
		case 'ProtoLocalMinString':
			var listInput = localString.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalMinComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringListToCompList, listInput)));
		case 'ProtoLocalStringIf':
			var ifInput = localString.a;
			var thenInput = localString.b;
			var elseInput = localString.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalCompIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, elseInput)));
		case 'ProtoLocalPickString':
			var listInput = localString.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickComp,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringListToCompList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$adjustLocalBoolComparisons = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalGTString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalGTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringB))));
		case 'ProtoLocalGTNumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalGTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberB))));
		case 'ProtoLocalGTDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalGTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateB))));
		case 'ProtoLocalGTDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalGTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateB))));
		case 'ProtoLocalGTEString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalGTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringB))));
		case 'ProtoLocalGTENumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalGTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberB))));
		case 'ProtoLocalGTEDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalGTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateB))));
		case 'ProtoLocalGTEDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalGTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateB))));
		case 'ProtoLocalLTString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalLTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringB))));
		case 'ProtoLocalLTNumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalLTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberB))));
		case 'ProtoLocalLTDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalLTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateB))));
		case 'ProtoLocalLTDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalLTComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateB))));
		case 'ProtoLocalLTEString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalLTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringB))));
		case 'ProtoLocalLTENumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalLTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberB))));
		case 'ProtoLocalLTEDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalLTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateB))));
		case 'ProtoLocalLTEDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalLTEComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateB))));
		case 'ProtoLocalEqualString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringB))));
		case 'ProtoLocalEqualNumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberB))));
		case 'ProtoLocalEqualDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateB))));
		case 'ProtoLocalEqualDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateB))));
		case 'ProtoLocalEqualBool':
			var boolA = proto.a;
			var boolB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalEqualAny,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localBoolToAny, boolA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localBoolToAny, boolB))));
		case 'ProtoLocalNotEqualString':
			var stringA = proto.a;
			var stringB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToComp, stringB))));
		case 'ProtoLocalNotEqualNumber':
			var numberA = proto.a;
			var numberB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToComp, numberB))));
		case 'ProtoLocalNotEqualDate':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToComp, dateB))));
		case 'ProtoLocalNotEqualDateTime':
			var dateA = proto.a;
			var dateB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToComp, dateB))));
		case 'ProtoLocalNotEqualBool':
			var boolA = proto.a;
			var boolB = proto.b;
			return A2(
				$elm$core$Maybe$withDefault,
				proto,
				A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualAny,
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localBoolToAny, boolA)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localBoolToAny, boolB))));
		default:
			return proto;
	}
};
var $author$project$DataElement$ProtoExpression$localCompListToAnyList = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalCompListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToAnyList, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToAnyList, elseInput)));
		case 'ProtoLocalAllCompsInField':
			var refInput = proto.a;
			var fieldState = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField, refInput, fieldState));
		case 'ProtoLocalCompsAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList,
				$elm_community$maybe_extra$Maybe$Extra$combine(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Input$map($author$project$DataElement$ProtoExpression$localCompToAny),
							$author$project$Input$maybe),
						listOfExprs)),
				$elm$core$Maybe$Just(dragModel));
		default:
			var relationship = proto.a;
			var fieldState = proto.b;
			return $elm$core$Maybe$Just(
				A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny, relationship, fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localCompToAny = function (localComp) {
	switch (localComp.$) {
		case 'ProtoLocalMaxComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalMinComp':
			return $elm$core$Maybe$Nothing;
		case 'ProtoLocalCompIf':
			var ifInput = localComp.a;
			var thenInput = localComp.b;
			var elseInput = localComp.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToAny, elseInput)));
		default:
			var listInput = localComp.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToAnyList, listInput)));
	}
};
var $author$project$ExpressionInput$convertLocalCompFieldToLocalField = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringComp':
			var localString = proto.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalStringField(localString);
		case 'ProtoLocalNumberComp':
			var localNumber = proto.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalNumberField(localNumber);
		case 'ProtoLocalDateComp':
			var localDate = proto.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateField(localDate);
		case 'ProtoLocalDateTimeComp':
			var localDateTime = proto.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeField(localDateTime);
		default:
			var localComp = proto.a;
			var _v1 = $author$project$DataElement$ProtoExpression$localCompToAny(localComp);
			if (_v1.$ === 'Just') {
				var localAny = _v1.a;
				return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny);
			} else {
				return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(localComp);
			}
	}
};
var $author$project$DataElement$ProtoExpression$localAnyListToBoolList = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalBoolListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToBoolList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToBoolList, elseInput));
		case 'ProtoLocalAllAnysInField':
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllBoolsInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		case 'ProtoLocalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalBoolsAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToBool),
					listOfExprs),
				dragModel);
		default:
			var relationship = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedBool,
				relationship,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyToBool = function (localAny) {
	if (localAny.$ === 'ProtoLocalAnyIf') {
		var ifInput = localAny.a;
		var thenInput = localAny.b;
		var elseInput = localAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoLocalBoolIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToBool, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToBool, elseInput));
	} else {
		var listInput = localAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalPickBool(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToBoolList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyListToCompList = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToCompList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToCompList, elseInput));
		case 'ProtoLocalAllAnysInField':
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalAllCompsInField, refInput, fieldState);
		case 'ProtoLocalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToComp),
					listOfExprs),
				dragModel);
		default:
			var relationship = proto.a;
			var fieldState = proto.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp, relationship, fieldState);
	}
};
var $author$project$DataElement$ProtoExpression$localAnyToComp = function (localAny) {
	if (localAny.$ === 'ProtoLocalAnyIf') {
		var ifInput = localAny.a;
		var thenInput = localAny.b;
		var elseInput = localAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoLocalCompIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToComp, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToComp, elseInput));
	} else {
		var anyList = localAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalPickComp(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToCompList, anyList));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyListToDateList = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateList, elseInput));
		case 'ProtoLocalAllAnysInField':
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllDatesInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		case 'ProtoLocalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalDatesAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToDate),
					listOfExprs),
				dragModel);
		default:
			var relationship = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
				relationship,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyToDate = function (localAny) {
	if (localAny.$ === 'ProtoLocalAnyIf') {
		var ifInput = localAny.a;
		var thenInput = localAny.b;
		var elseInput = localAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDate, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDate, elseInput));
	} else {
		var listInput = localAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalPickDate(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyListToDateTimeList = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateTimeList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateTimeList, elseInput));
		case 'ProtoLocalAllAnysInField':
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllDateTimesInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		case 'ProtoLocalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimesAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToDateTime),
					listOfExprs),
				dragModel);
		default:
			var relationship = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
				relationship,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyToDateTime = function (localAny) {
	if (localAny.$ === 'ProtoLocalAnyIf') {
		var ifInput = localAny.a;
		var thenInput = localAny.b;
		var elseInput = localAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDateTime, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDateTime, elseInput));
	} else {
		var listInput = localAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalPickDateTime(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateTimeList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyListToNumberList = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToNumberList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToNumberList, elseInput));
		case 'ProtoLocalAllAnysInField':
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllNumbersInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		case 'ProtoLocalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumbersAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToNumber),
					listOfExprs),
				dragModel);
		default:
			var relationship = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
				relationship,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyToNumber = function (localAny) {
	if (localAny.$ === 'ProtoLocalAnyIf') {
		var ifInput = localAny.a;
		var thenInput = localAny.b;
		var elseInput = localAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToNumber, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToNumber, elseInput));
	} else {
		var listInput = localAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalPickNumber(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToNumberList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyListToStringList = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalAnyListIf':
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToStringList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToStringList, elseInput));
		case 'ProtoLocalAllAnysInField':
			var refInput = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllStringsInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		case 'ProtoLocalAnysAsList':
			var listOfExprs = proto.a;
			var dragModel = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringsAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToString),
					listOfExprs),
				dragModel);
		default:
			var relationship = proto.a;
			var fieldState = proto.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedString,
				relationship,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localAnyToString = function (localAny) {
	if (localAny.$ === 'ProtoLocalAnyIf') {
		var ifInput = localAny.a;
		var thenInput = localAny.b;
		var elseInput = localAny.c;
		return A3(
			$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
			ifInput,
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToString, thenInput),
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToString, elseInput));
	} else {
		var listInput = localAny.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalPickString(
			A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToStringList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$localCompListToDateList = function (localCompList) {
	switch (localCompList.$) {
		case 'ProtoLocalCompListIf':
			var ifInput = localCompList.a;
			var thenInput = localCompList.b;
			var elseInput = localCompList.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateList, elseInput));
		case 'ProtoLocalAllCompsInField':
			var refInput = localCompList.a;
			var fieldState = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllDatesInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		case 'ProtoLocalCompsAsList':
			var listOfExpr = localCompList.a;
			var dragModel = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalDatesAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localCompToDate),
					listOfExpr),
				dragModel);
		default:
			var relationship = localCompList.a;
			var fieldState = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
				relationship,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localCompToDate = function (localComp) {
	switch (localComp.$) {
		case 'ProtoLocalMaxComp':
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMaxDate(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateList, listInput));
		case 'ProtoLocalMinComp':
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMinDate(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateList, listInput));
		case 'ProtoLocalCompIf':
			var ifInput = localComp.a;
			var thenInput = localComp.b;
			var elseInput = localComp.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, elseInput));
		default:
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalPickDate(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$localCompListToDateTimeList = function (localCompList) {
	switch (localCompList.$) {
		case 'ProtoLocalCompListIf':
			var ifInput = localCompList.a;
			var thenInput = localCompList.b;
			var elseInput = localCompList.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateTimeList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateTimeList, elseInput));
		case 'ProtoLocalAllCompsInField':
			var refInput = localCompList.a;
			var fieldState = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllDateTimesInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		case 'ProtoLocalCompsAsList':
			var listOfExpr = localCompList.a;
			var dragModel = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimesAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localCompToDateTime),
					listOfExpr),
				dragModel);
		default:
			var relationship = localCompList.a;
			var fieldState = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
				relationship,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localCompToDateTime = function (localComp) {
	switch (localComp.$) {
		case 'ProtoLocalMaxComp':
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMaxDateTime(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateTimeList, listInput));
		case 'ProtoLocalMinComp':
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMinDateTime(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateTimeList, listInput));
		case 'ProtoLocalCompIf':
			var ifInput = localComp.a;
			var thenInput = localComp.b;
			var elseInput = localComp.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, elseInput));
		default:
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalPickDateTime(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateTimeList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$localCompListToNumberList = function (localCompList) {
	switch (localCompList.$) {
		case 'ProtoLocalCompListIf':
			var ifInput = localCompList.a;
			var thenInput = localCompList.b;
			var elseInput = localCompList.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToNumberList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToNumberList, elseInput));
		case 'ProtoLocalAllCompsInField':
			var refInput = localCompList.a;
			var fieldState = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllNumbersInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		case 'ProtoLocalCompsAsList':
			var listOfExpr = localCompList.a;
			var dragModel = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumbersAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localCompToNumber),
					listOfExpr),
				dragModel);
		default:
			var relationship = localCompList.a;
			var fieldState = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
				relationship,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localCompToNumber = function (localComp) {
	switch (localComp.$) {
		case 'ProtoLocalMaxComp':
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMaxNumber(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToNumberList, listInput));
		case 'ProtoLocalMinComp':
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMinNumber(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToNumberList, listInput));
		case 'ProtoLocalCompIf':
			var ifInput = localComp.a;
			var thenInput = localComp.b;
			var elseInput = localComp.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, elseInput));
		default:
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalPickNumber(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToNumberList, listInput));
	}
};
var $author$project$DataElement$ProtoExpression$localCompListToStringList = function (localCompList) {
	switch (localCompList.$) {
		case 'ProtoLocalCompListIf':
			var ifInput = localCompList.a;
			var thenInput = localCompList.b;
			var elseInput = localCompList.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToStringList, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToStringList, elseInput));
		case 'ProtoLocalAllCompsInField':
			var refInput = localCompList.a;
			var fieldState = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllStringsInField,
				refInput,
				$author$project$Input$Unselected(fieldState));
		case 'ProtoLocalCompsAsList':
			var listOfExpr = localCompList.a;
			var dragModel = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringsAsList,
				A2(
					$elm$core$List$map,
					$author$project$Input$map($author$project$DataElement$ProtoExpression$localCompToString),
					listOfExpr),
				dragModel);
		default:
			var relationship = localCompList.a;
			var fieldState = localCompList.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedString,
				relationship,
				$author$project$Input$Unselected(fieldState));
	}
};
var $author$project$DataElement$ProtoExpression$localCompToString = function (localComp) {
	switch (localComp.$) {
		case 'ProtoLocalMaxComp':
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMaxString(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToStringList, listInput));
		case 'ProtoLocalMinComp':
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMinString(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToStringList, listInput));
		case 'ProtoLocalCompIf':
			var ifInput = localComp.a;
			var thenInput = localComp.b;
			var elseInput = localComp.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
				ifInput,
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, thenInput),
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, elseInput));
		default:
			var listInput = localComp.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalPickString(
				A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToStringList, listInput));
	}
};
var $author$project$ExpressionInput$selectLocalAny = function (proto) {
	switch (proto.$) {
		case 'BaseLocalAny':
			var localAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny));
		case 'BaseLocalString':
			var localString = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringField(localString));
		case 'BaseLocalNumber':
			var localNumber = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberField(localNumber));
		case 'BaseLocalDate':
			var localDate = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateField(localDate));
		case 'BaseLocalDateTime':
			var localDateTime = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeField(localDateTime));
		case 'BaseLocalBool':
			var localBool = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalBoolField(localBool));
		case 'BaseLocalComp':
			var localComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(localComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalAnyList = function (proto) {
	switch (proto.$) {
		case 'BaseLocalStringList':
			var localStringList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringFieldList(localStringList));
		case 'BaseLocalNumberList':
			var localNumberList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberFieldList(localNumberList));
		case 'BaseLocalDateList':
			var localDateList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateFieldList(localDateList));
		case 'BaseLocalDateTimeList':
			var localDateTimeList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeFieldList(localDateTimeList));
		case 'BaseLocalBoolList':
			var localBoolList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalBoolFieldList(localBoolList));
		case 'BaseLocalAnyList':
			var localAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalFieldList(localAnyList));
		case 'BaseLocalCompList':
			var localCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompListAsFieldList(localCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalBool = function (proto) {
	switch (proto.$) {
		case 'BaseLocalBool':
			var localBool = proto.a;
			return $elm$core$Maybe$Just(localBool);
		case 'BaseLocalAny':
			var localAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyToBool(localAny));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalBoolList = function (proto) {
	switch (proto.$) {
		case 'BaseLocalBoolList':
			var localBoolList = proto.a;
			return $elm$core$Maybe$Just(localBoolList);
		case 'BaseLocalAnyList':
			var localAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyListToBoolList(localAnyList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalComp = function (proto) {
	switch (proto.$) {
		case 'BaseLocalAny':
			var localAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
					$author$project$DataElement$ProtoExpression$localAnyToComp(localAny)));
		case 'BaseLocalString':
			var localString = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringComp(localString));
		case 'BaseLocalNumber':
			var localNumber = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberComp(localNumber));
		case 'BaseLocalDate':
			var localDate = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateComp(localDate));
		case 'BaseLocalDateTime':
			var localDateTime = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp(localDateTime));
		case 'BaseLocalComp':
			var localComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalCompList = function (proto) {
	switch (proto.$) {
		case 'BaseLocalStringList':
			var localStringList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompStringList(localStringList));
		case 'BaseLocalNumberList':
			var localNumberList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompNumberList(localNumberList));
		case 'BaseLocalDateList':
			var localDateList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompDateList(localDateList));
		case 'BaseLocalDateTimeList':
			var localDateTimeList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompDateTimeList(localDateTimeList));
		case 'BaseLocalAnyList':
			var localAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
					$author$project$DataElement$ProtoExpression$localAnyListToCompList(localAnyList)));
		case 'BaseLocalCompList':
			var localCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(localCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalDate = function (proto) {
	switch (proto.$) {
		case 'BaseLocalDate':
			var localDate = proto.a;
			return $elm$core$Maybe$Just(localDate);
		case 'BaseLocalAny':
			var localAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyToDate(localAny));
		case 'BaseLocalComp':
			var localComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localCompToDate(localComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalDateList = function (proto) {
	switch (proto.$) {
		case 'BaseLocalDateList':
			var localDateList = proto.a;
			return $elm$core$Maybe$Just(localDateList);
		case 'BaseLocalAnyList':
			var localAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyListToDateList(localAnyList));
		case 'BaseLocalCompList':
			var localCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localCompListToDateList(localCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalDateTime = function (proto) {
	switch (proto.$) {
		case 'BaseLocalDateTime':
			var localDateTime = proto.a;
			return $elm$core$Maybe$Just(localDateTime);
		case 'BaseLocalAny':
			var localAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyToDateTime(localAny));
		case 'BaseLocalComp':
			var localComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localCompToDateTime(localComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalDateTimeList = function (proto) {
	switch (proto.$) {
		case 'BaseLocalDateTimeList':
			var localDateTimeList = proto.a;
			return $elm$core$Maybe$Just(localDateTimeList);
		case 'BaseLocalAnyList':
			var localAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyListToDateTimeList(localAnyList));
		case 'BaseLocalCompList':
			var localCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localCompListToDateTimeList(localCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalField = function (proto) {
	switch (proto.$) {
		case 'BaseLocalString':
			var localString = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringField(localString));
		case 'BaseLocalNumber':
			var localNumber = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberField(localNumber));
		case 'BaseLocalDate':
			var localDate = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateField(localDate));
		case 'BaseLocalDateTime':
			var localDateTime = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeField(localDateTime));
		case 'BaseLocalBool':
			var localBool = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalBoolField(localBool));
		case 'BaseLocalAny':
			var localAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny));
		case 'BaseLocalComp':
			var localComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(localComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalNumber = function (proto) {
	switch (proto.$) {
		case 'BaseLocalNumber':
			var localNumber = proto.a;
			return $elm$core$Maybe$Just(localNumber);
		case 'BaseLocalAny':
			var localAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyToNumber(localAny));
		case 'BaseLocalComp':
			var localComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localCompToNumber(localComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalNumberList = function (proto) {
	switch (proto.$) {
		case 'BaseLocalNumberList':
			var localNumberList = proto.a;
			return $elm$core$Maybe$Just(localNumberList);
		case 'BaseLocalAnyList':
			var localAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyListToNumberList(localAnyList));
		case 'BaseLocalCompList':
			var localCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localCompListToNumberList(localCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalString = function (proto) {
	switch (proto.$) {
		case 'BaseLocalString':
			var localString = proto.a;
			return $elm$core$Maybe$Just(localString);
		case 'BaseLocalAny':
			var localAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyToString(localAny));
		case 'BaseLocalComp':
			var localComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localCompToString(localComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$selectLocalStringList = function (proto) {
	switch (proto.$) {
		case 'BaseLocalStringList':
			var localStringList = proto.a;
			return $elm$core$Maybe$Just(localStringList);
		case 'BaseLocalAnyList':
			var localAnyList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localAnyListToStringList(localAnyList));
		case 'BaseLocalCompList':
			var localCompList = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$localCompListToStringList(localCompList));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$updateDragLocalAnyList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoLocalAnysAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragLocalBoolList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoLocalBoolsAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalBoolsAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragLocalCompFieldList = F2(
	function (dragMsg, proto) {
		if ((proto.$ === 'ProtoLocalCompFieldList') && (proto.a.$ === 'ProtoLocalCompsAsList')) {
			var _v1 = proto.a;
			var listOfInputs = _v1.a;
			var dragModel = _v1.b;
			var _v2 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v2.a;
			var newList = _v2.b;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
				A2($author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList, newList, newModel));
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragLocalCompList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoLocalCompsAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragLocalDateList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoLocalDatesAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalDatesAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragLocalDateTimeList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoLocalDateTimesAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalDateTimesAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragLocalNumberList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoLocalNumbersAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalNumbersAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$updateDragLocalStringList = F2(
	function (dragMsg, proto) {
		if (proto.$ === 'ProtoLocalStringsAsList') {
			var listOfInputs = proto.a;
			var dragModel = proto.b;
			var _v1 = A3($author$project$ExpressionInput$Msg$dndSystem.update, dragMsg, dragModel, listOfInputs);
			var newModel = _v1.a;
			var newList = _v1.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalStringsAsList, newList, newModel);
		} else {
			return proto;
		}
	});
var $author$project$ExpressionInput$wrapLocalBool = function (localBool) {
	var _v0 = $author$project$DataElement$ProtoExpression$localBoolToAny(localBool);
	if (_v0.$ === 'Just') {
		var localAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoLocalBoolField(localBool);
	}
};
var $author$project$DataElement$ProtoExpression$localDateListToAnyList = function (proto) {
	_v1$4:
	while (true) {
		switch (proto.$) {
			case 'ProtoLocalDateListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf(ifInput),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateListToAnyList, thenInput)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateListToAnyList, elseInput)));
			case 'ProtoLocalAllDatesInField':
				if (proto.b.$ === 'Unselected') {
					var refInput = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField, refInput, fieldState));
				} else {
					break _v1$4;
				}
			case 'ProtoLocalDatesAsList':
				var listOfExprs = proto.a;
				var dragModel = proto.b;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Input$map($author$project$DataElement$ProtoExpression$localDateToAny),
								$author$project$Input$maybe),
							listOfExprs)),
					$elm$core$Maybe$Just(dragModel));
			default:
				if (proto.b.$ === 'Unselected') {
					var relationship = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny, relationship, fieldState));
				} else {
					break _v1$4;
				}
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$DataElement$ProtoExpression$localDateToAny = function (localDate) {
	switch (localDate.$) {
		case 'ProtoLocalDateIf':
			var ifInput = localDate.a;
			var thenInput = localDate.b;
			var elseInput = localDate.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateToAny, elseInput)));
		case 'ProtoLocalPickDate':
			var listInput = localDate.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateListToAnyList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapLocalDate = function (localDate) {
	var _v0 = $author$project$DataElement$ProtoExpression$localDateToAny(localDate);
	if (_v0.$ === 'Just') {
		var localAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny);
	} else {
		var _v1 = $author$project$DataElement$ProtoExpression$localDateToComp(localDate);
		if (_v1.$ === 'Just') {
			var localComp = _v1.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(localComp);
		} else {
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateField(localDate);
		}
	}
};
var $author$project$ExpressionInput$wrapLocalDateListAsComp = function (dateList) {
	var _v0 = $author$project$DataElement$ProtoExpression$localDateListToCompList(dateList);
	if (_v0.$ === 'Just') {
		var compList = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(compList);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateList(dateList);
	}
};
var $author$project$DataElement$ProtoExpression$localDateTimeListToAnyList = function (proto) {
	_v1$4:
	while (true) {
		switch (proto.$) {
			case 'ProtoLocalDateTimeListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf(ifInput),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeListToAnyList, thenInput)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeListToAnyList, elseInput)));
			case 'ProtoLocalAllDateTimesInField':
				if (proto.b.$ === 'Unselected') {
					var refInput = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField, refInput, fieldState));
				} else {
					break _v1$4;
				}
			case 'ProtoLocalDateTimesAsList':
				var listOfExprs = proto.a;
				var dragModel = proto.b;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Input$map($author$project$DataElement$ProtoExpression$localDateTimeToAny),
								$author$project$Input$maybe),
							listOfExprs)),
					$elm$core$Maybe$Just(dragModel));
			default:
				if (proto.b.$ === 'Unselected') {
					var relationship = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny, relationship, fieldState));
				} else {
					break _v1$4;
				}
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$DataElement$ProtoExpression$localDateTimeToAny = function (localDateTime) {
	switch (localDateTime.$) {
		case 'ProtoLocalDateTimeIf':
			var ifInput = localDateTime.a;
			var thenInput = localDateTime.b;
			var elseInput = localDateTime.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeToAny, elseInput)));
		case 'ProtoLocalPickDateTime':
			var listInput = localDateTime.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localDateTimeListToAnyList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapLocalDateTime = function (localDateTime) {
	var _v0 = $author$project$DataElement$ProtoExpression$localDateTimeToAny(localDateTime);
	if (_v0.$ === 'Just') {
		var localAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny);
	} else {
		var _v1 = $author$project$DataElement$ProtoExpression$localDateTimeToComp(localDateTime);
		if (_v1.$ === 'Just') {
			var localComp = _v1.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(localComp);
		} else {
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeField(localDateTime);
		}
	}
};
var $author$project$ExpressionInput$wrapLocalDateTimeListAsComp = function (dateList) {
	var _v0 = $author$project$DataElement$ProtoExpression$localDateTimeListToCompList(dateList);
	if (_v0.$ === 'Just') {
		var compList = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(compList);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateTimeList(dateList);
	}
};
var $author$project$DataElement$ProtoExpression$localNumberListToAnyList = function (proto) {
	_v1$4:
	while (true) {
		switch (proto.$) {
			case 'ProtoLocalNumberListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf(ifInput),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberListToAnyList, thenInput)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberListToAnyList, elseInput)));
			case 'ProtoLocalAllNumbersInField':
				if (proto.b.$ === 'Unselected') {
					var refInput = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField, refInput, fieldState));
				} else {
					break _v1$4;
				}
			case 'ProtoLocalNumbersAsList':
				var listOfExprs = proto.a;
				var dragModel = proto.b;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Input$map($author$project$DataElement$ProtoExpression$localNumberToAny),
								$author$project$Input$maybe),
							listOfExprs)),
					$elm$core$Maybe$Just(dragModel));
			default:
				if (proto.b.$ === 'Unselected') {
					var relationship = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny, relationship, fieldState));
				} else {
					break _v1$4;
				}
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$DataElement$ProtoExpression$localNumberToAny = function (localNumber) {
	switch (localNumber.$) {
		case 'ProtoLocalNumberIf':
			var ifInput = localNumber.a;
			var thenInput = localNumber.b;
			var elseInput = localNumber.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberToAny, elseInput)));
		case 'ProtoLocalPickNumber':
			var listInput = localNumber.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localNumberListToAnyList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapLocalNumber = function (localNumber) {
	var _v0 = $author$project$DataElement$ProtoExpression$localNumberToAny(localNumber);
	if (_v0.$ === 'Just') {
		var localAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny);
	} else {
		var _v1 = $author$project$DataElement$ProtoExpression$localNumberToComp(localNumber);
		if (_v1.$ === 'Just') {
			var localComp = _v1.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(localComp);
		} else {
			return $author$project$DataElement$ProtoExpression$ProtoLocalNumberField(localNumber);
		}
	}
};
var $author$project$ExpressionInput$wrapLocalNumberListAsComp = function (numberList) {
	var _v0 = $author$project$DataElement$ProtoExpression$localNumberListToCompList(numberList);
	if (_v0.$ === 'Just') {
		var compList = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(compList);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompNumberList(numberList);
	}
};
var $author$project$DataElement$ProtoExpression$localStringListToAnyList = function (proto) {
	_v1$4:
	while (true) {
		switch (proto.$) {
			case 'ProtoLocalStringListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf(ifInput),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringListToAnyList, thenInput)),
					$author$project$Input$maybe(
						A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringListToAnyList, elseInput)));
			case 'ProtoLocalAllStringsInField':
				if (proto.b.$ === 'Unselected') {
					var refInput = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField, refInput, fieldState));
				} else {
					break _v1$4;
				}
			case 'ProtoLocalStringsAsList':
				var listOfExprs = proto.a;
				var dragModel = proto.b;
				return A3(
					$elm$core$Maybe$map2,
					$author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Input$map($author$project$DataElement$ProtoExpression$localStringToAny),
								$author$project$Input$maybe),
							listOfExprs)),
					$elm$core$Maybe$Just(dragModel));
			case 'ProtoRelatedString':
				if (proto.b.$ === 'Unselected') {
					var relationship = proto.a;
					var fieldState = proto.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny, relationship, fieldState));
				} else {
					break _v1$4;
				}
			default:
				break _v1$4;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$DataElement$ProtoExpression$localStringToAny = function (localString) {
	switch (localString.$) {
		case 'ProtoLocalStringIf':
			var ifInput = localString.a;
			var thenInput = localString.b;
			var elseInput = localString.c;
			return A3(
				$elm$core$Maybe$map2,
				$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf(ifInput),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToAny, thenInput)),
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringToAny, elseInput)));
		case 'ProtoLocalPickString':
			var listInput = localString.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$ProtoExpression$ProtoLocalPickAny,
				$author$project$Input$maybe(
					A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localStringListToAnyList, listInput)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapLocalString = function (localString) {
	var _v0 = $author$project$DataElement$ProtoExpression$localStringToAny(localString);
	if (_v0.$ === 'Just') {
		var localAny = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny);
	} else {
		var _v1 = $author$project$DataElement$ProtoExpression$localStringToComp(localString);
		if (_v1.$ === 'Just') {
			var localComp = _v1.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(localComp);
		} else {
			return $author$project$DataElement$ProtoExpression$ProtoLocalStringField(localString);
		}
	}
};
var $author$project$ExpressionInput$wrapLocalStringListAsComp = function (stringList) {
	var _v0 = $author$project$DataElement$ProtoExpression$localStringListToCompList(stringList);
	if (_v0.$ === 'Just') {
		var compList = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(compList);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompStringList(stringList);
	}
};
var $author$project$ExpressionInput$updateInputLocalAnyChild = F3(
	function (child, inputMsg, localAny) {
		var _v359 = _Utils_Tuple2(localAny, child);
		if (_v359.a.$ === 'ProtoLocalAnyIf') {
			switch (_v359.b) {
				case 0:
					var _v360 = _v359.a;
					var condInput = _v360.a;
					var thenInput = _v360.b;
					var elseInput = _v360.c;
					return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(
						A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput));
				case 1:
					var _v361 = _v359.a;
					var condInput = _v361.a;
					var thenInput = _v361.b;
					var elseInput = _v361.c;
					var _v362 = A2(
						$author$project$ExpressionInput$cyclic$updateInputLocalAny(),
						inputMsg,
						thenInput);
					if (_v362.$ === 'Selected') {
						switch (_v362.a.$) {
							case 'ProtoLocalStringField':
								var newThenInput = _v362.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalStringField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToString, elseInput)));
							case 'ProtoLocalNumberField':
								var newThenInput = _v362.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalNumberField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToNumber, elseInput)));
							case 'ProtoLocalDateField':
								var newThenInput = _v362.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDate, elseInput)));
							case 'ProtoLocalDateTimeField':
								var newThenInput = _v362.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDateTime, elseInput)));
							case 'ProtoLocalBoolField':
								var newThenInput = _v362.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalBoolField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalBoolIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToBool, elseInput)));
							case 'ProtoLocalAnyField':
								var newThenInput = _v362.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										elseInput));
							default:
								var newThenInput = _v362.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalCompIf,
										condInput,
										$author$project$Input$Selected(newThenInput),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToComp, elseInput)));
						}
					} else {
						var state = _v362.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf,
								condInput,
								$author$project$Input$Unselected(state),
								elseInput));
					}
				case 2:
					var _v363 = _v359.a;
					var condInput = _v363.a;
					var thenInput = _v363.b;
					var elseInput = _v363.c;
					var _v364 = A2(
						$author$project$ExpressionInput$cyclic$updateInputLocalAny(),
						inputMsg,
						elseInput);
					if (_v364.$ === 'Selected') {
						switch (_v364.a.$) {
							case 'ProtoLocalStringField':
								var newElseInput = _v364.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalStringField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToString, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoLocalNumberField':
								var newElseInput = _v364.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalNumberField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToNumber, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoLocalDateField':
								var newElseInput = _v364.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDate, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoLocalDateTimeField':
								var newElseInput = _v364.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDateTime, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoLocalBoolField':
								var newElseInput = _v364.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalBoolField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalBoolIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToBool, thenInput),
										$author$project$Input$Selected(newElseInput)));
							case 'ProtoLocalAnyField':
								var newElseInput = _v364.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf,
										condInput,
										thenInput,
										$author$project$Input$Selected(newElseInput)));
							default:
								var newElseInput = _v364.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(
									A3(
										$author$project$DataElement$ProtoExpression$ProtoLocalCompIf,
										condInput,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToComp, thenInput),
										$author$project$Input$Selected(newElseInput)));
						}
					} else {
						var elseState = _v364.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoLocalAnyIf,
								condInput,
								thenInput,
								$author$project$Input$Unselected(elseState)));
					}
				default:
					var _v365 = _v359.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny);
			}
		} else {
			if (!_v359.b) {
				var listInput = _v359.a.a;
				var _v366 = A2(
					$author$project$ExpressionInput$cyclic$updateInputLocalAnyList(),
					inputMsg,
					listInput);
				if (_v366.$ === 'Selected') {
					switch (_v366.a.$) {
						case 'ProtoLocalStringFieldList':
							var newListInput = _v366.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalStringField(
								$author$project$DataElement$ProtoExpression$ProtoLocalPickString(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoLocalNumberFieldList':
							var newListInput = _v366.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalNumberField(
								$author$project$DataElement$ProtoExpression$ProtoLocalPickNumber(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoLocalDateFieldList':
							var newListInput = _v366.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalDateField(
								$author$project$DataElement$ProtoExpression$ProtoLocalPickDate(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoLocalDateTimeFieldList':
							var newListInput = _v366.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeField(
								$author$project$DataElement$ProtoExpression$ProtoLocalPickDateTime(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoLocalBoolFieldList':
							var newListInput = _v366.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalBoolField(
								$author$project$DataElement$ProtoExpression$ProtoLocalPickBool(
									$author$project$Input$Selected(newListInput)));
						case 'ProtoLocalFieldList':
							var newListInput = _v366.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(
								$author$project$DataElement$ProtoExpression$ProtoLocalPickAny(
									$author$project$Input$Selected(newListInput)));
						default:
							var newListInput = _v366.a.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsField(
								$author$project$DataElement$ProtoExpression$ProtoLocalPickComp(
									$author$project$Input$Selected(newListInput)));
					}
				} else {
					var elseState = _v366.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(
						$author$project$DataElement$ProtoExpression$ProtoLocalPickAny(
							$author$project$Input$Unselected(elseState)));
				}
			} else {
				return $author$project$DataElement$ProtoExpression$ProtoLocalAnyField(localAny);
			}
		}
	});
var $author$project$ExpressionInput$updateInputLocalAnyListChild = F3(
	function (child, inputMsg, proto) {
		var _v319 = _Utils_Tuple2(proto, child);
		switch (_v319.a.$) {
			case 'ProtoLocalAnyListIf':
				switch (_v319.b) {
					case 0:
						var _v320 = _v319.a;
						var condInput = _v320.a;
						var thenInput = _v320.b;
						var elseInput = _v320.c;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf,
								A2(
									$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
									inputMsg,
									condInput),
								thenInput,
								elseInput));
					case 1:
						var _v321 = _v319.a;
						var condInput = _v321.a;
						var thenInput = _v321.b;
						var elseInput = _v321.c;
						var _v322 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalAnyList(),
							inputMsg,
							thenInput);
						if (_v322.$ === 'Selected') {
							switch (_v322.a.$) {
								case 'ProtoLocalStringFieldList':
									var newThenInput = _v322.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalStringFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToStringList, elseInput)));
								case 'ProtoLocalNumberFieldList':
									var newThenInput = _v322.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalNumberFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToNumberList, elseInput)));
								case 'ProtoLocalDateFieldList':
									var newThenInput = _v322.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateList, elseInput)));
								case 'ProtoLocalDateTimeFieldList':
									var newThenInput = _v322.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateTimeList, elseInput)));
								case 'ProtoLocalBoolFieldList':
									var newThenInput = _v322.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalBoolFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalBoolListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToBoolList, elseInput)));
								case 'ProtoLocalFieldList':
									var newThenInput = _v322.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											elseInput));
								default:
									var newThenInput = _v322.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompListAsFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToCompList, elseInput)));
							}
						} else {
							var state = _v322.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf,
									condInput,
									$author$project$Input$Unselected(state),
									elseInput));
						}
					case 2:
						var _v323 = _v319.a;
						var condInput = _v323.a;
						var thenInput = _v323.b;
						var elseInput = _v323.c;
						var _v324 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalAnyList(),
							inputMsg,
							elseInput);
						if (_v324.$ === 'Selected') {
							switch (_v324.a.$) {
								case 'ProtoLocalStringFieldList':
									var newElseInput = _v324.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalStringFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToStringList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoLocalNumberFieldList':
									var newElseInput = _v324.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalNumberFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToNumberList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoLocalDateFieldList':
									var newElseInput = _v324.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoLocalDateTimeFieldList':
									var newElseInput = _v324.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToDateTimeList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoLocalBoolFieldList':
									var newElseInput = _v324.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalBoolFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalBoolListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToBoolList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoLocalFieldList':
									var newElseInput = _v324.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf,
											condInput,
											thenInput,
											$author$project$Input$Selected(newElseInput)));
								default:
									var newElseInput = _v324.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompListAsFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyListToCompList, thenInput),
											$author$project$Input$Selected(newElseInput)));
							}
						} else {
							var elseState = _v324.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf,
									condInput,
									thenInput,
									$author$project$Input$Unselected(elseState)));
						}
					default:
						var _v325 = _v319.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(proto);
				}
			case 'ProtoLocalAnysAsList':
				var _v326 = _v319.a;
				var listOfExpr = _v326.a;
				var dragModel = _v326.b;
				var _v327 = A2(
					$elm$core$Maybe$map,
					$author$project$ExpressionInput$cyclic$updateInputLocalAny()(inputMsg),
					A2($elm_community$list_extra$List$Extra$getAt, child, listOfExpr));
				if (_v327.$ === 'Nothing') {
					return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList, listOfExpr, dragModel));
				} else {
					if (_v327.a.$ === 'Unselected') {
						var inputState = _v327.a.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList,
								$author$project$ExpressionInput$resizeInputList(
									A3(
										$elm_community$list_extra$List$Extra$setAt,
										child,
										$author$project$Input$Unselected(inputState),
										listOfExpr)),
								dragModel));
					} else {
						switch (_v327.a.a.$) {
							case 'ProtoLocalStringField':
								var localString = _v327.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalStringFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalStringsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localString),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToString),
													listOfExpr))),
										dragModel));
							case 'ProtoLocalNumberField':
								var localNumber = _v327.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalNumberFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNumbersAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localNumber),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToNumber),
													listOfExpr))),
										dragModel));
							case 'ProtoLocalDateField':
								var localDate = _v327.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalDatesAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localDate),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToDate),
													listOfExpr))),
										dragModel));
							case 'ProtoLocalDateTimeField':
								var localDateTime = _v327.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalDateTimesAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localDateTime),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToDateTime),
													listOfExpr))),
										dragModel));
							case 'ProtoLocalBoolField':
								var localBool = _v327.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalBoolFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalBoolsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localBool),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToBool),
													listOfExpr))),
										dragModel));
							case 'ProtoLocalAnyField':
								var localAny = _v327.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localAny),
												listOfExpr)),
										dragModel));
							default:
								var localComp = _v327.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompListAsFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localComp),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localAnyToComp),
													listOfExpr))),
										dragModel));
						}
					}
				}
			case 'ProtoLocalAllAnysInField':
				switch (_v319.b) {
					case 0:
						var _v328 = _v319.a;
						var refInput = _v328.a;
						var fieldNameState = _v328.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField,
								A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
								fieldNameState));
					case 1:
						var _v329 = _v319.a;
						var refInput = _v329.a;
						var fieldNameState = _v329.b;
						var _v330 = A2($author$project$ExpressionInput$updateAnyFieldNameState, inputMsg, fieldNameState);
						if (_v330.$ === 'Unselected') {
							var newState = _v330.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
								A2($author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField, refInput, newState));
						} else {
							switch (_v330.a.a.$) {
								case 'StringType':
									var _v331 = _v330.a;
									var _v332 = _v331.a;
									var fieldName = _v331.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalStringFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoLocalAllStringsInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'NumberType':
									var _v333 = _v330.a;
									var _v334 = _v333.a;
									var fieldName = _v333.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalNumberFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoLocalAllNumbersInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'DateType':
									var _v335 = _v330.a;
									var _v336 = _v335.a;
									var fieldName = _v335.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoLocalAllDatesInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'DateTimeType':
									var _v337 = _v330.a;
									var _v338 = _v337.a;
									var fieldName = _v337.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoLocalAllDateTimesInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								default:
									var _v339 = _v330.a;
									var _v340 = _v339.a;
									var fieldName = _v339.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalBoolFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoLocalAllBoolsInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
							}
						}
					default:
						var _v341 = _v319.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(proto);
				}
			default:
				switch (_v319.b) {
					case 0:
						var _v342 = _v319.a;
						var relationship = _v342.a;
						var fieldNameInput = _v342.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny,
								_Utils_update(
									relationship,
									{
										nextElement: A2($author$project$ExpressionInput$updateInputListReference, inputMsg, relationship.nextElement)
									}),
								fieldNameInput));
					case 1:
						var _v343 = _v319.a;
						var relationship = _v343.a;
						var fieldNameState = _v343.b;
						var _v344 = A2($author$project$ExpressionInput$updateAnyFieldNameState, inputMsg, fieldNameState);
						if (_v344.$ === 'Unselected') {
							var newState = _v344.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
								A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny, relationship, newState));
						} else {
							switch (_v344.a.a.$) {
								case 'StringType':
									var _v345 = _v344.a;
									var _v346 = _v345.a;
									var fieldName = _v345.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalStringFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoRelatedString,
											relationship,
											$author$project$Input$Selected(fieldName)));
								case 'NumberType':
									var _v347 = _v344.a;
									var _v348 = _v347.a;
									var fieldName = _v347.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalNumberFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
											relationship,
											$author$project$Input$Selected(fieldName)));
								case 'DateType':
									var _v349 = _v344.a;
									var _v350 = _v349.a;
									var fieldName = _v349.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
											relationship,
											$author$project$Input$Selected(fieldName)));
								case 'DateTimeType':
									var _v351 = _v344.a;
									var _v352 = _v351.a;
									var fieldName = _v351.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
											relationship,
											$author$project$Input$Selected(fieldName)));
								default:
									var _v353 = _v344.a;
									var _v354 = _v353.a;
									var fieldName = _v353.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalBoolFieldList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoRelatedBool,
											relationship,
											$author$project$Input$Selected(fieldName)));
							}
						}
					case 2:
						var _v355 = _v319.a;
						var relationship = _v355.a;
						var fieldNameInput = _v355.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny,
								_Utils_update(
									relationship,
									{
										idToMatch: A2(
											$author$project$ExpressionInput$cyclic$updateInputLocalString(),
											inputMsg,
											relationship.idToMatch)
									}),
								fieldNameInput));
					case 3:
						var _v356 = _v319.a;
						var relationship = _v356.a;
						var fieldNameInput = _v356.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny,
								_Utils_update(
									relationship,
									{
										localIds: A2(
											$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
											inputMsg,
											relationship.localIds)
									}),
								fieldNameInput));
					case 4:
						var _v357 = _v319.a;
						var relationship = _v357.a;
						var fieldNameInput = _v357.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny,
								_Utils_update(
									relationship,
									{
										optionalFilter: A2(
											$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
											inputMsg,
											relationship.optionalFilter)
									}),
								fieldNameInput));
					default:
						var _v358 = _v319.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalFieldList(proto);
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalBoolChild = F3(
	function (child, inputMsg, localBool) {
		return $author$project$ExpressionInput$adjustLocalBoolComparisons(
			A3($author$project$ExpressionInput$updateInputLocalBoolChildHelper, child, inputMsg, localBool));
	});
var $author$project$ExpressionInput$updateInputLocalBoolChildHelper = F3(
	function (child, inputMsg, localBool) {
		var _v188 = _Utils_Tuple2(localBool, child);
		switch (_v188.a.$) {
			case 'ProtoLocalBool':
				return localBool;
			case 'ProtoLocalBoolLookup':
				var _v189 = _v188.a;
				return localBool;
			case 'ProtoLocalBoolHardcoded':
				return localBool;
			case 'ProtoLocalGTString':
				switch (_v188.b) {
					case 0:
						var _v190 = _v188.a;
						var stringA = _v190.a;
						var stringB = _v190.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v191 = _v188.a;
						var stringA = _v191.a;
						var stringB = _v191.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringB));
					default:
						var _v192 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalGTNumber':
				switch (_v188.b) {
					case 0:
						var _v193 = _v188.a;
						var stringA = _v193.a;
						var stringB = _v193.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTNumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v194 = _v188.a;
						var stringA = _v194.a;
						var stringB = _v194.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTNumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringB));
					default:
						var _v195 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalGTDate':
				switch (_v188.b) {
					case 0:
						var _v196 = _v188.a;
						var dateA = _v196.a;
						var dateB = _v196.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v197 = _v188.a;
						var dateA = _v197.a;
						var dateB = _v197.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateB));
					default:
						var _v198 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalGTDateTime':
				switch (_v188.b) {
					case 0:
						var _v199 = _v188.a;
						var dateA = _v199.a;
						var dateB = _v199.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v200 = _v188.a;
						var dateA = _v200.a;
						var dateB = _v200.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v201 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalGTComp':
				switch (_v188.b) {
					case 0:
						var _v202 = _v188.a;
						var compA = _v202.a;
						var compB = _v202.b;
						var _v203 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compA);
						if (_v203.$ === 'Unselected') {
							var inputState = _v203.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalGTComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v203.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v203.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTString,
										$author$project$Input$Selected(protoLocalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compB));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v203.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTNumber,
										$author$project$Input$Selected(protoLocalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compB));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v203.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTDate,
										$author$project$Input$Selected(protoLocalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compB));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v203.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTDateTime,
										$author$project$Input$Selected(protoLocalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compB));
								default:
									var protoLocalCompField = _v203.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTComp,
										$author$project$Input$Selected(protoLocalCompField),
										compB);
							}
						}
					case 2:
						var _v204 = _v188.a;
						var compA = _v204.a;
						var compB = _v204.b;
						var _v205 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compB);
						if (_v205.$ === 'Unselected') {
							var inputState = _v205.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalGTComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v205.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v205.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compA),
										$author$project$Input$Selected(protoLocalString));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v205.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compA),
										$author$project$Input$Selected(protoLocalNumber));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v205.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compA),
										$author$project$Input$Selected(protoLocalDate));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v205.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compA),
										$author$project$Input$Selected(protoLocalDateTime));
								default:
									var protoLocalCompField = _v205.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTComp,
										compA,
										$author$project$Input$Selected(protoLocalCompField));
							}
						}
					default:
						var _v206 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalGTEString':
				switch (_v188.b) {
					case 0:
						var _v207 = _v188.a;
						var stringA = _v207.a;
						var stringB = _v207.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTEString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v208 = _v188.a;
						var stringA = _v208.a;
						var stringB = _v208.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTEString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringB));
					default:
						var _v209 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalGTENumber':
				switch (_v188.b) {
					case 0:
						var _v210 = _v188.a;
						var stringA = _v210.a;
						var stringB = _v210.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTENumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v211 = _v188.a;
						var stringA = _v211.a;
						var stringB = _v211.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTENumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringB));
					default:
						var _v212 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalGTEDate':
				switch (_v188.b) {
					case 0:
						var _v213 = _v188.a;
						var dateA = _v213.a;
						var dateB = _v213.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTEDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v214 = _v188.a;
						var dateA = _v214.a;
						var dateB = _v214.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTEDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateB));
					default:
						var _v215 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalGTEDateTime':
				switch (_v188.b) {
					case 0:
						var _v216 = _v188.a;
						var dateA = _v216.a;
						var dateB = _v216.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTEDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v217 = _v188.a;
						var dateA = _v217.a;
						var dateB = _v217.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalGTEDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v218 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalGTEComp':
				switch (_v188.b) {
					case 0:
						var _v219 = _v188.a;
						var compA = _v219.a;
						var compB = _v219.b;
						var _v220 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compA);
						if (_v220.$ === 'Unselected') {
							var inputState = _v220.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalGTEComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v220.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v220.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTEString,
										$author$project$Input$Selected(protoLocalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compB));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v220.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTENumber,
										$author$project$Input$Selected(protoLocalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compB));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v220.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTEDate,
										$author$project$Input$Selected(protoLocalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compB));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v220.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTEDateTime,
										$author$project$Input$Selected(protoLocalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compB));
								default:
									var protoLocalCompField = _v220.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTEComp,
										$author$project$Input$Selected(protoLocalCompField),
										compB);
							}
						}
					case 2:
						var _v221 = _v188.a;
						var compA = _v221.a;
						var compB = _v221.b;
						var _v222 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compB);
						if (_v222.$ === 'Unselected') {
							var inputState = _v222.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalGTEComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v222.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v222.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTEString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compA),
										$author$project$Input$Selected(protoLocalString));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v222.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTENumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compA),
										$author$project$Input$Selected(protoLocalNumber));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v222.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTEDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compA),
										$author$project$Input$Selected(protoLocalDate));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v222.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTEDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compA),
										$author$project$Input$Selected(protoLocalDateTime));
								default:
									var protoLocalCompField = _v222.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalGTEComp,
										compA,
										$author$project$Input$Selected(protoLocalCompField));
							}
						}
					default:
						var _v223 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTString':
				switch (_v188.b) {
					case 0:
						var _v224 = _v188.a;
						var stringA = _v224.a;
						var stringB = _v224.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v225 = _v188.a;
						var stringA = _v225.a;
						var stringB = _v225.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringB));
					default:
						var _v226 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTNumber':
				switch (_v188.b) {
					case 0:
						var _v227 = _v188.a;
						var stringA = _v227.a;
						var stringB = _v227.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTNumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v228 = _v188.a;
						var stringA = _v228.a;
						var stringB = _v228.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTNumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringB));
					default:
						var _v229 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTDate':
				switch (_v188.b) {
					case 0:
						var _v230 = _v188.a;
						var dateA = _v230.a;
						var dateB = _v230.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v231 = _v188.a;
						var dateA = _v231.a;
						var dateB = _v231.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateB));
					default:
						var _v232 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTDateTime':
				switch (_v188.b) {
					case 0:
						var _v233 = _v188.a;
						var dateA = _v233.a;
						var dateB = _v233.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v234 = _v188.a;
						var dateA = _v234.a;
						var dateB = _v234.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v235 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTComp':
				switch (_v188.b) {
					case 0:
						var _v236 = _v188.a;
						var compA = _v236.a;
						var compB = _v236.b;
						var _v237 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compA);
						if (_v237.$ === 'Unselected') {
							var inputState = _v237.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalLTComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v237.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v237.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTString,
										$author$project$Input$Selected(protoLocalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compB));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v237.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTNumber,
										$author$project$Input$Selected(protoLocalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compB));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v237.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTDate,
										$author$project$Input$Selected(protoLocalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compB));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v237.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTDateTime,
										$author$project$Input$Selected(protoLocalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compB));
								default:
									var protoLocalCompField = _v237.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTComp,
										$author$project$Input$Selected(protoLocalCompField),
										compB);
							}
						}
					case 2:
						var _v238 = _v188.a;
						var compA = _v238.a;
						var compB = _v238.b;
						var _v239 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compB);
						if (_v239.$ === 'Unselected') {
							var inputState = _v239.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalLTComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v239.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v239.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compA),
										$author$project$Input$Selected(protoLocalString));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v239.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compA),
										$author$project$Input$Selected(protoLocalNumber));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v239.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compA),
										$author$project$Input$Selected(protoLocalDate));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v239.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compA),
										$author$project$Input$Selected(protoLocalDateTime));
								default:
									var protoLocalCompField = _v239.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTComp,
										compA,
										$author$project$Input$Selected(protoLocalCompField));
							}
						}
					default:
						var _v240 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTEString':
				switch (_v188.b) {
					case 0:
						var _v241 = _v188.a;
						var stringA = _v241.a;
						var stringB = _v241.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTEString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v242 = _v188.a;
						var stringA = _v242.a;
						var stringB = _v242.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTEString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringB));
					default:
						var _v243 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTENumber':
				switch (_v188.b) {
					case 0:
						var _v244 = _v188.a;
						var stringA = _v244.a;
						var stringB = _v244.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTENumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v245 = _v188.a;
						var stringA = _v245.a;
						var stringB = _v245.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTENumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringB));
					default:
						var _v246 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTEDate':
				switch (_v188.b) {
					case 0:
						var _v247 = _v188.a;
						var dateA = _v247.a;
						var dateB = _v247.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTEDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v248 = _v188.a;
						var dateA = _v248.a;
						var dateB = _v248.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTEDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateB));
					default:
						var _v249 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTEDateTime':
				switch (_v188.b) {
					case 0:
						var _v250 = _v188.a;
						var dateA = _v250.a;
						var dateB = _v250.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTEDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v251 = _v188.a;
						var dateA = _v251.a;
						var dateB = _v251.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalLTEDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v252 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalLTEComp':
				switch (_v188.b) {
					case 0:
						var _v253 = _v188.a;
						var compA = _v253.a;
						var compB = _v253.b;
						var _v254 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compA);
						if (_v254.$ === 'Unselected') {
							var inputState = _v254.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalLTEComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v254.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTEString,
										$author$project$Input$Selected(protoLocalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compB));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTENumber,
										$author$project$Input$Selected(protoLocalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compB));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTEDate,
										$author$project$Input$Selected(protoLocalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compB));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTEDateTime,
										$author$project$Input$Selected(protoLocalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compB));
								default:
									var protoLocalCompField = _v254.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTEComp,
										$author$project$Input$Selected(protoLocalCompField),
										compB);
							}
						}
					case 2:
						var _v255 = _v188.a;
						var compA = _v255.a;
						var compB = _v255.b;
						var _v256 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compB);
						if (_v256.$ === 'Unselected') {
							var inputState = _v256.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalLTEComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v256.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTEString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compA),
										$author$project$Input$Selected(protoLocalString));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTENumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compA),
										$author$project$Input$Selected(protoLocalNumber));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTEDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compA),
										$author$project$Input$Selected(protoLocalDate));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTEDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compA),
										$author$project$Input$Selected(protoLocalDateTime));
								default:
									var protoLocalCompField = _v256.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalLTEComp,
										compA,
										$author$project$Input$Selected(protoLocalCompField));
							}
						}
					default:
						var _v257 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalEqualString':
				switch (_v188.b) {
					case 0:
						var _v258 = _v188.a;
						var stringA = _v258.a;
						var stringB = _v258.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v259 = _v188.a;
						var stringA = _v259.a;
						var stringB = _v259.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringB));
					default:
						var _v260 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalEqualNumber':
				switch (_v188.b) {
					case 0:
						var _v261 = _v188.a;
						var stringA = _v261.a;
						var stringB = _v261.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualNumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v262 = _v188.a;
						var stringA = _v262.a;
						var stringB = _v262.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualNumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringB));
					default:
						var _v263 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalEqualDate':
				switch (_v188.b) {
					case 0:
						var _v264 = _v188.a;
						var dateA = _v264.a;
						var dateB = _v264.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v265 = _v188.a;
						var dateA = _v265.a;
						var dateB = _v265.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateB));
					default:
						var _v266 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalEqualDateTime':
				switch (_v188.b) {
					case 0:
						var _v267 = _v188.a;
						var dateA = _v267.a;
						var dateB = _v267.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v268 = _v188.a;
						var dateA = _v268.a;
						var dateB = _v268.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v269 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalEqualBool':
				switch (_v188.b) {
					case 0:
						var _v270 = _v188.a;
						var boolA = _v270.a;
						var boolB = _v270.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualBool,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								boolA),
							boolB);
					case 2:
						var _v271 = _v188.a;
						var boolA = _v271.a;
						var boolB = _v271.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalEqualBool,
							boolA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								boolB));
					default:
						var _v272 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalEqualComp':
				switch (_v188.b) {
					case 0:
						var _v273 = _v188.a;
						var compA = _v273.a;
						var compB = _v273.b;
						var _v274 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compA);
						if (_v274.$ === 'Unselected') {
							var inputState = _v274.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v274.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v274.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualString,
										$author$project$Input$Selected(protoLocalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compB));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v274.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualNumber,
										$author$project$Input$Selected(protoLocalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compB));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v274.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualDate,
										$author$project$Input$Selected(protoLocalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compB));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v274.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualDateTime,
										$author$project$Input$Selected(protoLocalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compB));
								default:
									var protoLocalCompField = _v274.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
										$author$project$Input$Selected(protoLocalCompField),
										compB);
							}
						}
					case 2:
						var _v275 = _v188.a;
						var compA = _v275.a;
						var compB = _v275.b;
						var _v276 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compB);
						if (_v276.$ === 'Unselected') {
							var inputState = _v276.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v276.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v276.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compA),
										$author$project$Input$Selected(protoLocalString));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v276.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compA),
										$author$project$Input$Selected(protoLocalNumber));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v276.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compA),
										$author$project$Input$Selected(protoLocalDate));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v276.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compA),
										$author$project$Input$Selected(protoLocalDateTime));
								default:
									var protoLocalCompField = _v276.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
										compA,
										$author$project$Input$Selected(protoLocalCompField));
							}
						}
					default:
						var _v277 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalEqualAny':
				switch (_v188.b) {
					case 0:
						var _v278 = _v188.a;
						var compA = _v278.a;
						var compB = _v278.b;
						var _v279 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalAny(),
							inputMsg,
							compA);
						if (_v279.$ === 'Unselected') {
							var inputState = _v279.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalEqualAny,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v279.a.$) {
								case 'ProtoLocalStringField':
									var protoLocalString = _v279.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualString,
										$author$project$Input$Selected(protoLocalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToString, compB));
								case 'ProtoLocalNumberField':
									var protoLocalNumber = _v279.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualNumber,
										$author$project$Input$Selected(protoLocalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToNumber, compB));
								case 'ProtoLocalDateField':
									var protoLocalDate = _v279.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualDate,
										$author$project$Input$Selected(protoLocalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDate, compB));
								case 'ProtoLocalAnyField':
									var protoLocalAnyField = _v279.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualAny,
										$author$project$Input$Selected(protoLocalAnyField),
										compB);
								case 'ProtoLocalDateTimeField':
									var protoLocalDateTime = _v279.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualDateTime,
										$author$project$Input$Selected(protoLocalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDateTime, compB));
								case 'ProtoLocalBoolField':
									var protoLocalBool = _v279.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualBool,
										$author$project$Input$Selected(protoLocalBool),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToBool, compB));
								default:
									var protoLocalComp = _v279.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
										$author$project$Input$Selected(protoLocalComp),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToComp, compB));
							}
						}
					case 2:
						var _v280 = _v188.a;
						var compA = _v280.a;
						var compB = _v280.b;
						var _v281 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalAny(),
							inputMsg,
							compB);
						if (_v281.$ === 'Unselected') {
							var inputState = _v281.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalEqualAny,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v281.a.$) {
								case 'ProtoLocalStringField':
									var protoLocalString = _v281.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToString, compA),
										$author$project$Input$Selected(protoLocalString));
								case 'ProtoLocalNumberField':
									var protoLocalNumber = _v281.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToNumber, compA),
										$author$project$Input$Selected(protoLocalNumber));
								case 'ProtoLocalDateField':
									var protoLocalDate = _v281.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDate, compA),
										$author$project$Input$Selected(protoLocalDate));
								case 'ProtoLocalAnyField':
									var protoLocalAnyField = _v281.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualAny,
										compA,
										$author$project$Input$Selected(protoLocalAnyField));
								case 'ProtoLocalDateTimeField':
									var protoLocalDateTime = _v281.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDateTime, compA),
										$author$project$Input$Selected(protoLocalDateTime));
								case 'ProtoLocalBoolField':
									var protoLocalBool = _v281.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualBool,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToBool, compA),
										$author$project$Input$Selected(protoLocalBool));
								default:
									var protoLocalComp = _v281.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalEqualComp,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToComp, compA),
										$author$project$Input$Selected(protoLocalComp));
							}
						}
					default:
						var _v282 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalNotEqualString':
				switch (_v188.b) {
					case 0:
						var _v283 = _v188.a;
						var stringA = _v283.a;
						var stringB = _v283.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualString,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v284 = _v188.a;
						var stringA = _v284.a;
						var stringB = _v284.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualString,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringB));
					default:
						var _v285 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalNotEqualNumber':
				switch (_v188.b) {
					case 0:
						var _v286 = _v188.a;
						var stringA = _v286.a;
						var stringB = _v286.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualNumber,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringA),
							stringB);
					case 2:
						var _v287 = _v188.a;
						var stringA = _v287.a;
						var stringB = _v287.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualNumber,
							stringA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								stringB));
					default:
						var _v288 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalNotEqualDate':
				switch (_v188.b) {
					case 0:
						var _v289 = _v188.a;
						var dateA = _v289.a;
						var dateB = _v289.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v290 = _v188.a;
						var dateA = _v290.a;
						var dateB = _v290.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDate,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateB));
					default:
						var _v291 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalNotEqualDateTime':
				switch (_v188.b) {
					case 0:
						var _v292 = _v188.a;
						var dateA = _v292.a;
						var dateB = _v292.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDateTime,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateA),
							dateB);
					case 2:
						var _v293 = _v188.a;
						var dateA = _v293.a;
						var dateB = _v293.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDateTime,
							dateA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								dateB));
					default:
						var _v294 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalNotEqualBool':
				switch (_v188.b) {
					case 0:
						var _v295 = _v188.a;
						var boolA = _v295.a;
						var boolB = _v295.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualBool,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								boolA),
							boolB);
					case 2:
						var _v296 = _v188.a;
						var boolA = _v296.a;
						var boolB = _v296.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualBool,
							boolA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								boolB));
					default:
						var _v297 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalNotEqualComp':
				switch (_v188.b) {
					case 0:
						var _v298 = _v188.a;
						var compA = _v298.a;
						var compB = _v298.b;
						var _v299 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compA);
						if (_v299.$ === 'Unselected') {
							var inputState = _v299.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v299.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v299.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualString,
										$author$project$Input$Selected(protoLocalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compB));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v299.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualNumber,
										$author$project$Input$Selected(protoLocalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compB));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v299.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDate,
										$author$project$Input$Selected(protoLocalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compB));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v299.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDateTime,
										$author$project$Input$Selected(protoLocalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compB));
								default:
									var protoLocalCompField = _v299.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
										$author$project$Input$Selected(protoLocalCompField),
										compB);
							}
						}
					case 2:
						var _v300 = _v188.a;
						var compA = _v300.a;
						var compB = _v300.b;
						var _v301 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							compB);
						if (_v301.$ === 'Unselected') {
							var inputState = _v301.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v301.a.$) {
								case 'ProtoLocalStringComp':
									var protoLocalString = _v301.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, compA),
										$author$project$Input$Selected(protoLocalString));
								case 'ProtoLocalNumberComp':
									var protoLocalNumber = _v301.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, compA),
										$author$project$Input$Selected(protoLocalNumber));
								case 'ProtoLocalDateComp':
									var protoLocalDate = _v301.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, compA),
										$author$project$Input$Selected(protoLocalDate));
								case 'ProtoLocalDateTimeComp':
									var protoLocalDateTime = _v301.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, compA),
										$author$project$Input$Selected(protoLocalDateTime));
								default:
									var protoLocalCompField = _v301.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
										compA,
										$author$project$Input$Selected(protoLocalCompField));
							}
						}
					default:
						var _v302 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalNotEqualAny':
				switch (_v188.b) {
					case 0:
						var _v303 = _v188.a;
						var compA = _v303.a;
						var compB = _v303.b;
						var _v304 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalAny(),
							inputMsg,
							compA);
						if (_v304.$ === 'Unselected') {
							var inputState = _v304.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualAny,
								$author$project$Input$Unselected(inputState),
								compB);
						} else {
							switch (_v304.a.$) {
								case 'ProtoLocalStringField':
									var protoLocalString = _v304.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualString,
										$author$project$Input$Selected(protoLocalString),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToString, compB));
								case 'ProtoLocalNumberField':
									var protoLocalNumber = _v304.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualNumber,
										$author$project$Input$Selected(protoLocalNumber),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToNumber, compB));
								case 'ProtoLocalDateField':
									var protoLocalDate = _v304.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDate,
										$author$project$Input$Selected(protoLocalDate),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDate, compB));
								case 'ProtoLocalDateTimeField':
									var protoLocalDateTime = _v304.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDateTime,
										$author$project$Input$Selected(protoLocalDateTime),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDateTime, compB));
								case 'ProtoLocalBoolField':
									var protoLocalBool = _v304.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualBool,
										$author$project$Input$Selected(protoLocalBool),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToBool, compB));
								case 'ProtoLocalAnyField':
									var protoLocalAnyField = _v304.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualAny,
										$author$project$Input$Selected(protoLocalAnyField),
										compB);
								default:
									var protoLocalComp = _v304.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
										$author$project$Input$Selected(protoLocalComp),
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToComp, compB));
							}
						}
					case 2:
						var _v305 = _v188.a;
						var compA = _v305.a;
						var compB = _v305.b;
						var _v306 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalAny(),
							inputMsg,
							compB);
						if (_v306.$ === 'Unselected') {
							var inputState = _v306.a;
							return A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualAny,
								compA,
								$author$project$Input$Unselected(inputState));
						} else {
							switch (_v306.a.$) {
								case 'ProtoLocalStringField':
									var protoLocalString = _v306.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualString,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToString, compA),
										$author$project$Input$Selected(protoLocalString));
								case 'ProtoLocalNumberField':
									var protoLocalNumber = _v306.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualNumber,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToNumber, compA),
										$author$project$Input$Selected(protoLocalNumber));
								case 'ProtoLocalDateField':
									var protoLocalDate = _v306.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDate,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDate, compA),
										$author$project$Input$Selected(protoLocalDate));
								case 'ProtoLocalDateTimeField':
									var protoLocalDateTime = _v306.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDateTime,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToDateTime, compA),
										$author$project$Input$Selected(protoLocalDateTime));
								case 'ProtoLocalBoolField':
									var protoLocalBool = _v306.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualBool,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToBool, compA),
										$author$project$Input$Selected(protoLocalBool));
								case 'ProtoLocalAnyField':
									var protoLocalAnyField = _v306.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualAny,
										compA,
										$author$project$Input$Selected(protoLocalAnyField));
								default:
									var protoLocalComp = _v306.a.a;
									return A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualComp,
										A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localAnyToComp, compA),
										$author$project$Input$Selected(protoLocalComp));
							}
						}
					default:
						var _v307 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalStringIn':
				switch (_v188.b) {
					case 0:
						var _v308 = _v188.a;
						var string = _v308.a;
						var stringList = _v308.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringIn,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								string),
							stringList);
					case 2:
						var _v309 = _v188.a;
						var string = _v309.a;
						var stringList = _v309.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringIn,
							string,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
								inputMsg,
								stringList));
					default:
						var _v310 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalStringNotIn':
				switch (_v188.b) {
					case 0:
						var _v311 = _v188.a;
						var string = _v311.a;
						var stringList = _v311.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringNotIn,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								string),
							stringList);
					case 2:
						var _v312 = _v188.a;
						var string = _v312.a;
						var stringList = _v312.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringNotIn,
							string,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
								inputMsg,
								stringList));
					default:
						var _v313 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalNot':
				if (!_v188.b) {
					var boolInput = _v188.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalNot(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
							inputMsg,
							boolInput));
				} else {
					return localBool;
				}
			case 'ProtoLocalBoolIf':
				switch (_v188.b) {
					case 0:
						var _v314 = _v188.a;
						var condInput = _v314.a;
						var thenInput = _v314.b;
						var elseInput = _v314.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalBoolIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v315 = _v188.a;
						var condInput = _v315.a;
						var thenInput = _v315.b;
						var elseInput = _v315.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalBoolIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v316 = _v188.a;
						var condInput = _v316.a;
						var thenInput = _v316.b;
						var elseInput = _v316.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalBoolIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								elseInput));
					default:
						var _v317 = _v188.a;
						return localBool;
				}
			case 'ProtoLocalPickBool':
				if (!_v188.b) {
					var listInput = _v188.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalPickBool(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalBoolList(),
							inputMsg,
							listInput));
				} else {
					return localBool;
				}
			case 'ProtoLocalAll':
				if (!_v188.b) {
					var listInput = _v188.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalAll(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalBoolList(),
							inputMsg,
							listInput));
				} else {
					return localBool;
				}
			case 'ProtoLocalAny':
				if (!_v188.b) {
					var listInput = _v188.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalAny(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalBoolList(),
							inputMsg,
							listInput));
				} else {
					return localBool;
				}
			case 'ProtoLocalIsNull':
				if (!_v188.b) {
					var fieldInput = _v188.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalIsNull(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalField(),
							inputMsg,
							fieldInput));
				} else {
					return localBool;
				}
			default:
				if (!_v188.b) {
					var fieldInput = _v188.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalIsNotNull(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalField(),
							inputMsg,
							fieldInput));
				} else {
					return localBool;
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalBoolListChild = F3(
	function (child, inputMsg, proto) {
		var _v173 = _Utils_Tuple2(proto, child);
		switch (_v173.a.$) {
			case 'ProtoLocalBoolListIf':
				switch (_v173.b) {
					case 0:
						var _v174 = _v173.a;
						var condInput = _v174.a;
						var thenInput = _v174.b;
						var elseInput = _v174.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalBoolListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v175 = _v173.a;
						var condInput = _v175.a;
						var thenInput = _v175.b;
						var elseInput = _v175.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalBoolListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBoolList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v176 = _v173.a;
						var condInput = _v176.a;
						var thenInput = _v176.b;
						var elseInput = _v176.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalBoolListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBoolList(),
								inputMsg,
								elseInput));
					default:
						var _v177 = _v173.a;
						return proto;
				}
			case 'ProtoLocalAllBoolsInField':
				switch (_v173.b) {
					case 0:
						var _v178 = _v173.a;
						var refInput = _v178.a;
						var fieldNameInput = _v178.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllBoolsInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v179 = _v173.a;
						var refInput = _v179.a;
						var fieldNameInput = _v179.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllBoolsInField,
							refInput,
							A2($author$project$ExpressionInput$updateBoolFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v180 = _v173.a;
						return proto;
				}
			case 'ProtoLocalBoolsAsList':
				var _v181 = _v173.a;
				var listOfExpr = _v181.a;
				var dragModel = _v181.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoLocalBoolsAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputLocalBool()(inputMsg),
							listOfExpr)),
					dragModel);
			default:
				switch (_v173.b) {
					case 0:
						var _v182 = _v173.a;
						var relationship = _v182.a;
						var fieldNameInput = _v182.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedBool,
							_Utils_update(
								relationship,
								{
									nextElement: A2($author$project$ExpressionInput$updateInputListReference, inputMsg, relationship.nextElement)
								}),
							fieldNameInput);
					case 1:
						var _v183 = _v173.a;
						var relationship = _v183.a;
						var fieldNameInput = _v183.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedBool,
							relationship,
							A2($author$project$ExpressionInput$updateBoolFieldNameInput, inputMsg, fieldNameInput));
					case 2:
						var _v184 = _v173.a;
						var relationship = _v184.a;
						var fieldNameInput = _v184.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedBool,
							_Utils_update(
								relationship,
								{
									idToMatch: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalString(),
										inputMsg,
										relationship.idToMatch)
								}),
							fieldNameInput);
					case 3:
						var _v185 = _v173.a;
						var relationship = _v185.a;
						var fieldNameInput = _v185.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedBool,
							_Utils_update(
								relationship,
								{
									localIds: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
										inputMsg,
										relationship.localIds)
								}),
							fieldNameInput);
					case 4:
						var _v186 = _v173.a;
						var relationship = _v186.a;
						var fieldNameInput = _v186.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedBool,
							_Utils_update(
								relationship,
								{
									optionalFilter: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
										inputMsg,
										relationship.optionalFilter)
								}),
							fieldNameInput);
					default:
						var _v187 = _v173.a;
						return proto;
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalCompChild = F3(
	function (child, inputMsg, localComp) {
		var _v162 = _Utils_Tuple2(localComp, child);
		switch (_v162.a.$) {
			case 'ProtoLocalMaxComp':
				if (!_v162.b) {
					var listInput = _v162.a.a;
					var _v163 = A2(
						$author$project$ExpressionInput$cyclic$updateInputLocalCompList(),
						inputMsg,
						listInput);
					if (_v163.$ === 'Selected') {
						switch (_v163.a.$) {
							case 'ProtoLocalCompStringList':
								var localStringList = _v163.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalStringComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalMaxString(
										$author$project$Input$Selected(localStringList)));
							case 'ProtoLocalCompNumberList':
								var localNumberList = _v163.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalNumberComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalMaxNumber(
										$author$project$Input$Selected(localNumberList)));
							case 'ProtoLocalCompDateList':
								var localDateList = _v163.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalMaxDate(
										$author$project$Input$Selected(localDateList)));
							case 'ProtoLocalCompDateTimeList':
								var localDateTimeList = _v163.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalMaxDateTime(
										$author$project$Input$Selected(localDateTimeList)));
							default:
								var localCompList = _v163.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
									$author$project$DataElement$ProtoExpression$ProtoLocalMaxComp(
										$author$project$Input$Selected(localCompList)));
						}
					} else {
						var listState = _v163.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
							$author$project$DataElement$ProtoExpression$ProtoLocalMaxComp(
								$author$project$Input$Unselected(listState)));
					}
				} else {
					return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp);
				}
			case 'ProtoLocalMinComp':
				if (!_v162.b) {
					var listInput = _v162.a.a;
					var _v164 = A2(
						$author$project$ExpressionInput$cyclic$updateInputLocalCompList(),
						inputMsg,
						listInput);
					if (_v164.$ === 'Selected') {
						switch (_v164.a.$) {
							case 'ProtoLocalCompStringList':
								var localStringList = _v164.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalStringComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalMinString(
										$author$project$Input$Selected(localStringList)));
							case 'ProtoLocalCompNumberList':
								var localNumberList = _v164.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalNumberComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalMinNumber(
										$author$project$Input$Selected(localNumberList)));
							case 'ProtoLocalCompDateList':
								var localDateList = _v164.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalMinDate(
										$author$project$Input$Selected(localDateList)));
							case 'ProtoLocalCompDateTimeList':
								var localDateTimeList = _v164.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalMinDateTime(
										$author$project$Input$Selected(localDateTimeList)));
							default:
								var localCompList = _v164.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
									$author$project$DataElement$ProtoExpression$ProtoLocalMinComp(
										$author$project$Input$Selected(localCompList)));
						}
					} else {
						var listState = _v164.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
							$author$project$DataElement$ProtoExpression$ProtoLocalMinComp(
								$author$project$Input$Unselected(listState)));
					}
				} else {
					return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp);
				}
			case 'ProtoLocalCompIf':
				switch (_v162.b) {
					case 0:
						var _v165 = _v162.a;
						var ifInput = _v165.a;
						var thenInput = _v165.b;
						var elseInput = _v165.c;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoLocalCompIf,
								A2(
									$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
									inputMsg,
									ifInput),
								thenInput,
								elseInput));
					case 1:
						var _v166 = _v162.a;
						var ifInput = _v166.a;
						var thenInput = _v166.b;
						var elseInput = _v166.c;
						var _v167 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							thenInput);
						if (_v167.$ === 'Selected') {
							switch (_v167.a.$) {
								case 'ProtoLocalStringComp':
									var localString = _v167.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalStringComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
											ifInput,
											$author$project$Input$Selected(localString),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, elseInput)));
								case 'ProtoLocalNumberComp':
									var localNumber = _v167.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalNumberComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
											ifInput,
											$author$project$Input$Selected(localNumber),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, elseInput)));
								case 'ProtoLocalDateComp':
									var localDate = _v167.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
											ifInput,
											$author$project$Input$Selected(localDate),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, elseInput)));
								case 'ProtoLocalDateTimeComp':
									var localDateTime = _v167.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
											ifInput,
											$author$project$Input$Selected(localDateTime),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, elseInput)));
								default:
									var newLocalComp = _v167.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalCompIf,
											ifInput,
											$author$project$Input$Selected(newLocalComp),
											elseInput));
							}
						} else {
							var thenState = _v167.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoLocalCompIf,
									ifInput,
									$author$project$Input$Unselected(thenState),
									elseInput));
						}
					case 2:
						var _v168 = _v162.a;
						var ifInput = _v168.a;
						var thenInput = _v168.b;
						var elseInput = _v168.c;
						var _v169 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalComp(),
							inputMsg,
							elseInput);
						if (_v169.$ === 'Selected') {
							switch (_v169.a.$) {
								case 'ProtoLocalStringComp':
									var localString = _v169.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalStringComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
											ifInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToString, thenInput),
											$author$project$Input$Selected(localString)));
								case 'ProtoLocalNumberComp':
									var localNumber = _v169.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalNumberComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
											ifInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToNumber, thenInput),
											$author$project$Input$Selected(localNumber)));
								case 'ProtoLocalDateComp':
									var localDate = _v169.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
											ifInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDate, thenInput),
											$author$project$Input$Selected(localDate)));
								case 'ProtoLocalDateTimeComp':
									var localDateTime = _v169.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
											ifInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompToDateTime, thenInput),
											$author$project$Input$Selected(localDateTime)));
								default:
									var newLocalComp = _v169.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalCompIf,
											ifInput,
											thenInput,
											$author$project$Input$Selected(newLocalComp)));
							}
						} else {
							var elseState = _v169.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoLocalCompIf,
									ifInput,
									thenInput,
									$author$project$Input$Unselected(elseState)));
						}
					default:
						var _v170 = _v162.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp);
				}
			default:
				if (!_v162.b) {
					var listInput = _v162.a.a;
					var _v171 = A2(
						$author$project$ExpressionInput$cyclic$updateInputLocalCompList(),
						inputMsg,
						listInput);
					if (_v171.$ === 'Selected') {
						switch (_v171.a.$) {
							case 'ProtoLocalCompStringList':
								var localStringList = _v171.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalStringComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalPickString(
										$author$project$Input$Selected(localStringList)));
							case 'ProtoLocalCompNumberList':
								var localNumberList = _v171.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalNumberComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalPickNumber(
										$author$project$Input$Selected(localNumberList)));
							case 'ProtoLocalCompDateList':
								var localDateList = _v171.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalPickDate(
										$author$project$Input$Selected(localDateList)));
							case 'ProtoLocalCompDateTimeList':
								var localDateTimeList = _v171.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp(
									$author$project$DataElement$ProtoExpression$ProtoLocalPickDateTime(
										$author$project$Input$Selected(localDateTimeList)));
							default:
								var newLocalCompList = _v171.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
									$author$project$DataElement$ProtoExpression$ProtoLocalPickComp(
										$author$project$Input$Selected(newLocalCompList)));
						}
					} else {
						var listState = _v171.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
							$author$project$DataElement$ProtoExpression$ProtoLocalPickComp(
								$author$project$Input$Unselected(listState)));
					}
				} else {
					return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp);
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalCompFieldListChild = F3(
	function (child, inputMsg, proto) {
		switch (proto.$) {
			case 'ProtoLocalCompStringList':
				var stringList = proto.a;
				return $author$project$ExpressionInput$wrapLocalStringListAsComp(
					A3($author$project$ExpressionInput$updateInputLocalStringListChild, child, inputMsg, stringList));
			case 'ProtoLocalCompNumberList':
				var numberList = proto.a;
				return $author$project$ExpressionInput$wrapLocalNumberListAsComp(
					A3($author$project$ExpressionInput$updateInputLocalNumberListChild, child, inputMsg, numberList));
			case 'ProtoLocalCompDateList':
				var dateList = proto.a;
				return $author$project$ExpressionInput$wrapLocalDateListAsComp(
					A3($author$project$ExpressionInput$updateInputLocalDateListChild, child, inputMsg, dateList));
			case 'ProtoLocalCompDateTimeList':
				var dateList = proto.a;
				return $author$project$ExpressionInput$wrapLocalDateTimeListAsComp(
					A3($author$project$ExpressionInput$updateInputLocalDateTimeListChild, child, inputMsg, dateList));
			default:
				var compList = proto.a;
				return A3($author$project$ExpressionInput$updateInputLocalCompListChild, child, inputMsg, compList);
		}
	});
var $author$project$ExpressionInput$updateInputLocalCompListChild = F3(
	function (child, inputMsg, proto) {
		var _v125 = _Utils_Tuple2(proto, child);
		switch (_v125.a.$) {
			case 'ProtoLocalCompListIf':
				switch (_v125.b) {
					case 0:
						var _v126 = _v125.a;
						var condInput = _v126.a;
						var thenInput = _v126.b;
						var elseInput = _v126.c;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
							A3(
								$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf,
								A2(
									$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
									inputMsg,
									condInput),
								thenInput,
								elseInput));
					case 1:
						var _v127 = _v125.a;
						var condInput = _v127.a;
						var thenInput = _v127.b;
						var elseInput = _v127.c;
						var _v128 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalCompList(),
							inputMsg,
							thenInput);
						if (_v128.$ === 'Selected') {
							switch (_v128.a.$) {
								case 'ProtoLocalCompStringList':
									var newThenInput = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompStringList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToStringList, elseInput)));
								case 'ProtoLocalCompNumberList':
									var newThenInput = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompNumberList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToNumberList, elseInput)));
								case 'ProtoLocalCompDateList':
									var newThenInput = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateList, elseInput)));
								case 'ProtoLocalCompDateTimeList':
									var newThenInput = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateTimeList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateTimeList, elseInput)));
								default:
									var newThenInput = _v128.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf,
											condInput,
											$author$project$Input$Selected(newThenInput),
											elseInput));
							}
						} else {
							var state = _v128.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf,
									condInput,
									$author$project$Input$Unselected(state),
									elseInput));
						}
					case 2:
						var _v129 = _v125.a;
						var condInput = _v129.a;
						var thenInput = _v129.b;
						var elseInput = _v129.c;
						var _v130 = A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalCompList(),
							inputMsg,
							elseInput);
						if (_v130.$ === 'Selected') {
							switch (_v130.a.$) {
								case 'ProtoLocalCompStringList':
									var newElseInput = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompStringList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToStringList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoLocalCompNumberList':
									var newElseInput = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompNumberList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToNumberList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoLocalCompDateList':
									var newElseInput = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								case 'ProtoLocalCompDateTimeList':
									var newElseInput = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateTimeList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
											condInput,
											A2($author$project$Input$map, $author$project$DataElement$ProtoExpression$localCompListToDateTimeList, thenInput),
											$author$project$Input$Selected(newElseInput)));
								default:
									var newElseInput = _v130.a.a;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
										A3(
											$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf,
											condInput,
											thenInput,
											$author$project$Input$Selected(newElseInput)));
							}
						} else {
							var elseState = _v130.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
								A3(
									$author$project$DataElement$ProtoExpression$ProtoLocalCompListIf,
									condInput,
									thenInput,
									$author$project$Input$Unselected(elseState)));
						}
					default:
						var _v131 = _v125.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(proto);
				}
			case 'ProtoLocalCompsAsList':
				var _v132 = _v125.a;
				var listOfExpr = _v132.a;
				var dragModel = _v132.b;
				var _v133 = A2(
					$elm$core$Maybe$map,
					$author$project$ExpressionInput$cyclic$updateInputLocalComp()(inputMsg),
					A2($elm_community$list_extra$List$Extra$getAt, child, listOfExpr));
				if (_v133.$ === 'Nothing') {
					return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList, listOfExpr, dragModel));
				} else {
					if (_v133.a.$ === 'Unselected') {
						var inputState = _v133.a.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList,
								$author$project$ExpressionInput$resizeInputList(
									A3(
										$elm_community$list_extra$List$Extra$setAt,
										child,
										$author$project$Input$Unselected(inputState),
										listOfExpr)),
								dragModel));
					} else {
						switch (_v133.a.a.$) {
							case 'ProtoLocalStringComp':
								var localString = _v133.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompStringList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalStringsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localString),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localCompToString),
													listOfExpr))),
										dragModel));
							case 'ProtoLocalNumberComp':
								var localNumber = _v133.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompNumberList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalNumbersAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localNumber),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localCompToNumber),
													listOfExpr))),
										dragModel));
							case 'ProtoLocalDateComp':
								var localDate = _v133.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalDatesAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localDate),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localCompToDate),
													listOfExpr))),
										dragModel));
							case 'ProtoLocalDateTimeComp':
								var localDateTime = _v133.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateTimeList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalDateTimesAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localDateTime),
												A2(
													$elm$core$List$map,
													$author$project$Input$map($author$project$DataElement$ProtoExpression$localCompToDateTime),
													listOfExpr))),
										dragModel));
							default:
								var localComp = _v133.a.a.a;
								return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
									A2(
										$author$project$DataElement$ProtoExpression$ProtoLocalCompsAsList,
										$author$project$ExpressionInput$resizeInputList(
											A3(
												$elm_community$list_extra$List$Extra$setAt,
												child,
												$author$project$Input$Selected(localComp),
												listOfExpr)),
										dragModel));
						}
					}
				}
			case 'ProtoLocalAllCompsInField':
				switch (_v125.b) {
					case 0:
						var _v134 = _v125.a;
						var refInput = _v134.a;
						var fieldNameState = _v134.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalAllCompsInField,
								A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
								fieldNameState));
					case 1:
						var _v135 = _v125.a;
						var refInput = _v135.a;
						var fieldNameState = _v135.b;
						var _v136 = A2($author$project$ExpressionInput$updateCompFieldNameState, inputMsg, fieldNameState);
						if (_v136.$ === 'Unselected') {
							var newState = _v136.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
								A2($author$project$DataElement$ProtoExpression$ProtoLocalAllCompsInField, refInput, newState));
						} else {
							switch (_v136.a.a.$) {
								case 'StringComp':
									var _v137 = _v136.a;
									var _v138 = _v137.a;
									var fieldName = _v137.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompStringList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoLocalAllStringsInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'NumberComp':
									var _v139 = _v136.a;
									var _v140 = _v139.a;
									var fieldName = _v139.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompNumberList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoLocalAllNumbersInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								case 'DateComp':
									var _v141 = _v136.a;
									var _v142 = _v141.a;
									var fieldName = _v141.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoLocalAllDatesInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
								default:
									var _v143 = _v136.a;
									var _v144 = _v143.a;
									var fieldName = _v143.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateTimeList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoLocalAllDateTimesInField,
											refInput,
											$author$project$Input$Selected(fieldName)));
							}
						}
					default:
						var _v145 = _v125.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(proto);
				}
			default:
				switch (_v125.b) {
					case 0:
						var _v146 = _v125.a;
						var relationship = _v146.a;
						var fieldNameInput = _v146.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp,
								_Utils_update(
									relationship,
									{
										nextElement: A2($author$project$ExpressionInput$updateInputListReference, inputMsg, relationship.nextElement)
									}),
								fieldNameInput));
					case 1:
						var _v147 = _v125.a;
						var relationship = _v147.a;
						var fieldNameState = _v147.b;
						var _v148 = A2($author$project$ExpressionInput$updateCompFieldNameState, inputMsg, fieldNameState);
						if (_v148.$ === 'Unselected') {
							var newState = _v148.a;
							return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
								A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp, relationship, newState));
						} else {
							switch (_v148.a.a.$) {
								case 'StringComp':
									var _v149 = _v148.a;
									var _v150 = _v149.a;
									var fieldName = _v149.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompStringList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoRelatedString,
											relationship,
											$author$project$Input$Selected(fieldName)));
								case 'NumberComp':
									var _v151 = _v148.a;
									var _v152 = _v151.a;
									var fieldName = _v151.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompNumberList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
											relationship,
											$author$project$Input$Selected(fieldName)));
								case 'DateComp':
									var _v153 = _v148.a;
									var _v154 = _v153.a;
									var fieldName = _v153.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
											relationship,
											$author$project$Input$Selected(fieldName)));
								default:
									var _v155 = _v148.a;
									var _v156 = _v155.a;
									var fieldName = _v155.b;
									return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateTimeList(
										A2(
											$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
											relationship,
											$author$project$Input$Selected(fieldName)));
							}
						}
					case 2:
						var _v157 = _v125.a;
						var relationship = _v157.a;
						var fieldNameInput = _v157.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp,
								_Utils_update(
									relationship,
									{
										idToMatch: A2(
											$author$project$ExpressionInput$cyclic$updateInputLocalString(),
											inputMsg,
											relationship.idToMatch)
									}),
								fieldNameInput));
					case 3:
						var _v158 = _v125.a;
						var relationship = _v158.a;
						var fieldNameInput = _v158.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp,
								_Utils_update(
									relationship,
									{
										localIds: A2(
											$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
											inputMsg,
											relationship.localIds)
									}),
								fieldNameInput));
					case 4:
						var _v159 = _v125.a;
						var relationship = _v159.a;
						var fieldNameInput = _v159.b;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(
							A2(
								$author$project$DataElement$ProtoExpression$ProtoLocalRelatedComp,
								_Utils_update(
									relationship,
									{
										optionalFilter: A2(
											$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
											inputMsg,
											relationship.optionalFilter)
									}),
								fieldNameInput));
					default:
						var _v160 = _v125.a;
						return $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList(proto);
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalDateChild = F3(
	function (child, inputMsg, localDate) {
		var _v104 = _Utils_Tuple2(localDate, child);
		switch (_v104.a.$) {
			case 'ProtoLocalDate':
				return localDate;
			case 'ProtoLocalDateLookup':
				var _v105 = _v104.a;
				return localDate;
			case 'ProtoLocalDateHardcoded':
				return localDate;
			case 'ProtoLocalDateTimeToDate':
				if (!_v104.b) {
					var dateTime = _v104.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeToDate(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
							inputMsg,
							dateTime));
				} else {
					return localDate;
				}
			case 'ProtoLocalDateCeiling':
				switch (_v104.b) {
					case 0:
						var _v106 = _v104.a;
						var dateIntervalInput = _v106.a;
						var dateInput = _v106.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateCeiling,
							dateIntervalInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateInput));
					case 1:
						var _v107 = _v104.a;
						var dateIntervalInput = _v107.a;
						var dateInput = _v107.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateCeiling,
							A2($author$project$ExpressionInput$updateInputDateInterval, inputMsg, dateIntervalInput),
							dateInput);
					default:
						var _v108 = _v104.a;
						return localDate;
				}
			case 'ProtoLocalDateFloor':
				switch (_v104.b) {
					case 0:
						var _v109 = _v104.a;
						var dateIntervalInput = _v109.a;
						var dateInput = _v109.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateFloor,
							dateIntervalInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateInput));
					case 1:
						var _v110 = _v104.a;
						var dateIntervalInput = _v110.a;
						var dateInput = _v110.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateFloor,
							A2($author$project$ExpressionInput$updateInputDateInterval, inputMsg, dateIntervalInput),
							dateInput);
					default:
						var _v111 = _v104.a;
						return localDate;
				}
			case 'ProtoLocalDateAdd':
				switch (_v104.b) {
					case 0:
						var _v112 = _v104.a;
						var dateUnitInput = _v112.a;
						var numberInput = _v112.b;
						var dateInput = _v112.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateAdd,
							dateUnitInput,
							numberInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateInput));
					case 2:
						var _v113 = _v104.a;
						var dateUnitInput = _v113.a;
						var numberInput = _v113.b;
						var dateInput = _v113.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateAdd,
							dateUnitInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberInput),
							dateInput);
					case 3:
						var _v114 = _v104.a;
						var dateUnitInput = _v114.a;
						var numberInput = _v114.b;
						var dateInput = _v114.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateAdd,
							A2($author$project$ExpressionInput$updateInputDateUnit, inputMsg, dateUnitInput),
							numberInput,
							dateInput);
					default:
						var _v115 = _v104.a;
						return localDate;
				}
			case 'ProtoLocalDateSubtract':
				switch (_v104.b) {
					case 0:
						var _v116 = _v104.a;
						var dateUnitInput = _v116.a;
						var numberInput = _v116.b;
						var dateInput = _v116.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateSubtract,
							dateUnitInput,
							numberInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateInput));
					case 2:
						var _v117 = _v104.a;
						var dateUnitInput = _v117.a;
						var numberInput = _v117.b;
						var dateInput = _v117.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateSubtract,
							dateUnitInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberInput),
							dateInput);
					case 3:
						var _v118 = _v104.a;
						var dateUnitInput = _v118.a;
						var numberInput = _v118.b;
						var dateInput = _v118.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateSubtract,
							A2($author$project$ExpressionInput$updateInputDateUnit, inputMsg, dateUnitInput),
							numberInput,
							dateInput);
					default:
						var _v119 = _v104.a;
						return localDate;
				}
			case 'ProtoLocalDateIf':
				switch (_v104.b) {
					case 0:
						var _v120 = _v104.a;
						var condInput = _v120.a;
						var thenInput = _v120.b;
						var elseInput = _v120.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v121 = _v104.a;
						var condInput = _v121.a;
						var thenInput = _v121.b;
						var elseInput = _v121.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v122 = _v104.a;
						var condInput = _v122.a;
						var thenInput = _v122.b;
						var elseInput = _v122.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								elseInput));
					default:
						var _v123 = _v104.a;
						return localDate;
				}
			case 'ProtoLocalPickDate':
				if (!_v104.b) {
					var listInput = _v104.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalPickDate(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDateList(),
							inputMsg,
							listInput));
				} else {
					return localDate;
				}
			case 'ProtoLocalMaxDate':
				if (!_v104.b) {
					var listInput = _v104.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalMaxDate(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDateList(),
							inputMsg,
							listInput));
				} else {
					return localDate;
				}
			default:
				if (!_v104.b) {
					var listInput = _v104.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalMinDate(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDateList(),
							inputMsg,
							listInput));
				} else {
					return localDate;
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalDateListChild = F3(
	function (child, inputMsg, proto) {
		var _v89 = _Utils_Tuple2(proto, child);
		switch (_v89.a.$) {
			case 'ProtoLocalDateListIf':
				switch (_v89.b) {
					case 0:
						var _v90 = _v89.a;
						var condInput = _v90.a;
						var thenInput = _v90.b;
						var elseInput = _v90.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v91 = _v89.a;
						var condInput = _v91.a;
						var thenInput = _v91.b;
						var elseInput = _v91.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v92 = _v89.a;
						var condInput = _v92.a;
						var thenInput = _v92.b;
						var elseInput = _v92.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateList(),
								inputMsg,
								elseInput));
					default:
						var _v93 = _v89.a;
						return proto;
				}
			case 'ProtoLocalAllDatesInField':
				switch (_v89.b) {
					case 0:
						var _v94 = _v89.a;
						var refInput = _v94.a;
						var fieldNameInput = _v94.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllDatesInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v95 = _v89.a;
						var refInput = _v95.a;
						var fieldNameInput = _v95.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllDatesInField,
							refInput,
							A2($author$project$ExpressionInput$updateDateFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v96 = _v89.a;
						return proto;
				}
			case 'ProtoLocalDatesAsList':
				var _v97 = _v89.a;
				var listOfExpr = _v97.a;
				var dragModel = _v97.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoLocalDatesAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputLocalDate()(inputMsg),
							listOfExpr)),
					dragModel);
			default:
				switch (_v89.b) {
					case 0:
						var _v98 = _v89.a;
						var relationship = _v98.a;
						var fieldNameInput = _v98.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
							_Utils_update(
								relationship,
								{
									nextElement: A2($author$project$ExpressionInput$updateInputListReference, inputMsg, relationship.nextElement)
								}),
							fieldNameInput);
					case 1:
						var _v99 = _v89.a;
						var relationship = _v99.a;
						var fieldNameInput = _v99.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
							relationship,
							A2($author$project$ExpressionInput$updateDateFieldNameInput, inputMsg, fieldNameInput));
					case 2:
						var _v100 = _v89.a;
						var relationship = _v100.a;
						var fieldNameInput = _v100.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
							_Utils_update(
								relationship,
								{
									idToMatch: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalString(),
										inputMsg,
										relationship.idToMatch)
								}),
							fieldNameInput);
					case 3:
						var _v101 = _v89.a;
						var relationship = _v101.a;
						var fieldNameInput = _v101.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
							_Utils_update(
								relationship,
								{
									localIds: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
										inputMsg,
										relationship.localIds)
								}),
							fieldNameInput);
					case 4:
						var _v102 = _v89.a;
						var relationship = _v102.a;
						var fieldNameInput = _v102.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
							_Utils_update(
								relationship,
								{
									optionalFilter: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
										inputMsg,
										relationship.optionalFilter)
								}),
							fieldNameInput);
					default:
						var _v103 = _v89.a;
						return proto;
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalDateTimeChild = F3(
	function (child, inputMsg, localDateTime) {
		var _v82 = _Utils_Tuple2(localDateTime, child);
		switch (_v82.a.$) {
			case 'ProtoLocalDateTime':
				return localDateTime;
			case 'ProtoLocalDateTimeLookup':
				var _v83 = _v82.a;
				return localDateTime;
			case 'ProtoLocalDateTimeHardcoded':
				return localDateTime;
			case 'ProtoLocalDateTimeIf':
				switch (_v82.b) {
					case 0:
						var _v84 = _v82.a;
						var condInput = _v84.a;
						var thenInput = _v84.b;
						var elseInput = _v84.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v85 = _v82.a;
						var condInput = _v85.a;
						var thenInput = _v85.b;
						var elseInput = _v85.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v86 = _v82.a;
						var condInput = _v86.a;
						var thenInput = _v86.b;
						var elseInput = _v86.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
								inputMsg,
								elseInput));
					default:
						var _v87 = _v82.a;
						return localDateTime;
				}
			case 'ProtoLocalPickDateTime':
				if (!_v82.b) {
					var listInput = _v82.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalPickDateTime(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDateTimeList(),
							inputMsg,
							listInput));
				} else {
					return localDateTime;
				}
			case 'ProtoLocalMaxDateTime':
				if (!_v82.b) {
					var listInput = _v82.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalMaxDateTime(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDateTimeList(),
							inputMsg,
							listInput));
				} else {
					return localDateTime;
				}
			default:
				if (!_v82.b) {
					var listInput = _v82.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalMinDateTime(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDateTimeList(),
							inputMsg,
							listInput));
				} else {
					return localDateTime;
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalDateTimeListChild = F3(
	function (child, inputMsg, proto) {
		var _v67 = _Utils_Tuple2(proto, child);
		switch (_v67.a.$) {
			case 'ProtoLocalDateTimeListIf':
				switch (_v67.b) {
					case 0:
						var _v68 = _v67.a;
						var condInput = _v68.a;
						var thenInput = _v68.b;
						var elseInput = _v68.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v69 = _v67.a;
						var condInput = _v69.a;
						var thenInput = _v69.b;
						var elseInput = _v69.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTimeList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v70 = _v67.a;
						var condInput = _v70.a;
						var thenInput = _v70.b;
						var elseInput = _v70.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDateTimeList(),
								inputMsg,
								elseInput));
					default:
						var _v71 = _v67.a;
						return proto;
				}
			case 'ProtoLocalAllDateTimesInField':
				switch (_v67.b) {
					case 0:
						var _v72 = _v67.a;
						var refInput = _v72.a;
						var fieldNameInput = _v72.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllDateTimesInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v73 = _v67.a;
						var refInput = _v73.a;
						var fieldNameInput = _v73.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllDateTimesInField,
							refInput,
							A2($author$project$ExpressionInput$updateDateTimeFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v74 = _v67.a;
						return proto;
				}
			case 'ProtoLocalDateTimesAsList':
				var _v75 = _v67.a;
				var listOfExpr = _v75.a;
				var dragModel = _v75.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoLocalDateTimesAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputLocalDateTime()(inputMsg),
							listOfExpr)),
					dragModel);
			default:
				switch (_v67.b) {
					case 0:
						var _v76 = _v67.a;
						var relationship = _v76.a;
						var fieldNameInput = _v76.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
							_Utils_update(
								relationship,
								{
									nextElement: A2($author$project$ExpressionInput$updateInputListReference, inputMsg, relationship.nextElement)
								}),
							fieldNameInput);
					case 1:
						var _v77 = _v67.a;
						var relationship = _v77.a;
						var fieldNameInput = _v77.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
							relationship,
							A2($author$project$ExpressionInput$updateDateTimeFieldNameInput, inputMsg, fieldNameInput));
					case 2:
						var _v78 = _v67.a;
						var relationship = _v78.a;
						var fieldNameInput = _v78.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
							_Utils_update(
								relationship,
								{
									idToMatch: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalString(),
										inputMsg,
										relationship.idToMatch)
								}),
							fieldNameInput);
					case 3:
						var _v79 = _v67.a;
						var relationship = _v79.a;
						var fieldNameInput = _v79.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
							_Utils_update(
								relationship,
								{
									localIds: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
										inputMsg,
										relationship.localIds)
								}),
							fieldNameInput);
					case 4:
						var _v80 = _v67.a;
						var relationship = _v80.a;
						var fieldNameInput = _v80.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
							_Utils_update(
								relationship,
								{
									optionalFilter: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
										inputMsg,
										relationship.optionalFilter)
								}),
							fieldNameInput);
					default:
						var _v81 = _v67.a;
						return proto;
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalFieldChild = F3(
	function (child, inputMsg, localField) {
		switch (localField.$) {
			case 'ProtoLocalStringField':
				var localString = localField.a;
				return $author$project$ExpressionInput$wrapLocalString(
					A3($author$project$ExpressionInput$updateInputLocalStringChild, child, inputMsg, localString));
			case 'ProtoLocalNumberField':
				var localNumber = localField.a;
				return $author$project$ExpressionInput$wrapLocalNumber(
					A3($author$project$ExpressionInput$updateInputLocalNumberChild, child, inputMsg, localNumber));
			case 'ProtoLocalDateField':
				var localDate = localField.a;
				return $author$project$ExpressionInput$wrapLocalDate(
					A3($author$project$ExpressionInput$updateInputLocalDateChild, child, inputMsg, localDate));
			case 'ProtoLocalDateTimeField':
				var localDateTime = localField.a;
				return $author$project$ExpressionInput$wrapLocalDateTime(
					A3($author$project$ExpressionInput$updateInputLocalDateTimeChild, child, inputMsg, localDateTime));
			case 'ProtoLocalBoolField':
				var localBool = localField.a;
				return $author$project$ExpressionInput$wrapLocalBool(
					A3($author$project$ExpressionInput$updateInputLocalBoolChild, child, inputMsg, localBool));
			case 'ProtoLocalAnyField':
				var localAny = localField.a;
				return A3($author$project$ExpressionInput$updateInputLocalAnyChild, child, inputMsg, localAny);
			default:
				var localComp = localField.a;
				return $author$project$ExpressionInput$convertLocalCompFieldToLocalField(
					A3($author$project$ExpressionInput$updateInputLocalCompChild, child, inputMsg, localComp));
		}
	});
var $author$project$ExpressionInput$updateInputLocalNumberChild = F3(
	function (child, inputMsg, localNumber) {
		var _v46 = _Utils_Tuple2(localNumber, child);
		switch (_v46.a.$) {
			case 'ProtoLocalNumber':
				return localNumber;
			case 'ProtoLocalNumberLookup':
				var _v47 = _v46.a;
				return localNumber;
			case 'ProtoLocalNumberHardcoded':
				return localNumber;
			case 'ProtoLocalRoundNumber':
				if (!_v46.b) {
					var numberInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalRoundNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
							inputMsg,
							numberInput));
				} else {
					return localNumber;
				}
			case 'ProtoLocalSum':
				if (!_v46.b) {
					var listInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalSum(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalNumberList(),
							inputMsg,
							listInput));
				} else {
					return localNumber;
				}
			case 'ProtoLocalProduct':
				if (!_v46.b) {
					var listInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalProduct(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalNumberList(),
							inputMsg,
							listInput));
				} else {
					return localNumber;
				}
			case 'ProtoLocalAdd':
				switch (_v46.b) {
					case 0:
						var _v48 = _v46.a;
						var numberA = _v48.a;
						var numberB = _v48.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAdd,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberA),
							numberB);
					case 2:
						var _v49 = _v46.a;
						var numberA = _v49.a;
						var numberB = _v49.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAdd,
							numberA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberB));
					default:
						var _v50 = _v46.a;
						return localNumber;
				}
			case 'ProtoLocalSubtract':
				switch (_v46.b) {
					case 0:
						var _v51 = _v46.a;
						var numberA = _v51.a;
						var numberB = _v51.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalSubtract,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberA),
							numberB);
					case 2:
						var _v52 = _v46.a;
						var numberA = _v52.a;
						var numberB = _v52.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalSubtract,
							numberA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberB));
					default:
						var _v53 = _v46.a;
						return localNumber;
				}
			case 'ProtoLocalMultiply':
				switch (_v46.b) {
					case 0:
						var _v54 = _v46.a;
						var numberA = _v54.a;
						var numberB = _v54.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalMultiply,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberA),
							numberB);
					case 2:
						var _v55 = _v46.a;
						var numberA = _v55.a;
						var numberB = _v55.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalMultiply,
							numberA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberB));
					default:
						var _v56 = _v46.a;
						return localNumber;
				}
			case 'ProtoLocalDivide':
				switch (_v46.b) {
					case 0:
						var _v57 = _v46.a;
						var numberA = _v57.a;
						var numberB = _v57.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalDivide,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberA),
							numberB);
					case 2:
						var _v58 = _v46.a;
						var numberA = _v58.a;
						var numberB = _v58.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalDivide,
							numberA,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberB));
					default:
						var _v59 = _v46.a;
						return localNumber;
				}
			case 'ProtoLocalMonthNumber':
				if (!_v46.b) {
					var dateInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalMonthNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
							inputMsg,
							dateInput));
				} else {
					return localNumber;
				}
			case 'ProtoLocalYearNumber':
				if (!_v46.b) {
					var dateInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalYearNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
							inputMsg,
							dateInput));
				} else {
					return localNumber;
				}
			case 'ProtoLocalDayInMonth':
				if (!_v46.b) {
					var dateInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalDayInMonth(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
							inputMsg,
							dateInput));
				} else {
					return localNumber;
				}
			case 'ProtoLocalNumberIf':
				switch (_v46.b) {
					case 0:
						var _v60 = _v46.a;
						var condInput = _v60.a;
						var thenInput = _v60.b;
						var elseInput = _v60.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v61 = _v46.a;
						var condInput = _v61.a;
						var thenInput = _v61.b;
						var elseInput = _v61.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v62 = _v46.a;
						var condInput = _v62.a;
						var thenInput = _v62.b;
						var elseInput = _v62.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								elseInput));
					default:
						var _v63 = _v46.a;
						return localNumber;
				}
			case 'ProtoLocalPickNumber':
				if (!_v46.b) {
					var listInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalPickNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalNumberList(),
							inputMsg,
							listInput));
				} else {
					return localNumber;
				}
			case 'ProtoLocalMaxNumber':
				if (!_v46.b) {
					var listInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalMaxNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalNumberList(),
							inputMsg,
							listInput));
				} else {
					return localNumber;
				}
			case 'ProtoLocalMinNumber':
				if (!_v46.b) {
					var listInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalMinNumber(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalNumberList(),
							inputMsg,
							listInput));
				} else {
					return localNumber;
				}
			default:
				if (!_v46.b) {
					var listInput = _v46.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalCountUnique(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalCompFieldList(),
							inputMsg,
							listInput));
				} else {
					return localNumber;
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalNumberListChild = F3(
	function (child, inputMsg, proto) {
		var _v31 = _Utils_Tuple2(proto, child);
		switch (_v31.a.$) {
			case 'ProtoLocalNumberListIf':
				switch (_v31.b) {
					case 0:
						var _v32 = _v31.a;
						var condInput = _v32.a;
						var thenInput = _v32.b;
						var elseInput = _v32.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v33 = _v31.a;
						var condInput = _v33.a;
						var thenInput = _v33.b;
						var elseInput = _v33.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumberList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v34 = _v31.a;
						var condInput = _v34.a;
						var thenInput = _v34.b;
						var elseInput = _v34.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumberList(),
								inputMsg,
								elseInput));
					default:
						var _v35 = _v31.a;
						return proto;
				}
			case 'ProtoLocalAllNumbersInField':
				switch (_v31.b) {
					case 0:
						var _v36 = _v31.a;
						var refInput = _v36.a;
						var fieldNameInput = _v36.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllNumbersInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v37 = _v31.a;
						var refInput = _v37.a;
						var fieldNameInput = _v37.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllNumbersInField,
							refInput,
							A2($author$project$ExpressionInput$updateNumberFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v38 = _v31.a;
						return proto;
				}
			case 'ProtoLocalNumbersAsList':
				var _v39 = _v31.a;
				var listOfExpr = _v39.a;
				var dragModel = _v39.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoLocalNumbersAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputLocalNumber()(inputMsg),
							listOfExpr)),
					dragModel);
			default:
				switch (_v31.b) {
					case 0:
						var _v40 = _v31.a;
						var relationship = _v40.a;
						var fieldNameInput = _v40.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
							_Utils_update(
								relationship,
								{
									nextElement: A2($author$project$ExpressionInput$updateInputListReference, inputMsg, relationship.nextElement)
								}),
							fieldNameInput);
					case 1:
						var _v41 = _v31.a;
						var relationship = _v41.a;
						var fieldNameInput = _v41.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
							relationship,
							A2($author$project$ExpressionInput$updateNumberFieldNameInput, inputMsg, fieldNameInput));
					case 2:
						var _v42 = _v31.a;
						var relationship = _v42.a;
						var fieldNameInput = _v42.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
							_Utils_update(
								relationship,
								{
									idToMatch: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalString(),
										inputMsg,
										relationship.idToMatch)
								}),
							fieldNameInput);
					case 3:
						var _v43 = _v31.a;
						var relationship = _v43.a;
						var fieldNameInput = _v43.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
							_Utils_update(
								relationship,
								{
									localIds: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
										inputMsg,
										relationship.localIds)
								}),
							fieldNameInput);
					case 4:
						var _v44 = _v31.a;
						var relationship = _v44.a;
						var fieldNameInput = _v44.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
							_Utils_update(
								relationship,
								{
									optionalFilter: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
										inputMsg,
										relationship.optionalFilter)
								}),
							fieldNameInput);
					default:
						var _v45 = _v31.a;
						return proto;
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalStringChild = F3(
	function (child, inputMsg, localString) {
		var _v15 = _Utils_Tuple2(localString, child);
		switch (_v15.a.$) {
			case 'ProtoLocalString':
				return localString;
			case 'ProtoLocalStringLookup':
				var _v16 = _v15.a;
				return localString;
			case 'ProtoLocalStringHardcoded':
				return localString;
			case 'ProtoLocalFormatDate':
				switch (_v15.b) {
					case 0:
						var _v17 = _v15.a;
						var stringInput = _v17.a;
						var dateInput = _v17.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalFormatDate,
							stringInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalDate(),
								inputMsg,
								dateInput));
					case 1:
						var _v18 = _v15.a;
						var stringInput = _v18.a;
						var dateInput = _v18.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalFormatDate,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								stringInput),
							dateInput);
					default:
						var _v19 = _v15.a;
						return localString;
				}
			case 'ProtoLocalFormatNumber':
				switch (_v15.b) {
					case 0:
						var _v20 = _v15.a;
						var decimalInput = _v20.a;
						var numberInput = _v20.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalFormatNumber,
							decimalInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalNumber(),
								inputMsg,
								numberInput));
					case 1:
						var _v21 = _v15.a;
						var decimalInput = _v21.a;
						var numberInput = _v21.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalFormatNumber,
							A2($author$project$ExpressionInput$updateIntInput, inputMsg, decimalInput),
							numberInput);
					default:
						var _v22 = _v15.a;
						return localString;
				}
			case 'ProtoLocalStringIf':
				switch (_v15.b) {
					case 0:
						var _v23 = _v15.a;
						var condInput = _v23.a;
						var thenInput = _v23.b;
						var elseInput = _v23.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v24 = _v15.a;
						var condInput = _v24.a;
						var thenInput = _v24.b;
						var elseInput = _v24.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v25 = _v15.a;
						var condInput = _v25.a;
						var thenInput = _v25.b;
						var elseInput = _v25.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								elseInput));
					default:
						var _v26 = _v15.a;
						return localString;
				}
			case 'ProtoLocalPickString':
				if (!_v15.b) {
					var listInput = _v15.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalPickString(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
							inputMsg,
							listInput));
				} else {
					return localString;
				}
			case 'ProtoLocalConcat':
				switch (_v15.b) {
					case 0:
						var _v27 = _v15.a;
						var joinInput = _v27.a;
						var listInput = _v27.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalConcat,
							joinInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
								inputMsg,
								listInput));
					case 1:
						var _v28 = _v15.a;
						var joinInput = _v28.a;
						var listInput = _v28.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalConcat,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalString(),
								inputMsg,
								joinInput),
							listInput);
					default:
						var _v29 = _v15.a;
						return localString;
				}
			case 'ProtoLocalMaxString':
				if (!_v15.b) {
					var listInput = _v15.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalMaxString(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
							inputMsg,
							listInput));
				} else {
					return localString;
				}
			case 'ProtoLocalFormatDateTime':
				if (!_v15.b) {
					var input = _v15.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalFormatDateTime(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalDateTime(),
							inputMsg,
							input));
				} else {
					return localString;
				}
			default:
				if (!_v15.b) {
					var listInput = _v15.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalMinString(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
							inputMsg,
							listInput));
				} else {
					return localString;
				}
		}
	});
var $author$project$ExpressionInput$updateInputLocalStringListChild = F3(
	function (child, inputMsg, proto) {
		var _v0 = _Utils_Tuple2(proto, child);
		switch (_v0.a.$) {
			case 'ProtoLocalStringListIf':
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.a;
						var condInput = _v1.a;
						var thenInput = _v1.b;
						var elseInput = _v1.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
								inputMsg,
								condInput),
							thenInput,
							elseInput);
					case 1:
						var _v2 = _v0.a;
						var condInput = _v2.a;
						var thenInput = _v2.b;
						var elseInput = _v2.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
							condInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
								inputMsg,
								thenInput),
							elseInput);
					case 2:
						var _v3 = _v0.a;
						var condInput = _v3.a;
						var thenInput = _v3.b;
						var elseInput = _v3.c;
						return A3(
							$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
							condInput,
							thenInput,
							A2(
								$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
								inputMsg,
								elseInput));
					default:
						var _v4 = _v0.a;
						return proto;
				}
			case 'ProtoLocalAllStringsInField':
				switch (_v0.b) {
					case 0:
						var _v5 = _v0.a;
						var refInput = _v5.a;
						var fieldNameInput = _v5.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllStringsInField,
							A2($author$project$ExpressionInput$updateInputListReference, inputMsg, refInput),
							fieldNameInput);
					case 1:
						var _v6 = _v0.a;
						var refInput = _v6.a;
						var fieldNameInput = _v6.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoLocalAllStringsInField,
							refInput,
							A2($author$project$ExpressionInput$updateStringFieldNameInput, inputMsg, fieldNameInput));
					default:
						var _v7 = _v0.a;
						return proto;
				}
			case 'ProtoLocalStringsAsList':
				var _v8 = _v0.a;
				var listOfExpr = _v8.a;
				var dragModel = _v8.b;
				return A2(
					$author$project$DataElement$ProtoExpression$ProtoLocalStringsAsList,
					$author$project$ExpressionInput$resizeInputList(
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							child,
							$author$project$ExpressionInput$cyclic$updateInputLocalString()(inputMsg),
							listOfExpr)),
					dragModel);
			case 'ProtoRelatedString':
				switch (_v0.b) {
					case 0:
						var _v9 = _v0.a;
						var relationship = _v9.a;
						var fieldNameInput = _v9.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedString,
							_Utils_update(
								relationship,
								{
									nextElement: A2($author$project$ExpressionInput$updateInputListReference, inputMsg, relationship.nextElement)
								}),
							fieldNameInput);
					case 1:
						var _v10 = _v0.a;
						var relationship = _v10.a;
						var fieldNameInput = _v10.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedString,
							relationship,
							A2($author$project$ExpressionInput$updateStringFieldNameInput, inputMsg, fieldNameInput));
					case 2:
						var _v11 = _v0.a;
						var relationship = _v11.a;
						var fieldNameInput = _v11.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedString,
							_Utils_update(
								relationship,
								{
									idToMatch: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalString(),
										inputMsg,
										relationship.idToMatch)
								}),
							fieldNameInput);
					case 3:
						var _v12 = _v0.a;
						var relationship = _v12.a;
						var fieldNameInput = _v12.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedString,
							_Utils_update(
								relationship,
								{
									localIds: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalStringList(),
										inputMsg,
										relationship.localIds)
								}),
							fieldNameInput);
					case 4:
						var _v13 = _v0.a;
						var relationship = _v13.a;
						var fieldNameInput = _v13.b;
						return A2(
							$author$project$DataElement$ProtoExpression$ProtoRelatedString,
							_Utils_update(
								relationship,
								{
									optionalFilter: A2(
										$author$project$ExpressionInput$cyclic$updateInputLocalBool(),
										inputMsg,
										relationship.optionalFilter)
								}),
							fieldNameInput);
					default:
						var _v14 = _v0.a;
						return proto;
				}
			case 'ProtoLocalChallengeReasons':
				if (!_v0.b) {
					var acctIdInput = _v0.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalChallengeReasons(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalString(),
							inputMsg,
							acctIdInput));
				} else {
					return proto;
				}
			default:
				if (!_v0.b) {
					var acctIdInput = _v0.a.a;
					return $author$project$DataElement$ProtoExpression$ProtoLocalTargetChallengeReasons(
						A2(
							$author$project$ExpressionInput$cyclic$updateInputLocalString(),
							inputMsg,
							acctIdInput));
				} else {
					return proto;
				}
		}
	});
function $author$project$ExpressionInput$cyclic$updateInputLocalAny() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $author$project$DataElement$ProtoExpression$ProtoLocalAnyField,
			select: $author$project$ExpressionInput$selectLocalAny,
			tag: 'Update Local Any',
			updateChild: $author$project$ExpressionInput$updateInputLocalAnyChild,
			updateDrag: function (_v367) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalAnyList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $author$project$DataElement$ProtoExpression$ProtoLocalFieldList, select: $author$project$ExpressionInput$selectLocalAnyList, tag: 'Update Local Any List', updateChild: $author$project$ExpressionInput$updateInputLocalAnyListChild, updateDrag: $author$project$ExpressionInput$updateDragLocalAnyList});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalBool() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectLocalBool,
			tag: 'Update Local Bool',
			updateChild: $author$project$ExpressionInput$updateInputLocalBoolChild,
			updateDrag: function (_v318) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalBoolList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectLocalBoolList, tag: 'Update Local Bool List', updateChild: $author$project$ExpressionInput$updateInputLocalBoolListChild, updateDrag: $author$project$ExpressionInput$updateDragLocalBoolList});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalComp() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField,
			select: $author$project$ExpressionInput$selectLocalComp,
			tag: 'Update Local Comp',
			updateChild: $author$project$ExpressionInput$updateInputLocalCompChild,
			updateDrag: function (_v172) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalCompFieldList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectLocalCompList, tag: 'Update Local Comp Field List', updateChild: $author$project$ExpressionInput$updateInputLocalCompFieldListChild, updateDrag: $author$project$ExpressionInput$updateDragLocalCompFieldList});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalCompList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $author$project$DataElement$ProtoExpression$ProtoLocalCompFieldList, select: $author$project$ExpressionInput$selectLocalCompList, tag: 'Update Local Comp List', updateChild: $author$project$ExpressionInput$updateInputLocalCompListChild, updateDrag: $author$project$ExpressionInput$updateDragLocalCompList});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalDate() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectLocalDate,
			tag: 'Update Local Date',
			updateChild: $author$project$ExpressionInput$updateInputLocalDateChild,
			updateDrag: function (_v124) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalDateList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectLocalDateList, tag: 'Update Local Date List', updateChild: $author$project$ExpressionInput$updateInputLocalDateListChild, updateDrag: $author$project$ExpressionInput$updateDragLocalDateList});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalDateTime() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectLocalDateTime,
			tag: 'Update Local DateTime',
			updateChild: $author$project$ExpressionInput$updateInputLocalDateTimeChild,
			updateDrag: function (_v88) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalDateTimeList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectLocalDateTimeList, tag: 'Update Local DateTime List', updateChild: $author$project$ExpressionInput$updateInputLocalDateTimeListChild, updateDrag: $author$project$ExpressionInput$updateDragLocalDateTimeList});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalField() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectLocalField,
			tag: 'Update Local Field',
			updateChild: $author$project$ExpressionInput$updateInputLocalFieldChild,
			updateDrag: function (_v66) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalNumber() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectLocalNumber,
			tag: 'Update Local Number',
			updateChild: $author$project$ExpressionInput$updateInputLocalNumberChild,
			updateDrag: function (_v64) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalNumberList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectLocalNumberList, tag: 'Update Local Number List', updateChild: $author$project$ExpressionInput$updateInputLocalNumberListChild, updateDrag: $author$project$ExpressionInput$updateDragLocalNumberList});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalString() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{
			convert: $elm$core$Basics$identity,
			select: $author$project$ExpressionInput$selectLocalString,
			tag: 'Update Local String',
			updateChild: $author$project$ExpressionInput$updateInputLocalStringChild,
			updateDrag: function (_v30) {
				return $elm$core$Basics$identity;
			}
		});
}
function $author$project$ExpressionInput$cyclic$updateInputLocalStringList() {
	return $author$project$ExpressionInput$updateInputGeneric(
		{convert: $elm$core$Basics$identity, select: $author$project$ExpressionInput$selectLocalStringList, tag: 'Update Local String List', updateChild: $author$project$ExpressionInput$updateInputLocalStringListChild, updateDrag: $author$project$ExpressionInput$updateDragLocalStringList});
}
try {
	var $author$project$ExpressionInput$updateInputLocalAny = $author$project$ExpressionInput$cyclic$updateInputLocalAny();
	$author$project$ExpressionInput$cyclic$updateInputLocalAny = function () {
		return $author$project$ExpressionInput$updateInputLocalAny;
	};
	var $author$project$ExpressionInput$updateInputLocalAnyList = $author$project$ExpressionInput$cyclic$updateInputLocalAnyList();
	$author$project$ExpressionInput$cyclic$updateInputLocalAnyList = function () {
		return $author$project$ExpressionInput$updateInputLocalAnyList;
	};
	var $author$project$ExpressionInput$updateInputLocalBool = $author$project$ExpressionInput$cyclic$updateInputLocalBool();
	$author$project$ExpressionInput$cyclic$updateInputLocalBool = function () {
		return $author$project$ExpressionInput$updateInputLocalBool;
	};
	var $author$project$ExpressionInput$updateInputLocalBoolList = $author$project$ExpressionInput$cyclic$updateInputLocalBoolList();
	$author$project$ExpressionInput$cyclic$updateInputLocalBoolList = function () {
		return $author$project$ExpressionInput$updateInputLocalBoolList;
	};
	var $author$project$ExpressionInput$updateInputLocalComp = $author$project$ExpressionInput$cyclic$updateInputLocalComp();
	$author$project$ExpressionInput$cyclic$updateInputLocalComp = function () {
		return $author$project$ExpressionInput$updateInputLocalComp;
	};
	var $author$project$ExpressionInput$updateInputLocalCompFieldList = $author$project$ExpressionInput$cyclic$updateInputLocalCompFieldList();
	$author$project$ExpressionInput$cyclic$updateInputLocalCompFieldList = function () {
		return $author$project$ExpressionInput$updateInputLocalCompFieldList;
	};
	var $author$project$ExpressionInput$updateInputLocalCompList = $author$project$ExpressionInput$cyclic$updateInputLocalCompList();
	$author$project$ExpressionInput$cyclic$updateInputLocalCompList = function () {
		return $author$project$ExpressionInput$updateInputLocalCompList;
	};
	var $author$project$ExpressionInput$updateInputLocalDate = $author$project$ExpressionInput$cyclic$updateInputLocalDate();
	$author$project$ExpressionInput$cyclic$updateInputLocalDate = function () {
		return $author$project$ExpressionInput$updateInputLocalDate;
	};
	var $author$project$ExpressionInput$updateInputLocalDateList = $author$project$ExpressionInput$cyclic$updateInputLocalDateList();
	$author$project$ExpressionInput$cyclic$updateInputLocalDateList = function () {
		return $author$project$ExpressionInput$updateInputLocalDateList;
	};
	var $author$project$ExpressionInput$updateInputLocalDateTime = $author$project$ExpressionInput$cyclic$updateInputLocalDateTime();
	$author$project$ExpressionInput$cyclic$updateInputLocalDateTime = function () {
		return $author$project$ExpressionInput$updateInputLocalDateTime;
	};
	var $author$project$ExpressionInput$updateInputLocalDateTimeList = $author$project$ExpressionInput$cyclic$updateInputLocalDateTimeList();
	$author$project$ExpressionInput$cyclic$updateInputLocalDateTimeList = function () {
		return $author$project$ExpressionInput$updateInputLocalDateTimeList;
	};
	var $author$project$ExpressionInput$updateInputLocalField = $author$project$ExpressionInput$cyclic$updateInputLocalField();
	$author$project$ExpressionInput$cyclic$updateInputLocalField = function () {
		return $author$project$ExpressionInput$updateInputLocalField;
	};
	var $author$project$ExpressionInput$updateInputLocalNumber = $author$project$ExpressionInput$cyclic$updateInputLocalNumber();
	$author$project$ExpressionInput$cyclic$updateInputLocalNumber = function () {
		return $author$project$ExpressionInput$updateInputLocalNumber;
	};
	var $author$project$ExpressionInput$updateInputLocalNumberList = $author$project$ExpressionInput$cyclic$updateInputLocalNumberList();
	$author$project$ExpressionInput$cyclic$updateInputLocalNumberList = function () {
		return $author$project$ExpressionInput$updateInputLocalNumberList;
	};
	var $author$project$ExpressionInput$updateInputLocalString = $author$project$ExpressionInput$cyclic$updateInputLocalString();
	$author$project$ExpressionInput$cyclic$updateInputLocalString = function () {
		return $author$project$ExpressionInput$updateInputLocalString;
	};
	var $author$project$ExpressionInput$updateInputLocalStringList = $author$project$ExpressionInput$cyclic$updateInputLocalStringList();
	$author$project$ExpressionInput$cyclic$updateInputLocalStringList = function () {
		return $author$project$ExpressionInput$updateInputLocalStringList;
	};
} catch ($) {
	throw 'Some top-level definitions from `ExpressionInput` are causing infinite recursion:\n\n  ┌─────┐\n  │    updateInputLocalAny\n  │     ↓\n  │    updateInputLocalAnyChild\n  │     ↓\n  │    updateInputLocalAnyList\n  │     ↓\n  │    updateInputLocalAnyListChild\n  │     ↓\n  │    updateInputLocalBool\n  │     ↓\n  │    updateInputLocalBoolChild\n  │     ↓\n  │    updateInputLocalBoolChildHelper\n  │     ↓\n  │    updateInputLocalBoolList\n  │     ↓\n  │    updateInputLocalBoolListChild\n  │     ↓\n  │    updateInputLocalComp\n  │     ↓\n  │    updateInputLocalCompChild\n  │     ↓\n  │    updateInputLocalCompFieldList\n  │     ↓\n  │    updateInputLocalCompFieldListChild\n  │     ↓\n  │    updateInputLocalCompList\n  │     ↓\n  │    updateInputLocalCompListChild\n  │     ↓\n  │    updateInputLocalDate\n  │     ↓\n  │    updateInputLocalDateChild\n  │     ↓\n  │    updateInputLocalDateList\n  │     ↓\n  │    updateInputLocalDateListChild\n  │     ↓\n  │    updateInputLocalDateTime\n  │     ↓\n  │    updateInputLocalDateTimeChild\n  │     ↓\n  │    updateInputLocalDateTimeList\n  │     ↓\n  │    updateInputLocalDateTimeListChild\n  │     ↓\n  │    updateInputLocalField\n  │     ↓\n  │    updateInputLocalFieldChild\n  │     ↓\n  │    updateInputLocalNumber\n  │     ↓\n  │    updateInputLocalNumberChild\n  │     ↓\n  │    updateInputLocalNumberList\n  │     ↓\n  │    updateInputLocalNumberListChild\n  │     ↓\n  │    updateInputLocalString\n  │     ↓\n  │    updateInputLocalStringChild\n  │     ↓\n  │    updateInputLocalStringList\n  │     ↓\n  │    updateInputLocalStringListChild\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$validateLocalTransformer = F3(
	function (allElements, context, listRef) {
		return {
			add: $elm$core$Basics$append,
			all: $elm$core$Basics$identity,
			allBoolsInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$BoolType),
			allDateTimesInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$DateTimeType),
			allDatesInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$DateType),
			allNumbersInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$NumberType),
			allStringsInField: A3($author$project$DataElement$validateAllValuesInField, allElements, context, $author$project$FieldType$StringType),
			any: $elm$core$Basics$identity,
			boolsAsList: $elm$core$List$concat,
			challengeReasons: $elm$core$Basics$identity,
			comparableEqual: function (_v0) {
				return $elm$core$Basics$append;
			},
			comparableNotEqual: function (_v1) {
				return $elm$core$Basics$append;
			},
			concat: $elm$core$Basics$append,
			countUnique: $elm$core$Basics$always($elm$core$Basics$identity),
			dateAdd: function (_v2) {
				return $elm$core$Basics$append;
			},
			dateCeiling: F2(
				function (_v3, errors) {
					return errors;
				}),
			dateFloor: F2(
				function (_v4, errors) {
					return errors;
				}),
			dateSubtract: function (_v5) {
				return $elm$core$Basics$append;
			},
			dateTimeToDate: $elm$core$Basics$identity,
			dateTimesAsList: $elm$core$List$concat,
			datesAsList: $elm$core$List$concat,
			dayInMonth: $elm$core$Basics$identity,
			divide: $elm$core$Basics$append,
			equal: function (_v6) {
				return $elm$core$Basics$append;
			},
			formatDate: $elm$core$Basics$append,
			formatDateLocaleAware: $elm$core$Basics$identity,
			formatDateTime: $elm$core$Basics$identity,
			formatNumber: function (_v7) {
				return $elm$core$Basics$identity;
			},
			globalBoolLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$BoolType),
			globalDateLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$DateType),
			globalDateTimeLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$DateTimeType),
			globalNumberLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$NumberType),
			globalStringLookup: A3($author$project$DataElement$validateSingletonFieldByRefAndName, allElements, context, $author$project$FieldType$StringType),
			greaterThan: function (_v8) {
				return $elm$core$Basics$append;
			},
			greaterThanOrEqual: function (_v9) {
				return $elm$core$Basics$append;
			},
			hardcodedBool: function (_v10) {
				return _List_Nil;
			},
			hardcodedDate: function (_v11) {
				return _List_Nil;
			},
			hardcodedDateTime: function (_v12) {
				return _List_Nil;
			},
			hardcodedNumber: function (_v13) {
				return _List_Nil;
			},
			hardcodedString: function (_v14) {
				return _List_Nil;
			},
			if_: F4(
				function (_v15, a, b, c) {
					return _Utils_ap(
						a,
						_Utils_ap(b, c));
				}),
			isNotNull: $elm$core$Basics$identity,
			isNull: $elm$core$Basics$identity,
			lessThan: function (_v16) {
				return $elm$core$Basics$append;
			},
			lessThanOrEqual: function (_v17) {
				return $elm$core$Basics$append;
			},
			localBool: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$BoolType),
			localDate: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$DateType),
			localDateTime: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$DateTimeType),
			localNumber: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$NumberType),
			localString: A4($author$project$DataElement$validateFieldTypeByRefAndName, allElements, context, listRef, $author$project$FieldType$StringType),
			max: function (_v18) {
				return $elm$core$Basics$identity;
			},
			min: function (_v19) {
				return $elm$core$Basics$identity;
			},
			monthNumber: $elm$core$Basics$identity,
			multiply: $elm$core$Basics$append,
			not: $elm$core$Basics$identity,
			notEqual: function (_v20) {
				return $elm$core$Basics$append;
			},
			numbersAsList: $elm$core$List$concat,
			pickOne: function (_v21) {
				return $elm$core$Basics$identity;
			},
			product: $elm$core$Basics$identity,
			relatedBool: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$BoolType),
			relatedDate: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$DateType),
			relatedDateTime: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$DateTimeType),
			relatedNumber: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$NumberType),
			relatedString: A4($author$project$DataElement$validateRelatedField, allElements, context, listRef, $author$project$FieldType$StringType),
			round: $elm$core$Basics$identity,
			stringIn: $elm$core$Basics$append,
			stringNotIn: $elm$core$Basics$append,
			stringsAsList: $elm$core$List$concat,
			subtract: $elm$core$Basics$append,
			sum: $elm$core$Basics$identity,
			targetChallengeReasons: $elm$core$Basics$identity,
			yearNumber: $elm$core$Basics$identity
		};
	});
var $author$project$DataElement$validateRelatedField = F6(
	function (elementsByName, context, listRef, fieldType, relationship, fieldName) {
		return _Utils_ap(
			A2(
				$author$project$DataElement$Expression$applyLocalStringList,
				A3($author$project$DataElement$validateLocalTransformer, elementsByName, context, listRef),
				relationship.localIds),
			_Utils_ap(
				A2(
					$author$project$DataElement$Expression$applyLocalString,
					A3($author$project$DataElement$validateLocalTransformer, elementsByName, context, relationship.nextElement),
					relationship.idToMatch),
				_Utils_ap(
					A5($author$project$DataElement$validateFieldTypeByRefAndName, elementsByName, context, relationship.nextElement, fieldType, fieldName),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$Expression$applyLocalBool(
								A3($author$project$DataElement$validateLocalTransformer, elementsByName, context, relationship.nextElement)),
							relationship.optionalFilter)))));
	});
var $author$project$ExpressionInput$localBoolInputPipeline = F2(
	function (viewInfo, ref) {
		return {
			encode: $author$project$DataElement$Expression$applyLocalBool($author$project$DataElement$Expression$encodeTransformer),
			objectTags: $author$project$DataElement$Expression$applyLocalBool(
				A2($author$project$DataElement$objectTagLocalTransformer, viewInfo.dataElements, ref)),
			parse: $author$project$DataElement$ProtoElement$Parse$localBool,
			toDragCmds: $author$project$ExpressionInput$protoLocalBoolDragCmds,
			toModel: A2($author$project$ExpressionInput$LocalBoolInput, viewInfo, ref),
			updateHelper: $author$project$ExpressionInput$updateInputLocalBool,
			validate: $author$project$DataElement$Expression$applyLocalBool(
				A3($author$project$DataElement$validateLocalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput, ref))
		};
	});
var $author$project$ExpressionInput$LocalCompInput = F3(
	function (a, b, c) {
		return {$: 'LocalCompInput', a: a, b: b, c: c};
	});
var $author$project$DataElement$Expression$applyLocalComparable = F2(
	function (transformers, globalComparable) {
		switch (globalComparable.$) {
			case 'LocalCompStringExpr':
				var localString = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyLocalString, transformers, localString);
			case 'LocalCompNumberExpr':
				var localNumber = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyLocalNumber, transformers, localNumber);
			case 'LocalCompDateExpr':
				var localDate = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyLocalDate, transformers, localDate);
			default:
				var localDateTime = globalComparable.a;
				return A2($author$project$DataElement$Expression$applyLocalDateTime, transformers, localDateTime);
		}
	});
var $author$project$DataElement$Expression$LocalCompDateExpr = function (a) {
	return {$: 'LocalCompDateExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompDateTimeExpr = function (a) {
	return {$: 'LocalCompDateTimeExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompNumberExpr = function (a) {
	return {$: 'LocalCompNumberExpr', a: a};
};
var $author$project$DataElement$Expression$LocalCompStringExpr = function (a) {
	return {$: 'LocalCompStringExpr', a: a};
};
var $author$project$DataElement$ProtoElement$Parse$localCompHelper = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringComp':
			var stringProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalCompStringExpr,
				$author$project$DataElement$ProtoElement$Parse$localStringHelper(stringProto));
		case 'ProtoLocalNumberComp':
			var numberProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalCompNumberExpr,
				$author$project$DataElement$ProtoElement$Parse$localNumberHelper(numberProto));
		case 'ProtoLocalDateComp':
			var dateProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalCompDateExpr,
				$author$project$DataElement$ProtoElement$Parse$localDateHelper(dateProto));
		case 'ProtoLocalDateTimeComp':
			var dateTimeProto = proto.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$DataElement$Expression$LocalCompDateTimeExpr,
				$author$project$DataElement$ProtoElement$Parse$localDateTimeHelper(dateTimeProto));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DataElement$ProtoElement$Parse$localComp = $author$project$DataElement$ProtoElement$Parse$wrap($author$project$DataElement$ProtoElement$Parse$localCompHelper);
var $author$project$ExpressionInput$protoLocalCompFieldDragCmds = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringComp':
			var compProto = proto.a;
			return $author$project$ExpressionInput$protoLocalStringDragCmds(compProto);
		case 'ProtoLocalNumberComp':
			var compProto = proto.a;
			return $author$project$ExpressionInput$protoLocalNumberDragCmds(compProto);
		case 'ProtoLocalDateComp':
			var compProto = proto.a;
			return $author$project$ExpressionInput$protoLocalDateDragCmds(compProto);
		case 'ProtoLocalDateTimeComp':
			var compProto = proto.a;
			return $author$project$ExpressionInput$protoLocalDateTimeDragCmds(compProto);
		default:
			var compProto = proto.a;
			return $author$project$ExpressionInput$protoLocalCompDragCmds(compProto);
	}
};
var $author$project$ExpressionInput$selectLocalCompField = function (proto) {
	switch (proto.$) {
		case 'BaseLocalString':
			var localString = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringComp(localString));
		case 'BaseLocalNumber':
			var localNumber = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberComp(localNumber));
		case 'BaseLocalDate':
			var localDate = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateComp(localDate));
		case 'BaseLocalDateTime':
			var localDateTime = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp(localDateTime));
		case 'BaseLocalAny':
			var localAny = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(
					$author$project$DataElement$ProtoExpression$localAnyToComp(localAny)));
		case 'BaseLocalComp':
			var localComp = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ExpressionInput$wrapLocalDateCompField = function (localDate) {
	var _v0 = $author$project$DataElement$ProtoExpression$localDateToComp(localDate);
	if (_v0.$ === 'Just') {
		var localComp = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoLocalDateComp(localDate);
	}
};
var $author$project$ExpressionInput$wrapLocalDateTimeCompField = function (localDateTime) {
	var _v0 = $author$project$DataElement$ProtoExpression$localDateTimeToComp(localDateTime);
	if (_v0.$ === 'Just') {
		var localComp = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp(localDateTime);
	}
};
var $author$project$ExpressionInput$wrapLocalNumberCompField = function (localNumber) {
	var _v0 = $author$project$DataElement$ProtoExpression$localNumberToComp(localNumber);
	if (_v0.$ === 'Just') {
		var localComp = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoLocalNumberComp(localNumber);
	}
};
var $author$project$ExpressionInput$wrapLocalStringCompField = function (localString) {
	var _v0 = $author$project$DataElement$ProtoExpression$localStringToComp(localString);
	if (_v0.$ === 'Just') {
		var localComp = _v0.a;
		return $author$project$DataElement$ProtoExpression$ProtoLocalCompAsCompField(localComp);
	} else {
		return $author$project$DataElement$ProtoExpression$ProtoLocalStringComp(localString);
	}
};
var $author$project$ExpressionInput$updateInputLocalCompFieldChild = F3(
	function (child, inputMsg, localCompField) {
		switch (localCompField.$) {
			case 'ProtoLocalStringComp':
				var localString = localCompField.a;
				return $author$project$ExpressionInput$wrapLocalStringCompField(
					A3($author$project$ExpressionInput$updateInputLocalStringChild, child, inputMsg, localString));
			case 'ProtoLocalNumberComp':
				var localNumber = localCompField.a;
				return $author$project$ExpressionInput$wrapLocalNumberCompField(
					A3($author$project$ExpressionInput$updateInputLocalNumberChild, child, inputMsg, localNumber));
			case 'ProtoLocalDateComp':
				var localDate = localCompField.a;
				return $author$project$ExpressionInput$wrapLocalDateCompField(
					A3($author$project$ExpressionInput$updateInputLocalDateChild, child, inputMsg, localDate));
			case 'ProtoLocalDateTimeComp':
				var localDateTime = localCompField.a;
				return $author$project$ExpressionInput$wrapLocalDateTimeCompField(
					A3($author$project$ExpressionInput$updateInputLocalDateTimeChild, child, inputMsg, localDateTime));
			default:
				var localComp = localCompField.a;
				return A3($author$project$ExpressionInput$updateInputLocalCompChild, child, inputMsg, localComp);
		}
	});
var $author$project$ExpressionInput$updateInputLocalCompField = $author$project$ExpressionInput$updateInputGeneric(
	{
		convert: $elm$core$Basics$identity,
		select: $author$project$ExpressionInput$selectLocalCompField,
		tag: 'Update Local Comp Field',
		updateChild: $author$project$ExpressionInput$updateInputLocalCompFieldChild,
		updateDrag: function (_v0) {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$ExpressionInput$localCompInputPipeline = F2(
	function (viewInfo, ref) {
		return {
			encode: $author$project$DataElement$Expression$applyLocalComparable($author$project$DataElement$Expression$encodeTransformer),
			objectTags: $author$project$DataElement$Expression$applyLocalComparable(
				A2($author$project$DataElement$objectTagLocalTransformer, viewInfo.dataElements, ref)),
			parse: $author$project$DataElement$ProtoElement$Parse$localComp,
			toDragCmds: $author$project$ExpressionInput$protoLocalCompFieldDragCmds,
			toModel: A2($author$project$ExpressionInput$LocalCompInput, viewInfo, ref),
			updateHelper: $author$project$ExpressionInput$updateInputLocalCompField,
			validate: $author$project$DataElement$Expression$applyLocalComparable(
				A3($author$project$DataElement$validateLocalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput, ref))
		};
	});
var $author$project$ExpressionInput$LocalDateInput = F3(
	function (a, b, c) {
		return {$: 'LocalDateInput', a: a, b: b, c: c};
	});
var $author$project$ExpressionInput$localDateInputPipeline = F2(
	function (viewInfo, ref) {
		return {
			encode: $author$project$DataElement$Expression$applyLocalDate($author$project$DataElement$Expression$encodeTransformer),
			objectTags: $author$project$DataElement$Expression$applyLocalDate(
				A2($author$project$DataElement$objectTagLocalTransformer, viewInfo.dataElements, ref)),
			parse: $author$project$DataElement$ProtoElement$Parse$localDate,
			toDragCmds: $author$project$ExpressionInput$protoLocalDateDragCmds,
			toModel: A2($author$project$ExpressionInput$LocalDateInput, viewInfo, ref),
			updateHelper: $author$project$ExpressionInput$updateInputLocalDate,
			validate: $author$project$DataElement$Expression$applyLocalDate(
				A3($author$project$DataElement$validateLocalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput, ref))
		};
	});
var $author$project$ExpressionInput$LocalDateTimeInput = F3(
	function (a, b, c) {
		return {$: 'LocalDateTimeInput', a: a, b: b, c: c};
	});
var $author$project$ExpressionInput$localDateTimeInputPipeline = F2(
	function (viewInfo, ref) {
		return {
			encode: $author$project$DataElement$Expression$applyLocalDateTime($author$project$DataElement$Expression$encodeTransformer),
			objectTags: $author$project$DataElement$Expression$applyLocalDateTime(
				A2($author$project$DataElement$objectTagLocalTransformer, viewInfo.dataElements, ref)),
			parse: $author$project$DataElement$ProtoElement$Parse$localDateTime,
			toDragCmds: $author$project$ExpressionInput$protoLocalDateTimeDragCmds,
			toModel: A2($author$project$ExpressionInput$LocalDateTimeInput, viewInfo, ref),
			updateHelper: $author$project$ExpressionInput$updateInputLocalDateTime,
			validate: $author$project$DataElement$Expression$applyLocalDateTime(
				A3($author$project$DataElement$validateLocalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput, ref))
		};
	});
var $author$project$ExpressionInput$LocalFieldInput = F3(
	function (a, b, c) {
		return {$: 'LocalFieldInput', a: a, b: b, c: c};
	});
var $author$project$ExpressionInput$localFieldInputPipeline = F2(
	function (viewInfo, ref) {
		return {
			encode: $author$project$DataElement$Expression$applyLocalField($author$project$DataElement$Expression$encodeTransformer),
			objectTags: $author$project$DataElement$Expression$applyLocalField(
				A2($author$project$DataElement$objectTagLocalTransformer, viewInfo.dataElements, ref)),
			parse: $author$project$DataElement$ProtoElement$Parse$localField,
			toDragCmds: $author$project$ExpressionInput$protoLocalFieldDragCmds,
			toModel: A2($author$project$ExpressionInput$LocalFieldInput, viewInfo, ref),
			updateHelper: $author$project$ExpressionInput$updateInputLocalField,
			validate: $author$project$DataElement$Expression$applyLocalField(
				A3($author$project$DataElement$validateLocalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput, ref))
		};
	});
var $author$project$ExpressionInput$LocalNumberInput = F3(
	function (a, b, c) {
		return {$: 'LocalNumberInput', a: a, b: b, c: c};
	});
var $author$project$ExpressionInput$localNumberInputPipeline = F2(
	function (viewInfo, ref) {
		return {
			encode: $author$project$DataElement$Expression$applyLocalNumber($author$project$DataElement$Expression$encodeTransformer),
			objectTags: $author$project$DataElement$Expression$applyLocalNumber(
				A2($author$project$DataElement$objectTagLocalTransformer, viewInfo.dataElements, ref)),
			parse: $author$project$DataElement$ProtoElement$Parse$localNumber,
			toDragCmds: $author$project$ExpressionInput$protoLocalNumberDragCmds,
			toModel: A2($author$project$ExpressionInput$LocalNumberInput, viewInfo, ref),
			updateHelper: $author$project$ExpressionInput$updateInputLocalNumber,
			validate: $author$project$DataElement$Expression$applyLocalNumber(
				A3($author$project$DataElement$validateLocalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput, ref))
		};
	});
var $author$project$ExpressionInput$LocalStringInput = F3(
	function (a, b, c) {
		return {$: 'LocalStringInput', a: a, b: b, c: c};
	});
var $author$project$ExpressionInput$localStringInputPipeline = F2(
	function (viewInfo, ref) {
		return {
			encode: $author$project$DataElement$Expression$applyLocalString($author$project$DataElement$Expression$encodeTransformer),
			objectTags: $author$project$DataElement$Expression$applyLocalString(
				A2($author$project$DataElement$objectTagLocalTransformer, viewInfo.dataElements, ref)),
			parse: $author$project$DataElement$ProtoElement$Parse$localString,
			toDragCmds: $author$project$ExpressionInput$protoLocalStringDragCmds,
			toModel: A2($author$project$ExpressionInput$LocalStringInput, viewInfo, ref),
			updateHelper: $author$project$ExpressionInput$updateInputLocalString,
			validate: $author$project$DataElement$Expression$applyLocalString(
				A3($author$project$DataElement$validateLocalTransformer, viewInfo.dataElements, $author$project$StudioApp$Error$InExpressionInput, ref))
		};
	});
var $author$project$ObjectName$encode = function (_v0) {
	var name = _v0.a;
	return $elm$json$Json$Encode$string(name);
};
var $author$project$ExpressionInput$encodeExpressionObjectTags = F3(
	function (getObjectTags, encodeSuccess, success) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'expression',
					encodeSuccess(success)),
					_Utils_Tuple2(
					'objectTags',
					A2(
						$elm$json$Json$Encode$list,
						$author$project$ObjectName$encode,
						getObjectTags(success)))
				]));
	});
var $author$project$ExpressionInput$sendUpdate = _Platform_outgoingPort('sendUpdate', $elm$core$Basics$identity);
var $author$project$ExpressionInput$sendUpdateToJs = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$withDefault($elm$json$Json$Encode$null),
	$author$project$ExpressionInput$sendUpdate);
var $author$project$ExpressionInput$validateInput = function (validate) {
	return $elm$core$Maybe$andThen(
		function (parsed) {
			var _v0 = validate(parsed);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(parsed);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$ExpressionInput$notifySuccessInit = F2(
	function (_v0, input) {
		var parse = _v0.parse;
		var validate = _v0.validate;
		var objectTags = _v0.objectTags;
		var encode = _v0.encode;
		return $author$project$ExpressionInput$sendUpdateToJs(
			A2(
				$elm$core$Maybe$map,
				A2($author$project$ExpressionInput$encodeExpressionObjectTags, objectTags, encode),
				A2(
					$author$project$ExpressionInput$validateInput,
					validate,
					parse(input))));
	});
var $author$project$ExpressionInput$initInputExpression = function (model) {
	switch (model.$) {
		case 'GlobalFieldInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalFieldInputPipeline(viewInfo),
				input);
		case 'GlobalCompInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalCompInputPipeline(viewInfo),
				input);
		case 'GlobalStringInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalStringInputPipeline(viewInfo),
				input);
		case 'GlobalNumberInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalNumberInputPipeline(viewInfo),
				input);
		case 'GlobalDateInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalDateInputPipeline(viewInfo),
				input);
		case 'GlobalDateTimeInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalDateTimeInputPipeline(viewInfo),
				input);
		case 'GlobalBoolInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalBoolInputPipeline(viewInfo),
				input);
		case 'LocalFieldInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				A2($author$project$ExpressionInput$localFieldInputPipeline, viewInfo, ref),
				input);
		case 'LocalCompInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				A2($author$project$ExpressionInput$localCompInputPipeline, viewInfo, ref),
				input);
		case 'LocalStringInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				A2($author$project$ExpressionInput$localStringInputPipeline, viewInfo, ref),
				input);
		case 'LocalNumberInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				A2($author$project$ExpressionInput$localNumberInputPipeline, viewInfo, ref),
				input);
		case 'LocalDateInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				A2($author$project$ExpressionInput$localDateInputPipeline, viewInfo, ref),
				input);
		case 'LocalDateTimeInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				A2($author$project$ExpressionInput$localDateTimeInputPipeline, viewInfo, ref),
				input);
		case 'LocalBoolInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				A2($author$project$ExpressionInput$localBoolInputPipeline, viewInfo, ref),
				input);
		case 'GlobalStringListInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalStringListInputPipeline(viewInfo),
				input);
		case 'GlobalNumberListInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalNumberListInputPipeline(viewInfo),
				input);
		case 'GlobalDateListInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalDateListInputPipeline(viewInfo),
				input);
		case 'GlobalDateTimeListInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalDateTimeListInputPipeline(viewInfo),
				input);
		case 'GlobalBoolListInput':
			var viewInfo = model.a;
			var input = model.b;
			return A2(
				$author$project$ExpressionInput$notifySuccessInit,
				$author$project$ExpressionInput$globalBoolListInputPipeline(viewInfo),
				input);
		default:
			return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$FieldTypeRequirement$AnyType = {$: 'AnyType'};
var $author$project$DataElement$Metadata$ListOfRecords = {$: 'ListOfRecords'};
var $author$project$DataElement$Metadata$Singleton = {$: 'Singleton'};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$SearchOption$Global = {$: 'Global'};
var $author$project$SearchOption$Local = function (a) {
	return {$: 'Local', a: a};
};
var $author$project$DataElement$Reference$Reference = function (a) {
	return {$: 'Reference', a: a};
};
var $danyx23$elm_uuid$Uuid$Uuid = function (a) {
	return {$: 'Uuid', a: a};
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {index: index, match: match, number: number, submatches: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $elm$core$String$toLower = _String_toLower;
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$danyx23$elm_uuid$Uuid$Uuid(
			$elm$core$String$toLower(text))) : $elm$core$Maybe$Nothing;
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $danyx23$elm_uuid$Uuid$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $danyx23$elm_uuid$Uuid$fromString(string);
		if (_v0.$ === 'Just') {
			var uuid = _v0.a;
			return $elm$json$Json$Decode$succeed(uuid);
		} else {
			return $elm$json$Json$Decode$fail('Not a valid UUID');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$DataElement$Reference$recordListReferenceDecoder = A2($elm$json$Json$Decode$map, $author$project$DataElement$Reference$Reference, $danyx23$elm_uuid$Uuid$decoder);
var $author$project$ExpressionInput$contextDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (isGlobal) {
		return isGlobal ? $elm$json$Json$Decode$succeed($author$project$SearchOption$Global) : A2(
			$elm$json$Json$Decode$map,
			$author$project$SearchOption$Local,
			A2($elm$json$Json$Decode$field, 'uuid', $author$project$DataElement$Reference$recordListReferenceDecoder));
	},
	A2($elm$json$Json$Decode$field, 'isGlobal', $elm$json$Json$Decode$bool));
var $elm_community$json_extra$Json$Decode$Extra$fromResult = function (result) {
	if (result.$ === 'Ok') {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $author$project$FieldTypeRequirement$AnyComparableType = {$: 'AnyComparableType'};
var $author$project$FieldTypeRequirement$OneDataType = function (a) {
	return {$: 'OneDataType', a: a};
};
var $author$project$FieldTypeRequirement$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'comparable':
			return $elm$core$Result$Ok($author$project$FieldTypeRequirement$AnyComparableType);
		case 'any':
			return $elm$core$Result$Ok($author$project$FieldTypeRequirement$AnyType);
		case 'string':
			return $elm$core$Result$Ok(
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType));
		case 'int':
			return $elm$core$Result$Ok(
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType));
		case 'float':
			return $elm$core$Result$Ok(
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType));
		case 'number':
			return $elm$core$Result$Ok(
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType));
		case 'date':
			return $elm$core$Result$Ok(
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType));
		case 'datetime':
			return $elm$core$Result$Ok(
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType));
		case 'date/time':
			return $elm$core$Result$Ok(
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType));
		case 'bool':
			return $elm$core$Result$Ok(
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType));
		default:
			return $elm$core$Result$Err('\'' + (words + '\' is not a valid dataType'));
	}
};
var $author$project$FieldTypeRequirement$pickDecoder = A2($elm$core$Basics$composeR, $author$project$FieldTypeRequirement$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult);
var $author$project$FieldTypeRequirement$decoder = A2($elm$json$Json$Decode$andThen, $author$project$FieldTypeRequirement$pickDecoder, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$ExpressionInput$contextAndTypeDecoder = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (a, b, c) {
			return _Utils_Tuple3(a, b, c);
		}),
	$author$project$ExpressionInput$contextDecoder,
	A2(
		$elm$json$Json$Decode$field,
		'dataType',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault($author$project$FieldTypeRequirement$AnyType),
			$elm$json$Json$Decode$nullable($author$project$FieldTypeRequirement$decoder))),
	A2(
		$elm$json$Json$Decode$map,
		function (bool) {
			return bool ? $author$project$DataElement$Metadata$ListOfRecords : $author$project$DataElement$Metadata$Singleton;
		},
		A2($elm$json$Json$Decode$field, 'isListExpression', $elm$json$Json$Decode$bool)));
var $author$project$DataElement$ProtoExpression$ProtoGlobalBoolHardcoded = function (a) {
	return {$: 'ProtoGlobalBoolHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalBoolLookup = F2(
	function (a, b) {
		return {$: 'ProtoGlobalBoolLookup', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateHardcoded = function (a) {
	return {$: 'ProtoGlobalDateHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateLookup = F2(
	function (a, b) {
		return {$: 'ProtoGlobalDateLookup', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeHardcoded = function (a) {
	return {$: 'ProtoGlobalDateTimeHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeLookup = F2(
	function (a, b) {
		return {$: 'ProtoGlobalDateTimeLookup', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalNumberHardcoded = function (a) {
	return {$: 'ProtoGlobalNumberHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalNumberLookup = F2(
	function (a, b) {
		return {$: 'ProtoGlobalNumberLookup', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringHardcoded = function (a) {
	return {$: 'ProtoGlobalStringHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoGlobalStringLookup = F2(
	function (a, b) {
		return {$: 'ProtoGlobalStringLookup', a: a, b: b};
	});
var $author$project$DataElement$ProtoElement$Convert$globalBool = function (expr) {
	switch (expr.$) {
		case 'GlobalBoolLookup':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalBoolLookup, ref, fieldName);
		case 'GlobalBoolHardcoded':
			var bool = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolHardcoded(bool);
		case 'GlobalGTString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalGTString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringB)));
		case 'GlobalGTNumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalGTNumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalGTDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalGTDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateB)));
		case 'GlobalGTDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalGTDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeB)));
		case 'GlobalGTEString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalGTEString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringB)));
		case 'GlobalGTENumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalGTENumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalGTEDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateB)));
		case 'GlobalGTEDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalGTEDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeB)));
		case 'GlobalLTString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalLTString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringB)));
		case 'GlobalLTNumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalLTNumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalLTDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalLTDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateB)));
		case 'GlobalLTDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalLTDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeB)));
		case 'GlobalLTEString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalLTEString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringB)));
		case 'GlobalLTENumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalLTENumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalLTEDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateB)));
		case 'GlobalLTEDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalLTEDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeB)));
		case 'GlobalEqualString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalEqualString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringB)));
		case 'GlobalEqualNumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalEqualNumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalEqualDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateB)));
		case 'GlobalEqualDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalEqualDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeB)));
		case 'GlobalEqualBool':
			var boolA = expr.a;
			var boolB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalEqualBool,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(boolA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(boolB)));
		case 'GlobalNotEqualString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(stringB)));
		case 'GlobalNotEqualNumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualNumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalNotEqualDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(dateB)));
		case 'GlobalNotEqualDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeB)));
		case 'GlobalNotEqualBool':
			var boolA = expr.a;
			var boolB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualBool,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(boolA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(boolB)));
		case 'GlobalStringIn':
			var string = expr.a;
			var stringList = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringIn,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(string)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalStringList(stringList)));
		case 'GlobalStringNotIn':
			var string = expr.a;
			var stringList = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringNotIn,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(string)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalStringList(stringList)));
		case 'GlobalNot':
			var bool = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalNot(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(bool)));
		case 'GlobalBoolIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalBoolIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(elseExpr)));
		case 'GlobalPickBool':
			var boolList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalPickBool(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBoolList(boolList)));
		case 'GlobalAll':
			var boolList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalAll(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBoolList(boolList)));
		case 'GlobalAny':
			var boolList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalAny(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBoolList(boolList)));
		case 'GlobalIsNull':
			var field = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalIsNull(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalField(field)));
		default:
			var field = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalIsNotNull(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalField(field)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalBoolList = function (expr) {
	switch (expr.$) {
		case 'GlobalAllBoolsInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllBoolsInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'GlobalBoolsAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalBoolsAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalBool, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		default:
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalBoolListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBoolList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBoolList(elseExpr)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalComparableList = function (expr) {
	switch (expr.$) {
		case 'GlobalCompStringListExpr':
			var stringList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalCompStringList(
				$author$project$DataElement$ProtoElement$Convert$globalStringList(stringList));
		case 'GlobalCompNumberListExpr':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalCompNumberList(
				$author$project$DataElement$ProtoElement$Convert$globalNumberList(numberList));
		case 'GlobalCompDateListExpr':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateList(
				$author$project$DataElement$ProtoElement$Convert$globalDateList(dateList));
		default:
			var dateTimeList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalCompDateTimeList(
				$author$project$DataElement$ProtoElement$Convert$globalDateTimeList(dateTimeList));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalDate = function (expr) {
	switch (expr.$) {
		case 'GlobalDateLookup':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalDateLookup, ref, fieldName);
		case 'GlobalDateHardcoded':
			var date = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateHardcoded(date);
		case 'GlobalDateTimeToDate':
			var dateTime = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeToDate(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTime)));
		case 'GlobalDateCeiling':
			var dateInterval = expr.a;
			var date = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateCeiling,
				$author$project$Input$Selected(dateInterval),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(date)));
		case 'GlobalDateFloor':
			var dateInterval = expr.a;
			var date = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateFloor,
				$author$project$Input$Selected(dateInterval),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(date)));
		case 'GlobalDateAdd':
			var dateUnit = expr.a;
			var number = expr.b;
			var date = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateAdd,
				$author$project$Input$Selected(dateUnit),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(number)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(date)));
		case 'GlobalDateSubtract':
			var dateUnit = expr.a;
			var number = expr.b;
			var date = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateSubtract,
				$author$project$Input$Selected(dateUnit),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(number)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(date)));
		case 'GlobalDateIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(elseExpr)));
		case 'GlobalPickDate':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalPickDate(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateList(dateList)));
		case 'GlobalMaxDate':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxDate(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateList(dateList)));
		default:
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMinDate(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateList(dateList)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalDateList = function (expr) {
	switch (expr.$) {
		case 'GlobalAllDatesInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllDatesInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'GlobalDatesAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDatesAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalDate, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		default:
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateList(elseExpr)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalDateTime = function (expr) {
	switch (expr.$) {
		case 'GlobalDateTimeLookup':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeLookup, ref, fieldName);
		case 'GlobalDateTimeHardcoded':
			var posix = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeHardcoded(posix);
		case 'GlobalDateTimeIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(elseExpr)));
		case 'GlobalPickDateTime':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalPickDateTime(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTimeList(dateList)));
		case 'GlobalMaxDateTime':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxDateTime(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTimeList(dateList)));
		default:
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMinDateTime(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTimeList(dateList)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalDateTimeList = function (expr) {
	switch (expr.$) {
		case 'GlobalAllDateTimesInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllDateTimesInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'GlobalDateTimesAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimesAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalDateTime, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		default:
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTimeList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTimeList(elseExpr)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalField = function (expr) {
	switch (expr.$) {
		case 'GlobalStringExpr':
			var stringExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalStringField(
				$author$project$DataElement$ProtoElement$Convert$globalString(stringExpr));
		case 'GlobalNumberExpr':
			var numberExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberField(
				$author$project$DataElement$ProtoElement$Convert$globalNumber(numberExpr));
		case 'GlobalDateExpr':
			var dateExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateField(
				$author$project$DataElement$ProtoElement$Convert$globalDate(dateExpr));
		case 'GlobalDateTimeExpr':
			var dateTimeExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeField(
				$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeExpr));
		default:
			var boolExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalBoolField(
				$author$project$DataElement$ProtoElement$Convert$globalBool(boolExpr));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalNumber = function (expr) {
	switch (expr.$) {
		case 'GlobalNumberLookup':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalNumberLookup, ref, fieldName);
		case 'GlobalNumberHardcoded':
			var number = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberHardcoded(number);
		case 'GlobalCountUnique':
			var comparableList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalCountUnique(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalComparableList(comparableList)));
		case 'GlobalRound':
			var number = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalRoundNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(number)));
		case 'GlobalSum':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalSum(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumberList(numberList)));
		case 'GlobalProduct':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalProduct(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumberList(numberList)));
		case 'GlobalAdd':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAdd,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalSubtract':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalSubtract,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalMultiply':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalMultiply,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalDivide':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalDivide,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberB)));
		case 'GlobalMonthNumber':
			var date = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMonthNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(date)));
		case 'GlobalYearNumber':
			var date = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalYearNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(date)));
		case 'GlobalDayInMonth':
			var date = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDayInMonth(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(date)));
		case 'GlobalNumberIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(elseExpr)));
		case 'GlobalPickNumber':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalPickNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumberList(numberList)));
		case 'GlobalMaxNumber':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumberList(numberList)));
		default:
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMinNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumberList(numberList)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalNumberList = function (expr) {
	switch (expr.$) {
		case 'GlobalAllNumbersInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllNumbersInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'GlobalNumbersAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumbersAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalNumber, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		default:
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalNumberListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumberList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumberList(elseExpr)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalString = function (stringExpr) {
	switch (stringExpr.$) {
		case 'GlobalStringLookup':
			var ref = stringExpr.a;
			var fieldName = stringExpr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoGlobalStringLookup, ref, fieldName);
		case 'GlobalStringHardcoded':
			var words = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalStringHardcoded(words);
		case 'GlobalFormatDate':
			var string = stringExpr.a;
			var date = stringExpr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalFormatDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(string)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(date)));
		case 'GlobalFormatDateLocaleAware':
			var date = stringExpr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalFormatDate,
				$author$project$Input$empty,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDate(date)));
		case 'GlobalFormatDateTime':
			var dateTime = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalFormatDateTime(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTime)));
		case 'GlobalFormatNumber':
			var decimals = stringExpr.a;
			var numberExp = stringExpr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalFormatNumber,
				$author$project$IntInput$Selected(decimals),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalNumber(numberExp)));
		case 'GlobalStringIf':
			var ifExpr = stringExpr.a;
			var thenExpr = stringExpr.b;
			var elseExpr = stringExpr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(elseExpr)));
		case 'GlobalPickString':
			var stringList = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalPickString(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalStringList(stringList)));
		case 'GlobalConcat':
			var string = stringExpr.a;
			var stringList = stringExpr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalConcat,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(string)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalStringList(stringList)));
		case 'GlobalMaxString':
			var stringList = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMaxString(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalStringList(stringList)));
		default:
			var stringList = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalMinString(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalStringList(stringList)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$globalStringList = function (expr) {
	switch (expr.$) {
		case 'GlobalAllStringsInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalAllStringsInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'GlobalStringsAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringsAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalString, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		case 'GlobalStringListIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoGlobalStringListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalStringList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalStringList(elseExpr)));
		case 'GlobalChallengeReasons':
			var acctId = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalChallengeReasons(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(acctId)));
		default:
			var acctId = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalTargetChallengeReasons(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$globalString(acctId)));
	}
};
var $author$project$ComparableType$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'string':
			return $elm$core$Result$Ok($author$project$ComparableType$StringComp);
		case 'int':
			return $elm$core$Result$Ok($author$project$ComparableType$NumberComp);
		case 'float':
			return $elm$core$Result$Ok($author$project$ComparableType$NumberComp);
		case 'number':
			return $elm$core$Result$Ok($author$project$ComparableType$NumberComp);
		case 'date':
			return $elm$core$Result$Ok($author$project$ComparableType$DateComp);
		case 'date/time':
			return $elm$core$Result$Ok($author$project$ComparableType$DateTimeComp);
		case 'datetime':
			return $elm$core$Result$Ok($author$project$ComparableType$DateTimeComp);
		default:
			return $elm$core$Result$Err('\'' + (words + '\' is not a valid ComparableType'));
	}
};
var $author$project$ComparableType$pickDecoder = A2($elm$core$Basics$composeR, $author$project$ComparableType$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult);
var $author$project$ComparableType$decoder = A2($elm$json$Json$Decode$andThen, $author$project$ComparableType$pickDecoder, $elm$json$Json$Decode$string);
var $author$project$DataElement$Expression$compareDecoder = function (info) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (comp) {
			switch (comp.$) {
				case 'StringComp':
					return A3(
						$elm$json$Json$Decode$map2,
						info.stringCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.stringDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.stringDecoder));
				case 'NumberComp':
					return A3(
						$elm$json$Json$Decode$map2,
						info.numberCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.numberDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.numberDecoder));
				case 'DateComp':
					return A3(
						$elm$json$Json$Decode$map2,
						info.dateCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.dateDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.dateDecoder));
				default:
					return A3(
						$elm$json$Json$Decode$map2,
						info.dateTimeCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.dateTimeDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.dateTimeDecoder));
			}
		},
		A2($elm$json$Json$Decode$field, 'inputDataType', $author$project$ComparableType$decoder));
};
var $author$project$FieldType$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'string':
			return $elm$core$Result$Ok($author$project$FieldType$StringType);
		case 'int':
			return $elm$core$Result$Ok($author$project$FieldType$NumberType);
		case 'integer':
			return $elm$core$Result$Ok($author$project$FieldType$NumberType);
		case 'float':
			return $elm$core$Result$Ok($author$project$FieldType$NumberType);
		case 'number':
			return $elm$core$Result$Ok($author$project$FieldType$NumberType);
		case 'date':
			return $elm$core$Result$Ok($author$project$FieldType$DateType);
		case 'date/time':
			return $elm$core$Result$Ok($author$project$FieldType$DateTimeType);
		case 'datetime':
			return $elm$core$Result$Ok($author$project$FieldType$DateTimeType);
		case 'bool':
			return $elm$core$Result$Ok($author$project$FieldType$BoolType);
		case 'boolean':
			return $elm$core$Result$Ok($author$project$FieldType$BoolType);
		default:
			return $elm$core$Result$Err('\'' + (words + '\' is not a valid FieldType'));
	}
};
var $author$project$FieldType$pickDecoder = A2($elm$core$Basics$composeR, $author$project$FieldType$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult);
var $author$project$FieldType$decoder = A2($elm$json$Json$Decode$andThen, $author$project$FieldType$pickDecoder, $elm$json$Json$Decode$string);
var $author$project$DataElement$Expression$compareFieldDecoder = function (info) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A3(
						$elm$json$Json$Decode$map2,
						info.stringCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.stringDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.stringDecoder));
				case 'NumberType':
					return A3(
						$elm$json$Json$Decode$map2,
						info.numberCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.numberDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.numberDecoder));
				case 'DateType':
					return A3(
						$elm$json$Json$Decode$map2,
						info.dateCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.dateDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.dateDecoder));
				case 'DateTimeType':
					return A3(
						$elm$json$Json$Decode$map2,
						info.dateTimeCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.dateTimeDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.dateTimeDecoder));
				default:
					return A3(
						$elm$json$Json$Decode$map2,
						info.boolCompare,
						A2($elm$json$Json$Decode$field, 'expression1', info.boolDecoder),
						A2($elm$json$Json$Decode$field, 'expression2', info.boolDecoder));
			}
		},
		A2($elm$json$Json$Decode$field, 'inputDataType', $author$project$FieldType$decoder));
};
var $author$project$DataElement$Expression$confirmDataType = F2(
	function (intendedType, innerDecoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (fieldType) {
				return _Utils_eq(fieldType, intendedType) ? innerDecoder : $elm$json$Json$Decode$fail(
					'dataType should be ' + ($author$project$FieldType$toString(intendedType) + (' but it is ' + $author$project$FieldType$toString(fieldType))));
			},
			A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.problem;
	if (problem.$ === 'Problem') {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (result.$ === 'Ok') {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 'MonthAndDay', a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 'OrdinalDay', a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 'WeekAndWeekday', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0.a;
	return $elm$parser$Parser$Advanced$Parser(
		function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 'Bad') {
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, false, x);
			} else {
				var a = _v1.b;
				var s1 = _v1.c;
				return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
			}
		});
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, true, a, s);
		});
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(_Utils_Tuple0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m.$) {
			case 'Jan':
				return 0;
			case 'Feb':
				return 31;
			case 'Mar':
				return 59 + leapDays;
			case 'Apr':
				return 90 + leapDays;
			case 'May':
				return 120 + leapDays;
			case 'Jun':
				return 151 + leapDays;
			case 'Jul':
				return 181 + leapDays;
			case 'Aug':
				return 212 + leapDays;
			case 'Sep':
				return 243 + leapDays;
			case 'Oct':
				return 273 + leapDays;
			case 'Nov':
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeYear(y) + A2(
					$justinmimbs$date$Date$daysBeforeMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + d)));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				$justinmimbs$date$Date$daysBeforeYear(y) + od));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$RD(
		$justinmimbs$date$Date$daysBeforeYear(y) + 1);
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn)));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 'MonthAndDay':
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 'WeekAndWeekday':
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(_Utils_Tuple0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return _Utils_eq(
											c,
											_Utils_chr('-'));
									}),
									$elm$parser$Parser$succeed(_Utils_Tuple0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (result.$ === 'Ok') {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq(
										_Utils_chr('T')))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$DataElement$Expression$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$DateInterval$Month = {$: 'Month'};
var $author$project$DateInterval$Quarter = {$: 'Quarter'};
var $author$project$DateInterval$Week = {$: 'Week'};
var $author$project$DateInterval$Year = {$: 'Year'};
var $author$project$DateInterval$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'week':
			return $elm$core$Result$Ok($author$project$DateInterval$Week);
		case 'month':
			return $elm$core$Result$Ok($author$project$DateInterval$Month);
		case 'quarter':
			return $elm$core$Result$Ok($author$project$DateInterval$Quarter);
		case 'year':
			return $elm$core$Result$Ok($author$project$DateInterval$Year);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a Date Interval'));
	}
};
var $author$project$DateInterval$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DateInterval$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$DateUnit$Days = {$: 'Days'};
var $author$project$DateUnit$Months = {$: 'Months'};
var $author$project$DateUnit$Weeks = {$: 'Weeks'};
var $author$project$DateUnit$Years = {$: 'Years'};
var $author$project$DateUnit$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'days':
			return $elm$core$Result$Ok($author$project$DateUnit$Days);
		case 'weeks':
			return $elm$core$Result$Ok($author$project$DateUnit$Weeks);
		case 'months':
			return $elm$core$Result$Ok($author$project$DateUnit$Months);
		case 'years':
			return $elm$core$Result$Ok($author$project$DateUnit$Years);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a Date Unit'));
	}
};
var $author$project$DateUnit$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DateUnit$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$FieldName$decoder = A2($elm$json$Json$Decode$map, $author$project$FieldName$FieldName, $elm$json$Json$Decode$string);
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString = function (p) {
	switch (p.$) {
		case 'Expecting':
			var s = p.a;
			return 'expecting \'' + (s + '\'');
		case 'ExpectingInt':
			return 'expecting int';
		case 'ExpectingHex':
			return 'expecting hex';
		case 'ExpectingOctal':
			return 'expecting octal';
		case 'ExpectingBinary':
			return 'expecting binary';
		case 'ExpectingFloat':
			return 'expecting float';
		case 'ExpectingNumber':
			return 'expecting number';
		case 'ExpectingVariable':
			return 'expecting variable';
		case 'ExpectingSymbol':
			var s = p.a;
			return 'expecting symbol \'' + (s + '\'');
		case 'ExpectingKeyword':
			var s = p.a;
			return 'expecting keyword \'' + (s + '\'');
		case 'ExpectingEnd':
			return 'expecting end';
		case 'UnexpectedChar':
			return 'unexpected char';
		case 'Problem':
			var s = p.a;
			return 'problem ' + s;
		default:
			return 'bad repeat';
	}
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString = function (deadend) {
	return $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString(deadend.problem) + (' at row ' + ($elm$core$String$fromInt(deadend.row) + (', col ' + $elm$core$String$fromInt(deadend.col))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString = function (deadEnds) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			'; ',
			A2($elm$core$List$map, $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString, deadEnds)));
};
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (_v0.$ === 'Just') {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = function (a) {
	return {$: 'Posix', a: a};
};
var $elm$time$Time$millisToPosix = $elm$time$Time$Posix;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0.a;
			var _v1 = parse(s0);
			if (_v1.$ === 'Good') {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (step.$ === 'Loop') {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
			});
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (step.$ === 'Loop') {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (_v0.$ === 'Just') {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 'ExpectingSymbol', a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 'Err') {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$DataElement$Expression$ifDecoder = F3(
	function (maker, boolDecoder, innerDecoder) {
		return A4(
			$elm$json$Json$Decode$map3,
			maker,
			A2($elm$json$Json$Decode$field, 'ifExpression', boolDecoder),
			A2($elm$json$Json$Decode$field, 'thenExpression', innerDecoder),
			A2($elm$json$Json$Decode$field, 'elseExpression', innerDecoder));
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $elm_community$json_extra$Json$Decode$Extra$optionalField = F2(
	function (fieldName, decoder) {
		var finishDecoding = function (json) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$value),
				json);
			if (_v0.$ === 'Ok') {
				var val = _v0.a;
				return A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$field, fieldName, decoder));
			} else {
				return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
			}
		};
		return A2($elm$json$Json$Decode$andThen, finishDecoding, $elm$json$Json$Decode$value);
	});
var $elm_community$json_extra$Json$Decode$Extra$optionalNullableField = F2(
	function (fieldName, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$andThen($elm$core$Basics$identity),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalField,
				fieldName,
				$elm$json$Json$Decode$nullable(decoder)));
	});
var $author$project$DataElement$Expression$pickOneDecoder = F2(
	function (maker, listDecoder) {
		return A2(
			$elm$json$Json$Decode$map,
			maker,
			A2($elm$json$Json$Decode$field, 'expression', listDecoder));
	});
var $author$project$DataElement$Reference$singletonReferenceDecoder = A2($elm$json$Json$Decode$map, $author$project$DataElement$Reference$Reference, $danyx23$elm_uuid$Uuid$decoder);
var $author$project$DataElement$Expression$typeDecoder = function (pickDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		pickDecoder,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
};
function $author$project$DataElement$Expression$cyclic$globalBoolDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$BoolType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v11 = $elm$core$String$toLower(words);
				switch (_v11) {
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalBoolLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalBoolHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$bool));
					case 'gt':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$GlobalGTDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalGTDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalGTNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalGTString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'gte':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$GlobalGTEDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalGTEDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalGTENumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalGTEString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'lt':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$GlobalLTDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalLTDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalLTNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalLTString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'lte':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$GlobalLTEDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalLTEDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalLTENumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalLTEString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'equal':
						return $author$project$DataElement$Expression$compareFieldDecoder(
							{
								boolCompare: $author$project$DataElement$Expression$GlobalEqualBool,
								boolDecoder: $author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
								dateCompare: $author$project$DataElement$Expression$GlobalEqualDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalEqualDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalEqualNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalEqualString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'not equal':
						return $author$project$DataElement$Expression$compareFieldDecoder(
							{
								boolCompare: $author$project$DataElement$Expression$GlobalNotEqualBool,
								boolDecoder: $author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
								dateCompare: $author$project$DataElement$Expression$GlobalNotEqualDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$globalDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$GlobalNotEqualDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$GlobalNotEqualNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$globalNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$GlobalNotEqualString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$globalStringDecoder()
							});
					case 'in':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalStringIn,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'not in':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalStringNotIn,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'not':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalNot,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalBoolDecoder()));
					case 'all':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalAll,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalBoolListDecoder()));
					case 'any':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalAny,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalBoolListDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickBool,
							$author$project$DataElement$Expression$cyclic$globalBoolListDecoder());
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalBoolIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder());
					case 'is null':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalIsNull,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalFieldDecoder()));
					case 'is not null':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalIsNotNull,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalFieldDecoder()));
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Bool Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalBoolListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$BoolType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v10 = $elm$core$String$toLower(words);
				switch (_v10) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllBoolsInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalBoolsAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalBoolDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalBoolListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalBoolListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Bool List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalComparableListDecoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalCompStringListExpr,
						$author$project$DataElement$Expression$cyclic$globalStringListDecoder());
				case 'NumberType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalCompNumberListExpr,
						$author$project$DataElement$Expression$cyclic$globalNumberListDecoder());
				case 'DateType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalCompDateListExpr,
						$author$project$DataElement$Expression$cyclic$globalDateListDecoder());
				case 'DateTimeType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalCompDateTimeListExpr,
						$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder());
				default:
					return $elm$json$Json$Decode$fail(
						'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported as a Global Comparable List Expression'));
			}
		},
		A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
}
function $author$project$DataElement$Expression$cyclic$globalDateDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v8 = $elm$core$String$toLower(words);
				switch (_v8) {
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDateLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDateHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$dateDecoder));
					case 'date/time to date':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDateTimeToDate,
							A2(
								$elm$json$Json$Decode$field,
								'dateTimeExpression',
								$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder()));
					case 'date ceiling':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDateCeiling,
							A2($elm$json$Json$Decode$field, 'dateInterval', $author$project$DateInterval$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date floor':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDateFloor,
							A2($elm$json$Json$Decode$field, 'dateInterval', $author$project$DateInterval$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date addition':
						return A4(
							$elm$json$Json$Decode$map3,
							$author$project$DataElement$Expression$GlobalDateAdd,
							A2($elm$json$Json$Decode$field, 'dateUnit', $author$project$DateUnit$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date subtraction':
						return A4(
							$elm$json$Json$Decode$map3,
							$author$project$DataElement$Expression$GlobalDateSubtract,
							A2($elm$json$Json$Decode$field, 'dateUnit', $author$project$DateUnit$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickDate,
							$author$project$DataElement$Expression$cyclic$globalDateListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMaxDate,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMinDate,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalDateIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalDateDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Date Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalDateListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v7 = $elm$core$String$toLower(words);
				switch (_v7) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllDatesInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDatesAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalDateDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalDateListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalDateListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Date List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateTimeType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v6 = $elm$core$String$toLower(words);
				switch (_v6) {
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDateTimeLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDateTimeHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickDateTime,
							$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMaxDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMinDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalDateTimeIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global DateTime Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateTimeType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v5 = $elm$core$String$toLower(words);
				switch (_v5) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllDateTimesInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDateTimesAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalDateTimeListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global DateTime List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalFieldDecoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalStringExpr,
						$author$project$DataElement$Expression$cyclic$globalStringDecoder());
				case 'NumberType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalNumberExpr,
						$author$project$DataElement$Expression$cyclic$globalNumberDecoder());
				case 'DateType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalDateExpr,
						$author$project$DataElement$Expression$cyclic$globalDateDecoder());
				case 'DateTimeType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalDateTimeExpr,
						$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder());
				default:
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$GlobalBoolExpr,
						$author$project$DataElement$Expression$cyclic$globalBoolDecoder());
			}
		},
		A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
}
function $author$project$DataElement$Expression$cyclic$globalNumberDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$NumberType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v3 = $elm$core$String$toLower(words);
				switch (_v3) {
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalNumberLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalNumberHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$float));
					case 'count unique':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalCountUnique,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalComparableListDecoder()));
					case 'round number':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalRound,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'sum':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalSum,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberListDecoder()));
					case 'product':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalProduct,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberListDecoder()));
					case 'add number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAdd,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'subtract number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalSubtract,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'multiply number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalMultiply,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'divide number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalDivide,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'date month':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMonthNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date year':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalYearNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'date day in month':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalDayInMonth,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickNumber,
							$author$project$DataElement$Expression$cyclic$globalNumberListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMaxNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMinNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalNumberIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalNumberDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Float Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalNumberListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$NumberType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v2 = $elm$core$String$toLower(words);
				switch (_v2) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllNumbersInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalNumbersAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalNumberDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalNumberListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalNumberListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global Number List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalStringDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$StringType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v1 = $elm$core$String$toLower(words);
				switch (_v1) {
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalStringHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalStringLookup,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'format date':
						return A3(
							$elm$json$Json$Decode$map2,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($author$project$DataElement$Expression$GlobalFormatDate),
								$elm$core$Maybe$withDefault($author$project$DataElement$Expression$GlobalFormatDateLocaleAware)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'formatExpression',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'dateExpression',
								$author$project$DataElement$Expression$cyclic$globalDateDecoder()));
					case 'format date/time':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalFormatDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'dateTimeExpression',
								$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder()));
					case 'float to string':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalFormatNumber,
							A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'number to string':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalFormatNumber,
							A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalNumberDecoder()));
					case 'concat':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalConcat,
							A2(
								$elm$json$Json$Decode$field,
								'joinExpression',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'listExpression',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$GlobalPickString,
							$author$project$DataElement$Expression$cyclic$globalStringListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMaxString,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalMinString,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalStringListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalStringIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalStringDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global String Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$globalStringListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$StringType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v0 = $elm$core$String$toLower(words);
				switch (_v0) {
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$GlobalAllStringsInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalStringsAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$globalStringDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$GlobalStringListIf,
							$author$project$DataElement$Expression$cyclic$globalBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$globalStringListDecoder());
					case 'challenge reasons':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalChallengeReasons,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()));
					case 'target challenge reasons':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$GlobalTargetChallengeReasons,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$globalStringDecoder()));
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Global String List Expression'));
				}
			}));
}
try {
	var $author$project$DataElement$Expression$globalBoolDecoder = $author$project$DataElement$Expression$cyclic$globalBoolDecoder();
	$author$project$DataElement$Expression$cyclic$globalBoolDecoder = function () {
		return $author$project$DataElement$Expression$globalBoolDecoder;
	};
	var $author$project$DataElement$Expression$globalBoolListDecoder = $author$project$DataElement$Expression$cyclic$globalBoolListDecoder();
	$author$project$DataElement$Expression$cyclic$globalBoolListDecoder = function () {
		return $author$project$DataElement$Expression$globalBoolListDecoder;
	};
	var $author$project$DataElement$Expression$globalComparableListDecoder = $author$project$DataElement$Expression$cyclic$globalComparableListDecoder();
	$author$project$DataElement$Expression$cyclic$globalComparableListDecoder = function () {
		return $author$project$DataElement$Expression$globalComparableListDecoder;
	};
	var $author$project$DataElement$Expression$globalDateDecoder = $author$project$DataElement$Expression$cyclic$globalDateDecoder();
	$author$project$DataElement$Expression$cyclic$globalDateDecoder = function () {
		return $author$project$DataElement$Expression$globalDateDecoder;
	};
	var $author$project$DataElement$Expression$globalDateListDecoder = $author$project$DataElement$Expression$cyclic$globalDateListDecoder();
	$author$project$DataElement$Expression$cyclic$globalDateListDecoder = function () {
		return $author$project$DataElement$Expression$globalDateListDecoder;
	};
	var $author$project$DataElement$Expression$globalDateTimeDecoder = $author$project$DataElement$Expression$cyclic$globalDateTimeDecoder();
	$author$project$DataElement$Expression$cyclic$globalDateTimeDecoder = function () {
		return $author$project$DataElement$Expression$globalDateTimeDecoder;
	};
	var $author$project$DataElement$Expression$globalDateTimeListDecoder = $author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder();
	$author$project$DataElement$Expression$cyclic$globalDateTimeListDecoder = function () {
		return $author$project$DataElement$Expression$globalDateTimeListDecoder;
	};
	var $author$project$DataElement$Expression$globalFieldDecoder = $author$project$DataElement$Expression$cyclic$globalFieldDecoder();
	$author$project$DataElement$Expression$cyclic$globalFieldDecoder = function () {
		return $author$project$DataElement$Expression$globalFieldDecoder;
	};
	var $author$project$DataElement$Expression$globalNumberDecoder = $author$project$DataElement$Expression$cyclic$globalNumberDecoder();
	$author$project$DataElement$Expression$cyclic$globalNumberDecoder = function () {
		return $author$project$DataElement$Expression$globalNumberDecoder;
	};
	var $author$project$DataElement$Expression$globalNumberListDecoder = $author$project$DataElement$Expression$cyclic$globalNumberListDecoder();
	$author$project$DataElement$Expression$cyclic$globalNumberListDecoder = function () {
		return $author$project$DataElement$Expression$globalNumberListDecoder;
	};
	var $author$project$DataElement$Expression$globalStringDecoder = $author$project$DataElement$Expression$cyclic$globalStringDecoder();
	$author$project$DataElement$Expression$cyclic$globalStringDecoder = function () {
		return $author$project$DataElement$Expression$globalStringDecoder;
	};
	var $author$project$DataElement$Expression$globalStringListDecoder = $author$project$DataElement$Expression$cyclic$globalStringListDecoder();
	$author$project$DataElement$Expression$cyclic$globalStringListDecoder = function () {
		return $author$project$DataElement$Expression$globalStringListDecoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    globalBoolDecoder\n  │     ↓\n  │    globalBoolListDecoder\n  │     ↓\n  │    globalComparableListDecoder\n  │     ↓\n  │    globalDateDecoder\n  │     ↓\n  │    globalDateListDecoder\n  │     ↓\n  │    globalDateTimeDecoder\n  │     ↓\n  │    globalDateTimeListDecoder\n  │     ↓\n  │    globalFieldDecoder\n  │     ↓\n  │    globalNumberDecoder\n  │     ↓\n  │    globalNumberListDecoder\n  │     ↓\n  │    globalStringDecoder\n  │     ↓\n  │    globalStringListDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$ProtoElement$Convert$globalComparable = function (compExpr) {
	switch (compExpr.$) {
		case 'GlobalCompStringExpr':
			var stringExpr = compExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalStringComp(
				$author$project$DataElement$ProtoElement$Convert$globalString(stringExpr));
		case 'GlobalCompNumberExpr':
			var numberExpr = compExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalNumberComp(
				$author$project$DataElement$ProtoElement$Convert$globalNumber(numberExpr));
		case 'GlobalCompDateExpr':
			var dateExpr = compExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateComp(
				$author$project$DataElement$ProtoElement$Convert$globalDate(dateExpr));
		default:
			var dateTimeExpr = compExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeComp(
				$author$project$DataElement$ProtoElement$Convert$globalDateTime(dateTimeExpr));
	}
};
var $author$project$DataElement$Expression$globalComparableDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (fieldType) {
		switch (fieldType.$) {
			case 'StringType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$GlobalCompStringExpr, $author$project$DataElement$Expression$globalStringDecoder);
			case 'NumberType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$GlobalCompNumberExpr, $author$project$DataElement$Expression$globalNumberDecoder);
			case 'DateType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$GlobalCompDateExpr, $author$project$DataElement$Expression$globalDateDecoder);
			case 'DateTimeType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$GlobalCompDateTimeExpr, $author$project$DataElement$Expression$globalDateTimeDecoder);
			default:
				return $elm$json$Json$Decode$fail(
					'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported as a Global Comparable Expression'));
		}
	},
	A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
var $author$project$DataElement$ProtoExpression$ProtoLocalBool = function (a) {
	return {$: 'ProtoLocalBool', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalBoolHardcoded = function (a) {
	return {$: 'ProtoLocalBoolHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalBoolLookup = F2(
	function (a, b) {
		return {$: 'ProtoLocalBoolLookup', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDate = function (a) {
	return {$: 'ProtoLocalDate', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateHardcoded = function (a) {
	return {$: 'ProtoLocalDateHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateLookup = F2(
	function (a, b) {
		return {$: 'ProtoLocalDateLookup', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTime = function (a) {
	return {$: 'ProtoLocalDateTime', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeHardcoded = function (a) {
	return {$: 'ProtoLocalDateTimeHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeLookup = F2(
	function (a, b) {
		return {$: 'ProtoLocalDateTimeLookup', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalNumber = function (a) {
	return {$: 'ProtoLocalNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalNumberHardcoded = function (a) {
	return {$: 'ProtoLocalNumberHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalNumberLookup = F2(
	function (a, b) {
		return {$: 'ProtoLocalNumberLookup', a: a, b: b};
	});
var $author$project$DataElement$ProtoExpression$ProtoLocalString = function (a) {
	return {$: 'ProtoLocalString', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalStringHardcoded = function (a) {
	return {$: 'ProtoLocalStringHardcoded', a: a};
};
var $author$project$DataElement$ProtoExpression$ProtoLocalStringLookup = F2(
	function (a, b) {
		return {$: 'ProtoLocalStringLookup', a: a, b: b};
	});
var $author$project$Input$fromMaybe = function (maybeA) {
	if (maybeA.$ === 'Just') {
		var a = maybeA.a;
		return $author$project$Input$Selected(a);
	} else {
		return $author$project$Input$empty;
	}
};
var $author$project$DataElement$ProtoElement$Convert$convertRelationship = function (info) {
	return {
		idToMatch: $author$project$Input$Selected(
			$author$project$DataElement$ProtoElement$Convert$localString(info.idToMatch)),
		localIds: $author$project$Input$Selected(
			$author$project$DataElement$ProtoElement$Convert$localStringList(info.localIds)),
		nextElement: $author$project$Input$Selected(info.nextElement),
		optionalFilter: $author$project$Input$fromMaybe(
			A2($elm$core$Maybe$map, $author$project$DataElement$ProtoElement$Convert$localBool, info.optionalFilter))
	};
};
var $author$project$DataElement$ProtoElement$Convert$localBool = function (expr) {
	switch (expr.$) {
		case 'LocalBool':
			var fieldName = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalBool(fieldName);
		case 'LocalSingletonBool':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalBoolLookup, ref, fieldName);
		case 'LocalBoolHardcoded':
			var bool = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalBoolHardcoded(bool);
		case 'LocalGTString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalGTString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringB)));
		case 'LocalGTNumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalGTNumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalGTDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalGTDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateB)));
		case 'LocalGTDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalGTDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeB)));
		case 'LocalGTEString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalGTEString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringB)));
		case 'LocalGTENumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalGTENumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalGTEDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalGTEDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateB)));
		case 'LocalGTEDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalGTEDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeB)));
		case 'LocalLTString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalLTString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringB)));
		case 'LocalLTNumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalLTNumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalLTDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalLTDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateB)));
		case 'LocalLTDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalLTDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeB)));
		case 'LocalLTEString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalLTEString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringB)));
		case 'LocalLTENumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalLTENumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalLTEDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalLTEDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateB)));
		case 'LocalLTEDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalLTEDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeB)));
		case 'LocalEqualString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalEqualString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringB)));
		case 'LocalEqualNumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalEqualNumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalEqualDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalEqualDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateB)));
		case 'LocalEqualDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalEqualDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeB)));
		case 'LocalEqualBool':
			var boolA = expr.a;
			var boolB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalEqualBool,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(boolA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(boolB)));
		case 'LocalNotEqualString':
			var stringA = expr.a;
			var stringB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualString,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(stringB)));
		case 'LocalNotEqualNumber':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualNumber,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalNotEqualDate':
			var dateA = expr.a;
			var dateB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(dateB)));
		case 'LocalNotEqualDateTime':
			var dateTimeA = expr.a;
			var dateTimeB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualDateTime,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeB)));
		case 'LocalNotEqualBool':
			var boolA = expr.a;
			var boolB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalNotEqualBool,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(boolA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(boolB)));
		case 'LocalStringIn':
			var string = expr.a;
			var stringList = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringIn,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(string)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localStringList(stringList)));
		case 'LocalStringNotIn':
			var string = expr.a;
			var stringList = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringNotIn,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(string)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localStringList(stringList)));
		case 'LocalNot':
			var bool = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalNot(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(bool)));
		case 'LocalBoolIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalBoolIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(elseExpr)));
		case 'LocalPickBool':
			var boolList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalPickBool(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBoolList(boolList)));
		case 'LocalAll':
			var boolList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalAll(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBoolList(boolList)));
		case 'LocalAny':
			var boolList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalAny(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBoolList(boolList)));
		case 'LocalIsNull':
			var field = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalIsNull(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localField(field)));
		default:
			var field = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalIsNotNull(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localField(field)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localBoolList = function (expr) {
	switch (expr.$) {
		case 'RelatedBool':
			var relationship = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedBool,
				$author$project$DataElement$ProtoElement$Convert$convertRelationship(relationship),
				$author$project$Input$Selected(fieldName));
		case 'LocalAllBoolsInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllBoolsInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'LocalBoolsAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalBoolsAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localBool, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		default:
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalBoolListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBoolList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBoolList(elseExpr)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localComparableList = function (expr) {
	switch (expr.$) {
		case 'LocalCompStringListExpr':
			var stringList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCompStringList(
				$author$project$DataElement$ProtoElement$Convert$localStringList(stringList));
		case 'LocalCompNumberListExpr':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCompNumberList(
				$author$project$DataElement$ProtoElement$Convert$localNumberList(numberList));
		case 'LocalCompDateListExpr':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateList(
				$author$project$DataElement$ProtoElement$Convert$localDateList(dateList));
		default:
			var dateTimeList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCompDateTimeList(
				$author$project$DataElement$ProtoElement$Convert$localDateTimeList(dateTimeList));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localDate = function (expr) {
	switch (expr.$) {
		case 'LocalDate':
			var fieldName = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDate(fieldName);
		case 'LocalSingletonDate':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalDateLookup, ref, fieldName);
		case 'LocalDateHardcoded':
			var date = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateHardcoded(date);
		case 'LocalDateTimeToDate':
			var dateTime = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeToDate(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTime)));
		case 'LocalDateCeiling':
			var dateInterval = expr.a;
			var date = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateCeiling,
				$author$project$Input$Selected(dateInterval),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(date)));
		case 'LocalDateFloor':
			var dateInterval = expr.a;
			var date = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateFloor,
				$author$project$Input$Selected(dateInterval),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(date)));
		case 'LocalDateAdd':
			var dateUnit = expr.a;
			var number = expr.b;
			var date = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateAdd,
				$author$project$Input$Selected(dateUnit),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(number)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(date)));
		case 'LocalDateSubtract':
			var dateUnit = expr.a;
			var number = expr.b;
			var date = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateSubtract,
				$author$project$Input$Selected(dateUnit),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(number)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(date)));
		case 'LocalDateIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(elseExpr)));
		case 'LocalPickDate':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalPickDate(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateList(dateList)));
		case 'LocalMaxDate':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMaxDate(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateList(dateList)));
		default:
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMinDate(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateList(dateList)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localDateList = function (expr) {
	switch (expr.$) {
		case 'RelatedDate':
			var relationship = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedDate,
				$author$project$DataElement$ProtoElement$Convert$convertRelationship(relationship),
				$author$project$Input$Selected(fieldName));
		case 'LocalAllDatesInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllDatesInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'LocalDatesAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalDatesAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localDate, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		default:
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateList(elseExpr)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localDateTime = function (expr) {
	switch (expr.$) {
		case 'LocalDateTime':
			var fieldName = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateTime(fieldName);
		case 'LocalSingletonDateTime':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalDateTimeLookup, ref, fieldName);
		case 'LocalDateTimeHardcoded':
			var date = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeHardcoded(date);
		case 'LocalDateTimeIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(elseExpr)));
		case 'LocalPickDateTime':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalPickDateTime(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTimeList(dateList)));
		case 'LocalMaxDateTime':
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMaxDateTime(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTimeList(dateList)));
		default:
			var dateList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMinDateTime(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTimeList(dateList)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localDateTimeList = function (expr) {
	switch (expr.$) {
		case 'RelatedDateTime':
			var relationship = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedDateTime,
				$author$project$DataElement$ProtoElement$Convert$convertRelationship(relationship),
				$author$project$Input$Selected(fieldName));
		case 'LocalAllDateTimesInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllDateTimesInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'LocalDateTimesAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimesAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localDateTime, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		default:
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTimeList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTimeList(elseExpr)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localField = function (expr) {
	switch (expr.$) {
		case 'LocalStringExpr':
			var stringExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalStringField(
				$author$project$DataElement$ProtoElement$Convert$localString(stringExpr));
		case 'LocalNumberExpr':
			var numberExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalNumberField(
				$author$project$DataElement$ProtoElement$Convert$localNumber(numberExpr));
		case 'LocalDateExpr':
			var dateExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateField(
				$author$project$DataElement$ProtoElement$Convert$localDate(dateExpr));
		case 'LocalDateTimeExpr':
			var dateTimeExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeField(
				$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeExpr));
		default:
			var boolExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalBoolField(
				$author$project$DataElement$ProtoElement$Convert$localBool(boolExpr));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localNumber = function (expr) {
	switch (expr.$) {
		case 'LocalNumber':
			var fieldName = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalNumber(fieldName);
		case 'LocalSingletonNumber':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalNumberLookup, ref, fieldName);
		case 'LocalNumberHardcoded':
			var number = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalNumberHardcoded(number);
		case 'LocalCountUnique':
			var comparableList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalCountUnique(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localComparableList(comparableList)));
		case 'LocalRound':
			var number = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalRoundNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(number)));
		case 'LocalSum':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalSum(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumberList(numberList)));
		case 'LocalProduct':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalProduct(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumberList(numberList)));
		case 'LocalAdd':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAdd,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalSubtract':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalSubtract,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalMultiply':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalMultiply,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalDivide':
			var numberA = expr.a;
			var numberB = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalDivide,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberA)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberB)));
		case 'LocalMonthNumber':
			var date = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMonthNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(date)));
		case 'LocalYearNumber':
			var date = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalYearNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(date)));
		case 'LocalDayInMonth':
			var date = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDayInMonth(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(date)));
		case 'LocalNumberIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(elseExpr)));
		case 'LocalPickNumber':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalPickNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumberList(numberList)));
		case 'LocalMaxNumber':
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMaxNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumberList(numberList)));
		default:
			var numberList = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMinNumber(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumberList(numberList)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localNumberList = function (expr) {
	switch (expr.$) {
		case 'RelatedNumber':
			var relationship = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedNumber,
				$author$project$DataElement$ProtoElement$Convert$convertRelationship(relationship),
				$author$project$Input$Selected(fieldName));
		case 'LocalAllNumbersInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllNumbersInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'LocalNumbersAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumbersAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localNumber, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		default:
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalNumberListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumberList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumberList(elseExpr)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localString = function (stringExpr) {
	switch (stringExpr.$) {
		case 'LocalString':
			var fieldName = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalString(fieldName);
		case 'LocalSingletonString':
			var ref = stringExpr.a;
			var fieldName = stringExpr.b;
			return A2($author$project$DataElement$ProtoExpression$ProtoLocalStringLookup, ref, fieldName);
		case 'LocalStringHardcoded':
			var words = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalStringHardcoded(words);
		case 'LocalFormatDate':
			var string = stringExpr.a;
			var date = stringExpr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalFormatDate,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(string)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(date)));
		case 'LocalFormatDateLocaleAware':
			var date = stringExpr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalFormatDate,
				$author$project$Input$empty,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDate(date)));
		case 'LocalFormatDateTime':
			var dateTime = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalFormatDateTime(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTime)));
		case 'LocalFormatNumber':
			var decimals = stringExpr.a;
			var numberExp = stringExpr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalFormatNumber,
				$author$project$IntInput$Selected(decimals),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localNumber(numberExp)));
		case 'LocalStringIf':
			var ifExpr = stringExpr.a;
			var thenExpr = stringExpr.b;
			var elseExpr = stringExpr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(elseExpr)));
		case 'LocalPickString':
			var stringList = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalPickString(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localStringList(stringList)));
		case 'LocalConcat':
			var string = stringExpr.a;
			var stringList = stringExpr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalConcat,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(string)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localStringList(stringList)));
		case 'LocalMaxString':
			var stringList = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMaxString(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localStringList(stringList)));
		default:
			var stringList = stringExpr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalMinString(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localStringList(stringList)));
	}
};
var $author$project$DataElement$ProtoElement$Convert$localStringList = function (expr) {
	switch (expr.$) {
		case 'RelatedString':
			var relationship = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoRelatedString,
				$author$project$DataElement$ProtoElement$Convert$convertRelationship(relationship),
				$author$project$Input$Selected(fieldName));
		case 'LocalAllStringsInField':
			var ref = expr.a;
			var fieldName = expr.b;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalAllStringsInField,
				$author$project$Input$Selected(ref),
				$author$project$Input$Selected(fieldName));
		case 'LocalStringsAsList':
			var listOfExprs = expr.a;
			return A2(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringsAsList,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localString, $author$project$Input$Selected),
						listOfExprs),
					_List_fromArray(
						[$author$project$Input$empty])),
				$author$project$ExpressionInput$Msg$dndSystem.model);
		case 'LocalStringListIf':
			var ifExpr = expr.a;
			var thenExpr = expr.b;
			var elseExpr = expr.c;
			return A3(
				$author$project$DataElement$ProtoExpression$ProtoLocalStringListIf,
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localBool(ifExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localStringList(thenExpr)),
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localStringList(elseExpr)));
		case 'LocalChallengeReasons':
			var acctId = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalChallengeReasons(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(acctId)));
		default:
			var acctId = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalTargetChallengeReasons(
				$author$project$Input$Selected(
					$author$project$DataElement$ProtoElement$Convert$localString(acctId)));
	}
};
var $elm$json$Json$Decode$map4 = _Json_map4;
function $author$project$DataElement$Expression$cyclic$relationshipDecoder() {
	return A5(
		$elm$json$Json$Decode$map4,
		$author$project$DataElement$Expression$RelationshipInfo,
		A2($elm$json$Json$Decode$field, 'nextElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'idToMatch',
			$author$project$DataElement$Expression$cyclic$localStringDecoder()),
		A2(
			$elm$json$Json$Decode$field,
			'localIds',
			$author$project$DataElement$Expression$cyclic$localStringListDecoder()),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
			'filterBy',
			$author$project$DataElement$Expression$cyclic$localBoolDecoder()));
}
function $author$project$DataElement$Expression$cyclic$localBoolDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$BoolType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v11 = $elm$core$String$toLower(words);
				switch (_v11) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalBool,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonBool,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalBoolHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$bool));
					case 'gt':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$LocalGTDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalGTDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalGTNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalGTString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'gte':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$LocalGTEDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalGTEDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalGTENumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalGTEString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'lt':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$LocalLTDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalLTDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalLTNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalLTString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'lte':
						return $author$project$DataElement$Expression$compareDecoder(
							{
								dateCompare: $author$project$DataElement$Expression$LocalLTEDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalLTEDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalLTENumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalLTEString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'equal':
						return $author$project$DataElement$Expression$compareFieldDecoder(
							{
								boolCompare: $author$project$DataElement$Expression$LocalEqualBool,
								boolDecoder: $author$project$DataElement$Expression$cyclic$localBoolDecoder(),
								dateCompare: $author$project$DataElement$Expression$LocalEqualDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalEqualDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalEqualNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalEqualString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'not equal':
						return $author$project$DataElement$Expression$compareFieldDecoder(
							{
								boolCompare: $author$project$DataElement$Expression$LocalNotEqualBool,
								boolDecoder: $author$project$DataElement$Expression$cyclic$localBoolDecoder(),
								dateCompare: $author$project$DataElement$Expression$LocalNotEqualDate,
								dateDecoder: $author$project$DataElement$Expression$cyclic$localDateDecoder(),
								dateTimeCompare: $author$project$DataElement$Expression$LocalNotEqualDateTime,
								dateTimeDecoder: $author$project$DataElement$Expression$cyclic$localDateTimeDecoder(),
								numberCompare: $author$project$DataElement$Expression$LocalNotEqualNumber,
								numberDecoder: $author$project$DataElement$Expression$cyclic$localNumberDecoder(),
								stringCompare: $author$project$DataElement$Expression$LocalNotEqualString,
								stringDecoder: $author$project$DataElement$Expression$cyclic$localStringDecoder()
							});
					case 'in':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalStringIn,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'not in':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalStringNotIn,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'not':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalNot,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localBoolDecoder()));
					case 'all':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalAll,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localBoolListDecoder()));
					case 'any':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalAny,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localBoolListDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickBool,
							$author$project$DataElement$Expression$cyclic$localBoolListDecoder());
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalBoolIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localBoolDecoder());
					case 'is null':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalIsNull,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localFieldDecoder()));
					case 'is not null':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalIsNotNull,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localFieldDecoder()));
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Bool Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localBoolListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$BoolType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v10 = $elm$core$String$toLower(words);
				switch (_v10) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedBool,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllBoolsInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalBoolsAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localBoolDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalBoolListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localBoolListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Bool List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localComparableListDecoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalCompStringListExpr,
						$author$project$DataElement$Expression$cyclic$localStringListDecoder());
				case 'NumberType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalCompNumberListExpr,
						$author$project$DataElement$Expression$cyclic$localNumberListDecoder());
				case 'DateType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalCompDateListExpr,
						$author$project$DataElement$Expression$cyclic$localDateListDecoder());
				case 'DateTimeType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalCompDateTimeListExpr,
						$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder());
				default:
					return $elm$json$Json$Decode$fail(
						'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported as a Local Comparable List Expression'));
			}
		},
		A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
}
function $author$project$DataElement$Expression$cyclic$localDateDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v8 = $elm$core$String$toLower(words);
				switch (_v8) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDate,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonDate,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$dateDecoder));
					case 'date/time to date':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateTimeToDate,
							A2(
								$elm$json$Json$Decode$field,
								'dateTimeExpression',
								$author$project$DataElement$Expression$cyclic$localDateTimeDecoder()));
					case 'date ceiling':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalDateCeiling,
							A2($elm$json$Json$Decode$field, 'dateInterval', $author$project$DateInterval$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date floor':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalDateFloor,
							A2($elm$json$Json$Decode$field, 'dateInterval', $author$project$DateInterval$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date addition':
						return A4(
							$elm$json$Json$Decode$map3,
							$author$project$DataElement$Expression$LocalDateAdd,
							A2($elm$json$Json$Decode$field, 'dateUnit', $author$project$DateUnit$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date subtraction':
						return A4(
							$elm$json$Json$Decode$map3,
							$author$project$DataElement$Expression$LocalDateSubtract,
							A2($elm$json$Json$Decode$field, 'dateUnit', $author$project$DateUnit$decoder),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickDate,
							$author$project$DataElement$Expression$cyclic$localDateListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMaxDate,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMinDate,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalDateIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localDateDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Date Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localDateListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v7 = $elm$core$String$toLower(words);
				switch (_v7) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedDate,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllDatesInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDatesAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localDateDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalDateListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localDateListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Date List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localDateTimeDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateTimeType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v6 = $elm$core$String$toLower(words);
				switch (_v6) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateTime,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonDateTime,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateTimeHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickDateTime,
							$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMaxDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMinDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalDateTimeIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localDateTimeDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local DateTime Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localDateTimeListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$DateTimeType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v5 = $elm$core$String$toLower(words);
				switch (_v5) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllDateTimesInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDateTimesAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localDateTimeDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalDateTimeListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local DateTime List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localFieldDecoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldType) {
			switch (fieldType.$) {
				case 'StringType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalStringExpr,
						$author$project$DataElement$Expression$cyclic$localStringDecoder());
				case 'NumberType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalNumberExpr,
						$author$project$DataElement$Expression$cyclic$localNumberDecoder());
				case 'DateType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalDateExpr,
						$author$project$DataElement$Expression$cyclic$localDateDecoder());
				case 'DateTimeType':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalDateTimeExpr,
						$author$project$DataElement$Expression$cyclic$localDateTimeDecoder());
				default:
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$DataElement$Expression$LocalBoolExpr,
						$author$project$DataElement$Expression$cyclic$localBoolDecoder());
			}
		},
		A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
}
function $author$project$DataElement$Expression$cyclic$localNumberDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$NumberType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v3 = $elm$core$String$toLower(words);
				switch (_v3) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalNumber,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonNumber,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalNumberHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$float));
					case 'count unique':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalCountUnique,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localComparableListDecoder()));
					case 'round number':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalRound,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'sum':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalSum,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberListDecoder()));
					case 'product':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalProduct,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberListDecoder()));
					case 'add number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAdd,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'subtract number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSubtract,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'multiply number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalMultiply,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'divide number':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalDivide,
							A2(
								$elm$json$Json$Decode$field,
								'expression1',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'expression2',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'date month':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMonthNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date year':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalYearNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'date day in month':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalDayInMonth,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickNumber,
							$author$project$DataElement$Expression$cyclic$localNumberListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMaxNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMinNumber,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalNumberIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localNumberDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Number Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localNumberListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$NumberType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v2 = $elm$core$String$toLower(words);
				switch (_v2) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedNumber,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllNumbersInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalNumbersAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localNumberDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalNumberListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localNumberListDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local Number List Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localStringDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$StringType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v1 = $elm$core$String$toLower(words);
				switch (_v1) {
					case 'local field':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalString,
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'singleton field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalSingletonString,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$singletonReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'static':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalStringHardcoded,
							A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
					case 'format date':
						return A3(
							$elm$json$Json$Decode$map2,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($author$project$DataElement$Expression$LocalFormatDate),
								$elm$core$Maybe$withDefault($author$project$DataElement$Expression$LocalFormatDateLocaleAware)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'formatExpression',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'dateExpression',
								$author$project$DataElement$Expression$cyclic$localDateDecoder()));
					case 'format date/time':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalFormatDateTime,
							A2(
								$elm$json$Json$Decode$field,
								'dateTimeExpression',
								$author$project$DataElement$Expression$cyclic$localDateTimeDecoder()));
					case 'float to string':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalFormatNumber,
							A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'number to string':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalFormatNumber,
							A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localNumberDecoder()));
					case 'concat':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalConcat,
							A2(
								$elm$json$Json$Decode$field,
								'joinExpression',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()),
							A2(
								$elm$json$Json$Decode$field,
								'listExpression',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'pick one':
						return A2(
							$author$project$DataElement$Expression$pickOneDecoder,
							$author$project$DataElement$Expression$LocalPickString,
							$author$project$DataElement$Expression$cyclic$localStringListDecoder());
					case 'max':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMaxString,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'min':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalMinString,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localStringListDecoder()));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalStringIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localStringDecoder());
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local String Expression'));
				}
			}));
}
function $author$project$DataElement$Expression$cyclic$localStringListDecoder() {
	return A2(
		$author$project$DataElement$Expression$confirmDataType,
		$author$project$FieldType$StringType,
		$author$project$DataElement$Expression$typeDecoder(
			function (words) {
				var _v0 = $elm$core$String$toLower(words);
				switch (_v0) {
					case 'related field':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$RelatedString,
							A2(
								$elm$json$Json$Decode$field,
								'relationship',
								$author$project$DataElement$Expression$cyclic$relationshipDecoder()),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'field in list':
						return A3(
							$elm$json$Json$Decode$map2,
							$author$project$DataElement$Expression$LocalAllStringsInField,
							A2($elm$json$Json$Decode$field, 'dataElement', $author$project$DataElement$Reference$recordListReferenceDecoder),
							A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
					case 'list of expressions':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalStringsAsList,
							A2(
								$elm$json$Json$Decode$field,
								'expressions',
								$elm$json$Json$Decode$list(
									$author$project$DataElement$Expression$cyclic$localStringDecoder())));
					case 'if':
						return A3(
							$author$project$DataElement$Expression$ifDecoder,
							$author$project$DataElement$Expression$LocalStringListIf,
							$author$project$DataElement$Expression$cyclic$localBoolDecoder(),
							$author$project$DataElement$Expression$cyclic$localStringListDecoder());
					case 'challenge reasons':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalChallengeReasons,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()));
					case 'target challenge reasons':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$DataElement$Expression$LocalTargetChallengeReasons,
							A2(
								$elm$json$Json$Decode$field,
								'expression',
								$author$project$DataElement$Expression$cyclic$localStringDecoder()));
					default:
						return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Local String List Expression'));
				}
			}));
}
try {
	var $author$project$DataElement$Expression$relationshipDecoder = $author$project$DataElement$Expression$cyclic$relationshipDecoder();
	$author$project$DataElement$Expression$cyclic$relationshipDecoder = function () {
		return $author$project$DataElement$Expression$relationshipDecoder;
	};
	var $author$project$DataElement$Expression$localBoolDecoder = $author$project$DataElement$Expression$cyclic$localBoolDecoder();
	$author$project$DataElement$Expression$cyclic$localBoolDecoder = function () {
		return $author$project$DataElement$Expression$localBoolDecoder;
	};
	var $author$project$DataElement$Expression$localBoolListDecoder = $author$project$DataElement$Expression$cyclic$localBoolListDecoder();
	$author$project$DataElement$Expression$cyclic$localBoolListDecoder = function () {
		return $author$project$DataElement$Expression$localBoolListDecoder;
	};
	var $author$project$DataElement$Expression$localComparableListDecoder = $author$project$DataElement$Expression$cyclic$localComparableListDecoder();
	$author$project$DataElement$Expression$cyclic$localComparableListDecoder = function () {
		return $author$project$DataElement$Expression$localComparableListDecoder;
	};
	var $author$project$DataElement$Expression$localDateDecoder = $author$project$DataElement$Expression$cyclic$localDateDecoder();
	$author$project$DataElement$Expression$cyclic$localDateDecoder = function () {
		return $author$project$DataElement$Expression$localDateDecoder;
	};
	var $author$project$DataElement$Expression$localDateListDecoder = $author$project$DataElement$Expression$cyclic$localDateListDecoder();
	$author$project$DataElement$Expression$cyclic$localDateListDecoder = function () {
		return $author$project$DataElement$Expression$localDateListDecoder;
	};
	var $author$project$DataElement$Expression$localDateTimeDecoder = $author$project$DataElement$Expression$cyclic$localDateTimeDecoder();
	$author$project$DataElement$Expression$cyclic$localDateTimeDecoder = function () {
		return $author$project$DataElement$Expression$localDateTimeDecoder;
	};
	var $author$project$DataElement$Expression$localDateTimeListDecoder = $author$project$DataElement$Expression$cyclic$localDateTimeListDecoder();
	$author$project$DataElement$Expression$cyclic$localDateTimeListDecoder = function () {
		return $author$project$DataElement$Expression$localDateTimeListDecoder;
	};
	var $author$project$DataElement$Expression$localFieldDecoder = $author$project$DataElement$Expression$cyclic$localFieldDecoder();
	$author$project$DataElement$Expression$cyclic$localFieldDecoder = function () {
		return $author$project$DataElement$Expression$localFieldDecoder;
	};
	var $author$project$DataElement$Expression$localNumberDecoder = $author$project$DataElement$Expression$cyclic$localNumberDecoder();
	$author$project$DataElement$Expression$cyclic$localNumberDecoder = function () {
		return $author$project$DataElement$Expression$localNumberDecoder;
	};
	var $author$project$DataElement$Expression$localNumberListDecoder = $author$project$DataElement$Expression$cyclic$localNumberListDecoder();
	$author$project$DataElement$Expression$cyclic$localNumberListDecoder = function () {
		return $author$project$DataElement$Expression$localNumberListDecoder;
	};
	var $author$project$DataElement$Expression$localStringDecoder = $author$project$DataElement$Expression$cyclic$localStringDecoder();
	$author$project$DataElement$Expression$cyclic$localStringDecoder = function () {
		return $author$project$DataElement$Expression$localStringDecoder;
	};
	var $author$project$DataElement$Expression$localStringListDecoder = $author$project$DataElement$Expression$cyclic$localStringListDecoder();
	$author$project$DataElement$Expression$cyclic$localStringListDecoder = function () {
		return $author$project$DataElement$Expression$localStringListDecoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.Expression` are causing infinite recursion:\n\n  ┌─────┐\n  │    relationshipDecoder\n  │     ↓\n  │    localBoolDecoder\n  │     ↓\n  │    localBoolListDecoder\n  │     ↓\n  │    localComparableListDecoder\n  │     ↓\n  │    localDateDecoder\n  │     ↓\n  │    localDateListDecoder\n  │     ↓\n  │    localDateTimeDecoder\n  │     ↓\n  │    localDateTimeListDecoder\n  │     ↓\n  │    localFieldDecoder\n  │     ↓\n  │    localNumberDecoder\n  │     ↓\n  │    localNumberListDecoder\n  │     ↓\n  │    localStringDecoder\n  │     ↓\n  │    localStringListDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$ProtoElement$Convert$localComparable = function (expr) {
	switch (expr.$) {
		case 'LocalCompStringExpr':
			var stringExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalStringComp(
				$author$project$DataElement$ProtoElement$Convert$localString(stringExpr));
		case 'LocalCompNumberExpr':
			var numberExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalNumberComp(
				$author$project$DataElement$ProtoElement$Convert$localNumber(numberExpr));
		case 'LocalCompDateExpr':
			var dateExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateComp(
				$author$project$DataElement$ProtoElement$Convert$localDate(dateExpr));
		default:
			var dateTimeExpr = expr.a;
			return $author$project$DataElement$ProtoExpression$ProtoLocalDateTimeComp(
				$author$project$DataElement$ProtoElement$Convert$localDateTime(dateTimeExpr));
	}
};
var $author$project$DataElement$Expression$localComparableDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (fieldType) {
		switch (fieldType.$) {
			case 'StringType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$LocalCompStringExpr, $author$project$DataElement$Expression$localStringDecoder);
			case 'NumberType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$LocalCompNumberExpr, $author$project$DataElement$Expression$localNumberDecoder);
			case 'DateType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$LocalCompDateExpr, $author$project$DataElement$Expression$localDateDecoder);
			case 'DateTimeType':
				return A2($elm$json$Json$Decode$map, $author$project$DataElement$Expression$LocalCompDateTimeExpr, $author$project$DataElement$Expression$localDateTimeDecoder);
			default:
				return $elm$json$Json$Decode$fail(
					'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported as a Local Comparable Expression'));
		}
	},
	A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
var $author$project$ExpressionInput$ViewInfo = F5(
	function (dataElements, contentType, veevaMessages, i18nMessages, iconsUri) {
		return {contentType: contentType, dataElements: dataElements, i18nMessages: i18nMessages, iconsUri: iconsUri, veevaMessages: veevaMessages};
	});
var $author$project$DataElement$DataElement = F2(
	function (a, b) {
		return {$: 'DataElement', a: a, b: b};
	});
var $author$project$DataElement$CallAttendees = {$: 'CallAttendees'};
var $author$project$DataElement$DatepickerSelection = function (a) {
	return {$: 'DatepickerSelection', a: a};
};
var $author$project$DataElement$InteractiveSelectSelection = function (a) {
	return {$: 'InteractiveSelectSelection', a: a};
};
var $author$project$DataElement$Now = {$: 'Now'};
var $author$project$DataElement$RecordList = function (a) {
	return {$: 'RecordList', a: a};
};
var $author$project$DataElement$Singleton = function (a) {
	return {$: 'Singleton', a: a};
};
var $author$project$DataElement$Today = {$: 'Today'};
var $author$project$DataElement$FeedbackAccountChannelGoals = function (a) {
	return {$: 'FeedbackAccountChannelGoals', a: a};
};
var $author$project$DataElement$FeedbackAccountChannelGoals$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$selectedFieldsDecoder = A2(
	$elm$json$Json$Decode$field,
	'selectedFields',
	A2(
		$elm$json$Json$Decode$map,
		$pzp1997$assoc_list$AssocList$fromList,
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'name', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'type', $author$project$FieldType$decoder)))));
var $author$project$DataElement$accountChannelGoalsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackAccountChannelGoals, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackAccountChannelGoals$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$FeedbackAccountData = function (a) {
	return {$: 'FeedbackAccountData', a: a};
};
var $author$project$DataElement$FeedbackAccountData$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$accountDataDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackAccountData, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackAccountData$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$FeedbackAccountProductGoals = function (a) {
	return {$: 'FeedbackAccountProductGoals', a: a};
};
var $author$project$DataElement$FeedbackAccountProductGoals$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$accountProductGoalsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackAccountProductGoals, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackAccountProductGoals$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$FeedbackAccountProductMetrics = function (a) {
	return {$: 'FeedbackAccountProductMetrics', a: a};
};
var $author$project$DataElement$FeedbackAccountProductMetrics$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$accountProductMetricsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackAccountProductMetrics, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackAccountProductMetrics$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$AlignedTerritories = function (a) {
	return {$: 'AlignedTerritories', a: a};
};
var $author$project$MyInsights$AlignedTerritoriesOnly = {$: 'AlignedTerritoriesOnly'};
var $author$project$MyInsights$IncludeChildTerritories = {$: 'IncludeChildTerritories'};
var $author$project$DataElement$AlignedTerritories$Info = function (includeChildren) {
	return {includeChildren: includeChildren};
};
var $author$project$DataElement$alignedTerritoriesDecoder = function () {
	var helper = function (bool) {
		return bool ? $author$project$MyInsights$IncludeChildTerritories : $author$project$MyInsights$AlignedTerritoriesOnly;
	};
	return A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeR, $author$project$DataElement$AlignedTerritories, $author$project$DataElement$RecordList),
		A2(
			$elm$json$Json$Decode$map,
			$author$project$DataElement$AlignedTerritories$Info,
			A2(
				$elm$json$Json$Decode$map,
				helper,
				A2($elm$json$Json$Decode$field, 'includeChildren', $elm$json$Json$Decode$bool))));
}();
var $author$project$DataElement$FeedbackChannelGoals = function (a) {
	return {$: 'FeedbackChannelGoals', a: a};
};
var $author$project$DataElement$FeedbackChannelGoals$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$channelGoalsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackChannelGoals, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackChannelGoals$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$ContextQuery = function (a) {
	return {$: 'ContextQuery', a: a};
};
var $author$project$ValidContextObject$Account = {$: 'Account'};
var $author$project$ValidContextObject$AccountPlan = {$: 'AccountPlan'};
var $author$project$ValidContextObject$Call = {$: 'Call'};
var $author$project$ValidContextObject$EMSpeaker = {$: 'EMSpeaker'};
var $author$project$ValidContextObject$HTMLReport = {$: 'HTMLReport'};
var $author$project$ValidContextObject$InventoryMonitoring = {$: 'InventoryMonitoring'};
var $author$project$ValidContextObject$Order = {$: 'Order'};
var $author$project$ValidContextObject$TSF = {$: 'TSF'};
var $author$project$ValidContextObject$User = {$: 'User'};
var $author$project$ValidContextObject$pickDecoder = function (objectName) {
	var _v0 = $elm$core$String$toLower(objectName);
	switch (_v0) {
		case 'account':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$Account);
		case 'account_plan_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$AccountPlan);
		case 'accountplan':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$AccountPlan);
		case 'html_report_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$HTMLReport);
		case 'htmlreport':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$HTMLReport);
		case 'order_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$Order);
		case 'order':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$Order);
		case 'tsf_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$TSF);
		case 'tsf':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$TSF);
		case 'user':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$User);
		case 'inventory_monitoring_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$InventoryMonitoring);
		case 'inventorymonitoring':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$InventoryMonitoring);
		case 'em_speaker_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$EMSpeaker);
		case 'call2_vod__c':
			return $elm$json$Json$Decode$succeed($author$project$ValidContextObject$Call);
		default:
			return $elm$json$Json$Decode$fail('Invalid context object');
	}
};
var $author$project$ValidContextObject$decoder = A2($elm$json$Json$Decode$andThen, $author$project$ValidContextObject$pickDecoder, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $author$project$DataElement$ContextQueryInfo = F4(
	function (objectName, fieldName, fieldType, objectTag) {
		return {fieldName: fieldName, fieldType: fieldType, objectName: objectName, objectTag: objectTag};
	});
var $author$project$DataElement$makeContextQueryInfo = F3(
	function (elementName, fields, objectTags) {
		if (fields.b && (!fields.b.b)) {
			var _v1 = fields.a;
			var fieldName = _v1.a;
			var fieldType = _v1.b;
			return $elm$core$Result$Ok(
				A4(
					$author$project$DataElement$ContextQueryInfo,
					elementName,
					$author$project$FieldName$fromString(fieldName),
					fieldType,
					A2(
						$pzp1997$assoc_list$AssocList$get,
						$author$project$FieldName$fromString(fieldName),
						objectTags)));
		} else {
			return $elm$core$Result$Err('A Context Query must have exactly one field');
		}
	});
var $author$project$ObjectName$decoder = A2($elm$json$Json$Decode$map, $author$project$ObjectName$ObjectName, $elm$json$Json$Decode$string);
var $author$project$DataElement$objectTagsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault($pzp1997$assoc_list$AssocList$empty),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
		'objectTags',
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
				$pzp1997$assoc_list$AssocList$fromList),
			$elm$json$Json$Decode$keyValuePairs($author$project$ObjectName$decoder))));
var $author$project$DataElement$contextQueryDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$ContextQuery, $author$project$DataElement$Singleton),
	A2(
		$elm$json$Json$Decode$andThen,
		$elm_community$json_extra$Json$Decode$Extra$fromResult,
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$DataElement$makeContextQueryInfo,
			A2($elm$json$Json$Decode$field, 'object', $author$project$ValidContextObject$decoder),
			A2(
				$elm$json$Json$Decode$field,
				'fields',
				$elm$json$Json$Decode$keyValuePairs(
					A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder))),
			$author$project$DataElement$objectTagsDecoder)));
var $author$project$DataElement$CrmDataEngineQuery$Info = F5(
	function (table, fields, whereClause, sort, limit) {
		return {fields: fields, limit: limit, sort: sort, table: table, whereClause: whereClause};
	});
var $author$project$DataElement$CrmDataEngine$Field$Concat = function (a) {
	return {$: 'Concat', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$Count = function (a) {
	return {$: 'Count', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$CountDistinct = function (a) {
	return {$: 'CountDistinct', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$DateTruncate = F2(
	function (a, b) {
		return {$: 'DateTruncate', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$DimensionField = F2(
	function (a, b) {
		return {$: 'DimensionField', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Divide = F2(
	function (a, b) {
		return {$: 'Divide', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Max = F2(
	function (a, b) {
		return {$: 'Max', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$MetricField = F2(
	function (a, b) {
		return {$: 'MetricField', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Min = F2(
	function (a, b) {
		return {$: 'Min', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Minus = F2(
	function (a, b) {
		return {$: 'Minus', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Multiply = F2(
	function (a, b) {
		return {$: 'Multiply', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Plus = F2(
	function (a, b) {
		return {$: 'Plus', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$PureField = F2(
	function (a, b) {
		return {$: 'PureField', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Field$Sum = function (a) {
	return {$: 'Sum', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$ConcatField = function (a) {
	return {$: 'ConcatField', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$concatFragmentFieldDecoder = A2($elm$json$Json$Decode$map, $author$project$DataElement$CrmDataEngine$Field$ConcatField, $author$project$FieldName$decoder);
var $author$project$DataElement$CrmDataEngine$Field$ConcatQuote = function (a) {
	return {$: 'ConcatQuote', a: a};
};
var $author$project$DataElement$CrmDataEngine$Field$concatFragmentQuoteDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DataElement$CrmDataEngine$Field$ConcatQuote,
	A2($elm$json$Json$Decode$field, 'text', $elm$json$Json$Decode$string));
var $author$project$DataElement$CrmDataEngine$Field$concatFragmentDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$DataElement$CrmDataEngine$Field$concatFragmentQuoteDecoder, $author$project$DataElement$CrmDataEngine$Field$concatFragmentFieldDecoder]));
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Century = {$: 'Century'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Day = {$: 'Day'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Decade = {$: 'Decade'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Hour = {$: 'Hour'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Millennium = {$: 'Millennium'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Milliseconds = {$: 'Milliseconds'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Minute = {$: 'Minute'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Month = {$: 'Month'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Quarter = {$: 'Quarter'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Second = {$: 'Second'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Week = {$: 'Week'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Year = {$: 'Year'};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'milliseconds':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Milliseconds);
		case 'second':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Second);
		case 'minute':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Minute);
		case 'hour':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Hour);
		case 'day':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Day);
		case 'week':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Week);
		case 'month':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Month);
		case 'quarter':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Quarter);
		case 'year':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Year);
		case 'decade':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Decade);
		case 'century':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Century);
		case 'millennium':
			return $elm$core$Result$Ok($author$project$DataElement$CrmDataEngine$ExpandedDateInterval$Millennium);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a Date Interval'));
	}
};
var $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$DataElement$CrmDataEngine$Field$fieldTypeToDecoder = function (type_) {
	var _v0 = $elm$core$String$toLower(
		$author$project$FieldName$toString(type_));
	switch (_v0) {
		case 'field':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$PureField,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder));
		case 'concat':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A2(
					$elm$json$Json$Decode$map,
					$author$project$DataElement$CrmDataEngine$Field$Concat,
					A2(
						$elm$json$Json$Decode$field,
						'arguments',
						$elm$json$Json$Decode$list($author$project$DataElement$CrmDataEngine$Field$concatFragmentDecoder))));
		case 'date_trunc':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$DateTruncate,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'interval', $author$project$DataElement$CrmDataEngine$ExpandedDateInterval$decoder)));
		case 'div':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Divide,
					A2($elm$json$Json$Decode$field, 'fieldA', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'fieldB', $author$project$FieldName$decoder)));
		case 'multi':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Multiply,
					A2($elm$json$Json$Decode$field, 'fieldA', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'fieldB', $author$project$FieldName$decoder)));
		case 'minus':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Minus,
					A2($elm$json$Json$Decode$field, 'fieldA', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'fieldB', $author$project$FieldName$decoder)));
		case 'plus':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$DimensionField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Plus,
					A2($elm$json$Json$Decode$field, 'fieldA', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'fieldB', $author$project$FieldName$decoder)));
		case 'sum':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A2(
					$elm$json$Json$Decode$map,
					$author$project$DataElement$CrmDataEngine$Field$Sum,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder)));
		case 'count':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A2(
					$elm$json$Json$Decode$map,
					$author$project$DataElement$CrmDataEngine$Field$Count,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder)));
		case 'count_distinct':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A2(
					$elm$json$Json$Decode$map,
					$author$project$DataElement$CrmDataEngine$Field$CountDistinct,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder)));
		case 'max':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Max,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'dataType', $author$project$ComparableType$decoder)));
		case 'min':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Field$MetricField,
				A2($elm$json$Json$Decode$field, 'as', $author$project$FieldName$decoder),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$DataElement$CrmDataEngine$Field$Min,
					A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
					A2($elm$json$Json$Decode$field, 'dataType', $author$project$ComparableType$decoder)));
		default:
			return $elm$json$Json$Decode$fail(
				'Could not parse ' + ($author$project$FieldName$toString(type_) + 'as a field.'));
	}
};
var $author$project$DataElement$CrmDataEngine$Field$decoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$DataElement$CrmDataEngine$Field$fieldTypeToDecoder,
	A2($elm$json$Json$Decode$field, 'type', $author$project$FieldName$decoder));
var $author$project$DataElement$CrmDataEngine$Where$AllOf = function (a) {
	return {$: 'AllOf', a: a};
};
var $author$project$DataElement$CrmDataEngine$Where$AnyOf = function (a) {
	return {$: 'AnyOf', a: a};
};
var $author$project$DataElement$CrmDataEngine$Where$Eq = F2(
	function (a, b) {
		return {$: 'Eq', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$Gt = F2(
	function (a, b) {
		return {$: 'Gt', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$Gte = F2(
	function (a, b) {
		return {$: 'Gte', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$In = F2(
	function (a, b) {
		return {$: 'In', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$IsNotNull = function (a) {
	return {$: 'IsNotNull', a: a};
};
var $author$project$DataElement$CrmDataEngine$Where$IsNull = function (a) {
	return {$: 'IsNull', a: a};
};
var $author$project$DataElement$CrmDataEngine$Where$Lt = F2(
	function (a, b) {
		return {$: 'Lt', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$Lte = F2(
	function (a, b) {
		return {$: 'Lte', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$NotEq = F2(
	function (a, b) {
		return {$: 'NotEq', a: a, b: b};
	});
var $author$project$DataElement$CrmDataEngine$Where$BetweenDate = F3(
	function (a, b, c) {
		return {$: 'BetweenDate', a: a, b: b, c: c};
	});
var $author$project$DataElement$CrmDataEngine$Where$BetweenDateTime = F3(
	function (a, b, c) {
		return {$: 'BetweenDateTime', a: a, b: b, c: c};
	});
var $author$project$DataElement$CrmDataEngine$Where$BetweenNumber = F3(
	function (a, b, c) {
		return {$: 'BetweenNumber', a: a, b: b, c: c};
	});
var $author$project$DataElement$CrmDataEngine$Where$BetweenString = F3(
	function (a, b, c) {
		return {$: 'BetweenString', a: a, b: b, c: c};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$DataElement$CrmDataEngine$Where$betweenDecoder = F2(
	function (constructor, innerDecoder) {
		return A4(
			$elm$json$Json$Decode$map3,
			constructor,
			A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
			A2($elm$json$Json$Decode$field, 'startValue', innerDecoder),
			A2($elm$json$Json$Decode$field, 'endValue', innerDecoder));
	});
var $author$project$DataElement$CrmDataEngine$Where$getCorrectBetweenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (fieldType) {
		switch (fieldType.$) {
			case 'StringType':
				return A2($author$project$DataElement$CrmDataEngine$Where$betweenDecoder, $author$project$DataElement$CrmDataEngine$Where$BetweenString, $author$project$DataElement$Expression$globalStringDecoder);
			case 'NumberType':
				return A2($author$project$DataElement$CrmDataEngine$Where$betweenDecoder, $author$project$DataElement$CrmDataEngine$Where$BetweenNumber, $author$project$DataElement$Expression$globalNumberDecoder);
			case 'DateType':
				return A2($author$project$DataElement$CrmDataEngine$Where$betweenDecoder, $author$project$DataElement$CrmDataEngine$Where$BetweenDate, $author$project$DataElement$Expression$globalDateDecoder);
			case 'DateTimeType':
				return A2($author$project$DataElement$CrmDataEngine$Where$betweenDecoder, $author$project$DataElement$CrmDataEngine$Where$BetweenDateTime, $author$project$DataElement$Expression$globalDateTimeDecoder);
			default:
				return $elm$json$Json$Decode$fail(
					'Data type \'' + ($author$project$FieldType$toString(fieldType) + '\' is not supported in Between.'));
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['startValue', 'dataType']),
		$author$project$FieldType$decoder));
var $author$project$DataElement$CrmDataEngine$Where$individualWhereDecoder = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'all_of':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$CrmDataEngine$Where$AllOf,
				A2(
					$elm$json$Json$Decode$field,
					'conditions',
					$elm$json$Json$Decode$list(
						$author$project$DataElement$CrmDataEngine$Where$cyclic$decoder())));
		case 'any_of':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$CrmDataEngine$Where$AnyOf,
				A2(
					$elm$json$Json$Decode$field,
					'conditions',
					$elm$json$Json$Decode$list(
						$author$project$DataElement$CrmDataEngine$Where$cyclic$decoder())));
		case 'equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Eq,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalFieldDecoder));
		case 'not_equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$NotEq,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalFieldDecoder));
		case 'greater_than':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Gt,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'greater_than_or_equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Gte,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'less_than':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Lt,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'less_than_or_equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$Lte,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'value', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'between':
			return $author$project$DataElement$CrmDataEngine$Where$getCorrectBetweenDecoder;
		case 'in':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$CrmDataEngine$Where$In,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'values', $author$project$DataElement$Expression$globalStringListDecoder));
		case 'is_null':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$CrmDataEngine$Where$IsNull,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
		case 'is_not_null':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$CrmDataEngine$Where$IsNotNull,
				A2($elm$json$Json$Decode$field, 'field', $author$project$FieldName$decoder));
		default:
			return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a Where clause'));
	}
};
function $author$project$DataElement$CrmDataEngine$Where$cyclic$decoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$DataElement$CrmDataEngine$Where$individualWhereDecoder,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
}
try {
	var $author$project$DataElement$CrmDataEngine$Where$decoder = $author$project$DataElement$CrmDataEngine$Where$cyclic$decoder();
	$author$project$DataElement$CrmDataEngine$Where$cyclic$decoder = function () {
		return $author$project$DataElement$CrmDataEngine$Where$decoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.CrmDataEngine.Where` are causing infinite recursion:\n\n  ┌─────┐\n  │    decoder\n  │     ↓\n  │    individualWhereDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$SortKey$SortKey = F2(
	function (field, direction) {
		return {direction: direction, field: field};
	});
var $author$project$SortDirection$Ascending = {$: 'Ascending'};
var $author$project$SortDirection$Descending = {$: 'Descending'};
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$SortDirection$fromString = function (words) {
	var _v0 = $elm$core$String$toUpper(words);
	switch (_v0) {
		case 'ASC':
			return $elm$core$Result$Ok($author$project$SortDirection$Ascending);
		case 'DESC':
			return $elm$core$Result$Ok($author$project$SortDirection$Descending);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a sort direction'));
	}
};
var $author$project$SortDirection$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$SortDirection$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$DataElement$SortKey$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$SortKey$SortKey,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['key', 'name']),
		$author$project$FieldName$decoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['sortDir', 'value']),
		$author$project$SortDirection$decoder));
var $mgold$elm_nonempty_list$List$Nonempty$fromList = function (ys) {
	if (ys.b) {
		var x = ys.a;
		var xs = ys.b;
		return $elm$core$Maybe$Just(
			A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (maybe.$ === 'Just') {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$DataElement$CrmDataEngineQuery$decoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$DataElement$CrmDataEngineQuery$Info,
	A2($elm$json$Json$Decode$field, 'table', $author$project$ObjectName$decoder),
	A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$mgold$elm_nonempty_list$List$Nonempty$fromList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$fromMaybe('\'fields\' cannot be empty'),
				$elm_community$json_extra$Json$Decode$Extra$fromResult)),
		A2(
			$elm$json$Json$Decode$field,
			'fields',
			$elm$json$Json$Decode$list($author$project$DataElement$CrmDataEngine$Field$decoder))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'where', $author$project$DataElement$CrmDataEngine$Where$decoder)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'sort',
				$elm$json$Json$Decode$list($author$project$DataElement$SortKey$decoder)))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'limit', $elm$json$Json$Decode$int)));
var $author$project$DataElement$Datepicker$Info = function (_default) {
	return {_default: _default};
};
var $author$project$DataElement$Datepicker$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DataElement$Datepicker$Info,
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'default', $author$project$DataElement$Expression$globalDateDecoder));
var $author$project$DataElement$Dropdown$Info = F3(
	function (options, placeholder, requireSelection) {
		return {options: options, placeholder: placeholder, requireSelection: requireSelection};
	});
var $author$project$DataElement$Dropdown$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$DataElement$Dropdown$Info,
	A2($elm$json$Json$Decode$field, 'options', $author$project$DataElement$Expression$globalStringListDecoder),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'placeholder', $author$project$DataElement$Expression$globalStringDecoder),
	A2($elm$json$Json$Decode$field, 'requireSelection', $elm$json$Json$Decode$bool));
var $author$project$DataElement$SalesQuery$Info = F7(
	function (limit, sort, scale, dataType, accountIds, startDate, endDate) {
		return {accountIds: accountIds, dataType: dataType, endDate: endDate, limit: limit, scale: scale, sort: sort, startDate: startDate};
	});
var $author$project$DataElement$SalesQuery$Scale$Month = {$: 'Month'};
var $author$project$DataElement$SalesQuery$Scale$Week = {$: 'Week'};
var $author$project$DataElement$SalesQuery$Scale$fromString = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'week_vod':
			return $elm$core$Result$Ok($author$project$DataElement$SalesQuery$Scale$Week);
		case 'month_vod':
			return $elm$core$Result$Ok($author$project$DataElement$SalesQuery$Scale$Month);
		default:
			return $elm$core$Result$Err('Could not parse \'' + (words + '\' as a scale'));
	}
};
var $author$project$DataElement$SalesQuery$Scale$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DataElement$SalesQuery$Scale$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$DataElement$SalesQuery$decoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$DataElement$SalesQuery$Info,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'limit', $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'sort',
				$elm$json$Json$Decode$list($author$project$DataElement$SortKey$decoder)))),
	A2($elm$json$Json$Decode$field, 'scale', $author$project$DataElement$SalesQuery$Scale$decoder),
	A2($elm$json$Json$Decode$field, 'dataType', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'accountIds', $author$project$DataElement$Expression$globalStringListDecoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'startDate', $author$project$DataElement$Expression$globalDateDecoder)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'endDate', $author$project$DataElement$Expression$globalDateDecoder)));
var $author$project$DataElement$FieldTranslation = function (a) {
	return {$: 'FieldTranslation', a: a};
};
var $author$project$DataElement$FieldTranslation$Info = F2(
	function (object, fields) {
		return {fields: fields, object: object};
	});
var $author$project$DataElement$fieldTranslationDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FieldTranslation, $author$project$DataElement$Singleton),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DataElement$FieldTranslation$Info,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['object', 'name']),
					$author$project$ObjectName$decoder),
					A2($elm$json$Json$Decode$field, 'object', $author$project$ObjectName$decoder)
				])),
		A2(
			$elm$json$Json$Decode$field,
			'fields',
			A2(
				$elm$json$Json$Decode$andThen,
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$fromList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Result$fromMaybe('\'fields\' cannot be empty'),
						$elm_community$json_extra$Json$Decode$Extra$fromResult)),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$List$map(
						A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$FieldName$fromString)),
					$elm$json$Json$Decode$keyValuePairs(
						$elm$json$Json$Decode$succeed(_Utils_Tuple0)))))));
var $author$project$DataElement$CalcFilterList = function (a) {
	return {$: 'CalcFilterList', a: a};
};
var $author$project$DataElement$FilterList$Info = F2(
	function (original, filter) {
		return {filter: filter, original: original};
	});
var $author$project$DataElement$filterListDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcFilterList, $author$project$DataElement$RecordList),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DataElement$FilterList$Info,
		A2($elm$json$Json$Decode$field, 'original', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2($elm$json$Json$Decode$field, 'filter', $author$project$DataElement$Expression$localBoolDecoder)));
var $author$project$DataElement$CalcMergeList = function (a) {
	return {$: 'CalcMergeList', a: a};
};
var $author$project$DataElement$MergeList$ListCombineMatrix = function (a) {
	return {$: 'ListCombineMatrix', a: a};
};
var $pzp1997$assoc_list$AssocList$keys = function (_v0) {
	var alist = _v0.a;
	return A2($elm$core$List$map, $elm$core$Tuple$first, alist);
};
var $author$project$DataElement$MergeList$fromDict = function (inputList) {
	var fieldLabels = function (_v2) {
		var fieldDict = _v2.b;
		return A2(
			$elm$core$List$map,
			$author$project$FieldName$toString,
			$pzp1997$assoc_list$AssocList$keys(fieldDict));
	};
	var containsFieldLabelList = function (fieldLabelList) {
		return A2(
			$elm$core$List$map,
			function (fieldLabel) {
				return A2($elm$core$List$member, fieldLabel, fieldLabelList);
			},
			$elm_community$list_extra$List$Extra$unique(
				$elm$core$List$concat(
					A2($elm$core$List$map, fieldLabels, inputList))));
	};
	var validDataSource = function (innerFieldsList) {
		var _v1 = $elm_community$list_extra$List$Extra$unique(
			containsFieldLabelList(innerFieldsList));
		if ((_v1.b && _v1.a) && (!_v1.b.b)) {
			return true;
		} else {
			return false;
		}
	};
	var getDataSourceStatuses = A2(
		$elm$core$List$map,
		A2($elm$core$Basics$composeR, fieldLabels, validDataSource),
		inputList);
	var validMergeList = function () {
		var _v0 = $elm_community$list_extra$List$Extra$unique(getDataSourceStatuses);
		if ((_v0.b && _v0.a) && (!_v0.b.b)) {
			return true;
		} else {
			return false;
		}
	}();
	return validMergeList ? $elm$core$Result$Ok(
		$author$project$DataElement$MergeList$ListCombineMatrix(inputList)) : $elm$core$Result$Err('Merge list is not valid. Each field label needs a field value from each datasource.');
};
var $author$project$DataElement$MergeList$innerDictDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
		$pzp1997$assoc_list$AssocList$fromList),
	$elm$json$Json$Decode$keyValuePairs($author$project$FieldName$decoder));
var $author$project$DataElement$MergeList$listDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'dataSource', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2($elm$json$Json$Decode$field, 'dict', $author$project$DataElement$MergeList$innerDictDecoder)));
var $author$project$DataElement$MergeList$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$DataElement$MergeList$fromDict, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$author$project$DataElement$MergeList$listDecoder);
var $author$project$DataElement$mergeListDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcMergeList, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$field, 'sources', $author$project$DataElement$MergeList$decoder));
var $author$project$DataElement$ObjectTranslation = function (a) {
	return {$: 'ObjectTranslation', a: a};
};
var $author$project$DataElement$objectTranslationDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$ObjectTranslation, $author$project$DataElement$Singleton),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['object', 'name']),
				$author$project$ObjectName$decoder),
				A2($elm$json$Json$Decode$field, 'object', $author$project$ObjectName$decoder)
			])));
var $author$project$DataElement$CalcOneForOne = function (a) {
	return {$: 'CalcOneForOne', a: a};
};
var $author$project$DataElement$OneForOneInfo = F2(
	function (original, fields) {
		return {fields: fields, original: original};
	});
var $author$project$DataElement$oneForOneDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcOneForOne, $author$project$DataElement$RecordList),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DataElement$OneForOneInfo,
		A2($elm$json$Json$Decode$field, 'original', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'fields',
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
					$pzp1997$assoc_list$AssocList$fromList),
				$elm$json$Json$Decode$keyValuePairs($author$project$DataElement$Expression$localFieldDecoder)))));
var $author$project$DataElement$FeedbackOverview = function (a) {
	return {$: 'FeedbackOverview', a: a};
};
var $author$project$DataElement$FeedbackOverviewInfo = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$overviewDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackOverview, $author$project$DataElement$Singleton),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackOverviewInfo, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$FeedbackProductGoals = function (a) {
	return {$: 'FeedbackProductGoals', a: a};
};
var $author$project$DataElement$FeedbackProductGoals$Info = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$productGoalsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$FeedbackProductGoals, $author$project$DataElement$RecordList),
	A2($elm$json$Json$Decode$map, $author$project$DataElement$FeedbackProductGoals$Info, $author$project$DataElement$selectedFieldsDecoder));
var $author$project$DataElement$QueryInfo = F6(
	function (objectName, fields, limit, sort, whereClause, objectTags) {
		return {fields: fields, limit: limit, objectName: objectName, objectTags: objectTags, sort: sort, whereClause: whereClause};
	});
var $author$project$DataElement$WhereClause$WhereAnd = function (a) {
	return {$: 'WhereAnd', a: a};
};
var $author$project$DataElement$WhereClause$WhereIndividual = function (a) {
	return {$: 'WhereIndividual', a: a};
};
var $author$project$DataElement$WhereClause$WhereOr = function (a) {
	return {$: 'WhereOr', a: a};
};
var $author$project$DataElement$WhereClause$WhereEqual = F2(
	function (a, b) {
		return {$: 'WhereEqual', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereGT = F2(
	function (a, b) {
		return {$: 'WhereGT', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereGTE = F2(
	function (a, b) {
		return {$: 'WhereGTE', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereIn = F2(
	function (a, b) {
		return {$: 'WhereIn', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereLT = F2(
	function (a, b) {
		return {$: 'WhereLT', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereLTE = F2(
	function (a, b) {
		return {$: 'WhereLTE', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$WhereNotEqual = F2(
	function (a, b) {
		return {$: 'WhereNotEqual', a: a, b: b};
	});
var $author$project$DataElement$WhereClause$pickWhereIndividualDecoder = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'in':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereIn,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalStringListDecoder));
		case 'equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereEqual,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalFieldDecoder));
		case 'not equal':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereNotEqual,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalFieldDecoder));
		case 'gt':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereGT,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'gte':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereGTE,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'lt':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereLT,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalComparableDecoder));
		case 'lte':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$DataElement$WhereClause$WhereLTE,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['field', 'name']),
					$author$project$FieldName$decoder),
				A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$globalComparableDecoder));
		default:
			return $elm$json$Json$Decode$fail('Could not parse \'' + (words + '\' as a valid where clause type'));
	}
};
var $author$project$DataElement$WhereClause$pickWhereClauseDecoder = function (words) {
	var _v0 = $elm$core$String$toLower(words);
	switch (_v0) {
		case 'and':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$WhereClause$WhereAnd,
				A2(
					$elm$json$Json$Decode$field,
					'subclauses',
					$elm$json$Json$Decode$list(
						$author$project$DataElement$WhereClause$cyclic$decoder())));
		case 'or':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$WhereClause$WhereOr,
				A2(
					$elm$json$Json$Decode$field,
					'subclauses',
					$elm$json$Json$Decode$list(
						$author$project$DataElement$WhereClause$cyclic$decoder())));
		default:
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$DataElement$WhereClause$WhereIndividual,
				$author$project$DataElement$WhereClause$pickWhereIndividualDecoder(words));
	}
};
function $author$project$DataElement$WhereClause$cyclic$decoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$DataElement$WhereClause$pickWhereClauseDecoder,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['type', 'value']),
			$elm$json$Json$Decode$string));
}
try {
	var $author$project$DataElement$WhereClause$decoder = $author$project$DataElement$WhereClause$cyclic$decoder();
	$author$project$DataElement$WhereClause$cyclic$decoder = function () {
		return $author$project$DataElement$WhereClause$decoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `DataElement.WhereClause` are causing infinite recursion:\n\n  ┌─────┐\n  │    decoder\n  │     ↓\n  │    pickWhereClauseDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$DataElement$FieldInfo = F2(
	function (fieldType, _default) {
		return {_default: _default, fieldType: fieldType};
	});
var $author$project$DataElement$fieldInfoDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$FieldInfo,
	A2($elm$json$Json$Decode$field, 'dataType', $author$project$FieldType$decoder),
	$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing));
var $author$project$DataElement$fieldInfoPicklistTupleDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	$author$project$DataElement$fieldInfoDecoder,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'isPicklist', $elm$json$Json$Decode$bool)));
var $author$project$DataElement$addPicklistTranslationField = F2(
	function (_v0, dict) {
		var fieldName = _v0.a;
		var _v1 = _v0.b;
		var fieldInfo = _v1.a;
		var isPicklist = _v1.b;
		return isPicklist ? A3(
			$pzp1997$assoc_list$AssocList$insert,
			fieldName,
			fieldInfo,
			A3(
				$pzp1997$assoc_list$AssocList$insert,
				$author$project$FieldName$fromString(
					A2(
						$elm$core$String$append,
						$author$project$FieldName$toString(fieldName),
						'_Translation')),
				{_default: $elm$core$Maybe$Nothing, fieldType: fieldInfo.fieldType},
				dict)) : A3($pzp1997$assoc_list$AssocList$insert, fieldName, fieldInfo, dict);
	});
var $author$project$DataElement$getFieldNameDictWithTranslations = function (initialList) {
	return A3($elm$core$List$foldl, $author$project$DataElement$addPicklistTranslationField, $pzp1997$assoc_list$AssocList$empty, initialList);
};
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$DataElement$queryInfoDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$DataElement$QueryInfo,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['object', 'name']),
				$author$project$ObjectName$decoder),
				A2($elm$json$Json$Decode$field, 'object', $author$project$ObjectName$decoder)
			])),
	A2(
		$elm$json$Json$Decode$field,
		'fields',
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
				$author$project$DataElement$getFieldNameDictWithTranslations),
			$elm$json$Json$Decode$keyValuePairs($author$project$DataElement$fieldInfoPicklistTupleDecoder))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'limit', $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'sort',
				$elm$json$Json$Decode$list($author$project$DataElement$SortKey$decoder)))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'where', $author$project$DataElement$WhereClause$decoder)),
	$author$project$DataElement$objectTagsDecoder);
var $author$project$DataElement$CalcSortList = function (a) {
	return {$: 'CalcSortList', a: a};
};
var $author$project$DataElement$SortList$Info = F2(
	function (original, sortBy) {
		return {original: original, sortBy: sortBy};
	});
var $author$project$DataElement$SortList$SortKey = F2(
	function (expression, direction) {
		return {direction: direction, expression: expression};
	});
var $author$project$DataElement$sortListKeyDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$SortList$SortKey,
	A2($elm$json$Json$Decode$field, 'expression', $author$project$DataElement$Expression$localComparableDecoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['sortDir', 'value']),
		$author$project$SortDirection$decoder));
var $author$project$DataElement$sortListDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcSortList, $author$project$DataElement$RecordList),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$DataElement$SortList$Info,
		A2($elm$json$Json$Decode$field, 'original', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$mgold$elm_nonempty_list$List$Nonempty$fromList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$fromMaybe('\'sort\' cannot be empty'),
					$elm_community$json_extra$Json$Decode$Extra$fromResult)),
			A2(
				$elm$json$Json$Decode$field,
				'sort',
				$elm$json$Json$Decode$list($author$project$DataElement$sortListKeyDecoder)))));
var $author$project$DataElement$CalcSublist = function (a) {
	return {$: 'CalcSublist', a: a};
};
var $author$project$DataElement$Sublist$Info = F3(
	function (original, skipThisMany, keepThisMany) {
		return {keepThisMany: keepThisMany, original: original, skipThisMany: skipThisMany};
	});
var $author$project$DataElement$sublistDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $author$project$DataElement$CalcSublist, $author$project$DataElement$RecordList),
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$DataElement$Sublist$Info,
		A2($elm$json$Json$Decode$field, 'original', $author$project$DataElement$Reference$recordListReferenceDecoder),
		A2($elm$json$Json$Decode$field, 'skip', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'keep', $elm$json$Json$Decode$int)));
var $author$project$DataElement$CalcSummarize = function (a) {
	return {$: 'CalcSummarize', a: a};
};
var $author$project$DataElement$SummarizeInfo = function (fields) {
	return {fields: fields};
};
var $author$project$DataElement$summarizeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$DataElement$SummarizeInfo,
		A2($elm$core$Basics$composeR, $author$project$DataElement$CalcSummarize, $author$project$DataElement$Singleton)),
	A2(
		$elm$json$Json$Decode$field,
		'fields',
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$FieldName$fromString)),
				$pzp1997$assoc_list$AssocList$fromList),
			$elm$json$Json$Decode$keyValuePairs($author$project$DataElement$Expression$globalFieldDecoder))));
var $author$project$DataElement$VeevaMessages$Info = function (tokens) {
	return {tokens: tokens};
};
var $author$project$DataElement$VeevaMessages = function (a) {
	return {$: 'VeevaMessages', a: a};
};
var $author$project$DataElement$VeevaMessages$Token = F2(
	function (name, category) {
		return {category: category, name: name};
	});
var $author$project$DataElement$veevaMessageTokenDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$VeevaMessages$Token,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'category', $elm$json$Json$Decode$string));
var $author$project$DataElement$veevaMessagesDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$DataElement$VeevaMessages$Info,
		A2($elm$core$Basics$composeR, $author$project$DataElement$VeevaMessages, $author$project$DataElement$Singleton)),
	A2(
		$elm$json$Json$Decode$field,
		'messages',
		$elm$json$Json$Decode$list($author$project$DataElement$veevaMessageTokenDecoder)));
var $author$project$DataElement$CrmQuery = function (a) {
	return {$: 'CrmQuery', a: a};
};
var $author$project$DataElement$LimitOneCrmQuery = function (a) {
	return {$: 'LimitOneCrmQuery', a: a};
};
var $author$project$DataElement$wrapCrmQuery = function (info) {
	var _v0 = info.limit;
	if ((_v0.$ === 'Just') && (_v0.a === 1)) {
		return $author$project$DataElement$Singleton(
			$author$project$DataElement$LimitOneCrmQuery(info));
	} else {
		return $author$project$DataElement$RecordList(
			$author$project$DataElement$CrmQuery(info));
	}
};
var $author$project$DataElement$CrmDataEngineQuery = function (a) {
	return {$: 'CrmDataEngineQuery', a: a};
};
var $author$project$DataElement$LimitOneCrmDataEngineQuery = function (a) {
	return {$: 'LimitOneCrmDataEngineQuery', a: a};
};
var $author$project$DataElement$wrapDataEngineQuery = function (info) {
	var _v0 = info.limit;
	if ((_v0.$ === 'Just') && (_v0.a === 1)) {
		return $author$project$DataElement$Singleton(
			$author$project$DataElement$LimitOneCrmDataEngineQuery(info));
	} else {
		return $author$project$DataElement$RecordList(
			$author$project$DataElement$CrmDataEngineQuery(info));
	}
};
var $author$project$DataElement$LimitOneNitroQuery = function (a) {
	return {$: 'LimitOneNitroQuery', a: a};
};
var $author$project$DataElement$NitroQuery = function (a) {
	return {$: 'NitroQuery', a: a};
};
var $author$project$DataElement$wrapNitroQuery = function (info) {
	var _v0 = info.limit;
	if ((_v0.$ === 'Just') && (_v0.a === 1)) {
		return $author$project$DataElement$Singleton(
			$author$project$DataElement$LimitOneNitroQuery(info));
	} else {
		return $author$project$DataElement$RecordList(
			$author$project$DataElement$NitroQuery(info));
	}
};
var $author$project$DataElement$LimitOneSalesQuery = function (a) {
	return {$: 'LimitOneSalesQuery', a: a};
};
var $author$project$DataElement$SalesQuery = function (a) {
	return {$: 'SalesQuery', a: a};
};
var $author$project$DataElement$wrapSalesQuery = function (info) {
	var _v0 = info.limit;
	if ((_v0.$ === 'Just') && (_v0.a === 1)) {
		return $author$project$DataElement$Singleton(
			$author$project$DataElement$LimitOneSalesQuery(info));
	} else {
		return $author$project$DataElement$RecordList(
			$author$project$DataElement$SalesQuery(info));
	}
};
var $author$project$DataElement$pickDecoder = function (typeWords) {
	switch (typeWords) {
		case 'DATA_EL_CONTEXT_QUERY':
			return $author$project$DataElement$contextQueryDecoder;
		case 'Context Query':
			return $author$project$DataElement$contextQueryDecoder;
		case 'DATA_EL_CRM_QUERY':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapCrmQuery, $author$project$DataElement$queryInfoDecoder);
		case 'CRM Query':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapCrmQuery, $author$project$DataElement$queryInfoDecoder);
		case 'DATA_EL_SALES_DATA_QUERY':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapSalesQuery, $author$project$DataElement$SalesQuery$decoder);
		case 'DATA_EL_NITRO_QUERY':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapNitroQuery, $author$project$DataElement$queryInfoDecoder);
		case 'DATA_EL_CRM_DATA_ENGINE':
			return A2($elm$json$Json$Decode$map, $author$project$DataElement$wrapDataEngineQuery, $author$project$DataElement$CrmDataEngineQuery$decoder);
		case 'DATA_EL_ONE_FOR_ONE':
			return $author$project$DataElement$oneForOneDecoder;
		case 'One for One':
			return $author$project$DataElement$oneForOneDecoder;
		case 'DATA_EL_SORT_LIST':
			return $author$project$DataElement$sortListDecoder;
		case 'DATA_EL_FILTER_LIST':
			return $author$project$DataElement$filterListDecoder;
		case 'DATA_EL_SUBLIST':
			return $author$project$DataElement$sublistDecoder;
		case 'DATA_EL_ALIGNED_TERRITORIES':
			return $author$project$DataElement$alignedTerritoriesDecoder;
		case 'DATA_EL_CALL_ATTENDEES':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$RecordList($author$project$DataElement$CallAttendees));
		case 'DATA_EL_TODAY':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$Singleton($author$project$DataElement$Today));
		case 'Today':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$Singleton($author$project$DataElement$Today));
		case 'Now':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$Singleton($author$project$DataElement$Now));
		case 'DATA_EL_NOW':
			return $elm$json$Json$Decode$succeed(
				$author$project$DataElement$Singleton($author$project$DataElement$Now));
		case 'DATA_EL_SUMMARIZE':
			return $author$project$DataElement$summarizeDecoder;
		case 'Summarize':
			return $author$project$DataElement$summarizeDecoder;
		case 'DATA_EL_OBJECT_TRANSLATION':
			return $author$project$DataElement$objectTranslationDecoder;
		case 'DATA_EL_FIELD_TRANSLATION':
			return $author$project$DataElement$fieldTranslationDecoder;
		case 'DATA_EL_VEEVA_MESSAGES':
			return $author$project$DataElement$veevaMessagesDecoder;
		case 'DATA_EL_MERGE_LIST':
			return $author$project$DataElement$mergeListDecoder;
		case 'Date Picker State':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$DataElement$DatepickerSelection, $author$project$DataElement$Singleton),
				$author$project$DataElement$Datepicker$decoder);
		case 'Dropdown State':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$DataElement$InteractiveSelectSelection, $author$project$DataElement$Singleton),
				$author$project$DataElement$Dropdown$decoder);
		case 'DATA_EL_FEEDBACK_OVERVIEW':
			return $author$project$DataElement$overviewDecoder;
		case 'DATA_EL_FEEDBACK_CHANNEL_GOALS':
			return $author$project$DataElement$channelGoalsDecoder;
		case 'DATA_EL_FEEDBACK_PRODUCT_GOALS':
			return $author$project$DataElement$productGoalsDecoder;
		case 'DATA_EL_FEEDBACK_ACCOUNT_DATA':
			return $author$project$DataElement$accountDataDecoder;
		case 'DATA_EL_FEEDBACK_ACCOUNT_CHANNEL_GOALS':
			return $author$project$DataElement$accountChannelGoalsDecoder;
		case 'DATA_EL_FEEDBACK_ACCOUNT_PRODUCT_GOALS':
			return $author$project$DataElement$accountProductGoalsDecoder;
		case 'DATA_EL_FEEDBACK_ACCOUNT_PRODUCT_METRICS':
			return $author$project$DataElement$accountProductMetricsDecoder;
		default:
			return $elm$json$Json$Decode$fail('Could not parse \'' + (typeWords + '\' as a Data Element'));
	}
};
var $author$project$DataElement$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DataElement$DataElement,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$DataElement$pickDecoder,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string)));
var $author$project$UuidDict$checkUuidKey = function (words) {
	return A2(
		$elm$core$Result$fromMaybe,
		'\'' + (words + '\' is not a valid UUID'),
		$danyx23$elm_uuid$Uuid$fromString(words));
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 'Err') {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 'Err') {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm_community$result_extra$Result$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $elm_community$result_extra$Result$Extra$combineMap = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		$elm_community$result_extra$Result$Extra$combine,
		$elm$core$List$map(f));
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (ra.$ === 'Ok') {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm_community$result_extra$Result$Extra$combineFirst = function (_v0) {
	var rx = _v0.a;
	var y = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (x) {
			return A2($elm$core$Tuple$pair, x, y);
		},
		rx);
};
var $elm_community$result_extra$Result$Extra$combineMapFirst = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		$elm_community$result_extra$Result$Extra$combineFirst,
		$elm$core$Tuple$mapFirst(f));
};
var $elm_community$dict_extra$Dict$Extra$fromListBy = F2(
	function (keyfn, xs) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$insert,
						keyfn(x),
						x,
						acc);
				}),
			$elm$core$Dict$empty,
			xs);
	});
var $author$project$UuidDict$decoder = function (innerDecoder) {
	return A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$dict_extra$Dict$Extra$fromListBy(
				A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $danyx23$elm_uuid$Uuid$toString)),
			$author$project$UuidDict$UuidDict),
		A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm_community$result_extra$Result$Extra$combineMap(
					$elm_community$result_extra$Result$Extra$combineMapFirst($author$project$UuidDict$checkUuidKey)),
				$elm_community$json_extra$Json$Decode$Extra$fromResult),
			$elm$json$Json$Decode$keyValuePairs(innerDecoder)));
};
var $author$project$DataElement$collectionDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$DataElement$DataElementCollection,
	$author$project$UuidDict$decoder($author$project$DataElement$decoder));
var $author$project$ExpressionInput$ContentType$Account = {$: 'Account'};
var $author$project$ExpressionInput$ContentType$AccountPlan = {$: 'AccountPlan'};
var $author$project$ExpressionInput$ContentType$Call = {$: 'Call'};
var $author$project$ExpressionInput$ContentType$InventoryMonitoring = {$: 'InventoryMonitoring'};
var $author$project$ExpressionInput$ContentType$Orders = {$: 'Orders'};
var $author$project$ExpressionInput$ContentType$Speaker = {$: 'Speaker'};
var $author$project$ExpressionInput$ContentType$TerritoryFeedback = {$: 'TerritoryFeedback'};
var $author$project$ExpressionInput$ContentType$fromString = function (words) {
	switch (words) {
		case 'Territory':
			return $elm$core$Result$Ok($author$project$ExpressionInput$ContentType$Territory);
		case 'Account':
			return $elm$core$Result$Ok($author$project$ExpressionInput$ContentType$Account);
		case 'Account Plan':
			return $elm$core$Result$Ok($author$project$ExpressionInput$ContentType$AccountPlan);
		case 'Inventory Monitoring':
			return $elm$core$Result$Ok($author$project$ExpressionInput$ContentType$InventoryMonitoring);
		case 'Orders':
			return $elm$core$Result$Ok($author$project$ExpressionInput$ContentType$Orders);
		case 'Speaker':
			return $elm$core$Result$Ok($author$project$ExpressionInput$ContentType$Speaker);
		case 'Call':
			return $elm$core$Result$Ok($author$project$ExpressionInput$ContentType$Call);
		case 'Territory Feedback':
			return $elm$core$Result$Ok($author$project$ExpressionInput$ContentType$TerritoryFeedback);
		default:
			return $elm$core$Result$Err('\'' + (words + '\' is not a valid ContentType'));
	}
};
var $author$project$ExpressionInput$ContentType$pickDecoder = A2($elm$core$Basics$composeR, $author$project$ExpressionInput$ContentType$fromString, $elm_community$json_extra$Json$Decode$Extra$fromResult);
var $author$project$ExpressionInput$ContentType$decoder = A2($elm$json$Json$Decode$andThen, $author$project$ExpressionInput$ContentType$pickDecoder, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$ExpressionInput$viewInfoDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$ExpressionInput$ViewInfo,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($author$project$DataElement$emptyCollection),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'dataElements', $author$project$DataElement$collectionDecoder)),
	A2($elm$json$Json$Decode$field, 'contentType', $author$project$ExpressionInput$ContentType$decoder),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($elm$core$Dict$empty),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
			'veevaMessages',
			$elm$json$Json$Decode$dict(
				A2($elm$json$Json$Decode$field, 'Text_vod__c', $elm$json$Json$Decode$string)))),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($elm$core$Dict$empty),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
			'i18nMessages',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string))),
	A2($elm$json$Json$Decode$field, 'iconsUri', $elm$json$Json$Decode$string));
var $author$project$ExpressionInput$pickModelDecoder = function (bundle) {
	if (bundle.c.$ === 'Singleton') {
		if (bundle.a.$ === 'Global') {
			switch (bundle.b.$) {
				case 'AnyType':
					var _v1 = bundle.a;
					var _v2 = bundle.b;
					var _v3 = bundle.c;
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$ExpressionInput$GlobalFieldInput,
						$author$project$ExpressionInput$viewInfoDecoder,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault($author$project$Input$empty),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'initialExpression',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalField, $author$project$Input$Selected),
									$author$project$DataElement$Expression$globalFieldDecoder))));
				case 'AnyComparableType':
					var _v4 = bundle.a;
					var _v5 = bundle.b;
					var _v6 = bundle.c;
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$ExpressionInput$GlobalCompInput,
						$author$project$ExpressionInput$viewInfoDecoder,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault($author$project$Input$empty),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'initialExpression',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalComparable, $author$project$Input$Selected),
									$author$project$DataElement$Expression$globalComparableDecoder))));
				default:
					switch (bundle.b.a.$) {
						case 'StringType':
							var _v7 = bundle.a;
							var _v8 = bundle.b.a;
							var _v9 = bundle.c;
							return A3(
								$elm$json$Json$Decode$map2,
								$author$project$ExpressionInput$GlobalStringInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalString, $author$project$Input$Selected),
											$author$project$DataElement$Expression$globalStringDecoder))));
						case 'NumberType':
							var _v10 = bundle.a;
							var _v11 = bundle.b.a;
							var _v12 = bundle.c;
							return A3(
								$elm$json$Json$Decode$map2,
								$author$project$ExpressionInput$GlobalNumberInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalNumber, $author$project$Input$Selected),
											$author$project$DataElement$Expression$globalNumberDecoder))));
						case 'DateType':
							var _v13 = bundle.a;
							var _v14 = bundle.b.a;
							var _v15 = bundle.c;
							return A3(
								$elm$json$Json$Decode$map2,
								$author$project$ExpressionInput$GlobalDateInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalDate, $author$project$Input$Selected),
											$author$project$DataElement$Expression$globalDateDecoder))));
						case 'DateTimeType':
							var _v16 = bundle.a;
							var _v17 = bundle.b.a;
							var _v18 = bundle.c;
							return A3(
								$elm$json$Json$Decode$map2,
								$author$project$ExpressionInput$GlobalDateTimeInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalDateTime, $author$project$Input$Selected),
											$author$project$DataElement$Expression$globalDateTimeDecoder))));
						default:
							var _v19 = bundle.a;
							var _v20 = bundle.b.a;
							var _v21 = bundle.c;
							return A3(
								$elm$json$Json$Decode$map2,
								$author$project$ExpressionInput$GlobalBoolInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalBool, $author$project$Input$Selected),
											$author$project$DataElement$Expression$globalBoolDecoder))));
					}
			}
		} else {
			switch (bundle.b.$) {
				case 'AnyType':
					var ref = bundle.a.a;
					var _v22 = bundle.b;
					var _v23 = bundle.c;
					return A4(
						$elm$json$Json$Decode$map3,
						$author$project$ExpressionInput$LocalFieldInput,
						$author$project$ExpressionInput$viewInfoDecoder,
						$elm$json$Json$Decode$succeed(ref),
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault($author$project$Input$empty),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'initialExpression',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localField, $author$project$Input$Selected),
									$author$project$DataElement$Expression$localFieldDecoder))));
				case 'AnyComparableType':
					var ref = bundle.a.a;
					var _v24 = bundle.b;
					var _v25 = bundle.c;
					return A4(
						$elm$json$Json$Decode$map3,
						$author$project$ExpressionInput$LocalCompInput,
						$author$project$ExpressionInput$viewInfoDecoder,
						$elm$json$Json$Decode$succeed(ref),
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault($author$project$Input$empty),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'initialExpression',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localComparable, $author$project$Input$Selected),
									$author$project$DataElement$Expression$localComparableDecoder))));
				default:
					switch (bundle.b.a.$) {
						case 'StringType':
							var ref = bundle.a.a;
							var _v26 = bundle.b.a;
							var _v27 = bundle.c;
							return A4(
								$elm$json$Json$Decode$map3,
								$author$project$ExpressionInput$LocalStringInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								$elm$json$Json$Decode$succeed(ref),
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localString, $author$project$Input$Selected),
											$author$project$DataElement$Expression$localStringDecoder))));
						case 'NumberType':
							var ref = bundle.a.a;
							var _v28 = bundle.b.a;
							var _v29 = bundle.c;
							return A4(
								$elm$json$Json$Decode$map3,
								$author$project$ExpressionInput$LocalNumberInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								$elm$json$Json$Decode$succeed(ref),
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localNumber, $author$project$Input$Selected),
											$author$project$DataElement$Expression$localNumberDecoder))));
						case 'DateType':
							var ref = bundle.a.a;
							var _v30 = bundle.b.a;
							var _v31 = bundle.c;
							return A4(
								$elm$json$Json$Decode$map3,
								$author$project$ExpressionInput$LocalDateInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								$elm$json$Json$Decode$succeed(ref),
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localDate, $author$project$Input$Selected),
											$author$project$DataElement$Expression$localDateDecoder))));
						case 'DateTimeType':
							var ref = bundle.a.a;
							var _v32 = bundle.b.a;
							var _v33 = bundle.c;
							return A4(
								$elm$json$Json$Decode$map3,
								$author$project$ExpressionInput$LocalDateTimeInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								$elm$json$Json$Decode$succeed(ref),
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localDateTime, $author$project$Input$Selected),
											$author$project$DataElement$Expression$localDateTimeDecoder))));
						default:
							var ref = bundle.a.a;
							var _v34 = bundle.b.a;
							var _v35 = bundle.c;
							return A4(
								$elm$json$Json$Decode$map3,
								$author$project$ExpressionInput$LocalBoolInput,
								$author$project$ExpressionInput$viewInfoDecoder,
								$elm$json$Json$Decode$succeed(ref),
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$withDefault($author$project$Input$empty),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
										'initialExpression',
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$localBool, $author$project$Input$Selected),
											$author$project$DataElement$Expression$localBoolDecoder))));
					}
			}
		}
	} else {
		if ((bundle.a.$ === 'Global') && (bundle.b.$ === 'OneDataType')) {
			switch (bundle.b.a.$) {
				case 'StringType':
					var _v36 = bundle.a;
					var _v37 = bundle.b.a;
					var _v38 = bundle.c;
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$ExpressionInput$GlobalStringListInput,
						$author$project$ExpressionInput$viewInfoDecoder,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault($author$project$Input$empty),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'initialExpression',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalStringList, $author$project$Input$Selected),
									$author$project$DataElement$Expression$globalStringListDecoder))));
				case 'NumberType':
					var _v39 = bundle.a;
					var _v40 = bundle.b.a;
					var _v41 = bundle.c;
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$ExpressionInput$GlobalNumberListInput,
						$author$project$ExpressionInput$viewInfoDecoder,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault($author$project$Input$empty),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'initialExpression',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalNumberList, $author$project$Input$Selected),
									$author$project$DataElement$Expression$globalNumberListDecoder))));
				case 'DateType':
					var _v42 = bundle.a;
					var _v43 = bundle.b.a;
					var _v44 = bundle.c;
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$ExpressionInput$GlobalDateListInput,
						$author$project$ExpressionInput$viewInfoDecoder,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault($author$project$Input$empty),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'initialExpression',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalDateList, $author$project$Input$Selected),
									$author$project$DataElement$Expression$globalDateListDecoder))));
				case 'DateTimeType':
					var _v45 = bundle.a;
					var _v46 = bundle.b.a;
					var _v47 = bundle.c;
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$ExpressionInput$GlobalDateTimeListInput,
						$author$project$ExpressionInput$viewInfoDecoder,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault($author$project$Input$empty),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'initialExpression',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalDateTimeList, $author$project$Input$Selected),
									$author$project$DataElement$Expression$globalDateTimeListDecoder))));
				default:
					var _v48 = bundle.a;
					var _v49 = bundle.b.a;
					var _v50 = bundle.c;
					return A3(
						$elm$json$Json$Decode$map2,
						$author$project$ExpressionInput$GlobalBoolListInput,
						$author$project$ExpressionInput$viewInfoDecoder,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault($author$project$Input$empty),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
								'initialExpression',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$DataElement$ProtoElement$Convert$globalBoolList, $author$project$Input$Selected),
									$author$project$DataElement$Expression$globalBoolListDecoder))));
			}
		} else {
			var _v51 = bundle.c;
			return A2($elm$json$Json$Decode$map, $author$project$ExpressionInput$UnknownInput, $author$project$ExpressionInput$viewInfoDecoder);
		}
	}
};
var $author$project$ExpressionInput$modelInitDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$andThen, $author$project$ExpressionInput$pickModelDecoder, $author$project$ExpressionInput$contextAndTypeDecoder),
			A2($elm$json$Json$Decode$map, $author$project$ExpressionInput$UnknownInput, $author$project$ExpressionInput$viewInfoDecoder)
		]));
var $author$project$ExpressionInput$init = function (json) {
	var model = A2(
		$elm$core$Result$withDefault,
		$author$project$ExpressionInput$UnknownInput($author$project$ExpressionInput$emptyViewInfo),
		A2($elm$json$Json$Decode$decodeValue, $author$project$ExpressionInput$modelInitDecoder, json));
	return _Utils_Tuple2(
		model,
		$author$project$ExpressionInput$initInputExpression(model));
};
var $author$project$ExpressionInput$Msg$MsgForInput = function (a) {
	return {$: 'MsgForInput', a: a};
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$ExpressionInput$protoGlobalAnyListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalAnyListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyListSub, inputElse))))
					]));
		case 'ProtoGlobalAnysAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$ExpressionInput$protoGlobalAnySub = function (proto) {
	if (proto.$ === 'ProtoGlobalPickAny') {
		var list = proto.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$ExpressionInput$Msg$InnerMsg(0),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				$author$project$Input$toMaybe(
					A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnyListSub, list))));
	} else {
		var inputIf = proto.a;
		var inputThen = proto.b;
		var inputElse = proto.c;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$ExpressionInput$Msg$InnerMsg(0),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Sub$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$ExpressionInput$Msg$InnerMsg(1),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Sub$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnySub, inputThen)))),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$ExpressionInput$Msg$InnerMsg(2),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Sub$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnySub, inputElse))))
				]));
	}
};
var $author$project$ExpressionInput$protoGlobalBoolListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalBoolListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListSub, inputElse))))
					]));
		case 'ProtoGlobalBoolsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$ExpressionInput$protoGlobalBoolSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalBoolLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalBoolHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalGTString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputB))))
					]));
		case 'ProtoGlobalGTNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalGTDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputB))))
					]));
		case 'ProtoGlobalGTDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputB))))
					]));
		case 'ProtoGlobalGTComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputB))))
					]));
		case 'ProtoGlobalGTEString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputB))))
					]));
		case 'ProtoGlobalGTENumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalGTEDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputB))))
					]));
		case 'ProtoGlobalGTEDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputB))))
					]));
		case 'ProtoGlobalGTEComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputB))))
					]));
		case 'ProtoGlobalLTString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputB))))
					]));
		case 'ProtoGlobalLTNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalLTDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputB))))
					]));
		case 'ProtoGlobalLTDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputB))))
					]));
		case 'ProtoGlobalLTComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputB))))
					]));
		case 'ProtoGlobalLTEString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputB))))
					]));
		case 'ProtoGlobalLTENumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalLTEDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputB))))
					]));
		case 'ProtoGlobalLTEDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputB))))
					]));
		case 'ProtoGlobalLTEComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputB))))
					]));
		case 'ProtoGlobalEqualString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputB))))
					]));
		case 'ProtoGlobalEqualNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalEqualDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputB))))
					]));
		case 'ProtoGlobalEqualDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputB))))
					]));
		case 'ProtoGlobalEqualBool':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputB))))
					]));
		case 'ProtoGlobalEqualComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputB))))
					]));
		case 'ProtoGlobalEqualAny':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnySub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnySub, inputB))))
					]));
		case 'ProtoGlobalNotEqualString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputB))))
					]));
		case 'ProtoGlobalNotEqualNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalNotEqualDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputB))))
					]));
		case 'ProtoGlobalNotEqualDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputB))))
					]));
		case 'ProtoGlobalNotEqualBool':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputB))))
					]));
		case 'ProtoGlobalNotEqualComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputB))))
					]));
		case 'ProtoGlobalNotEqualAny':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnySub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalAnySub, inputB))))
					]));
		case 'ProtoGlobalStringIn':
			var inputString = proto.a;
			var inputStringList = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputString)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListSub, inputStringList))))
					]));
		case 'ProtoGlobalStringNotIn':
			var inputString = proto.a;
			var inputStringList = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputString)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListSub, inputStringList))))
					]));
		case 'ProtoGlobalNot':
			var inputBool = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputBool))));
		case 'ProtoGlobalBoolIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputElse))))
					]));
		case 'ProtoGlobalPickBool':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListSub, list))));
		case 'ProtoGlobalAll':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListSub, list))));
		case 'ProtoGlobalAny':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListSub, list))));
		case 'ProtoGlobalIsNull':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldSub, input))));
		default:
			var input = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldSub, input))));
	}
};
var $author$project$ExpressionInput$protoGlobalCompFieldListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalCompStringList':
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoGlobalStringListSub(protoList);
		case 'ProtoGlobalCompNumberList':
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoGlobalNumberListSub(protoList);
		case 'ProtoGlobalCompDateList':
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateListSub(protoList);
		case 'ProtoGlobalCompDateTimeList':
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateTimeListSub(protoList);
		default:
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoGlobalCompListSub(protoList);
	}
};
var $author$project$ExpressionInput$protoGlobalCompListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalCompListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompListSub, inputElse))))
					]));
		case 'ProtoGlobalCompsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$ExpressionInput$protoGlobalCompSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalPickComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompListSub, list))));
		case 'ProtoGlobalMaxComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompListSub, list))));
		case 'ProtoGlobalMinComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompListSub, list))));
		default:
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompSub, inputElse))))
					]));
	}
};
var $author$project$ExpressionInput$protoGlobalDateListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListSub, inputElse))))
					]));
		case 'ProtoGlobalDatesAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$ExpressionInput$protoGlobalDateSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalDateHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalDateTimeToDate':
			var inputDateTime = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputDateTime))));
		case 'ProtoGlobalDateCeiling':
			var inputDateInterval = proto.a;
			var inputDate = proto.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputDate))));
		case 'ProtoGlobalDateFloor':
			var inputDateInterval = proto.a;
			var inputDate = proto.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputDate))));
		case 'ProtoGlobalDateAdd':
			var inputDateUnit = proto.a;
			var inputNumber = proto.b;
			var inputDate = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputDate)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputNumber))))
					]));
		case 'ProtoGlobalDateSubtract':
			var inputDateUnit = proto.a;
			var inputNumber = proto.b;
			var inputDate = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputDate)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputNumber))))
					]));
		case 'ProtoGlobalDateIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputElse))))
					]));
		case 'ProtoGlobalPickDate':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListSub, list))));
		case 'ProtoGlobalMaxDate':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListSub, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListSub, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalDateTimeListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateTimeListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListSub, inputElse))))
					]));
		case 'ProtoGlobalAllDateTimesInField':
			return $elm$core$Platform$Sub$none;
		default:
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
	}
};
var $author$project$ExpressionInput$protoGlobalDateTimeSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalDateTimeLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalDateTimeHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalDateTimeIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputElse))))
					]));
		case 'ProtoGlobalPickDateTime':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListSub, list))));
		case 'ProtoGlobalMaxDateTime':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListSub, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListSub, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalFieldSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringField':
			var protoString = proto.a;
			return $author$project$ExpressionInput$protoGlobalStringSub(protoString);
		case 'ProtoGlobalNumberField':
			var protoNumber = proto.a;
			return $author$project$ExpressionInput$protoGlobalNumberSub(protoNumber);
		case 'ProtoGlobalDateField':
			var protoDate = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateSub(protoDate);
		case 'ProtoGlobalDateTimeField':
			var protoDateTime = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateTimeSub(protoDateTime);
		case 'ProtoGlobalBoolField':
			var protoBool = proto.a;
			return $author$project$ExpressionInput$protoGlobalBoolSub(protoBool);
		case 'ProtoGlobalAnyField':
			var protoAny = proto.a;
			return $author$project$ExpressionInput$protoGlobalAnySub(protoAny);
		default:
			var protoComp = proto.a;
			return $author$project$ExpressionInput$protoGlobalCompSub(protoComp);
	}
};
var $author$project$ExpressionInput$protoGlobalNumberListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalNumberListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListSub, inputElse))))
					]));
		case 'ProtoGlobalNumbersAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$ExpressionInput$protoGlobalNumberSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalNumberLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalNumberHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalCountUnique':
			var inputCompField = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompFieldListSub, inputCompField))));
		case 'ProtoGlobalRoundNumber':
			var inputNumber = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputNumber))));
		case 'ProtoGlobalSum':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListSub, list))));
		case 'ProtoGlobalProduct':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListSub, list))));
		case 'ProtoGlobalAdd':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalSubtract':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalMultiply':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalDivide':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputB))))
					]));
		case 'ProtoGlobalMonthNumber':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputDate))));
		case 'ProtoGlobalYearNumber':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputDate))));
		case 'ProtoGlobalDayInMonth':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputDate))));
		case 'ProtoGlobalNumberIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputElse))))
					]));
		case 'ProtoGlobalPickNumber':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListSub, list))));
		case 'ProtoGlobalMaxNumber':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListSub, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListSub, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalStringListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListSub, inputElse))))
					]));
		case 'ProtoGlobalStringsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		case 'ProtoGlobalAllStringsInField':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalChallengeReasons':
			var acctIdInput = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, acctIdInput))));
		default:
			var acctIdInput = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, acctIdInput))));
	}
};
var $author$project$ExpressionInput$protoGlobalStringSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalStringHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoGlobalFormatDate':
			var inputString = proto.a;
			var inputDate = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, inputDate)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputString))))
					]));
		case 'ProtoGlobalFormatDateTime':
			var inputDateTime = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, inputDateTime))));
		case 'ProtoGlobalFormatNumber':
			var inputIntInput = proto.a;
			var inputNumber = proto.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, inputNumber))));
		case 'ProtoGlobalStringIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputElse))))
					]));
		case 'ProtoGlobalPickString':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListSub, list))));
		case 'ProtoGlobalConcat':
			var inputString = proto.a;
			var list = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListSub, list)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, inputString))))
					]));
		case 'ProtoGlobalMaxString':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListSub, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListSub, list))));
	}
};
var $author$project$ExpressionInput$protoGlobalCompFieldSub = function (proto) {
	switch (proto.$) {
		case 'ProtoGlobalStringComp':
			var protoString = proto.a;
			return $author$project$ExpressionInput$protoGlobalStringSub(protoString);
		case 'ProtoGlobalNumberComp':
			var protoNumber = proto.a;
			return $author$project$ExpressionInput$protoGlobalNumberSub(protoNumber);
		case 'ProtoGlobalDateComp':
			var protoDate = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateSub(protoDate);
		case 'ProtoGlobalDateTimeComp':
			var protoDateTime = proto.a;
			return $author$project$ExpressionInput$protoGlobalDateTimeSub(protoDateTime);
		default:
			var protoComp = proto.a;
			return $author$project$ExpressionInput$protoGlobalCompSub(protoComp);
	}
};
var $author$project$ExpressionInput$protoLocalAnyListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalAnyListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyListSub, inputElse))))
					]));
		case 'ProtoLocalAllAnysInField':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalAnysAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedSub(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalAnySub = function (proto) {
	if (proto.$ === 'ProtoLocalAnyIf') {
		var inputIf = proto.a;
		var inputThen = proto.b;
		var inputElse = proto.c;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$ExpressionInput$Msg$InnerMsg(0),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Sub$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$ExpressionInput$Msg$InnerMsg(1),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Sub$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnySub, inputThen)))),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$ExpressionInput$Msg$InnerMsg(2),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Sub$none,
						$author$project$Input$toMaybe(
							A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnySub, inputElse))))
				]));
	} else {
		var list = proto.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$ExpressionInput$Msg$InnerMsg(0),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				$author$project$Input$toMaybe(
					A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnyListSub, list))));
	}
};
var $author$project$ExpressionInput$protoLocalBoolListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalBoolListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListSub, inputElse))))
					]));
		case 'ProtoLocalAllBoolsInField':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalBoolsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedSub(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalBoolSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalBool':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalBoolLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalBoolHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalGTString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputB))))
					]));
		case 'ProtoLocalGTNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalGTDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputB))))
					]));
		case 'ProtoLocalGTDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputB))))
					]));
		case 'ProtoLocalGTComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputB))))
					]));
		case 'ProtoLocalGTEString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputB))))
					]));
		case 'ProtoLocalGTENumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalGTEDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputB))))
					]));
		case 'ProtoLocalGTEDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputB))))
					]));
		case 'ProtoLocalGTEComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputB))))
					]));
		case 'ProtoLocalLTString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputB))))
					]));
		case 'ProtoLocalLTNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalLTDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputB))))
					]));
		case 'ProtoLocalLTDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputB))))
					]));
		case 'ProtoLocalLTComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputB))))
					]));
		case 'ProtoLocalLTEString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputB))))
					]));
		case 'ProtoLocalLTENumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalLTEDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputB))))
					]));
		case 'ProtoLocalLTEDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputB))))
					]));
		case 'ProtoLocalLTEComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputB))))
					]));
		case 'ProtoLocalEqualString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputB))))
					]));
		case 'ProtoLocalEqualNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalEqualDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputB))))
					]));
		case 'ProtoLocalEqualDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputB))))
					]));
		case 'ProtoLocalEqualBool':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputB))))
					]));
		case 'ProtoLocalEqualComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputB))))
					]));
		case 'ProtoLocalEqualAny':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnySub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnySub, inputB))))
					]));
		case 'ProtoLocalNotEqualString':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputB))))
					]));
		case 'ProtoLocalNotEqualNumber':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalNotEqualDate':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputB))))
					]));
		case 'ProtoLocalNotEqualDateTime':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputB))))
					]));
		case 'ProtoLocalNotEqualBool':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputB))))
					]));
		case 'ProtoLocalNotEqualComp':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputB))))
					]));
		case 'ProtoLocalNotEqualAny':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnySub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalAnySub, inputB))))
					]));
		case 'ProtoLocalStringIn':
			var inputString = proto.a;
			var inputStringList = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputString)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListSub, inputStringList))))
					]));
		case 'ProtoLocalStringNotIn':
			var inputString = proto.a;
			var inputStringList = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputString)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListSub, inputStringList))))
					]));
		case 'ProtoLocalNot':
			var inputBool = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputBool))));
		case 'ProtoLocalBoolIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputElse))))
					]));
		case 'ProtoLocalPickBool':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListSub, list))));
		case 'ProtoLocalAll':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListSub, list))));
		case 'ProtoLocalAny':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolListSub, list))));
		case 'ProtoLocalIsNull':
			var input = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldSub, input))));
		default:
			var input = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldSub, input))));
	}
};
var $author$project$ExpressionInput$protoLocalCompFieldListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalCompStringList':
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoLocalStringListSub(protoList);
		case 'ProtoLocalCompNumberList':
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoLocalNumberListSub(protoList);
		case 'ProtoLocalCompDateList':
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoLocalDateListSub(protoList);
		case 'ProtoLocalCompDateTimeList':
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoLocalDateTimeListSub(protoList);
		default:
			var protoList = proto.a;
			return $author$project$ExpressionInput$protoLocalCompListSub(protoList);
	}
};
var $author$project$ExpressionInput$protoLocalCompListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalCompListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompListSub, inputElse))))
					]));
		case 'ProtoLocalAllCompsInField':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalCompsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedSub(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalCompSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalPickComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompListSub, list))));
		case 'ProtoLocalMaxComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompListSub, list))));
		case 'ProtoLocalMinComp':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompListSub, list))));
		default:
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompSub, inputElse))))
					]));
	}
};
var $author$project$ExpressionInput$protoLocalDateListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDateListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListSub, inputElse))))
					]));
		case 'ProtoLocalAllDatesInField':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalDatesAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedSub(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalDateSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDate':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalDateLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalDateHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalDateTimeToDate':
			var inputDateTime = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputDateTime))));
		case 'ProtoLocalDateCeiling':
			var inputDateInterval = proto.a;
			var inputDate = proto.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputDate))));
		case 'ProtoLocalDateFloor':
			var inputDateInterval = proto.a;
			var inputDate = proto.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputDate))));
		case 'ProtoLocalDateAdd':
			var inputDateUnit = proto.a;
			var inputNumber = proto.b;
			var inputDate = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputDate)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputNumber))))
					]));
		case 'ProtoLocalDateSubtract':
			var inputDateUnit = proto.a;
			var inputNumber = proto.b;
			var inputDate = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputDate)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputNumber))))
					]));
		case 'ProtoLocalDateIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputElse))))
					]));
		case 'ProtoLocalPickDate':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListSub, list))));
		case 'ProtoLocalMaxDate':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListSub, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateListSub, list))));
	}
};
var $author$project$ExpressionInput$protoLocalDateTimeListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDateTimeListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListSub, inputElse))))
					]));
		case 'ProtoLocalAllDateTimesInField':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalDateTimesAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedSub(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalDateTimeSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalDateTime':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalDateTimeLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalDateTimeHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalDateTimeIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputElse))))
					]));
		case 'ProtoLocalPickDateTime':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListSub, list))));
		case 'ProtoLocalMaxDateTime':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListSub, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeListSub, list))));
	}
};
var $author$project$ExpressionInput$protoLocalFieldSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalStringSub(fieldProto);
		case 'ProtoLocalNumberField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalNumberSub(fieldProto);
		case 'ProtoLocalDateField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalDateSub(fieldProto);
		case 'ProtoLocalDateTimeField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalDateTimeSub(fieldProto);
		case 'ProtoLocalBoolField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalBoolSub(fieldProto);
		case 'ProtoLocalAnyField':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalAnySub(fieldProto);
		default:
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalCompSub(fieldProto);
	}
};
var $author$project$ExpressionInput$protoLocalNumberListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalNumberListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListSub, inputElse))))
					]));
		case 'ProtoLocalAllNumbersInField':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalNumbersAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		default:
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedSub(relationship);
	}
};
var $author$project$ExpressionInput$protoLocalNumberSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalNumber':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalNumberLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalNumberHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalCountUnique':
			var inputCompField = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompFieldListSub, inputCompField))));
		case 'ProtoLocalRoundNumber':
			var inputNumber = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputNumber))));
		case 'ProtoLocalSum':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListSub, list))));
		case 'ProtoLocalProduct':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListSub, list))));
		case 'ProtoLocalAdd':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalSubtract':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalMultiply':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalDivide':
			var inputA = proto.a;
			var inputB = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputA)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputB))))
					]));
		case 'ProtoLocalMonthNumber':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputDate))));
		case 'ProtoLocalYearNumber':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputDate))));
		case 'ProtoLocalDayInMonth':
			var inputDate = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputDate))));
		case 'ProtoLocalNumberIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputElse))))
					]));
		case 'ProtoLocalPickNumber':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListSub, list))));
		case 'ProtoLocalMaxNumber':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListSub, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberListSub, list))));
	}
};
var $author$project$ExpressionInput$protoLocalRelatedSub = function (_v2) {
	var localIds = _v2.localIds;
	var nextElement = _v2.nextElement;
	var idToMatch = _v2.idToMatch;
	var optionalFilter = _v2.optionalFilter;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(2),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, idToMatch)))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(3),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListSub, localIds)))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(4),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, optionalFilter))))
			]));
};
var $author$project$ExpressionInput$protoLocalStringListSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringListIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListSub, inputElse))))
					]));
		case 'ProtoLocalAllStringsInField':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalStringsAsList':
			var inputList = proto.a;
			var dragModel = proto.b;
			return $author$project$ExpressionInput$Msg$dndSystem.subscriptions(dragModel);
		case 'ProtoRelatedString':
			var relationship = proto.a;
			var state = proto.b;
			return $author$project$ExpressionInput$protoLocalRelatedSub(relationship);
		case 'ProtoLocalChallengeReasons':
			var acctIdInput = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, acctIdInput))));
		default:
			var acctIdInput = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, acctIdInput))));
	}
};
var $author$project$ExpressionInput$protoLocalStringSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalString':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalStringLookup':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalStringHardcoded':
			return $elm$core$Platform$Sub$none;
		case 'ProtoLocalFormatDate':
			var inputString = proto.a;
			var inputDate = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, inputDate)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputString))))
					]));
		case 'ProtoLocalFormatDateTime':
			var inputDateTime = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, inputDateTime))));
		case 'ProtoLocalFormatNumber':
			var inputIntInput = proto.a;
			var inputNumber = proto.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, inputNumber))));
		case 'ProtoLocalStringIf':
			var inputIf = proto.a;
			var inputThen = proto.b;
			var inputElse = proto.c;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, inputIf)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputThen)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(2),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputElse))))
					]));
		case 'ProtoLocalPickString':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListSub, list))));
		case 'ProtoLocalConcat':
			var inputString = proto.a;
			var list = proto.b;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(0),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListSub, list)))),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$ExpressionInput$Msg$InnerMsg(1),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Sub$none,
							$author$project$Input$toMaybe(
								A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, inputString))))
					]));
		case 'ProtoLocalMaxString':
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListSub, list))));
		default:
			var list = proto.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$InnerMsg(0),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringListSub, list))));
	}
};
var $author$project$ExpressionInput$protoLocalCompFieldSub = function (proto) {
	switch (proto.$) {
		case 'ProtoLocalStringComp':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalStringSub(fieldProto);
		case 'ProtoLocalNumberComp':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalNumberSub(fieldProto);
		case 'ProtoLocalDateComp':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalDateSub(fieldProto);
		case 'ProtoLocalDateTimeComp':
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalDateTimeSub(fieldProto);
		default:
			var fieldProto = proto.a;
			return $author$project$ExpressionInput$protoLocalCompSub(fieldProto);
	}
};
var $author$project$ExpressionInput$subscriptions = function (model) {
	switch (model.$) {
		case 'GlobalFieldInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalFieldSub, input))));
		case 'GlobalCompInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalCompFieldSub, input))));
		case 'GlobalStringInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringSub, input))));
		case 'GlobalNumberInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberSub, input))));
		case 'GlobalDateInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateSub, input))));
		case 'GlobalDateTimeInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeSub, input))));
		case 'GlobalBoolInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolSub, input))));
		case 'GlobalStringListInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalStringListSub, input))));
		case 'GlobalNumberListInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalNumberListSub, input))));
		case 'GlobalDateListInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateListSub, input))));
		case 'GlobalDateTimeListInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalDateTimeListSub, input))));
		case 'GlobalBoolListInput':
			var input = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoGlobalBoolListSub, input))));
		case 'LocalStringInput':
			var input = model.c;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalStringSub, input))));
		case 'LocalCompInput':
			var input = model.c;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalCompFieldSub, input))));
		case 'LocalNumberInput':
			var input = model.c;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalNumberSub, input))));
		case 'LocalDateInput':
			var input = model.c;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateSub, input))));
		case 'LocalDateTimeInput':
			var input = model.c;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalDateTimeSub, input))));
		case 'LocalBoolInput':
			var input = model.c;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalBoolSub, input))));
		case 'LocalFieldInput':
			var input = model.c;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$ExpressionInput$Msg$MsgForInput,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					$author$project$Input$toMaybe(
						A2($author$project$Input$map, $author$project$ExpressionInput$protoLocalFieldSub, input))));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $Fresheyeball$elm_return$Return$effect_ = F2(
	function (f, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						f(model)
					])));
	});
var $Fresheyeball$elm_return$Return$map = F2(
	function (f, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			f(model),
			cmd);
	});
var $author$project$ExpressionInput$notifySuccessChange = F6(
	function (parse, validate, getObjectTags, encodeSuccess, old, _new) {
		var maybeOld = A2(
			$author$project$ExpressionInput$validateInput,
			validate,
			parse(old));
		var maybeNew = A2(
			$author$project$ExpressionInput$validateInput,
			validate,
			parse(_new));
		var _v0 = _Utils_Tuple2(maybeOld, maybeNew);
		if (_v0.a.$ === 'Nothing') {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm$core$Platform$Cmd$none;
			} else {
				var _v4 = _v0.a;
				var success = _v0.b.a;
				return $author$project$ExpressionInput$sendUpdateToJs(
					$elm$core$Maybe$Just(
						A3($author$project$ExpressionInput$encodeExpressionObjectTags, getObjectTags, encodeSuccess, success)));
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v3 = _v0.b;
				return $author$project$ExpressionInput$sendUpdateToJs($elm$core$Maybe$Nothing);
			} else {
				var oldSuccess = _v0.a.a;
				var newSuccess = _v0.b.a;
				return _Utils_eq(oldSuccess, newSuccess) ? $elm$core$Platform$Cmd$none : $author$project$ExpressionInput$sendUpdateToJs(
					$elm$core$Maybe$Just(
						A3($author$project$ExpressionInput$encodeExpressionObjectTags, getObjectTags, encodeSuccess, newSuccess)));
			}
		}
	});
var $Fresheyeball$elm_return$Return$singleton = function (a) {
	return _Utils_Tuple2(a, $elm$core$Platform$Cmd$none);
};
var $author$project$ExpressionInput$standardUpdatePipeline = F3(
	function (info, inputMsg, input) {
		return A2(
			$Fresheyeball$elm_return$Return$map,
			info.toModel,
			A2(
				$Fresheyeball$elm_return$Return$effect_,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Input$map(info.toDragCmds),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Input$toMaybe,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none),
							$elm$core$Platform$Cmd$map($author$project$ExpressionInput$Msg$MsgForInput)))),
				A2(
					$Fresheyeball$elm_return$Return$effect_,
					A5($author$project$ExpressionInput$notifySuccessChange, info.parse, info.validate, info.objectTags, info.encode, input),
					$Fresheyeball$elm_return$Return$singleton(
						A2(info.updateHelper, inputMsg, input)))));
	});
var $author$project$ExpressionInput$updateInputExpression = F2(
	function (inputMsg, model) {
		switch (model.$) {
			case 'GlobalFieldInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalFieldInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalCompInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalCompInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalStringInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalStringInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalNumberInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalNumberInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalDateInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalDateInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalDateTimeInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalDateTimeInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalBoolInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalBoolInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'LocalFieldInput':
				var viewInfo = model.a;
				var ref = model.b;
				var input = model.c;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					A2($author$project$ExpressionInput$localFieldInputPipeline, viewInfo, ref),
					inputMsg,
					input);
			case 'LocalCompInput':
				var viewInfo = model.a;
				var ref = model.b;
				var input = model.c;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					A2($author$project$ExpressionInput$localCompInputPipeline, viewInfo, ref),
					inputMsg,
					input);
			case 'LocalStringInput':
				var viewInfo = model.a;
				var ref = model.b;
				var input = model.c;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					A2($author$project$ExpressionInput$localStringInputPipeline, viewInfo, ref),
					inputMsg,
					input);
			case 'LocalNumberInput':
				var viewInfo = model.a;
				var ref = model.b;
				var input = model.c;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					A2($author$project$ExpressionInput$localNumberInputPipeline, viewInfo, ref),
					inputMsg,
					input);
			case 'LocalDateInput':
				var viewInfo = model.a;
				var ref = model.b;
				var input = model.c;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					A2($author$project$ExpressionInput$localDateInputPipeline, viewInfo, ref),
					inputMsg,
					input);
			case 'LocalDateTimeInput':
				var viewInfo = model.a;
				var ref = model.b;
				var input = model.c;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					A2($author$project$ExpressionInput$localDateTimeInputPipeline, viewInfo, ref),
					inputMsg,
					input);
			case 'LocalBoolInput':
				var viewInfo = model.a;
				var ref = model.b;
				var input = model.c;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					A2($author$project$ExpressionInput$localBoolInputPipeline, viewInfo, ref),
					inputMsg,
					input);
			case 'GlobalStringListInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalStringListInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalNumberListInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalNumberListInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalDateListInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalDateListInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalDateTimeListInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalDateTimeListInputPipeline(viewInfo),
					inputMsg,
					input);
			case 'GlobalBoolListInput':
				var viewInfo = model.a;
				var input = model.b;
				return A3(
					$author$project$ExpressionInput$standardUpdatePipeline,
					$author$project$ExpressionInput$globalBoolListInputPipeline(viewInfo),
					inputMsg,
					input);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$ExpressionInput$update = F2(
	function (msg, model) {
		var inputMsg = msg.a;
		return A2($author$project$ExpressionInput$updateInputExpression, inputMsg, model);
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Icon$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $author$project$Icon$makeIcon = F2(
	function (name, category) {
		return $author$project$Icon$Icon(
			{category: category, name: name});
	});
var $author$project$Icon$bool = A2($author$project$Icon$makeIcon, 'check', 'utility');
var $author$project$ExpressionInput$translateMessage = F2(
	function (veevaMessages, key) {
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, veevaMessages));
	});
var $author$project$ExpressionInput$boolToTranslatedString = F2(
	function (viewInfo, bool) {
		return bool ? A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'BOOLEAN_TRUE') : A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'BOOLEAN_FALSE');
	});
var $author$project$Icon$date = A2($author$project$Icon$makeIcon, 'date_input', 'utility');
var $author$project$Icon$dateTime = A2($author$project$Icon$makeIcon, 'date_time', 'utility');
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$FieldTypeRequirement$mostSpecificRequirement = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalString':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType);
		case 'BaseGlobalNumber':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType);
		case 'BaseGlobalDate':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType);
		case 'BaseGlobalDateTime':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType);
		case 'BaseGlobalBool':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType);
		case 'BaseGlobalAny':
			return $author$project$FieldTypeRequirement$AnyType;
		case 'BaseGlobalComp':
			return $author$project$FieldTypeRequirement$AnyComparableType;
		case 'BaseGlobalStringList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType);
		case 'BaseGlobalNumberList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType);
		case 'BaseGlobalDateList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType);
		case 'BaseGlobalDateTimeList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType);
		case 'BaseGlobalBoolList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType);
		case 'BaseGlobalAnyList':
			return $author$project$FieldTypeRequirement$AnyType;
		case 'BaseGlobalCompList':
			return $author$project$FieldTypeRequirement$AnyComparableType;
		case 'BaseLocalString':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType);
		case 'BaseLocalNumber':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType);
		case 'BaseLocalDate':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType);
		case 'BaseLocalDateTime':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType);
		case 'BaseLocalBool':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType);
		case 'BaseLocalAny':
			return $author$project$FieldTypeRequirement$AnyType;
		case 'BaseLocalComp':
			return $author$project$FieldTypeRequirement$AnyComparableType;
		case 'BaseLocalStringList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType);
		case 'BaseLocalNumberList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType);
		case 'BaseLocalDateList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType);
		case 'BaseLocalDateTimeList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType);
		case 'BaseLocalBoolList':
			return $author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType);
		case 'BaseLocalAnyList':
			return $author$project$FieldTypeRequirement$AnyType;
		case 'BaseLocalCompList':
			return $author$project$FieldTypeRequirement$AnyComparableType;
		case 'BaseListRef':
			return $author$project$FieldTypeRequirement$AnyType;
		case 'BaseFieldName':
			var fieldType = proto.a;
			return $author$project$FieldTypeRequirement$OneDataType(fieldType);
		case 'BaseDateInterval':
			return $author$project$FieldTypeRequirement$AnyType;
		default:
			return $author$project$FieldTypeRequirement$AnyType;
	}
};
var $author$project$SearchOption$fieldTypeMatchesRequirement = F2(
	function (requirement, _v0) {
		var proto = _v0.a.proto;
		var _v1 = _Utils_Tuple2(
			requirement,
			$author$project$FieldTypeRequirement$mostSpecificRequirement(proto));
		switch (_v1.a.$) {
			case 'AnyType':
				var _v2 = _v1.a;
				return true;
			case 'AnyComparableType':
				if ((_v1.b.$ === 'OneDataType') && (_v1.b.a.$ === 'BoolType')) {
					var _v3 = _v1.a;
					var _v4 = _v1.b.a;
					return false;
				} else {
					var _v5 = _v1.a;
					return true;
				}
			default:
				switch (_v1.b.$) {
					case 'AnyType':
						var _v6 = _v1.b;
						return true;
					case 'AnyComparableType':
						if (_v1.a.a.$ === 'BoolType') {
							var _v7 = _v1.a.a;
							var _v8 = _v1.b;
							return false;
						} else {
							var _v9 = _v1.b;
							return true;
						}
					default:
						var requiredType = _v1.a.a;
						var typeOnOffer = _v1.b.a;
						return _Utils_eq(requiredType, typeOnOffer);
				}
		}
	});
var $author$project$SearchOption$fromSeed = function (_v0) {
	var label = _v0.a.label;
	var proto = _v0.a.proto;
	return {label: label, proto: proto};
};
var $author$project$DataElement$ProtoExpression$BaseGlobalStringList = function (a) {
	return {$: 'BaseGlobalStringList', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseLocalStringList = function (a) {
	return {$: 'BaseLocalStringList', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseGlobalAnyList = function (a) {
	return {$: 'BaseGlobalAnyList', a: a};
};
var $annaghi$dnd_list$DnDList$Swap = {$: 'Swap'};
var $author$project$SearchOption$dnDConfig = {
	beforeUpdate: F3(
		function (_v0, _v1, list) {
			return list;
		}),
	listen: $annaghi$dnd_list$DnDList$OnDrag,
	movement: $annaghi$dnd_list$DnDList$Vertical,
	operation: $annaghi$dnd_list$DnDList$Swap
};
var $author$project$SearchOption$dndSystem = A2($annaghi$dnd_list$DnDList$create, $author$project$SearchOption$dnDConfig, $elm$core$Basics$identity);
var $author$project$SearchOption$Seed = function (a) {
	return {$: 'Seed', a: a};
};
var $author$project$SearchOption$simpleSeed = F2(
	function (label, proto) {
		return $author$project$SearchOption$Seed(
			{alternateSearch: '', label: label, proto: proto});
	});
var $author$project$SearchOption$translateVM = F2(
	function (veevaMessages, key) {
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, veevaMessages));
	});
var $author$project$SearchOption$baseGlobalListSeeds = function (veevaMessages) {
	return _List_fromArray(
		[
			A2(
			$author$project$SearchOption$simpleSeed,
			A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_FIELD_IN_LIST'),
			$author$project$DataElement$ProtoExpression$BaseGlobalAnyList(
				A2($author$project$DataElement$ProtoExpression$ProtoGlobalAllAnysInField, $author$project$Input$empty, $author$project$Input$emptyState))),
			A2(
			$author$project$SearchOption$simpleSeed,
			A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_LIST_OF_EXPRESSIONS'),
			$author$project$DataElement$ProtoExpression$BaseGlobalAnyList(
				A2(
					$author$project$DataElement$ProtoExpression$ProtoGlobalAnysAsList,
					_List_fromArray(
						[$author$project$Input$empty]),
					$author$project$SearchOption$dndSystem.model))),
			A2(
			$author$project$SearchOption$simpleSeed,
			A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_IF'),
			$author$project$DataElement$ProtoExpression$BaseGlobalAnyList(
				A3($author$project$DataElement$ProtoExpression$ProtoGlobalAnyListIf, $author$project$Input$empty, $author$project$Input$empty, $author$project$Input$empty)))
		]);
};
var $author$project$DataElement$ProtoExpression$BaseLocalAnyList = function (a) {
	return {$: 'BaseLocalAnyList', a: a};
};
var $author$project$DataElement$ProtoExpression$emptyRelationship = {idToMatch: $author$project$Input$empty, localIds: $author$project$Input$empty, nextElement: $author$project$Input$empty, optionalFilter: $author$project$Input$empty};
var $author$project$SearchOption$baseLocalListSeeds = function (veevaMessages) {
	return _List_fromArray(
		[
			A2(
			$author$project$SearchOption$simpleSeed,
			A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_FIELD_IN_LIST'),
			$author$project$DataElement$ProtoExpression$BaseLocalAnyList(
				A2($author$project$DataElement$ProtoExpression$ProtoLocalAllAnysInField, $author$project$Input$empty, $author$project$Input$emptyState))),
			A2(
			$author$project$SearchOption$simpleSeed,
			A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_LIST_OF_EXPRESSIONS'),
			$author$project$DataElement$ProtoExpression$BaseLocalAnyList(
				A2(
					$author$project$DataElement$ProtoExpression$ProtoLocalAnysAsList,
					_List_fromArray(
						[$author$project$Input$empty]),
					$author$project$SearchOption$dndSystem.model))),
			A2(
			$author$project$SearchOption$simpleSeed,
			A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_RELATED_FIELD'),
			$author$project$DataElement$ProtoExpression$BaseLocalAnyList(
				A2($author$project$DataElement$ProtoExpression$ProtoLocalRelatedAny, $author$project$DataElement$ProtoExpression$emptyRelationship, $author$project$Input$emptyState))),
			A2(
			$author$project$SearchOption$simpleSeed,
			A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_IF'),
			$author$project$DataElement$ProtoExpression$BaseLocalAnyList(
				A3($author$project$DataElement$ProtoExpression$ProtoLocalAnyListIf, $author$project$Input$empty, $author$project$Input$empty, $author$project$Input$empty)))
		]);
};
var $author$project$SearchOption$listCalculationSeeds = F4(
	function (veevaMessages, i18nMessages, contentType, context) {
		var _v0 = _Utils_Tuple2(context, contentType);
		if (_v0.a.$ === 'Global') {
			if (_v0.b.$ === 'TerritoryFeedback') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return _Utils_ap(
					$author$project$SearchOption$baseGlobalListSeeds(veevaMessages),
					_List_fromArray(
						[
							A2(
							$author$project$SearchOption$simpleSeed,
							A2($author$project$SearchOption$translateVM, i18nMessages, 'challengeReasons'),
							$author$project$DataElement$ProtoExpression$BaseGlobalStringList(
								$author$project$DataElement$ProtoExpression$ProtoGlobalChallengeReasons($author$project$Input$empty))),
							A2(
							$author$project$SearchOption$simpleSeed,
							A2($author$project$SearchOption$translateVM, i18nMessages, 'targetChallengeReasons'),
							$author$project$DataElement$ProtoExpression$BaseGlobalStringList(
								$author$project$DataElement$ProtoExpression$ProtoGlobalTargetChallengeReasons($author$project$Input$empty)))
						]));
			} else {
				var _v3 = _v0.a;
				return $author$project$SearchOption$baseGlobalListSeeds(veevaMessages);
			}
		} else {
			if (_v0.b.$ === 'TerritoryFeedback') {
				var _v4 = _v0.b;
				return _Utils_ap(
					$author$project$SearchOption$baseLocalListSeeds(veevaMessages),
					_List_fromArray(
						[
							A2(
							$author$project$SearchOption$simpleSeed,
							A2($author$project$SearchOption$translateVM, i18nMessages, 'challengeReasons'),
							$author$project$DataElement$ProtoExpression$BaseLocalStringList(
								$author$project$DataElement$ProtoExpression$ProtoLocalChallengeReasons($author$project$Input$empty))),
							A2(
							$author$project$SearchOption$simpleSeed,
							A2($author$project$SearchOption$translateVM, i18nMessages, 'targetChallengeReasons'),
							$author$project$DataElement$ProtoExpression$BaseLocalStringList(
								$author$project$DataElement$ProtoExpression$ProtoLocalTargetChallengeReasons($author$project$Input$empty)))
						]));
			} else {
				return $author$project$SearchOption$baseLocalListSeeds(veevaMessages);
			}
		}
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$SearchOption$singleSearchTermInSeed = F2(
	function (_v0, searchTerm) {
		var label = _v0.a.label;
		var alternateSearch = _v0.a.alternateSearch;
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchTerm),
			$elm$core$String$toLower(label + (' ' + alternateSearch)));
	});
var $author$project$SearchOption$matchesSearchTerm = F2(
	function (searchTerms, seed) {
		return A2(
			$elm$core$List$all,
			$author$project$SearchOption$singleSearchTermInSeed(seed),
			A2($elm$core$String$split, ' ', searchTerms));
	});
var $author$project$ExpressionInput$listSearchOptions = F4(
	function (viewInfo, context, typeRequirement, searchTerm) {
		return A2(
			$elm$core$List$map,
			$author$project$SearchOption$fromSeed,
			A2(
				$elm$core$List$filter,
				$author$project$SearchOption$matchesSearchTerm(searchTerm),
				A2(
					$elm$core$List$filter,
					$author$project$SearchOption$fieldTypeMatchesRequirement(typeRequirement),
					A4($author$project$SearchOption$listCalculationSeeds, viewInfo.veevaMessages, viewInfo.i18nMessages, viewInfo.contentType, context))));
	});
var $author$project$Icon$number = A2($author$project$Icon$makeIcon, 'number_input', 'utility');
var $elm_community$string_extra$String$Extra$surround = F2(
	function (wrapper, string) {
		return _Utils_ap(
			wrapper,
			_Utils_ap(string, wrapper));
	});
var $elm_community$string_extra$String$Extra$quote = function (string) {
	return A2($elm_community$string_extra$String$Extra$surround, '\"', string);
};
var $author$project$DataElement$ProtoExpression$BaseGlobalAny = function (a) {
	return {$: 'BaseGlobalAny', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseGlobalBool = function (a) {
	return {$: 'BaseGlobalBool', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseGlobalComp = function (a) {
	return {$: 'BaseGlobalComp', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseGlobalDate = function (a) {
	return {$: 'BaseGlobalDate', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseGlobalNumber = function (a) {
	return {$: 'BaseGlobalNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseGlobalString = function (a) {
	return {$: 'BaseGlobalString', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseLocalAny = function (a) {
	return {$: 'BaseLocalAny', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseLocalBool = function (a) {
	return {$: 'BaseLocalBool', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseLocalComp = function (a) {
	return {$: 'BaseLocalComp', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseLocalDate = function (a) {
	return {$: 'BaseLocalDate', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseLocalNumber = function (a) {
	return {$: 'BaseLocalNumber', a: a};
};
var $author$project$DataElement$ProtoExpression$BaseLocalString = function (a) {
	return {$: 'BaseLocalString', a: a};
};
var $author$project$SearchOption$calculationSeeds = F3(
	function (veevaMessages, i18nMessages, context) {
		if (context.$ === 'Global') {
			return _List_fromArray(
				[
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_COUNT_UNIQUE'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						$author$project$DataElement$ProtoExpression$ProtoGlobalCountUnique($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_SUM'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						$author$project$DataElement$ProtoExpression$ProtoGlobalSum($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_PRODUCT'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						$author$project$DataElement$ProtoExpression$ProtoGlobalProduct($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_ADD_NUM'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalAdd, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_SUBTRACT_NUM'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalSubtract, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_MULTIPLY_NUM'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalMultiply, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_DIVIDE_NUM'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalDivide, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_ROUND_NUM'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						$author$project$DataElement$ProtoExpression$ProtoGlobalRoundNumber($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_MAX'),
					$author$project$DataElement$ProtoExpression$BaseGlobalComp(
						$author$project$DataElement$ProtoExpression$ProtoGlobalMaxComp($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_MIN'),
					$author$project$DataElement$ProtoExpression$BaseGlobalComp(
						$author$project$DataElement$ProtoExpression$ProtoGlobalMinComp($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'valueFromList'),
					$author$project$DataElement$ProtoExpression$BaseGlobalAny(
						$author$project$DataElement$ProtoExpression$ProtoGlobalPickAny($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_CONCAT'),
					$author$project$DataElement$ProtoExpression$BaseGlobalString(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalConcat, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_NUMBER_TO_STRING'),
					$author$project$DataElement$ProtoExpression$BaseGlobalString(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalFormatNumber, $author$project$IntInput$Empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_FORMAT_DATE'),
					$author$project$DataElement$ProtoExpression$BaseGlobalString(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalFormatDate, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'formatDatetime'),
					$author$project$DataElement$ProtoExpression$BaseGlobalString(
						$author$project$DataElement$ProtoExpression$ProtoGlobalFormatDateTime($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'datetimeToDate'),
					$author$project$DataElement$ProtoExpression$BaseGlobalDate(
						$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeToDate($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_DATE_YEAR'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						$author$project$DataElement$ProtoExpression$ProtoGlobalYearNumber($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_DATE_MONTH'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						$author$project$DataElement$ProtoExpression$ProtoGlobalMonthNumber($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_DATE_DAY_IN_MONTH'),
					$author$project$DataElement$ProtoExpression$BaseGlobalNumber(
						$author$project$DataElement$ProtoExpression$ProtoGlobalDayInMonth($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'beginningOfCalendarPeriod'),
					$author$project$DataElement$ProtoExpression$BaseGlobalDate(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalDateFloor, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'endOfCalendarPeriod'),
					$author$project$DataElement$ProtoExpression$BaseGlobalDate(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalDateCeiling, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'addToDate'),
					$author$project$DataElement$ProtoExpression$BaseGlobalDate(
						A3($author$project$DataElement$ProtoExpression$ProtoGlobalDateAdd, $author$project$Input$empty, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'subtractFromDate'),
					$author$project$DataElement$ProtoExpression$BaseGlobalDate(
						A3($author$project$DataElement$ProtoExpression$ProtoGlobalDateSubtract, $author$project$Input$empty, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_NOT'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						$author$project$DataElement$ProtoExpression$ProtoGlobalNot($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_EQUAL'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalEqualAny, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_NOT_EQUAL'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalNotEqualAny, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_LT'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalLTComp, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_LTE'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalLTEComp, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_GT'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalGTComp, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_GTE'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalGTEComp, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'isNull'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						$author$project$DataElement$ProtoExpression$ProtoGlobalIsNull($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'isNotNull'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						$author$project$DataElement$ProtoExpression$ProtoGlobalIsNotNull($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_IN'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalStringIn, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_NOT_IN'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoGlobalStringNotIn, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_ALL'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						$author$project$DataElement$ProtoExpression$ProtoGlobalAll($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_ANY'),
					$author$project$DataElement$ProtoExpression$BaseGlobalBool(
						$author$project$DataElement$ProtoExpression$ProtoGlobalAny($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_IF'),
					$author$project$DataElement$ProtoExpression$BaseGlobalAny(
						A3($author$project$DataElement$ProtoExpression$ProtoGlobalAnyIf, $author$project$Input$empty, $author$project$Input$empty, $author$project$Input$empty)))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_COUNT_UNIQUE'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						$author$project$DataElement$ProtoExpression$ProtoLocalCountUnique($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_SUM'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						$author$project$DataElement$ProtoExpression$ProtoLocalSum($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_PRODUCT'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						$author$project$DataElement$ProtoExpression$ProtoLocalProduct($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_ADD_NUM'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalAdd, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_SUBTRACT_NUM'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalSubtract, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_MULTIPLY_NUM'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalMultiply, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_DIVIDE_NUM'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalDivide, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_ROUND_NUM'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						$author$project$DataElement$ProtoExpression$ProtoLocalRoundNumber($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_MAX'),
					$author$project$DataElement$ProtoExpression$BaseLocalComp(
						$author$project$DataElement$ProtoExpression$ProtoLocalMaxComp($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_MIN'),
					$author$project$DataElement$ProtoExpression$BaseLocalComp(
						$author$project$DataElement$ProtoExpression$ProtoLocalMinComp($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'valueFromList'),
					$author$project$DataElement$ProtoExpression$BaseLocalAny(
						$author$project$DataElement$ProtoExpression$ProtoLocalPickAny($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_CONCAT'),
					$author$project$DataElement$ProtoExpression$BaseLocalString(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalConcat, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_NUMBER_TO_STRING'),
					$author$project$DataElement$ProtoExpression$BaseLocalString(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalFormatNumber, $author$project$IntInput$Empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_FORMAT_DATE'),
					$author$project$DataElement$ProtoExpression$BaseLocalString(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalFormatDate, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'formatDatetime'),
					$author$project$DataElement$ProtoExpression$BaseLocalString(
						$author$project$DataElement$ProtoExpression$ProtoLocalFormatDateTime($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'datetimeToDate'),
					$author$project$DataElement$ProtoExpression$BaseLocalDate(
						$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeToDate($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_DATE_YEAR'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						$author$project$DataElement$ProtoExpression$ProtoLocalYearNumber($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_DATE_MONTH'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						$author$project$DataElement$ProtoExpression$ProtoLocalMonthNumber($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_DATE_DAY_IN_MONTH'),
					$author$project$DataElement$ProtoExpression$BaseLocalNumber(
						$author$project$DataElement$ProtoExpression$ProtoLocalDayInMonth($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'beginningOfCalendarPeriod'),
					$author$project$DataElement$ProtoExpression$BaseLocalDate(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalDateFloor, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'endOfCalendarPeriod'),
					$author$project$DataElement$ProtoExpression$BaseLocalDate(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalDateCeiling, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'addToDate'),
					$author$project$DataElement$ProtoExpression$BaseLocalDate(
						A3($author$project$DataElement$ProtoExpression$ProtoLocalDateAdd, $author$project$Input$empty, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'subtractFromDate'),
					$author$project$DataElement$ProtoExpression$BaseLocalDate(
						A3($author$project$DataElement$ProtoExpression$ProtoLocalDateSubtract, $author$project$Input$empty, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_NOT'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						$author$project$DataElement$ProtoExpression$ProtoLocalNot($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_EQUAL'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalEqualAny, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_NOT_EQUAL'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalNotEqualAny, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_LT'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalLTComp, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_LTE'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalLTEComp, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_GT'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalGTComp, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_GTE'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalGTEComp, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'isNull'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						$author$project$DataElement$ProtoExpression$ProtoLocalIsNull($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, i18nMessages, 'isNotNull'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						$author$project$DataElement$ProtoExpression$ProtoLocalIsNotNull($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_IN'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalStringIn, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_NOT_IN'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						A2($author$project$DataElement$ProtoExpression$ProtoLocalStringNotIn, $author$project$Input$empty, $author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_ALL'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						$author$project$DataElement$ProtoExpression$ProtoLocalAll($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_ANY'),
					$author$project$DataElement$ProtoExpression$BaseLocalBool(
						$author$project$DataElement$ProtoExpression$ProtoLocalAny($author$project$Input$empty))),
					A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateVM, veevaMessages, 'EXP_IF'),
					$author$project$DataElement$ProtoExpression$BaseLocalAny(
						A3($author$project$DataElement$ProtoExpression$ProtoLocalAnyIf, $author$project$Input$empty, $author$project$Input$empty, $author$project$Input$empty)))
				]);
		}
	});
var $author$project$DataElement$Reference$getReferenceFromUuid = function (uuid) {
	return $author$project$DataElement$Reference$Reference(uuid);
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$UuidDict$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$values(dict);
};
var $author$project$DataElement$collectionToList = function (_v0) {
	var uuidDict = _v0.a;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapFirst($author$project$DataElement$Reference$getReferenceFromUuid),
		$author$project$UuidDict$toList(uuidDict));
};
var $author$project$DataElement$Reference$IsRecordList = function (a) {
	return {$: 'IsRecordList', a: a};
};
var $author$project$DataElement$Reference$listFromUuid = function (uuid) {
	return $author$project$DataElement$Reference$IsRecordList(
		$author$project$DataElement$Reference$Reference(uuid));
};
var $author$project$DataElement$Reference$IsSingleton = function (a) {
	return {$: 'IsSingleton', a: a};
};
var $author$project$DataElement$Reference$singletonFromUuid = function (uuid) {
	return $author$project$DataElement$Reference$IsSingleton(
		$author$project$DataElement$Reference$Reference(uuid));
};
var $author$project$DataElement$eitherReference = F2(
	function (ref, element) {
		var uuid = $author$project$DataElement$Reference$getUuid(ref);
		var _v0 = $author$project$DataElement$unwrapElement(element);
		if (_v0.$ === 'RecordList') {
			return $author$project$DataElement$Reference$listFromUuid(uuid);
		} else {
			return $author$project$DataElement$Reference$singletonFromUuid(uuid);
		}
	});
var $author$project$DataElement$collectionToListWithEither = function (collection) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var ref = _v0.a;
			var element = _v0.b;
			return _Utils_Tuple2(
				A2($author$project$DataElement$eitherReference, ref, element),
				element);
		},
		$author$project$DataElement$collectionToList(collection));
};
var $NoRedInk$elm_compare$Compare$compose = F4(
	function (fn, comparator, left, right) {
		return A2(
			comparator,
			fn(left),
			fn(right));
	});
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $author$project$DataEngine$RecordMetadata$fields = function (_v0) {
	var dict = _v0.a;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapFirst($author$project$FieldName$fromString),
		$elm$core$Dict$toList(dict));
};
var $author$project$DataElement$ProtoExpression$BaseGlobalDateTime = function (a) {
	return {$: 'BaseGlobalDateTime', a: a};
};
var $author$project$SearchOption$globalFieldSeed = F3(
	function (singleRef, deName, _v0) {
		var fieldName = _v0.a;
		var fieldType = _v0.b;
		return $author$project$SearchOption$Seed(
			{
				alternateSearch: '',
				label: deName + (' -> ' + $author$project$FieldName$toString(fieldName)),
				proto: function () {
					switch (fieldType.$) {
						case 'StringType':
							return $author$project$DataElement$ProtoExpression$BaseGlobalString(
								A2($author$project$DataElement$ProtoExpression$ProtoGlobalStringLookup, singleRef, fieldName));
						case 'NumberType':
							return $author$project$DataElement$ProtoExpression$BaseGlobalNumber(
								A2($author$project$DataElement$ProtoExpression$ProtoGlobalNumberLookup, singleRef, fieldName));
						case 'DateType':
							return $author$project$DataElement$ProtoExpression$BaseGlobalDate(
								A2($author$project$DataElement$ProtoExpression$ProtoGlobalDateLookup, singleRef, fieldName));
						case 'DateTimeType':
							return $author$project$DataElement$ProtoExpression$BaseGlobalDateTime(
								A2($author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeLookup, singleRef, fieldName));
						default:
							return $author$project$DataElement$ProtoExpression$BaseGlobalBool(
								A2($author$project$DataElement$ProtoExpression$ProtoGlobalBoolLookup, singleRef, fieldName));
					}
				}()
			});
	});
var $author$project$DataElement$ProtoExpression$BaseLocalDateTime = function (a) {
	return {$: 'BaseLocalDateTime', a: a};
};
var $author$project$SearchOption$localFieldSeed = F2(
	function (deName, _v0) {
		var fieldName = _v0.a;
		var fieldType = _v0.b;
		return $author$project$SearchOption$Seed(
			{
				alternateSearch: 'local',
				label: deName + (' -> ' + $author$project$FieldName$toString(fieldName)),
				proto: function () {
					switch (fieldType.$) {
						case 'StringType':
							return $author$project$DataElement$ProtoExpression$BaseLocalString(
								$author$project$DataElement$ProtoExpression$ProtoLocalString(fieldName));
						case 'NumberType':
							return $author$project$DataElement$ProtoExpression$BaseLocalNumber(
								$author$project$DataElement$ProtoExpression$ProtoLocalNumber(fieldName));
						case 'DateType':
							return $author$project$DataElement$ProtoExpression$BaseLocalDate(
								$author$project$DataElement$ProtoExpression$ProtoLocalDate(fieldName));
						case 'DateTimeType':
							return $author$project$DataElement$ProtoExpression$BaseLocalDateTime(
								$author$project$DataElement$ProtoExpression$ProtoLocalDateTime(fieldName));
						default:
							return $author$project$DataElement$ProtoExpression$BaseLocalBool(
								$author$project$DataElement$ProtoExpression$ProtoLocalBool(fieldName));
					}
				}()
			});
	});
var $author$project$SearchOption$localSingletonFieldSeed = F3(
	function (singleRef, deName, _v0) {
		var fieldName = _v0.a;
		var fieldType = _v0.b;
		return $author$project$SearchOption$Seed(
			{
				alternateSearch: '',
				label: deName + (' -> ' + $author$project$FieldName$toString(fieldName)),
				proto: function () {
					switch (fieldType.$) {
						case 'StringType':
							return $author$project$DataElement$ProtoExpression$BaseLocalString(
								A2($author$project$DataElement$ProtoExpression$ProtoLocalStringLookup, singleRef, fieldName));
						case 'NumberType':
							return $author$project$DataElement$ProtoExpression$BaseLocalNumber(
								A2($author$project$DataElement$ProtoExpression$ProtoLocalNumberLookup, singleRef, fieldName));
						case 'DateType':
							return $author$project$DataElement$ProtoExpression$BaseLocalDate(
								A2($author$project$DataElement$ProtoExpression$ProtoLocalDateLookup, singleRef, fieldName));
						case 'DateTimeType':
							return $author$project$DataElement$ProtoExpression$BaseLocalDateTime(
								A2($author$project$DataElement$ProtoExpression$ProtoLocalDateTimeLookup, singleRef, fieldName));
						default:
							return $author$project$DataElement$ProtoExpression$BaseLocalBool(
								A2($author$project$DataElement$ProtoExpression$ProtoLocalBoolLookup, singleRef, fieldName));
					}
				}()
			});
	});
var $author$project$FieldName$toStringInsensitive = function (fieldName) {
	return $elm$core$String$toUpper(
		$author$project$FieldName$toString(fieldName));
};
var $author$project$FieldName$sortCaseInsensitive = F2(
	function (first, second) {
		return A2(
			$elm$core$Basics$compare,
			$author$project$FieldName$toStringInsensitive(first),
			$author$project$FieldName$toStringInsensitive(second));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$SearchOption$fields = F2(
	function (context, _v0) {
		var ref = _v0.a;
		var metadata = _v0.b;
		var _v1 = _Utils_Tuple2(context, metadata.listOrSingleton);
		if (_v1.a.$ === 'Global') {
			if (_v1.b.$ === 'Singleton') {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				if (ref.$ === 'IsSingleton') {
					var singleRef = ref.a;
					return A2(
						$elm$core$List$map,
						A2($author$project$SearchOption$globalFieldSeed, singleRef, metadata.name),
						A2(
							$elm$core$List$sortWith,
							A2($NoRedInk$elm_compare$Compare$compose, $elm$core$Tuple$first, $author$project$FieldName$sortCaseInsensitive),
							$author$project$DataEngine$RecordMetadata$fields(metadata.recordMetadata)));
				} else {
					var recordListReference = ref.a;
					return _List_Nil;
				}
			} else {
				return _List_Nil;
			}
		} else {
			if (_v1.b.$ === 'ListOfRecords') {
				var ourRef = _v1.a.a;
				var _v5 = _v1.b;
				if (ref.$ === 'IsRecordList') {
					var recordListReference = ref.a;
					return _Utils_eq(ourRef, recordListReference) ? A2(
						$elm$core$List$map,
						$author$project$SearchOption$localFieldSeed(metadata.name),
						A2(
							$elm$core$List$sortWith,
							A2($NoRedInk$elm_compare$Compare$compose, $elm$core$Tuple$first, $author$project$FieldName$sortCaseInsensitive),
							$author$project$DataEngine$RecordMetadata$fields(metadata.recordMetadata))) : _List_Nil;
				} else {
					var singleRef = ref.a;
					return _List_Nil;
				}
			} else {
				var ourRef = _v1.a.a;
				var _v7 = _v1.b;
				if (ref.$ === 'IsSingleton') {
					var singleRef = ref.a;
					return A2(
						$elm$core$List$map,
						A2($author$project$SearchOption$localSingletonFieldSeed, singleRef, metadata.name),
						A2(
							$elm$core$List$sortWith,
							A2($NoRedInk$elm_compare$Compare$compose, $elm$core$Tuple$first, $author$project$FieldName$sortCaseInsensitive),
							$author$project$DataEngine$RecordMetadata$fields(metadata.recordMetadata)));
				} else {
					var listRef = ref.a;
					return _List_Nil;
				}
			}
		}
	});
var $pzp1997$assoc_list$AssocList$map = F2(
	function (alter, _v0) {
		var alist = _v0.a;
		return $pzp1997$assoc_list$AssocList$D(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var key = _v1.a;
					var value = _v1.b;
					return _Utils_Tuple2(
						key,
						A2(alter, key, value));
				},
				alist));
	});
var $author$project$DataElement$fieldDict = F2(
	function (dataElements, element) {
		if (element.$ === 'RecordList') {
			switch (element.a.$) {
				case 'CrmQuery':
					var queryInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v1) {
							return function ($) {
								return $.fieldType;
							};
						},
						queryInfo.fields);
				case 'SalesQuery':
					return $author$project$DataElement$SalesQuery$fields;
				case 'NitroQuery':
					var queryInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v2) {
							return function ($) {
								return $.fieldType;
							};
						},
						queryInfo.fields);
				case 'CrmDataEngineQuery':
					var queryInfo = element.a.a;
					return $author$project$DataElement$CrmDataEngineQuery$fields(queryInfo);
				case 'CalcOneForOne':
					var oneForOne = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v3) {
							return $author$project$DataElement$Expression$localFieldDataType;
						},
						oneForOne.fields);
				case 'CalcSortList':
					var sortInfo = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$pzp1997$assoc_list$AssocList$empty,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DataElement$unwrapElement,
								$author$project$DataElement$fieldDict(dataElements)),
							A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, sortInfo.original)));
				case 'CalcFilterList':
					var filterInfo = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$pzp1997$assoc_list$AssocList$empty,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DataElement$unwrapElement,
								$author$project$DataElement$fieldDict(dataElements)),
							A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, filterInfo.original)));
				case 'CalcSublist':
					var sublistInfo = element.a.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$pzp1997$assoc_list$AssocList$empty,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DataElement$unwrapElement,
								$author$project$DataElement$fieldDict(dataElements)),
							A2($author$project$DataElement$getDataElementFromReferenceElement, dataElements, sublistInfo.original)));
				case 'CalcMergeList':
					var mergeListInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$fromList(
						A2(
							$elm$core$List$filterMap,
							function (fieldName) {
								return A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$pair(fieldName),
									A3($author$project$DataElement$getMergeListFieldTypeByRefAndName, mergeListInfo, dataElements, fieldName));
							},
							$pzp1997$assoc_list$AssocList$keys(
								$author$project$DataElement$MergeList$fields(mergeListInfo))));
				case 'AlignedTerritories':
					return $author$project$DataElement$AlignedTerritories$fields;
				case 'FeedbackChannelGoals':
					var feedbackChannelGoalsInfo = element.a.a;
					return $author$project$DataElement$FeedbackChannelGoals$fields(feedbackChannelGoalsInfo);
				case 'FeedbackProductGoals':
					var feedbackProductGoalsInfo = element.a.a;
					return $author$project$DataElement$FeedbackProductGoals$fields(feedbackProductGoalsInfo);
				case 'FeedbackAccountData':
					var feedbackAccountDataInfo = element.a.a;
					return $author$project$DataElement$FeedbackAccountData$fields(feedbackAccountDataInfo);
				case 'FeedbackAccountChannelGoals':
					var feedbackAccountChannelGoalsInfo = element.a.a;
					return $author$project$DataElement$FeedbackAccountChannelGoals$fields(feedbackAccountChannelGoalsInfo);
				case 'FeedbackAccountProductGoals':
					var feedbackAccountProductGoalsInfo = element.a.a;
					return $author$project$DataElement$FeedbackAccountProductGoals$fields(feedbackAccountProductGoalsInfo);
				case 'FeedbackAccountProductMetrics':
					var feedbackAccountProductMetricsInfo = element.a.a;
					return $author$project$DataElement$FeedbackAccountProductMetrics$fields(feedbackAccountProductMetricsInfo);
				default:
					var _v4 = element.a;
					return $author$project$DataElement$CallAttendees$fields;
			}
		} else {
			switch (element.a.$) {
				case 'FeedbackOverview':
					var overviewInfo = element.a.a;
					return overviewInfo.fields;
				case 'ContextQuery':
					var contextInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(contextInfo.fieldName, contextInfo.fieldType)
							]));
				case 'LimitOneCrmQuery':
					var queryInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v5) {
							return function ($) {
								return $.fieldType;
							};
						},
						queryInfo.fields);
				case 'LimitOneSalesQuery':
					return $author$project$DataElement$SalesQuery$fields;
				case 'LimitOneNitroQuery':
					var queryInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v6) {
							return function ($) {
								return $.fieldType;
							};
						},
						queryInfo.fields);
				case 'LimitOneCrmDataEngineQuery':
					var queryInfo = element.a.a;
					return $author$project$DataElement$CrmDataEngineQuery$fields(queryInfo);
				case 'Today':
					var _v7 = element.a;
					return $author$project$DataElement$Today$fields;
				case 'Now':
					var _v8 = element.a;
					return $author$project$DataElement$Now$fields;
				case 'CalcSummarize':
					var summarizeInfo = element.a.a;
					return A2(
						$pzp1997$assoc_list$AssocList$map,
						function (_v9) {
							return $author$project$DataElement$Expression$globalFieldDataType;
						},
						summarizeInfo.fields);
				case 'ObjectTranslation':
					return $pzp1997$assoc_list$AssocList$fromList(
						A2(
							$elm$core$List$map,
							function (fieldName) {
								return _Utils_Tuple2(fieldName, $author$project$FieldType$StringType);
							},
							$author$project$DataElement$ObjectTranslation$fieldNames));
				case 'FieldTranslation':
					var fieldTranslationInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$fromList(
						A2(
							$elm$core$List$map,
							function (fieldName) {
								return _Utils_Tuple2(fieldName, $author$project$FieldType$StringType);
							},
							$author$project$DataElement$FieldTranslation$fieldNames(fieldTranslationInfo)));
				case 'VeevaMessages':
					var vmInfo = element.a.a;
					return $pzp1997$assoc_list$AssocList$fromList(
						A2(
							$elm$core$List$map,
							function (fieldName) {
								return _Utils_Tuple2(fieldName, $author$project$FieldType$StringType);
							},
							$author$project$DataElement$VeevaMessages$fieldNames(vmInfo)));
				case 'DatepickerSelection':
					return $author$project$DataElement$Datepicker$fields;
				default:
					return $author$project$DataElement$Dropdown$fields;
			}
		}
	});
var $author$project$DataEngine$RecordMetadata$RecordMetadata = function (a) {
	return {$: 'RecordMetadata', a: a};
};
var $author$project$DataEngine$RecordMetadata$fromList = function (list) {
	return $author$project$DataEngine$RecordMetadata$RecordMetadata(
		$elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst($author$project$FieldName$toString),
				list)));
};
var $author$project$DataElement$getMetadata = F2(
	function (allDataElements, _v0) {
		var deName = _v0.a;
		var el = _v0.b;
		return {
			listOrSingleton: function () {
				if (el.$ === 'RecordList') {
					return $author$project$DataElement$Metadata$ListOfRecords;
				} else {
					return $author$project$DataElement$Metadata$Singleton;
				}
			}(),
			name: deName,
			recordMetadata: $author$project$DataEngine$RecordMetadata$fromList(
				$pzp1997$assoc_list$AssocList$toList(
					A2($author$project$DataElement$fieldDict, allDataElements, el)))
		};
	});
var $author$project$DataElement$sorter = F2(
	function (_v0, _v1) {
		var name1 = _v0.a;
		var element1 = _v0.b;
		var name2 = _v1.a;
		var element2 = _v1.b;
		var _v2 = _Utils_Tuple2(element1, element2);
		if (_v2.a.$ === 'RecordList') {
			if (_v2.b.$ === 'RecordList') {
				return A2(
					$elm$core$Basics$compare,
					$elm$core$String$toUpper(name1),
					$elm$core$String$toUpper(name2));
			} else {
				return $elm$core$Basics$LT;
			}
		} else {
			if (_v2.b.$ === 'RecordList') {
				return $elm$core$Basics$GT;
			} else {
				return A2(
					$elm$core$Basics$compare,
					$elm$core$String$toUpper(name1),
					$elm$core$String$toUpper(name2));
			}
		}
	});
var $author$project$ExpressionInput$getFieldsForSearch = F2(
	function (dataElements, context) {
		return A2(
			$elm$core$List$concatMap,
			$author$project$SearchOption$fields(context),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					$author$project$DataElement$getMetadata(dataElements)),
				A2(
					$elm$core$List$sortWith,
					A2($NoRedInk$elm_compare$Compare$compose, $elm$core$Tuple$second, $author$project$DataElement$sorter),
					$author$project$DataElement$collectionToListWithEither(dataElements))));
	});
var $author$project$FieldValue$BoolValue = function (a) {
	return {$: 'BoolValue', a: a};
};
var $author$project$FieldValue$DateValue = function (a) {
	return {$: 'DateValue', a: a};
};
var $author$project$FieldValue$NumberValue = function (a) {
	return {$: 'NumberValue', a: a};
};
var $author$project$FieldValue$StringValue = function (a) {
	return {$: 'StringValue', a: a};
};
var $author$project$SearchOption$translateBool = F2(
	function (veevaMessages, bool) {
		return bool ? A2(
			$elm$core$Maybe$withDefault,
			'True',
			A2($elm$core$Dict$get, 'BOOLEAN_TRUE', veevaMessages)) : A2(
			$elm$core$Maybe$withDefault,
			'False',
			A2($elm$core$Dict$get, 'BOOLEAN_FALSE', veevaMessages));
	});
var $author$project$SearchOption$hardcoded = F3(
	function (veevaMessages, context, fieldValue) {
		switch (fieldValue.$) {
			case 'StringValue':
				var words = fieldValue.a;
				return $author$project$SearchOption$Seed(
					{
						alternateSearch: '',
						label: function ($) {
							return $.text;
						}(words),
						proto: function () {
							if (context.$ === 'Global') {
								return $author$project$DataElement$ProtoExpression$BaseGlobalString(
									$author$project$DataElement$ProtoExpression$ProtoGlobalStringHardcoded(
										function ($) {
											return $.text;
										}(words)));
							} else {
								return $author$project$DataElement$ProtoExpression$BaseLocalString(
									$author$project$DataElement$ProtoExpression$ProtoLocalStringHardcoded(
										function ($) {
											return $.text;
										}(words)));
							}
						}()
					});
			case 'NumberValue':
				var number = fieldValue.a;
				return $author$project$SearchOption$Seed(
					{
						alternateSearch: '',
						label: $elm$core$String$fromFloat(number),
						proto: function () {
							if (context.$ === 'Global') {
								return $author$project$DataElement$ProtoExpression$BaseGlobalNumber(
									$author$project$DataElement$ProtoExpression$ProtoGlobalNumberHardcoded(number));
							} else {
								return $author$project$DataElement$ProtoExpression$BaseLocalNumber(
									$author$project$DataElement$ProtoExpression$ProtoLocalNumberHardcoded(number));
							}
						}()
					});
			case 'DateValue':
				var date = fieldValue.a;
				return $author$project$SearchOption$Seed(
					{
						alternateSearch: '',
						label: $justinmimbs$date$Date$toIsoString(date),
						proto: function () {
							if (context.$ === 'Global') {
								return $author$project$DataElement$ProtoExpression$BaseGlobalDate(
									$author$project$DataElement$ProtoExpression$ProtoGlobalDateHardcoded(date));
							} else {
								return $author$project$DataElement$ProtoExpression$BaseLocalDate(
									$author$project$DataElement$ProtoExpression$ProtoLocalDateHardcoded(date));
							}
						}()
					});
			case 'DateTimeValue':
				var posix = fieldValue.a;
				return $author$project$SearchOption$Seed(
					{
						alternateSearch: '',
						label: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(posix),
						proto: function () {
							if (context.$ === 'Global') {
								return $author$project$DataElement$ProtoExpression$BaseGlobalDateTime(
									$author$project$DataElement$ProtoExpression$ProtoGlobalDateTimeHardcoded(posix));
							} else {
								return $author$project$DataElement$ProtoExpression$BaseLocalDateTime(
									$author$project$DataElement$ProtoExpression$ProtoLocalDateTimeHardcoded(posix));
							}
						}()
					});
			default:
				var bool = fieldValue.a;
				return A2(
					$author$project$SearchOption$simpleSeed,
					A2($author$project$SearchOption$translateBool, veevaMessages, bool),
					function () {
						if (context.$ === 'Global') {
							return $author$project$DataElement$ProtoExpression$BaseGlobalBool(
								$author$project$DataElement$ProtoExpression$ProtoGlobalBoolHardcoded(bool));
						} else {
							return $author$project$DataElement$ProtoExpression$BaseLocalBool(
								$author$project$DataElement$ProtoExpression$ProtoLocalBoolHardcoded(bool));
						}
					}());
		}
	});
var $elm$core$Result$toMaybe = function (result) {
	if (result.$ === 'Ok') {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$StudioString$StudioString = F2(
	function (text, object) {
		return {object: object, text: text};
	});
var $author$project$StudioString$withoutObject = function (text) {
	return A2($author$project$StudioString$StudioString, text, $elm$core$Maybe$Nothing);
};
var $author$project$ExpressionInput$hardCodedOptions = F3(
	function (viewInfo, context, words) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A3(
						$author$project$SearchOption$hardcoded,
						viewInfo.veevaMessages,
						context,
						$author$project$FieldValue$StringValue(
							$author$project$StudioString$withoutObject(words)))),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$FieldValue$NumberValue,
						A2($author$project$SearchOption$hardcoded, viewInfo.veevaMessages, context)),
					$elm$core$String$toFloat(words)),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$FieldValue$DateValue,
						A2($author$project$SearchOption$hardcoded, viewInfo.veevaMessages, context)),
					$elm$core$Result$toMaybe(
						$justinmimbs$date$Date$fromIsoString(words))),
					$elm$core$Maybe$Just(
					A3(
						$author$project$SearchOption$hardcoded,
						viewInfo.veevaMessages,
						context,
						$author$project$FieldValue$BoolValue(true))),
					$elm$core$Maybe$Just(
					A3(
						$author$project$SearchOption$hardcoded,
						viewInfo.veevaMessages,
						context,
						$author$project$FieldValue$BoolValue(false)))
				]));
	});
var $author$project$ExpressionInput$searchOptions = F4(
	function (viewInfo, context, typeRequirement, searchTerm) {
		return A2(
			$elm$core$List$map,
			$author$project$SearchOption$fromSeed,
			A2(
				$elm$core$List$filter,
				$author$project$SearchOption$matchesSearchTerm(searchTerm),
				A2(
					$elm$core$List$filter,
					$author$project$SearchOption$fieldTypeMatchesRequirement(typeRequirement),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2($author$project$ExpressionInput$getFieldsForSearch, viewInfo.dataElements, context),
								A3($author$project$ExpressionInput$hardCodedOptions, viewInfo, context, searchTerm),
								A3($author$project$SearchOption$calculationSeeds, viewInfo.veevaMessages, viewInfo.i18nMessages, context)
							])))));
	});
var $author$project$Icon$string = A2($author$project$Icon$makeIcon, 'text', 'utility');
var $author$project$ExpressionInput$Msg$Reset = {$: 'Reset'};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$ExpressionInput$onEnter = function (msg) {
	var isEnter = function (code) {
		return (code === 13) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('not ENTER');
	};
	return A2(
		$elm$html$Html$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isEnter, $elm$html$Html$Events$keyCode));
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$use = $elm$svg$Svg$trustedNode('use');
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$ExpressionInput$viewLabelledInputRow = F2(
	function (index, _v0) {
		var label = _v0.a;
		var viewIndex = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row-data')
				]),
			_List_fromArray(
				[
					$elm$core$String$isEmpty(label) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('exp-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					viewIndex(index)
				]));
	});
var $author$project$ExpressionInput$viewLabelledInputRows = function (items) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('selection')
			]),
		A2($elm$core$List$indexedMap, $author$project$ExpressionInput$viewLabelledInputRow, items));
};
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$ExpressionInput$viewExpressionWithLabelledChildren = F3(
	function (viewInfo, exprName, labelledChildren) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('config-expression')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('exp-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selection')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(exprName),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$section,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('config-field inner-element')
														]),
													_List_fromArray(
														[
															$author$project$ExpressionInput$viewLabelledInputRows(labelledChildren)
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$tabindex(0),
									$elm$html$Html$Attributes$class('close-icon-wrapper'),
									$elm$html$Html$Events$onClick($author$project$ExpressionInput$Msg$Reset),
									$author$project$ExpressionInput$onEnter($author$project$ExpressionInput$Msg$Reset)
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$svg,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('close-icon')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$use,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$xlinkHref(viewInfo.iconsUri + '#close')
												]),
											_List_Nil)
										]))
								]))
						]))
				]));
	});
var $author$project$ExpressionInput$viewLabelOperatorRowHelper = F3(
	function (viewInfo, operator, index) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('label-operator')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(operator)
				]));
	});
var $author$project$ExpressionInput$Msg$MsgForInputState = function (a) {
	return {$: 'MsgForInputState', a: a};
};
var $author$project$ExpressionInput$Msg$OpenSearchList = {$: 'OpenSearchList'};
var $author$project$ExpressionInput$Msg$UserTyped = function (a) {
	return {$: 'UserTyped', a: a};
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseUp = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $Kurren123$k_dropdown_container$DropdownContainer$attributes = F3(
	function (state, config, visible) {
		var visibilityValue = function () {
			if (visible.$ === 'Open') {
				return 'block';
			} else {
				return 'none';
			}
		}();
		return _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', visibilityValue),
				A2($elm$html$Html$Attributes$style, 'z-index', '20'),
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				$elm$html$Html$Attributes$tabindex(config.tabIndex),
				$elm$html$Html$Events$onMouseDown(
				config.setState(
					$Kurren123$k_dropdown_container$DropdownContainer$State(true))),
				$elm$html$Html$Events$onMouseUp(
				config.setState(
					$Kurren123$k_dropdown_container$DropdownContainer$State(false))),
				$elm$html$Html$Events$onBlur(config.dropdownBlur)
			]);
	});
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$ExpressionInput$Msg$CloseSearchList = {$: 'CloseSearchList'};
var $author$project$ExpressionInput$Msg$SetDropdownState = function (a) {
	return {$: 'SetDropdownState', a: a};
};
var $author$project$ExpressionInput$dropdownConfig = {
	dropdownBlur: $author$project$ExpressionInput$Msg$MsgForInputState($author$project$ExpressionInput$Msg$CloseSearchList),
	setState: A2($elm$core$Basics$composeL, $author$project$ExpressionInput$Msg$MsgForInputState, $author$project$ExpressionInput$Msg$SetDropdownState),
	tabIndex: -20
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 'MayStopPropagation', a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $Kurren123$k_dropdown_container$DropdownContainer$triggerAttributes = function (config) {
	return _List_fromArray(
		[
			$elm$html$Html$Events$onBlur(config.dropdownBlur)
		]);
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$MyInsights$Online = {$: 'Online'};
var $author$project$ExpressionInput$Msg$Select = function (a) {
	return {$: 'Select', a: a};
};
var $author$project$Icon$XXSmall = {$: 'XXSmall'};
var $author$project$ExpressionInput$addDoubleQuotesIfHardcodedString = function (searchOption) {
	var _v0 = searchOption.proto;
	switch (_v0.$) {
		case 'BaseGlobalString':
			var protoString = _v0.a;
			if (protoString.$ === 'ProtoGlobalStringHardcoded') {
				return $elm_community$string_extra$String$Extra$quote(searchOption.label);
			} else {
				return searchOption.label;
			}
		case 'BaseLocalString':
			var protoString = _v0.a;
			if (protoString.$ === 'ProtoLocalStringHardcoded') {
				return $elm_community$string_extra$String$Extra$quote(searchOption.label);
			} else {
				return searchOption.label;
			}
		default:
			return searchOption.label;
	}
};
var $author$project$FieldType$toIcon = function (fieldType) {
	switch (fieldType.$) {
		case 'StringType':
			return $author$project$Icon$string;
		case 'NumberType':
			return $author$project$Icon$number;
		case 'DateType':
			return $author$project$Icon$date;
		case 'DateTimeType':
			return $author$project$Icon$dateTime;
		default:
			return $author$project$Icon$bool;
	}
};
var $author$project$DataElement$ProtoExpression$baseProtoToIcon = function (proto) {
	switch (proto.$) {
		case 'BaseGlobalString':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'text', 'utility'));
		case 'BaseGlobalNumber':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'number_input', 'utility'));
		case 'BaseGlobalDate':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'date_input', 'utility'));
		case 'BaseGlobalDateTime':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'date_time', 'utility'));
		case 'BaseGlobalBool':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'check', 'utility'));
		case 'BaseGlobalAny':
			return $elm$core$Maybe$Nothing;
		case 'BaseGlobalComp':
			return $elm$core$Maybe$Nothing;
		case 'BaseGlobalStringList':
			return $elm$core$Maybe$Nothing;
		case 'BaseGlobalNumberList':
			return $elm$core$Maybe$Nothing;
		case 'BaseGlobalDateList':
			return $elm$core$Maybe$Nothing;
		case 'BaseGlobalDateTimeList':
			return $elm$core$Maybe$Nothing;
		case 'BaseGlobalBoolList':
			return $elm$core$Maybe$Nothing;
		case 'BaseGlobalAnyList':
			return $elm$core$Maybe$Nothing;
		case 'BaseGlobalCompList':
			return $elm$core$Maybe$Nothing;
		case 'BaseLocalString':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'text', 'utility'));
		case 'BaseLocalNumber':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'number_input', 'utility'));
		case 'BaseLocalDate':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'date_input', 'utility'));
		case 'BaseLocalDateTime':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'date_time', 'utility'));
		case 'BaseLocalBool':
			return $elm$core$Maybe$Just(
				A2($author$project$Icon$makeIcon, 'check', 'utility'));
		case 'BaseLocalAny':
			return $elm$core$Maybe$Nothing;
		case 'BaseLocalComp':
			return $elm$core$Maybe$Nothing;
		case 'BaseLocalStringList':
			return $elm$core$Maybe$Nothing;
		case 'BaseLocalNumberList':
			return $elm$core$Maybe$Nothing;
		case 'BaseLocalDateList':
			return $elm$core$Maybe$Nothing;
		case 'BaseLocalDateTimeList':
			return $elm$core$Maybe$Nothing;
		case 'BaseLocalBoolList':
			return $elm$core$Maybe$Nothing;
		case 'BaseLocalAnyList':
			return $elm$core$Maybe$Nothing;
		case 'BaseLocalCompList':
			return $elm$core$Maybe$Nothing;
		case 'BaseListRef':
			return $elm$core$Maybe$Nothing;
		case 'BaseFieldName':
			var fieldType = proto.a;
			return $elm$core$Maybe$Just(
				$author$project$FieldType$toIcon(fieldType));
		case 'BaseDateInterval':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 'Nothing') {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$MyInsights$IOs = {$: 'IOs'};
var $author$project$Icon$addFlex = function (platform) {
	switch (platform.$) {
		case 'Online':
			return '';
		case 'IOs':
			return 'display-flex';
		default:
			return 'display-flex';
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Icon$appIconToContainerClassName = function (info) {
	return 'app-icon-' + (info.category + ('-' + A3($elm$core$String$replace, '_', '-', info.name)));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Icon$nameToHref = F2(
	function (url, name) {
		return url + ('#' + name);
	});
var $author$project$Icon$sizeToClassName = function (size) {
	switch (size.$) {
		case 'Small':
			return 'slds-icon_small';
		case 'XSmall':
			return 'slds-icon_x-small';
		default:
			return 'slds-icon_xx-small';
	}
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Icon$appView = F3(
	function (size, iconUrl, _v0) {
		var info = _v0.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'app-icon_container m-right_xx-small ' + $author$project$Icon$appIconToContainerClassName(info)),
					$elm$html$Html$Attributes$class(
					$author$project$Icon$addFlex($author$project$MyInsights$IOs)),
					$elm$html$Html$Attributes$title(info.name)
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class(
							'app-icon ' + $author$project$Icon$sizeToClassName(size)),
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$use,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$xlinkHref(
									A2($author$project$Icon$nameToHref, iconUrl, info.name))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slds-assistive-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(info.name)
						]))
				]));
	});
var $author$project$Icon$sldsIconToContainerClassName = function (info) {
	return 'slds-icon-' + (info.category + ('-' + A3($elm$core$String$replace, '_', '-', info.name)));
};
var $author$project$Icon$sldsView = F3(
	function (size, iconUrl, _v0) {
		var info = _v0.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'slds-icon_container slds-m-right_xx-small ' + $author$project$Icon$sldsIconToContainerClassName(info)),
					$elm$html$Html$Attributes$title(info.name)
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class(
							'slds-icon ' + $author$project$Icon$sizeToClassName(size)),
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$use,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$xlinkHref(
									A2($author$project$Icon$nameToHref, iconUrl, info.name))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slds-assistive-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(info.name)
						]))
				]));
	});
var $author$project$Icon$view = F4(
	function (platform, size, iconUrl, info) {
		switch (platform.$) {
			case 'Online':
				return A3($author$project$Icon$sldsView, size, iconUrl, info);
			case 'IOs':
				return A3($author$project$Icon$appView, size, iconUrl, info);
			default:
				return A3($author$project$Icon$appView, size, iconUrl, info);
		}
	});
var $author$project$ExpressionInput$viewSearchOption = F3(
	function (viewInfo, index, searchOption) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('m-item'),
					$elm$html$Html$Events$onClick(
					$author$project$ExpressionInput$Msg$Select(searchOption.proto))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-list-option-text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slds-icon-container m-list-option-icon')
								]),
							_List_fromArray(
								[
									A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$html$Html$text(''),
									A3($author$project$Icon$view, $author$project$MyInsights$Online, $author$project$Icon$XXSmall, viewInfo.iconsUri),
									$author$project$DataElement$ProtoExpression$baseProtoToIcon(searchOption.proto))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('m-list-option'),
									$elm$html$Html$Attributes$id(
									'search-option-' + $elm$core$String$fromInt(index))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('m-text-items')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('m-ellipsis')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$ExpressionInput$addDoubleQuotesIfHardcodedString(searchOption))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$ExpressionInput$viewInput = F4(
	function (conf, viewInfo, toMsg, input) {
		if (input.$ === 'Unselected') {
			var viewState = input.a;
			return A2(
				$elm$html$Html$map,
				toMsg,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('input-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('m-search-box')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$class('m-search-container'),
												$Kurren123$k_dropdown_container$DropdownContainer$triggerAttributes($author$project$ExpressionInput$dropdownConfig)),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$section,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('m-text-input')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('m-text-input__label')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_Utils_ap(
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('m-input'),
																				$elm$html$Html$Attributes$placeholder(
																				A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'SEARCH')),
																				$elm$html$Html$Attributes$type_('text'),
																				$elm$html$Html$Attributes$autocomplete(false),
																				$elm$html$Html$Events$onInput(
																				A2($elm$core$Basics$composeL, $author$project$ExpressionInput$Msg$MsgForInputState, $author$project$ExpressionInput$Msg$UserTyped)),
																				$elm$html$Html$Events$onFocus(
																				$author$project$ExpressionInput$Msg$MsgForInputState($author$project$ExpressionInput$Msg$OpenSearchList))
																			]),
																		$Kurren123$k_dropdown_container$DropdownContainer$triggerAttributes($author$project$ExpressionInput$dropdownConfig)),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$svg$Svg$svg,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$class('m-input-search-icon')
														]),
													_List_fromArray(
														[
															A2(
															$elm$svg$Svg$use,
															_List_fromArray(
																[
																	$elm$svg$Svg$Attributes$xlinkHref(viewInfo.iconsUri + '#search')
																]),
															_List_Nil)
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('m-result-list'),
										A3($Kurren123$k_dropdown_container$DropdownContainer$attributes, viewState.dropdownState, $author$project$ExpressionInput$dropdownConfig, viewState.open)),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$ul,
											_List_Nil,
											A2(
												$elm$core$List$indexedMap,
												$author$project$ExpressionInput$viewSearchOption(viewInfo),
												conf.toSearchOptions(viewState.text)))
										]))
								]))
						])));
		} else {
			var a = input.a;
			return A2(
				$elm$html$Html$map,
				toMsg,
				A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('exp-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selection padding')
								]),
							_List_fromArray(
								[
									conf.view(a)
								]))
						])));
		}
	});
var $author$project$ExpressionInput$viewLabelledInputRowHelper = F4(
	function (viewInfo, viewConfig, input, index) {
		return A4(
			$author$project$ExpressionInput$viewInput,
			viewConfig,
			viewInfo,
			$author$project$ExpressionInput$Msg$InnerMsg(index),
			input);
	});
var $author$project$ExpressionInput$viewOperands = F6(
	function (itemViewConfig, viewInfo, inputA, inputB, operator, expLabel) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, expLabel),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, itemViewConfig, inputA)),
					_Utils_Tuple2(
					'',
					A2($author$project$ExpressionInput$viewLabelOperatorRowHelper, viewInfo, operator)),
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, itemViewConfig, inputB))
				]));
	});
var $author$project$ExpressionInput$viewAdd = F4(
	function (itemViewConfig, viewInfo, numberA, numberB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, numberA, numberB, '+', 'EXP_ADD_NUM');
	});
var $author$project$ExpressionInput$viewAll = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_ALL'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewAny = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_ANY'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewChallengeReasons = F3(
	function (viewConfig, viewInfo, acctIdInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'challengeReasons'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'accountId'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, acctIdInput))
				]));
	});
var $author$project$ExpressionInput$viewConcat = F5(
	function (joinConfig, listConfig, viewInfo, joinInput, listInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_CONCAT'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_STRING_LIST'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, listConfig, listInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_JOIN_STRING'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, joinConfig, joinInput))
				]));
	});
var $author$project$ExpressionInput$viewCountUnique = F3(
	function (listViewConfig, viewInfo, listInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_COUNT_UNIQUE'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, listViewConfig, listInput))
				]));
	});
var $author$project$DataElement$ProtoExpression$BaseDateUnit = function (a) {
	return {$: 'BaseDateUnit', a: a};
};
var $author$project$DateUnit$toVeevaMessageLabel = function (interval) {
	switch (interval.$) {
		case 'Days':
			return 'DATE_UNIT_DAYS';
		case 'Weeks':
			return 'DATE_UNIT_WEEKS';
		case 'Months':
			return 'DATE_UNIT_MONTHS';
		default:
			return 'DATE_UNIT_YEARS';
	}
};
var $author$project$DateUnit$translate = F2(
	function (veevaMessages, interval) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$DateUnit$toString(interval),
			A2(
				$elm$core$Dict$get,
				$author$project$DateUnit$toVeevaMessageLabel(interval),
				veevaMessages));
	});
var $author$project$SearchOption$dateUnitSeed = F2(
	function (veevaMessages, dateUnit) {
		return $author$project$SearchOption$Seed(
			{
				alternateSearch: '',
				label: A2($author$project$DateUnit$translate, veevaMessages, dateUnit),
				proto: $author$project$DataElement$ProtoExpression$BaseDateUnit(dateUnit)
			});
	});
var $author$project$ExpressionInput$dateUnitSearchOptions = F2(
	function (viewInfo, searchTerms) {
		return A2(
			$elm$core$List$map,
			$author$project$SearchOption$fromSeed,
			A2(
				$elm$core$List$filter,
				$author$project$SearchOption$matchesSearchTerm(searchTerms),
				A2(
					$elm$core$List$map,
					$author$project$SearchOption$dateUnitSeed(viewInfo.veevaMessages),
					_List_fromArray(
						[$author$project$DateUnit$Days, $author$project$DateUnit$Weeks, $author$project$DateUnit$Months, $author$project$DateUnit$Years]))));
	});
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$ExpressionInput$viewTextInSelectionBox = F3(
	function (viewInfo, icon, words) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('m-search-box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-selection')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('m-item-selected m-selection-label')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('m-content-selection')
										]),
									_List_fromArray(
										[
											A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$elm$html$Html$text(''),
											A3($author$project$Icon$view, $author$project$MyInsights$Online, $author$project$Icon$XXSmall, viewInfo.iconsUri),
											icon),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(words)
												]))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('m-close-icon-wrapper'),
											$elm$html$Html$Events$onClick($author$project$ExpressionInput$Msg$Reset),
											$author$project$ExpressionInput$onEnter($author$project$ExpressionInput$Msg$Reset)
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$svg,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('m-close-selection-icon')
												]),
											_List_fromArray(
												[
													A2(
													$elm$svg$Svg$use,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$xlinkHref(viewInfo.iconsUri + '#close')
														]),
													_List_Nil)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$ExpressionInput$dateUnitViewConfig = function (viewInfo) {
	return {
		toSearchOptions: $author$project$ExpressionInput$dateUnitSearchOptions(viewInfo),
		view: function (dateUnit) {
			return A3(
				$author$project$ExpressionInput$viewTextInSelectionBox,
				viewInfo,
				$elm$core$Maybe$Nothing,
				A2($author$project$DateUnit$translate, viewInfo.veevaMessages, dateUnit));
		}
	};
};
var $author$project$ExpressionInput$viewDateOperatorLabelHelper = F3(
	function (viewInfo, operator, index) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('exp-operator-label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(operator)
				]));
	});
var $author$project$ExpressionInput$viewDateAdd = F6(
	function (numberViewConfig, dateViewConfig, viewInfo, dateUnit, numberInput, dateInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'addToDate'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'startingFromDate'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, dateViewConfig, dateInput)),
					_Utils_Tuple2(
					'',
					A2(
						$author$project$ExpressionInput$viewDateOperatorLabelHelper,
						viewInfo,
						A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'goForward'))),
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, numberViewConfig, numberInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_DATE_UNIT'),
					A3(
						$author$project$ExpressionInput$viewLabelledInputRowHelper,
						viewInfo,
						$author$project$ExpressionInput$dateUnitViewConfig(viewInfo),
						dateUnit))
				]));
	});
var $author$project$DataElement$ProtoExpression$BaseDateInterval = function (a) {
	return {$: 'BaseDateInterval', a: a};
};
var $author$project$DateInterval$toVeevaMessageLabel = function (interval) {
	switch (interval.$) {
		case 'Week':
			return 'DATE_INTERVAL_WEEK';
		case 'Month':
			return 'DATE_INTERVAL_MONTH';
		case 'Quarter':
			return 'DATE_INTERVAL_QUARTER';
		default:
			return 'DATE_INTERVAL_YEAR';
	}
};
var $author$project$DateInterval$translate = F2(
	function (veevaMessages, interval) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$DateInterval$toString(interval),
			A2(
				$elm$core$Dict$get,
				$author$project$DateInterval$toVeevaMessageLabel(interval),
				veevaMessages));
	});
var $author$project$SearchOption$dateIntervalSeed = F2(
	function (veevaMessages, dateInterval) {
		return $author$project$SearchOption$Seed(
			{
				alternateSearch: '',
				label: A2($author$project$DateInterval$translate, veevaMessages, dateInterval),
				proto: $author$project$DataElement$ProtoExpression$BaseDateInterval(dateInterval)
			});
	});
var $author$project$ExpressionInput$dateIntervalSearchOptions = F2(
	function (viewInfo, searchTerms) {
		return A2(
			$elm$core$List$map,
			$author$project$SearchOption$fromSeed,
			A2(
				$elm$core$List$filter,
				$author$project$SearchOption$matchesSearchTerm(searchTerms),
				A2(
					$elm$core$List$map,
					$author$project$SearchOption$dateIntervalSeed(viewInfo.veevaMessages),
					_List_fromArray(
						[$author$project$DateInterval$Week, $author$project$DateInterval$Month, $author$project$DateInterval$Quarter, $author$project$DateInterval$Year]))));
	});
var $author$project$ExpressionInput$dateIntervalViewConfig = function (viewInfo) {
	return {
		toSearchOptions: $author$project$ExpressionInput$dateIntervalSearchOptions(viewInfo),
		view: function (dateInterval) {
			return A3(
				$author$project$ExpressionInput$viewTextInSelectionBox,
				viewInfo,
				$elm$core$Maybe$Nothing,
				A2($author$project$DateInterval$translate, viewInfo.veevaMessages, dateInterval));
		}
	};
};
var $author$project$ExpressionInput$viewDateCeiling = F4(
	function (dateViewConfig, viewInfo, dateInterval, dateInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'endOfCalendarPeriod'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_DATE'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, dateViewConfig, dateInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'period'),
					A3(
						$author$project$ExpressionInput$viewLabelledInputRowHelper,
						viewInfo,
						$author$project$ExpressionInput$dateIntervalViewConfig(viewInfo),
						dateInterval))
				]));
	});
var $author$project$ExpressionInput$viewDateFloor = F4(
	function (dateViewConfig, viewInfo, dateInterval, dateInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'beginningOfCalendarPeriod'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_DATE'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, dateViewConfig, dateInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'period'),
					A3(
						$author$project$ExpressionInput$viewLabelledInputRowHelper,
						viewInfo,
						$author$project$ExpressionInput$dateIntervalViewConfig(viewInfo),
						dateInterval))
				]));
	});
var $author$project$ExpressionInput$viewDateSubtract = F6(
	function (numberViewConfig, dateViewConfig, viewInfo, dateUnit, numberInput, dateInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'subtractFromDate'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'startingFromDate'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, dateViewConfig, dateInput)),
					_Utils_Tuple2(
					'',
					A2(
						$author$project$ExpressionInput$viewDateOperatorLabelHelper,
						viewInfo,
						A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'goBackward'))),
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, numberViewConfig, numberInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_DATE_UNIT'),
					A3(
						$author$project$ExpressionInput$viewLabelledInputRowHelper,
						viewInfo,
						$author$project$ExpressionInput$dateUnitViewConfig(viewInfo),
						dateUnit))
				]));
	});
var $author$project$ExpressionInput$viewDateTimeToDate = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'datetimeToDate'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewDayInMonth = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_DATE_DAY_IN_MONTH'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_DATE'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewDivide = F4(
	function (itemViewConfig, viewInfo, numberA, numberB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, numberA, numberB, '÷', 'EXP_DIVIDE_NUM');
	});
var $author$project$ExpressionInput$viewEqual = F4(
	function (itemViewConfig, viewInfo, inputA, inputB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, inputA, inputB, '=', 'EXP_EQUAL');
	});
var $author$project$ExpressionInput$iconForField = F3(
	function (viewInfo, ref, fieldName) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$FieldType$toIcon,
			A3($author$project$DataElement$getFieldTypeByRefAndName, viewInfo.dataElements, ref, fieldName));
	});
var $author$project$DataElement$ProtoExpression$BaseFieldName = F2(
	function (a, b) {
		return {$: 'BaseFieldName', a: a, b: b};
	});
var $author$project$SearchOption$localFieldNameSeed = function (_v0) {
	var fieldName = _v0.a;
	var fieldType = _v0.b;
	return $author$project$SearchOption$Seed(
		{
			alternateSearch: '',
			label: $author$project$FieldName$toString(fieldName),
			proto: A2($author$project$DataElement$ProtoExpression$BaseFieldName, fieldType, fieldName)
		});
};
var $author$project$SearchOption$localFieldNames = function (metadata) {
	return A2(
		$elm$core$List$map,
		$author$project$SearchOption$localFieldNameSeed,
		$author$project$DataEngine$RecordMetadata$fields(metadata.recordMetadata));
};
var $author$project$ExpressionInput$localFieldNameSearchOptions = F4(
	function (_v0, maybeRef, typeRequirement, searchTerms) {
		var dataElements = _v0.dataElements;
		return A2(
			$elm$core$List$map,
			$author$project$SearchOption$fromSeed,
			A2(
				$elm$core$List$filter,
				$author$project$SearchOption$matchesSearchTerm(searchTerms),
				A2(
					$elm$core$List$filter,
					$author$project$SearchOption$fieldTypeMatchesRequirement(typeRequirement),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$SearchOption$localFieldNames,
							A2(
								$elm$core$Maybe$map,
								$author$project$DataElement$getMetadata(dataElements),
								A2(
									$elm$core$Maybe$andThen,
									$author$project$DataElement$getDataElementFromReferenceElement(dataElements),
									maybeRef)))))));
	});
var $author$project$ExpressionInput$fieldNameViewConfig = F3(
	function (viewInfo, maybeRef, typeRequirement) {
		return {
			toSearchOptions: A3($author$project$ExpressionInput$localFieldNameSearchOptions, viewInfo, maybeRef, typeRequirement),
			view: function (fieldName) {
				return A3(
					$author$project$ExpressionInput$viewTextInSelectionBox,
					viewInfo,
					A2(
						$elm$core$Maybe$andThen,
						function (ref) {
							return A3($author$project$ExpressionInput$iconForField, viewInfo, ref, fieldName);
						},
						maybeRef),
					$author$project$FieldName$toString(fieldName));
			}
		};
	});
var $author$project$DataElement$ProtoExpression$BaseListRef = function (a) {
	return {$: 'BaseListRef', a: a};
};
var $author$project$SearchOption$listRefOption = function (_v0) {
	var eitherRef = _v0.a;
	var meta = _v0.b;
	var _v1 = meta.listOrSingleton;
	if (_v1.$ === 'Singleton') {
		return $elm$core$Maybe$Nothing;
	} else {
		if (eitherRef.$ === 'IsRecordList') {
			var listRef = eitherRef.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$SearchOption$simpleSeed,
					meta.name,
					$author$project$DataElement$ProtoExpression$BaseListRef(listRef)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$ExpressionInput$listRefSearchOptions = F2(
	function (_v0, searchTerms) {
		var dataElements = _v0.dataElements;
		return A2(
			$elm$core$List$map,
			$author$project$SearchOption$fromSeed,
			A2(
				$elm$core$List$filter,
				$author$project$SearchOption$matchesSearchTerm(searchTerms),
				A2(
					$elm$core$List$filterMap,
					$author$project$SearchOption$listRefOption,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapSecond(
							$author$project$DataElement$getMetadata(dataElements)),
						$author$project$DataElement$collectionToListWithEither(dataElements)))));
	});
var $author$project$DataElement$name = function (_v0) {
	var elementName = _v0.a;
	return elementName;
};
var $author$project$ExpressionInput$listRefViewConfig = function (viewInfo) {
	return {
		toSearchOptions: $author$project$ExpressionInput$listRefSearchOptions(viewInfo),
		view: function (ref) {
			return A3(
				$author$project$ExpressionInput$viewTextInSelectionBox,
				viewInfo,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$withDefault,
					'<Unknown Data Element>',
					A2(
						$elm$core$Maybe$map,
						$author$project$DataElement$name,
						A2($author$project$DataElement$getDataElementFromReferenceElement, viewInfo.dataElements, ref))));
		}
	};
};
var $author$project$ExpressionInput$viewFieldsInList = F4(
	function (viewInfo, typeRequirement, refInput, fieldInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_FIELD_IN_LIST'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_RECORDS'),
					A3(
						$author$project$ExpressionInput$viewLabelledInputRowHelper,
						viewInfo,
						$author$project$ExpressionInput$listRefViewConfig(viewInfo),
						refInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_FIELD'),
					A3(
						$author$project$ExpressionInput$viewLabelledInputRowHelper,
						viewInfo,
						A3(
							$author$project$ExpressionInput$fieldNameViewConfig,
							viewInfo,
							$author$project$Input$toMaybe(refInput),
							typeRequirement),
						fieldInput))
				]));
	});
var $author$project$ExpressionInput$viewFormatDate = F5(
	function (stringViewConfig, dateViewConfig, viewInfo, stringInput, dateInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_FORMAT_DATE'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_DATE'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, dateViewConfig, dateInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_FORMAT'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, stringViewConfig, stringInput))
				]));
	});
var $author$project$ExpressionInput$viewFormatDateTime = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'formatDatetime'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$IntInput$toString = function (intInput) {
	switch (intInput.$) {
		case 'Empty':
			return '';
		case 'Dash':
			return '-';
		default:
			var x = intInput.a;
			return $elm$core$String$fromInt(x);
	}
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$ExpressionInput$viewLabelledIntInputRowHelper = F3(
	function (viewInfo, inputInt, index) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-input'),
					$elm$html$Html$Attributes$type_('number'),
					$elm$html$Html$Attributes$value(
					$author$project$IntInput$toString(inputInt)),
					$elm$html$Html$Events$onInput(
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							$author$project$ExpressionInput$Msg$InnerMsg(index),
							$author$project$ExpressionInput$Msg$MsgForInputState),
						$author$project$ExpressionInput$Msg$UserTyped))
				]),
			_List_Nil);
	});
var $author$project$ExpressionInput$viewFormatNumber = F4(
	function (decimalViewConfig, viewInfo, decimalInput, globalNumberInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_NUMBER_TO_STRING'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_NUMBER_TO_STRING'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, decimalViewConfig, globalNumberInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_DECIMALS'),
					A2($author$project$ExpressionInput$viewLabelledIntInputRowHelper, viewInfo, decimalInput))
				]));
	});
var $author$project$ExpressionInput$viewGT = F4(
	function (itemViewConfig, viewInfo, inputA, inputB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, inputA, inputB, '>', 'EXP_GT');
	});
var $author$project$ExpressionInput$viewGTE = F4(
	function (itemViewConfig, viewInfo, inputA, inputB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, inputA, inputB, '≥', 'EXP_GTE');
	});
var $author$project$ExpressionInput$viewIf = F6(
	function (boolViewConfig, itemViewConfig, viewInfo, ifInput, thenInput, elseInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_IF'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_IF'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, boolViewConfig, ifInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_THEN'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, itemViewConfig, thenInput)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_ELSE'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, itemViewConfig, elseInput))
				]));
	});
var $author$project$ExpressionInput$viewTextOperands = F7(
	function (itemViewConfig, itemViewConfigList, viewInfo, inputA, inputB, operator, expLabel) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, expLabel),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, itemViewConfig, inputA)),
					_Utils_Tuple2(
					'',
					A2($author$project$ExpressionInput$viewLabelOperatorRowHelper, viewInfo, operator)),
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, itemViewConfigList, inputB))
				]));
	});
var $author$project$ExpressionInput$viewIn = F5(
	function (itemViewConfig, itemViewConfigList, viewInfo, inputA, inputB) {
		return A7(
			$author$project$ExpressionInput$viewTextOperands,
			itemViewConfig,
			itemViewConfigList,
			viewInfo,
			inputA,
			inputB,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_IN'),
			'EXP_IN');
	});
var $author$project$ExpressionInput$viewIsNotNull = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'isNotNull'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'FIELD_LIST_ITEM_VALUE'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewIsNull = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'isNull'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'FIELD_LIST_ITEM_VALUE'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewLT = F4(
	function (itemViewConfig, viewInfo, inputA, inputB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, inputA, inputB, '<', 'EXP_LT');
	});
var $author$project$ExpressionInput$viewLTE = F4(
	function (itemViewConfig, viewInfo, inputA, inputB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, inputA, inputB, '≤', 'EXP_LTE');
	});
var $author$project$ExpressionInput$viewDraggableInputRowHelper = F5(
	function (viewInfo, viewConfig, input, dragModel, index) {
		var itemId = 'drag-' + $elm$core$String$fromInt(index);
		if (input.$ === 'Unselected') {
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('list-exp-item'),
					A2($author$project$ExpressionInput$Msg$dndSystem.dropEvents, index, itemId)),
				_List_fromArray(
					[
						A4($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input, index)
					]));
		} else {
			var _v1 = $author$project$ExpressionInput$Msg$dndSystem.info(dragModel);
			if (_v1.$ === 'Nothing') {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-exp-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$id(itemId),
								A2($author$project$ExpressionInput$Msg$dndSystem.dragEvents, index, itemId)),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$svg,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('list-drag-item-icon')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$use,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$xlinkHref(viewInfo.iconsUri + '#rows')
												]),
											_List_Nil)
										]))
								])),
							A4($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input, index)
						]));
			} else {
				var dragIndex = _v1.a.dragIndex;
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('list-exp-item'),
						A2($author$project$ExpressionInput$Msg$dndSystem.dropEvents, index, itemId)),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(itemId)
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$svg,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('list-drag-item-icon')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$use,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$xlinkHref(viewInfo.iconsUri + '#rows')
												]),
											_List_Nil)
										]))
								])),
							A4($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input, index)
						]));
			}
		}
	});
var $author$project$ExpressionInput$viewListOfExpressions = F4(
	function (viewConfig, viewInfo, listOfExpr, dragModel) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LIST_OF_EXPRESSIONS'),
			A2(
				$elm$core$List$map,
				function (input) {
					return _Utils_Tuple2(
						'',
						A4($author$project$ExpressionInput$viewDraggableInputRowHelper, viewInfo, viewConfig, input, dragModel));
				},
				listOfExpr));
	});
var $author$project$ExpressionInput$viewSelectedWithoutChildren = F3(
	function (viewInfo, icon, words) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('m-search-box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-selection')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('m-item-selected')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('m-selection-label')
										]),
									_List_fromArray(
										[
											A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$elm$html$Html$text(''),
											A3($author$project$Icon$view, $author$project$MyInsights$Online, $author$project$Icon$XXSmall, viewInfo.iconsUri),
											icon),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('m-content-selection')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(words)
														]))
												]))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('m-close-icon-wrapper'),
											$elm$html$Html$Events$onClick($author$project$ExpressionInput$Msg$Reset),
											$author$project$ExpressionInput$onEnter($author$project$ExpressionInput$Msg$Reset)
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$svg,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('m-close-selection-icon')
												]),
											_List_fromArray(
												[
													A2(
													$elm$svg$Svg$use,
													_List_fromArray(
														[
															$elm$svg$Svg$Attributes$xlinkHref(viewInfo.iconsUri + '#close')
														]),
													_List_Nil)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$ExpressionInput$viewLookup = F3(
	function (viewInfo, ref, fieldName) {
		var iconForSingletonField = A2(
			$elm$core$Maybe$map,
			$author$project$FieldType$toIcon,
			A3($author$project$DataElement$getSingletonFieldTypeByRefAndName, viewInfo.dataElements, ref, fieldName));
		return A3(
			$author$project$ExpressionInput$viewSelectedWithoutChildren,
			viewInfo,
			iconForSingletonField,
			$elm$core$String$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						'<Unknown Data Element>',
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$name,
							A2($author$project$DataElement$getDataElementFromReferenceElement, viewInfo.dataElements, ref))),
						' -> ',
						$author$project$FieldName$toString(fieldName)
					])));
	});
var $author$project$ExpressionInput$viewMax = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_MAX'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewMin = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_MIN'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewMonthDate = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_DATE_MONTH'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewMultiply = F4(
	function (itemViewConfig, viewInfo, numberA, numberB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, numberA, numberB, '×', 'EXP_MULTIPLY_NUM');
	});
var $author$project$ExpressionInput$viewNot = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_NOT'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_BOOL'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewNotEqual = F4(
	function (itemViewConfig, viewInfo, inputA, inputB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, inputA, inputB, '≠', 'EXP_NOT_EQUAL');
	});
var $author$project$ExpressionInput$viewNotIn = F5(
	function (itemViewConfig, itemViewConfigList, viewInfo, inputA, inputB) {
		return A7(
			$author$project$ExpressionInput$viewTextOperands,
			itemViewConfig,
			itemViewConfigList,
			viewInfo,
			inputA,
			inputB,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_LABEL_NOT_IN'),
			'EXP_NOT_IN');
	});
var $author$project$ExpressionInput$viewPickList = F3(
	function (listConfig, viewInfo, listInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'valueFromList'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'selectValueFrom'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, listConfig, listInput))
				]));
	});
var $author$project$ExpressionInput$viewProduct = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_PRODUCT'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewRound = F3(
	function (childConfig, viewInfo, child) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_ROUND_NUM'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, childConfig, child))
				]));
	});
var $author$project$ExpressionInput$viewSubtract = F4(
	function (itemViewConfig, viewInfo, numberA, numberB) {
		return A6($author$project$ExpressionInput$viewOperands, itemViewConfig, viewInfo, numberA, numberB, '−', 'EXP_SUBTRACT_NUM');
	});
var $author$project$ExpressionInput$viewSum = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_SUM'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$viewTargetChallengeReasons = F3(
	function (viewConfig, viewInfo, acctIdInput) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'targetChallengeReasons'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.i18nMessages, 'accountId'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, acctIdInput))
				]));
	});
var $author$project$ExpressionInput$viewYearDate = F3(
	function (viewConfig, viewInfo, input) {
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_DATE_YEAR'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, viewConfig, input))
				]));
	});
var $author$project$ExpressionInput$globalAnyListViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3($author$project$ExpressionInput$listSearchOptions, viewInfo, $author$project$SearchOption$Global, $author$project$FieldTypeRequirement$AnyType),
		view: $author$project$ExpressionInput$viewProtoGlobalAnyList(viewInfo)
	};
};
var $author$project$ExpressionInput$globalAnyViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3($author$project$ExpressionInput$searchOptions, viewInfo, $author$project$SearchOption$Global, $author$project$FieldTypeRequirement$AnyType),
		view: $author$project$ExpressionInput$viewProtoGlobalAny(viewInfo)
	};
};
var $author$project$ExpressionInput$globalBoolListViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$listSearchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType)),
		view: $author$project$ExpressionInput$viewProtoGlobalBoolList(viewInfo)
	};
};
var $author$project$ExpressionInput$globalBoolViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$searchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType)),
		view: $author$project$ExpressionInput$viewProtoGlobalBool(viewInfo)
	};
};
var $author$project$ExpressionInput$globalCompFieldListViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3($author$project$ExpressionInput$listSearchOptions, viewInfo, $author$project$SearchOption$Global, $author$project$FieldTypeRequirement$AnyComparableType),
		view: $author$project$ExpressionInput$viewProtoGlobalCompFieldList(viewInfo)
	};
};
var $author$project$ExpressionInput$globalCompListViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3($author$project$ExpressionInput$listSearchOptions, viewInfo, $author$project$SearchOption$Global, $author$project$FieldTypeRequirement$AnyComparableType),
		view: $author$project$ExpressionInput$viewProtoGlobalCompList(viewInfo)
	};
};
var $author$project$ExpressionInput$globalCompViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3($author$project$ExpressionInput$searchOptions, viewInfo, $author$project$SearchOption$Global, $author$project$FieldTypeRequirement$AnyComparableType),
		view: $author$project$ExpressionInput$viewProtoGlobalComp(viewInfo)
	};
};
var $author$project$ExpressionInput$globalDateListViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$listSearchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType)),
		view: $author$project$ExpressionInput$viewProtoGlobalDateList(viewInfo)
	};
};
var $author$project$ExpressionInput$globalDateTimeListViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$listSearchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType)),
		view: $author$project$ExpressionInput$viewProtoGlobalDateTimeList(viewInfo)
	};
};
var $author$project$ExpressionInput$globalDateTimeViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$searchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType)),
		view: $author$project$ExpressionInput$viewProtoGlobalDateTime(viewInfo)
	};
};
var $author$project$ExpressionInput$globalDateViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$searchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType)),
		view: $author$project$ExpressionInput$viewProtoGlobalDate(viewInfo)
	};
};
var $author$project$ExpressionInput$globalFieldViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3($author$project$ExpressionInput$searchOptions, viewInfo, $author$project$SearchOption$Global, $author$project$FieldTypeRequirement$AnyType),
		view: $author$project$ExpressionInput$viewProtoGlobalField(viewInfo)
	};
};
var $author$project$ExpressionInput$globalNumberListViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$listSearchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType)),
		view: $author$project$ExpressionInput$viewProtoGlobalNumberList(viewInfo)
	};
};
var $author$project$ExpressionInput$globalNumberViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$searchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType)),
		view: $author$project$ExpressionInput$viewProtoGlobalNumber(viewInfo)
	};
};
var $author$project$ExpressionInput$globalStringListViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$listSearchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType)),
		view: $author$project$ExpressionInput$viewProtoGlobalStringList(viewInfo)
	};
};
var $author$project$ExpressionInput$globalStringViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3(
			$author$project$ExpressionInput$searchOptions,
			viewInfo,
			$author$project$SearchOption$Global,
			$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType)),
		view: $author$project$ExpressionInput$viewProtoGlobalString(viewInfo)
	};
};
var $author$project$ExpressionInput$viewProtoGlobalAny = F2(
	function (viewInfo, proto) {
		if (proto.$ === 'ProtoGlobalAnyIf') {
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A6(
				$author$project$ExpressionInput$viewIf,
				$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
				$author$project$ExpressionInput$globalAnyViewConfig(viewInfo),
				viewInfo,
				ifInput,
				thenInput,
				elseInput);
		} else {
			var listInput = proto.a;
			return A3(
				$author$project$ExpressionInput$viewPickList,
				$author$project$ExpressionInput$globalAnyListViewConfig(viewInfo),
				viewInfo,
				listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalAnyList = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalAnyListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalAnyListViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalAnysAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					$author$project$ExpressionInput$globalAnyViewConfig(viewInfo),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var refInput = proto.a;
				var fieldState = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$AnyType,
					refInput,
					$author$project$Input$Unselected(fieldState));
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalBool = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalBoolLookup':
				var ref = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, ref, fieldName);
			case 'ProtoGlobalBoolHardcoded':
				var bool = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$bool),
					A2($author$project$ExpressionInput$boolToTranslatedString, viewInfo, bool));
			case 'ProtoGlobalGTString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoGlobalGTNumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalGTDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalGTDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalGTComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					$author$project$ExpressionInput$globalCompViewConfig(viewInfo),
					viewInfo,
					compA,
					compB);
			case 'ProtoGlobalGTEString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoGlobalGTENumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalGTEDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalGTEDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalGTEComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					$author$project$ExpressionInput$globalCompViewConfig(viewInfo),
					viewInfo,
					compA,
					compB);
			case 'ProtoGlobalLTString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoGlobalLTNumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalLTDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalLTDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalLTComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					$author$project$ExpressionInput$globalCompViewConfig(viewInfo),
					viewInfo,
					compA,
					compB);
			case 'ProtoGlobalLTEString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoGlobalLTENumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalLTEDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalLTEDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalLTEComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					$author$project$ExpressionInput$globalCompViewConfig(viewInfo),
					viewInfo,
					compA,
					compB);
			case 'ProtoGlobalEqualString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoGlobalEqualNumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalEqualDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalEqualDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalEqualBool':
				var boolA = proto.a;
				var boolB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					viewInfo,
					boolA,
					boolB);
			case 'ProtoGlobalEqualComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					$author$project$ExpressionInput$globalCompViewConfig(viewInfo),
					viewInfo,
					compA,
					compB);
			case 'ProtoGlobalEqualAny':
				var anyA = proto.a;
				var anyB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					$author$project$ExpressionInput$globalAnyViewConfig(viewInfo),
					viewInfo,
					anyA,
					anyB);
			case 'ProtoGlobalNotEqualString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoGlobalNotEqualNumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalNotEqualDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalNotEqualDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoGlobalNotEqualBool':
				var boolA = proto.a;
				var boolB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					viewInfo,
					boolA,
					boolB);
			case 'ProtoGlobalNotEqualComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					$author$project$ExpressionInput$globalCompViewConfig(viewInfo),
					viewInfo,
					compA,
					compB);
			case 'ProtoGlobalNotEqualAny':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					$author$project$ExpressionInput$globalAnyViewConfig(viewInfo),
					viewInfo,
					compA,
					compB);
			case 'ProtoGlobalStringIn':
				var string = proto.a;
				var stringList = proto.b;
				return A5(
					$author$project$ExpressionInput$viewIn,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					$author$project$ExpressionInput$globalStringListViewConfig(viewInfo),
					viewInfo,
					string,
					stringList);
			case 'ProtoGlobalStringNotIn':
				var string = proto.a;
				var stringList = proto.b;
				return A5(
					$author$project$ExpressionInput$viewNotIn,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					$author$project$ExpressionInput$globalStringListViewConfig(viewInfo),
					viewInfo,
					string,
					stringList);
			case 'ProtoGlobalNot':
				var bool = proto.a;
				return A3(
					$author$project$ExpressionInput$viewNot,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					viewInfo,
					bool);
			case 'ProtoGlobalBoolIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalPickBool':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					$author$project$ExpressionInput$globalBoolListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalAll':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewAll,
					$author$project$ExpressionInput$globalBoolListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalAny':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewAny,
					$author$project$ExpressionInput$globalBoolListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalIsNull':
				var field = proto.a;
				return A3(
					$author$project$ExpressionInput$viewIsNull,
					$author$project$ExpressionInput$globalFieldViewConfig(viewInfo),
					viewInfo,
					field);
			default:
				var field = proto.a;
				return A3(
					$author$project$ExpressionInput$viewIsNotNull,
					$author$project$ExpressionInput$globalFieldViewConfig(viewInfo),
					viewInfo,
					field);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalBoolList = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalBoolListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalBoolListViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalBoolsAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType),
					refInput,
					fieldInput);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalComp = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalMaxComp':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					$author$project$ExpressionInput$globalCompListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalMinComp':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					$author$project$ExpressionInput$globalCompListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalCompIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalCompViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			default:
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					$author$project$ExpressionInput$globalCompListViewConfig(viewInfo),
					viewInfo,
					listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalCompFieldList = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalCompStringList':
				var stringList = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalStringList, viewInfo, stringList);
			case 'ProtoGlobalCompNumberList':
				var numberList = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalNumberList, viewInfo, numberList);
			case 'ProtoGlobalCompDateList':
				var dateList = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalDateList, viewInfo, dateList);
			case 'ProtoGlobalCompDateTimeList':
				var dateList = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalDateTimeList, viewInfo, dateList);
			default:
				var compList = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalCompList, viewInfo, compList);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalCompList = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalCompListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalCompListViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalCompsAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					$author$project$ExpressionInput$globalCompViewConfig(viewInfo),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var refInput = proto.a;
				var fieldState = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$AnyComparableType,
					refInput,
					$author$project$Input$Unselected(fieldState));
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalDate = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalDateLookup':
				var ref = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, ref, fieldName);
			case 'ProtoGlobalDateHardcoded':
				var date = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$date),
					$justinmimbs$date$Date$toIsoString(date));
			case 'ProtoGlobalDateCeiling':
				var dateInterval = proto.a;
				var date = proto.b;
				return A4(
					$author$project$ExpressionInput$viewDateCeiling,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateInterval,
					date);
			case 'ProtoGlobalDateFloor':
				var dateInterval = proto.a;
				var date = proto.b;
				return A4(
					$author$project$ExpressionInput$viewDateFloor,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateInterval,
					date);
			case 'ProtoGlobalDateAdd':
				var dateUnit = proto.a;
				var number = proto.b;
				var date = proto.c;
				return A6(
					$author$project$ExpressionInput$viewDateAdd,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateUnit,
					number,
					date);
			case 'ProtoGlobalDateSubtract':
				var dateUnit = proto.a;
				var number = proto.b;
				var date = proto.c;
				return A6(
					$author$project$ExpressionInput$viewDateSubtract,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateUnit,
					number,
					date);
			case 'ProtoGlobalDateTimeToDate':
				var dateTimeInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewDateTimeToDate,
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					dateTimeInput);
			case 'ProtoGlobalDateIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalPickDate':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					$author$project$ExpressionInput$globalDateListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalMaxDate':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					$author$project$ExpressionInput$globalDateListViewConfig(viewInfo),
					viewInfo,
					listInput);
			default:
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					$author$project$ExpressionInput$globalDateListViewConfig(viewInfo),
					viewInfo,
					listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalDateList = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalDateListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalDateListViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalDatesAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType),
					refInput,
					fieldInput);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalDateTime = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalDateTimeLookup':
				var ref = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, ref, fieldName);
			case 'ProtoGlobalDateTimeHardcoded':
				var date = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$dateTime),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(date));
			case 'ProtoGlobalDateTimeIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalPickDateTime':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					$author$project$ExpressionInput$globalDateTimeListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalMaxDateTime':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					$author$project$ExpressionInput$globalDateTimeListViewConfig(viewInfo),
					viewInfo,
					listInput);
			default:
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					$author$project$ExpressionInput$globalDateTimeListViewConfig(viewInfo),
					viewInfo,
					listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalDateTimeList = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalDateTimeListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalDateTimeListViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalAllDateTimesInField':
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType),
					refInput,
					fieldInput);
			default:
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					listOfExpr,
					dragModel);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalField = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalStringField':
				var globalString = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalString, viewInfo, globalString);
			case 'ProtoGlobalNumberField':
				var globalNumber = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalNumber, viewInfo, globalNumber);
			case 'ProtoGlobalDateField':
				var globalDate = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalDate, viewInfo, globalDate);
			case 'ProtoGlobalDateTimeField':
				var globalDateTime = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalDateTime, viewInfo, globalDateTime);
			case 'ProtoGlobalBoolField':
				var globalBool = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalBool, viewInfo, globalBool);
			case 'ProtoGlobalAnyField':
				var globalAny = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalAny, viewInfo, globalAny);
			default:
				var globalComp = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalComp, viewInfo, globalComp);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalNumber = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalNumberLookup':
				var ref = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, ref, fieldName);
			case 'ProtoGlobalNumberHardcoded':
				var number = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$number),
					$elm$core$String$fromFloat(number));
			case 'ProtoGlobalRoundNumber':
				var numberInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewRound,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberInput);
			case 'ProtoGlobalSum':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSum,
					$author$project$ExpressionInput$globalNumberListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalProduct':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewProduct,
					$author$project$ExpressionInput$globalNumberListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalAdd':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewAdd,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalSubtract':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewSubtract,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalMultiply':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewMultiply,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalDivide':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewDivide,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoGlobalMonthNumber':
				var dateInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMonthDate,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateInput);
			case 'ProtoGlobalYearNumber':
				var dateInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewYearDate,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateInput);
			case 'ProtoGlobalDayInMonth':
				var dateInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewDayInMonth,
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					dateInput);
			case 'ProtoGlobalNumberIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalPickNumber':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					$author$project$ExpressionInput$globalNumberListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalMaxNumber':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					$author$project$ExpressionInput$globalNumberListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalMinNumber':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					$author$project$ExpressionInput$globalNumberListViewConfig(viewInfo),
					viewInfo,
					listInput);
			default:
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewCountUnique,
					$author$project$ExpressionInput$globalCompFieldListViewConfig(viewInfo),
					viewInfo,
					listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalNumberList = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalNumberListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalNumberListViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalNumbersAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType),
					refInput,
					fieldInput);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalString = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalStringLookup':
				var ref = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, ref, fieldName);
			case 'ProtoGlobalStringHardcoded':
				var words = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$string),
					$elm_community$string_extra$String$Extra$quote(words));
			case 'ProtoGlobalFormatDate':
				var stringInput = proto.a;
				var dateInput = proto.b;
				return A5(
					$author$project$ExpressionInput$viewFormatDate,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
					viewInfo,
					stringInput,
					dateInput);
			case 'ProtoGlobalFormatNumber':
				var decimal = proto.a;
				var numberInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFormatNumber,
					$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
					viewInfo,
					decimal,
					numberInput);
			case 'ProtoGlobalStringIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalPickString':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					$author$project$ExpressionInput$globalStringListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalConcat':
				var joinInput = proto.a;
				var listInput = proto.b;
				return A5(
					$author$project$ExpressionInput$viewConcat,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					$author$project$ExpressionInput$globalStringListViewConfig(viewInfo),
					viewInfo,
					joinInput,
					listInput);
			case 'ProtoGlobalMaxString':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					$author$project$ExpressionInput$globalStringListViewConfig(viewInfo),
					viewInfo,
					listInput);
			case 'ProtoGlobalMinString':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					$author$project$ExpressionInput$globalStringListViewConfig(viewInfo),
					viewInfo,
					listInput);
			default:
				var input = proto.a;
				return A3(
					$author$project$ExpressionInput$viewFormatDateTime,
					$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
					viewInfo,
					input);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalStringList = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalStringListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
					$author$project$ExpressionInput$globalStringListViewConfig(viewInfo),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoGlobalStringsAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					listOfExpr,
					dragModel);
			case 'ProtoGlobalAllStringsInField':
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType),
					refInput,
					fieldInput);
			case 'ProtoGlobalChallengeReasons':
				var acctIdInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewChallengeReasons,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					acctIdInput);
			default:
				var acctIdInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewTargetChallengeReasons,
					$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
					viewInfo,
					acctIdInput);
		}
	});
var $author$project$ExpressionInput$viewProtoGlobalCompField = F2(
	function (viewInfo, proto) {
		switch (proto.$) {
			case 'ProtoGlobalStringComp':
				var globalString = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalString, viewInfo, globalString);
			case 'ProtoGlobalNumberComp':
				var globalNumber = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalNumber, viewInfo, globalNumber);
			case 'ProtoGlobalDateComp':
				var globalDate = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalDate, viewInfo, globalDate);
			case 'ProtoGlobalDateTimeComp':
				var globalDateTime = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalDateTime, viewInfo, globalDateTime);
			default:
				var globalComp = proto.a;
				return A2($author$project$ExpressionInput$viewProtoGlobalComp, viewInfo, globalComp);
		}
	});
var $author$project$ExpressionInput$globalCompFieldViewConfig = function (viewInfo) {
	return {
		toSearchOptions: A3($author$project$ExpressionInput$searchOptions, viewInfo, $author$project$SearchOption$Global, $author$project$FieldTypeRequirement$AnyComparableType),
		view: $author$project$ExpressionInput$viewProtoGlobalCompField(viewInfo)
	};
};
var $author$project$ExpressionInput$viewEmptyInput = function (viewInfo) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('input-wrapper')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('m-search-box')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('m-search-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$section,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('m-text-input')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('m-text-input__label')
															]),
														_List_Nil),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('m-input'),
																$elm$html$Html$Attributes$placeholder(
																A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'SEARCH')),
																$elm$html$Html$Attributes$type_('text')
															]),
														_List_Nil)
													]))
											])),
										A2(
										$elm$svg$Svg$svg,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('m-input-search-icon')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$use,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$xlinkHref(viewInfo.iconsUri + '#search')
													]),
												_List_Nil)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$ExpressionInput$emptyViewConfig = function (viewInfo) {
	return {
		toSearchOptions: function (_v0) {
			return _List_Nil;
		},
		view: function (_v1) {
			return $author$project$ExpressionInput$viewEmptyInput(viewInfo);
		}
	};
};
var $author$project$ExpressionInput$viewLocalField = F3(
	function (viewInfo, ref, fieldName) {
		return A3(
			$author$project$ExpressionInput$viewSelectedWithoutChildren,
			viewInfo,
			A3($author$project$ExpressionInput$iconForField, viewInfo, ref, fieldName),
			$elm$core$String$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						'<Unknown Data Element>',
						A2(
							$elm$core$Maybe$map,
							$author$project$DataElement$name,
							A2($author$project$DataElement$getDataElementFromReferenceElement, viewInfo.dataElements, ref))),
						' -> ',
						$author$project$FieldName$toString(fieldName)
					])));
	});
var $author$project$ExpressionInput$localAnyListViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$listSearchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$AnyType),
			view: A2($author$project$ExpressionInput$viewProtoLocalAnyList, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localAnyViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$searchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$AnyType),
			view: A2($author$project$ExpressionInput$viewProtoLocalAny, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localBoolListViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$listSearchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalBoolList, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localBoolViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$searchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalBool, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localCompFieldListViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$listSearchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$AnyComparableType),
			view: A2($author$project$ExpressionInput$viewProtoLocalCompFieldList, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localCompListViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$listSearchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$AnyComparableType),
			view: A2($author$project$ExpressionInput$viewProtoLocalCompList, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localCompViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$searchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$AnyComparableType),
			view: A2($author$project$ExpressionInput$viewProtoLocalComp, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localDateListViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$listSearchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalDateList, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localDateTimeListViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$listSearchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalDateTimeList, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localDateTimeViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$searchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalDateTime, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localDateViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$searchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalDate, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localFieldViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$searchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$AnyType),
			view: A2($author$project$ExpressionInput$viewProtoLocalField, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localNumberListViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$listSearchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalNumberList, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localNumberViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$searchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalNumber, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localStringListViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$listSearchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalStringList, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$localStringViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$searchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType)),
			view: A2($author$project$ExpressionInput$viewProtoLocalString, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$viewProtoLocalAny = F3(
	function (viewInfo, ref, proto) {
		if (proto.$ === 'ProtoLocalAnyIf') {
			var ifInput = proto.a;
			var thenInput = proto.b;
			var elseInput = proto.c;
			return A6(
				$author$project$ExpressionInput$viewIf,
				A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
				A2($author$project$ExpressionInput$localAnyViewConfig, viewInfo, ref),
				viewInfo,
				ifInput,
				thenInput,
				elseInput);
		} else {
			var listInput = proto.a;
			return A3(
				$author$project$ExpressionInput$viewPickList,
				A2($author$project$ExpressionInput$localAnyListViewConfig, viewInfo, ref),
				viewInfo,
				listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalAnyList = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalAnyListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localAnyListViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalAllAnysInField':
				var refInput = proto.a;
				var fieldState = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$AnyType,
					refInput,
					$author$project$Input$Unselected(fieldState));
			case 'ProtoLocalAnysAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					A2($author$project$ExpressionInput$localAnyViewConfig, viewInfo, ref),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var relationship = proto.a;
				var fieldName = proto.b;
				return A5(
					$author$project$ExpressionInput$viewRelated,
					viewInfo,
					ref,
					relationship,
					$author$project$Input$Unselected(fieldName),
					$author$project$FieldTypeRequirement$AnyType);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalBool = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalBool':
				var fieldName = proto.a;
				return A3($author$project$ExpressionInput$viewLocalField, viewInfo, ref, fieldName);
			case 'ProtoLocalBoolLookup':
				var singleRef = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, singleRef, fieldName);
			case 'ProtoLocalBoolHardcoded':
				var words = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$bool),
					A2($author$project$ExpressionInput$boolToTranslatedString, viewInfo, words));
			case 'ProtoLocalGTString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoLocalGTNumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalGTDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalGTDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalGTComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGT,
					A2($author$project$ExpressionInput$localCompViewConfig, viewInfo, ref),
					viewInfo,
					compA,
					compB);
			case 'ProtoLocalGTEString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoLocalGTENumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalGTEDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalGTEDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalGTEComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewGTE,
					A2($author$project$ExpressionInput$localCompViewConfig, viewInfo, ref),
					viewInfo,
					compA,
					compB);
			case 'ProtoLocalLTString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoLocalLTNumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalLTDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalLTDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalLTComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLT,
					A2($author$project$ExpressionInput$localCompViewConfig, viewInfo, ref),
					viewInfo,
					compA,
					compB);
			case 'ProtoLocalLTEString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoLocalLTENumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalLTEDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalLTEDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalLTEComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewLTE,
					A2($author$project$ExpressionInput$localCompViewConfig, viewInfo, ref),
					viewInfo,
					compA,
					compB);
			case 'ProtoLocalEqualString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoLocalEqualNumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalEqualDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalEqualDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalEqualBool':
				var boolA = proto.a;
				var boolB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					viewInfo,
					boolA,
					boolB);
			case 'ProtoLocalEqualComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					A2($author$project$ExpressionInput$localCompViewConfig, viewInfo, ref),
					viewInfo,
					compA,
					compB);
			case 'ProtoLocalEqualAny':
				var anyA = proto.a;
				var anyB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewEqual,
					A2($author$project$ExpressionInput$localAnyViewConfig, viewInfo, ref),
					viewInfo,
					anyA,
					anyB);
			case 'ProtoLocalNotEqualString':
				var stringA = proto.a;
				var stringB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					stringA,
					stringB);
			case 'ProtoLocalNotEqualNumber':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalNotEqualDate':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalNotEqualDateTime':
				var dateA = proto.a;
				var dateB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					dateA,
					dateB);
			case 'ProtoLocalNotEqualBool':
				var boolA = proto.a;
				var boolB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					viewInfo,
					boolA,
					boolB);
			case 'ProtoLocalNotEqualComp':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					A2($author$project$ExpressionInput$localCompViewConfig, viewInfo, ref),
					viewInfo,
					compA,
					compB);
			case 'ProtoLocalNotEqualAny':
				var compA = proto.a;
				var compB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewNotEqual,
					A2($author$project$ExpressionInput$localAnyViewConfig, viewInfo, ref),
					viewInfo,
					compA,
					compB);
			case 'ProtoLocalStringIn':
				var string = proto.a;
				var stringList = proto.b;
				return A5(
					$author$project$ExpressionInput$viewIn,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localStringListViewConfig, viewInfo, ref),
					viewInfo,
					string,
					stringList);
			case 'ProtoLocalStringNotIn':
				var string = proto.a;
				var stringList = proto.b;
				return A5(
					$author$project$ExpressionInput$viewNotIn,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localStringListViewConfig, viewInfo, ref),
					viewInfo,
					string,
					stringList);
			case 'ProtoLocalNot':
				var bool = proto.a;
				return A3(
					$author$project$ExpressionInput$viewNot,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					viewInfo,
					bool);
			case 'ProtoLocalBoolIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalPickBool':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					A2($author$project$ExpressionInput$localBoolListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalAll':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewAll,
					A2($author$project$ExpressionInput$localBoolListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalAny':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewAny,
					A2($author$project$ExpressionInput$localBoolListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalIsNull':
				var field = proto.a;
				return A3(
					$author$project$ExpressionInput$viewIsNull,
					A2($author$project$ExpressionInput$localFieldViewConfig, viewInfo, ref),
					viewInfo,
					field);
			default:
				var field = proto.a;
				return A3(
					$author$project$ExpressionInput$viewIsNotNull,
					A2($author$project$ExpressionInput$localFieldViewConfig, viewInfo, ref),
					viewInfo,
					field);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalBoolList = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalBoolListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localBoolListViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalAllBoolsInField':
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType),
					refInput,
					fieldInput);
			case 'ProtoLocalBoolsAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var relationship = proto.a;
				var fieldName = proto.b;
				return A5(
					$author$project$ExpressionInput$viewRelated,
					viewInfo,
					ref,
					relationship,
					fieldName,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$BoolType));
		}
	});
var $author$project$ExpressionInput$viewProtoLocalComp = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalMaxComp':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					A2($author$project$ExpressionInput$localCompListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalMinComp':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					A2($author$project$ExpressionInput$localCompListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalCompIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localCompViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			default:
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					A2($author$project$ExpressionInput$localCompListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalCompFieldList = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalCompStringList':
				var stringList = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalStringList, viewInfo, ref, stringList);
			case 'ProtoLocalCompNumberList':
				var numberList = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalNumberList, viewInfo, ref, numberList);
			case 'ProtoLocalCompDateList':
				var dateList = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalDateList, viewInfo, ref, dateList);
			case 'ProtoLocalCompDateTimeList':
				var dateList = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalDateTimeList, viewInfo, ref, dateList);
			default:
				var compList = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalCompList, viewInfo, ref, compList);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalCompList = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalCompListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localCompListViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalAllCompsInField':
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$AnyComparableType,
					refInput,
					$author$project$Input$Unselected(fieldInput));
			case 'ProtoLocalCompsAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					A2($author$project$ExpressionInput$localCompViewConfig, viewInfo, ref),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var relationship = proto.a;
				var fieldName = proto.b;
				return A5(
					$author$project$ExpressionInput$viewRelated,
					viewInfo,
					ref,
					relationship,
					$author$project$Input$Unselected(fieldName),
					$author$project$FieldTypeRequirement$AnyComparableType);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalDate = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalDate':
				var fieldName = proto.a;
				return A3($author$project$ExpressionInput$viewLocalField, viewInfo, ref, fieldName);
			case 'ProtoLocalDateLookup':
				var singleRef = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, singleRef, fieldName);
			case 'ProtoLocalDateHardcoded':
				var date = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$date),
					$justinmimbs$date$Date$toIsoString(date));
			case 'ProtoLocalDateTimeToDate':
				var dateTimeInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewDateTimeToDate,
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					dateTimeInput);
			case 'ProtoLocalDateCeiling':
				var dateInterval = proto.a;
				var date = proto.b;
				return A4(
					$author$project$ExpressionInput$viewDateCeiling,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateInterval,
					date);
			case 'ProtoLocalDateFloor':
				var dateInterval = proto.a;
				var date = proto.b;
				return A4(
					$author$project$ExpressionInput$viewDateFloor,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateInterval,
					date);
			case 'ProtoLocalDateAdd':
				var dateUnit = proto.a;
				var number = proto.b;
				var date = proto.c;
				return A6(
					$author$project$ExpressionInput$viewDateAdd,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateUnit,
					number,
					date);
			case 'ProtoLocalDateSubtract':
				var dateUnit = proto.a;
				var number = proto.b;
				var date = proto.c;
				return A6(
					$author$project$ExpressionInput$viewDateSubtract,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateUnit,
					number,
					date);
			case 'ProtoLocalDateIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalPickDate':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					A2($author$project$ExpressionInput$localDateListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalMaxDate':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					A2($author$project$ExpressionInput$localDateListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			default:
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					A2($author$project$ExpressionInput$localDateListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalDateList = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalDateListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localDateListViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalAllDatesInField':
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType),
					refInput,
					fieldInput);
			case 'ProtoLocalDatesAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var relationship = proto.a;
				var fieldName = proto.b;
				return A5(
					$author$project$ExpressionInput$viewRelated,
					viewInfo,
					ref,
					relationship,
					fieldName,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateType));
		}
	});
var $author$project$ExpressionInput$viewProtoLocalDateTime = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalDateTime':
				var fieldName = proto.a;
				return A3($author$project$ExpressionInput$viewLocalField, viewInfo, ref, fieldName);
			case 'ProtoLocalDateTimeLookup':
				var singleRef = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, singleRef, fieldName);
			case 'ProtoLocalDateTimeHardcoded':
				var date = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$dateTime),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(date));
			case 'ProtoLocalDateTimeIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalPickDateTime':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					A2($author$project$ExpressionInput$localDateTimeListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalMaxDateTime':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					A2($author$project$ExpressionInput$localDateTimeListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			default:
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					A2($author$project$ExpressionInput$localDateTimeListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalDateTimeList = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalDateTimeListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localDateTimeListViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalAllDateTimesInField':
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType),
					refInput,
					fieldInput);
			case 'ProtoLocalDateTimesAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var relationship = proto.a;
				var fieldName = proto.b;
				return A5(
					$author$project$ExpressionInput$viewRelated,
					viewInfo,
					ref,
					relationship,
					fieldName,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$DateTimeType));
		}
	});
var $author$project$ExpressionInput$viewProtoLocalField = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalStringField':
				var globalString = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalString, viewInfo, ref, globalString);
			case 'ProtoLocalNumberField':
				var globalNumber = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalNumber, viewInfo, ref, globalNumber);
			case 'ProtoLocalDateField':
				var globalDate = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalDate, viewInfo, ref, globalDate);
			case 'ProtoLocalDateTimeField':
				var globalDateTime = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalDateTime, viewInfo, ref, globalDateTime);
			case 'ProtoLocalBoolField':
				var globalBool = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalBool, viewInfo, ref, globalBool);
			case 'ProtoLocalAnyField':
				var globalAny = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalAny, viewInfo, ref, globalAny);
			default:
				var globalComp = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalComp, viewInfo, ref, globalComp);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalNumber = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalNumber':
				var fieldName = proto.a;
				return A3($author$project$ExpressionInput$viewLocalField, viewInfo, ref, fieldName);
			case 'ProtoLocalNumberLookup':
				var singleRef = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, singleRef, fieldName);
			case 'ProtoLocalNumberHardcoded':
				var num = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$number),
					$elm$core$String$fromFloat(num));
			case 'ProtoLocalRoundNumber':
				var numberInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewRound,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberInput);
			case 'ProtoLocalSum':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSum,
					A2($author$project$ExpressionInput$localNumberListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalProduct':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewProduct,
					A2($author$project$ExpressionInput$localNumberListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalAdd':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewAdd,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalSubtract':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewSubtract,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalMultiply':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewMultiply,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalDivide':
				var numberA = proto.a;
				var numberB = proto.b;
				return A4(
					$author$project$ExpressionInput$viewDivide,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					numberA,
					numberB);
			case 'ProtoLocalMonthNumber':
				var dateInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMonthDate,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateInput);
			case 'ProtoLocalYearNumber':
				var dateInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewYearDate,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateInput);
			case 'ProtoLocalDayInMonth':
				var dateInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewDayInMonth,
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					dateInput);
			case 'ProtoLocalNumberIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalPickNumber':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					A2($author$project$ExpressionInput$localNumberListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalMaxNumber':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					A2($author$project$ExpressionInput$localNumberListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalMinNumber':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					A2($author$project$ExpressionInput$localNumberListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			default:
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewCountUnique,
					A2($author$project$ExpressionInput$localCompFieldListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalNumberList = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalNumberListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localNumberListViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalAllNumbersInField':
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType),
					refInput,
					fieldInput);
			case 'ProtoLocalNumbersAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					listOfExpr,
					dragModel);
			default:
				var relationship = proto.a;
				var fieldName = proto.b;
				return A5(
					$author$project$ExpressionInput$viewRelated,
					viewInfo,
					ref,
					relationship,
					fieldName,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$NumberType));
		}
	});
var $author$project$ExpressionInput$viewProtoLocalString = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalString':
				var fieldName = proto.a;
				return A3($author$project$ExpressionInput$viewLocalField, viewInfo, ref, fieldName);
			case 'ProtoLocalStringLookup':
				var singleRef = proto.a;
				var fieldName = proto.b;
				return A3($author$project$ExpressionInput$viewLookup, viewInfo, singleRef, fieldName);
			case 'ProtoLocalStringHardcoded':
				var words = proto.a;
				return A3(
					$author$project$ExpressionInput$viewSelectedWithoutChildren,
					viewInfo,
					$elm$core$Maybe$Just($author$project$Icon$string),
					$elm_community$string_extra$String$Extra$quote(words));
			case 'ProtoLocalFormatDate':
				var stringInput = proto.a;
				var dateInput = proto.b;
				return A5(
					$author$project$ExpressionInput$viewFormatDate,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
					viewInfo,
					stringInput,
					dateInput);
			case 'ProtoLocalFormatNumber':
				var decimal = proto.a;
				var numberInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFormatNumber,
					A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
					viewInfo,
					decimal,
					numberInput);
			case 'ProtoLocalStringIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalPickString':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewPickList,
					A2($author$project$ExpressionInput$localStringListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalConcat':
				var joinInput = proto.a;
				var listInput = proto.b;
				return A5(
					$author$project$ExpressionInput$viewConcat,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localStringListViewConfig, viewInfo, ref),
					viewInfo,
					joinInput,
					listInput);
			case 'ProtoLocalMaxString':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMax,
					A2($author$project$ExpressionInput$localStringListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			case 'ProtoLocalMinString':
				var listInput = proto.a;
				return A3(
					$author$project$ExpressionInput$viewMin,
					A2($author$project$ExpressionInput$localStringListViewConfig, viewInfo, ref),
					viewInfo,
					listInput);
			default:
				var input = proto.a;
				return A3(
					$author$project$ExpressionInput$viewFormatDateTime,
					A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
					viewInfo,
					input);
		}
	});
var $author$project$ExpressionInput$viewProtoLocalStringList = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalStringListIf':
				var ifInput = proto.a;
				var thenInput = proto.b;
				var elseInput = proto.c;
				return A6(
					$author$project$ExpressionInput$viewIf,
					A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
					A2($author$project$ExpressionInput$localStringListViewConfig, viewInfo, ref),
					viewInfo,
					ifInput,
					thenInput,
					elseInput);
			case 'ProtoLocalAllStringsInField':
				var refInput = proto.a;
				var fieldInput = proto.b;
				return A4(
					$author$project$ExpressionInput$viewFieldsInList,
					viewInfo,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType),
					refInput,
					fieldInput);
			case 'ProtoLocalStringsAsList':
				var listOfExpr = proto.a;
				var dragModel = proto.b;
				return A4(
					$author$project$ExpressionInput$viewListOfExpressions,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					listOfExpr,
					dragModel);
			case 'ProtoRelatedString':
				var relationship = proto.a;
				var fieldName = proto.b;
				return A5(
					$author$project$ExpressionInput$viewRelated,
					viewInfo,
					ref,
					relationship,
					fieldName,
					$author$project$FieldTypeRequirement$OneDataType($author$project$FieldType$StringType));
			case 'ProtoLocalChallengeReasons':
				var acctId = proto.a;
				return A3(
					$author$project$ExpressionInput$viewChallengeReasons,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					acctId);
			default:
				var acctId = proto.a;
				return A3(
					$author$project$ExpressionInput$viewTargetChallengeReasons,
					A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
					viewInfo,
					acctId);
		}
	});
var $author$project$ExpressionInput$viewRelated = F5(
	function (viewInfo, ref, relationship, inputFieldName, fieldType) {
		var relatedFilterConfig = function () {
			var _v1 = $author$project$Input$toMaybe(relationship.nextElement);
			if (_v1.$ === 'Nothing') {
				return $author$project$ExpressionInput$emptyViewConfig(viewInfo);
			} else {
				var nextRef = _v1.a;
				return A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, nextRef);
			}
		}();
		var idToMatchConfig = function () {
			var _v0 = $author$project$Input$toMaybe(relationship.nextElement);
			if (_v0.$ === 'Nothing') {
				return $author$project$ExpressionInput$emptyViewConfig(viewInfo);
			} else {
				var nextRef = _v0.a;
				return A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, nextRef);
			}
		}();
		return A3(
			$author$project$ExpressionInput$viewExpressionWithLabelledChildren,
			viewInfo,
			A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_RELATED_FIELD'),
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_RELATED_FIELD'),
					A3(
						$author$project$ExpressionInput$viewLabelledInputRowHelper,
						viewInfo,
						$author$project$ExpressionInput$listRefViewConfig(viewInfo),
						relationship.nextElement)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_RELATED_FIELD_GET'),
					A3(
						$author$project$ExpressionInput$viewLabelledInputRowHelper,
						viewInfo,
						A3(
							$author$project$ExpressionInput$fieldNameViewConfig,
							viewInfo,
							$author$project$Input$toMaybe(relationship.nextElement),
							fieldType),
						inputFieldName)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_RELATED_FIELD_WHERE'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, idToMatchConfig, relationship.idToMatch)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_RELATED_FIELD_MATCHES'),
					A3(
						$author$project$ExpressionInput$viewLabelledInputRowHelper,
						viewInfo,
						A2($author$project$ExpressionInput$localStringListViewConfig, viewInfo, ref),
						relationship.localIds)),
					_Utils_Tuple2(
					A2($author$project$ExpressionInput$translateMessage, viewInfo.veevaMessages, 'EXP_RELATED_FIELD_FILTER'),
					A3($author$project$ExpressionInput$viewLabelledInputRowHelper, viewInfo, relatedFilterConfig, relationship.optionalFilter))
				]));
	});
var $author$project$ExpressionInput$viewProtoLocalCompField = F3(
	function (viewInfo, ref, proto) {
		switch (proto.$) {
			case 'ProtoLocalStringComp':
				var globalString = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalString, viewInfo, ref, globalString);
			case 'ProtoLocalNumberComp':
				var globalNumber = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalNumber, viewInfo, ref, globalNumber);
			case 'ProtoLocalDateComp':
				var globalDate = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalDate, viewInfo, ref, globalDate);
			case 'ProtoLocalDateTimeComp':
				var globalDateTime = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalDateTime, viewInfo, ref, globalDateTime);
			default:
				var globalComp = proto.a;
				return A3($author$project$ExpressionInput$viewProtoLocalComp, viewInfo, ref, globalComp);
		}
	});
var $author$project$ExpressionInput$localCompFieldViewConfig = F2(
	function (viewInfo, ref) {
		return {
			toSearchOptions: A3(
				$author$project$ExpressionInput$searchOptions,
				viewInfo,
				$author$project$SearchOption$Local(ref),
				$author$project$FieldTypeRequirement$AnyComparableType),
			view: A2($author$project$ExpressionInput$viewProtoLocalCompField, viewInfo, ref)
		};
	});
var $author$project$ExpressionInput$viewExpressionInputSection = function (model) {
	switch (model.$) {
		case 'UnknownInput':
			var viewInfo = model.a;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Error: Unknown expression input type')
					]));
		case 'GlobalFieldInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalFieldViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalCompInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalCompFieldViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalStringInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalStringViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalNumberInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalNumberViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalDateInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalDateViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalDateTimeInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalDateTimeViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalBoolInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalBoolViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'LocalFieldInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A4(
				$author$project$ExpressionInput$viewInput,
				A2($author$project$ExpressionInput$localFieldViewConfig, viewInfo, ref),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'LocalCompInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A4(
				$author$project$ExpressionInput$viewInput,
				A2($author$project$ExpressionInput$localCompFieldViewConfig, viewInfo, ref),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'LocalStringInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A4(
				$author$project$ExpressionInput$viewInput,
				A2($author$project$ExpressionInput$localStringViewConfig, viewInfo, ref),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'LocalNumberInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A4(
				$author$project$ExpressionInput$viewInput,
				A2($author$project$ExpressionInput$localNumberViewConfig, viewInfo, ref),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'LocalDateInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A4(
				$author$project$ExpressionInput$viewInput,
				A2($author$project$ExpressionInput$localDateViewConfig, viewInfo, ref),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'LocalDateTimeInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A4(
				$author$project$ExpressionInput$viewInput,
				A2($author$project$ExpressionInput$localDateTimeViewConfig, viewInfo, ref),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'LocalBoolInput':
			var viewInfo = model.a;
			var ref = model.b;
			var input = model.c;
			return A4(
				$author$project$ExpressionInput$viewInput,
				A2($author$project$ExpressionInput$localBoolViewConfig, viewInfo, ref),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalStringListInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalStringListViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalNumberListInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalNumberListViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalDateListInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalDateListViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		case 'GlobalDateTimeListInput':
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalDateTimeListViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
		default:
			var viewInfo = model.a;
			var input = model.b;
			return A4(
				$author$project$ExpressionInput$viewInput,
				$author$project$ExpressionInput$globalBoolListViewConfig(viewInfo),
				viewInfo,
				$author$project$ExpressionInput$Msg$MsgForInput,
				input);
	}
};
var $author$project$ExpressionInput$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('selection')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						$author$project$ExpressionInput$viewExpressionInputSection(model)
					]))
			]));
};
var $author$project$ExpressionInput$main = $elm$browser$Browser$element(
	{init: $author$project$ExpressionInput$init, subscriptions: $author$project$ExpressionInput$subscriptions, update: $author$project$ExpressionInput$update, view: $author$project$ExpressionInput$view});
_Platform_export({'ExpressionInput':{'init':$author$project$ExpressionInput$main($elm$json$Json$Decode$value)(0)}});}(this));